import React, { useEffect, useRef, useState } from "react";
import {
  getLotsActiveList,
  updatePartLot,
} from "../../services/LotsServices";
import {
  getCatalogList,
  actionPartInventoryTempStore,
  getPartInventoryTempList,
  DestoryPartInventoryTemp,
  createPartsInventory,
  updatePartsInventory,
  actionPartInventoryImage,
  destoryPartInventoryImage,
  partVehicleProcessUpdateExpiryDate,
  partInvenoryVehicleSearch,
  partInvenoryPartETAIPrice,
  partInvenoryPartETAI,
  PartInventoryImageDetails,
  partRefDelete,
  partDamageDelete,
  getCatalogModalStatsHistoryDetails,
  getPartRefcodeConditionDetails,
  getPartEstimatePriceDetails,
  getPartStatiscalPriceDetails,
  createOCRreferenceRead,
  getvehicleCompatibleProduct,
  getStructureOem,
  getvehicleProductDetails,
  getVehicleCompatibleDetails,
  getPartsByReference,
  getwarHouseEntityList,
  getCheckVehicleAssociatePart,
  getPartCatalogChecklistItems,
  updateBulkPartInventoryPrice,
  updateBulkPartInventoryReference,
} from "../../services/PartsInventory";
import {
  Button,
  FormGroup,
  Label,
  Form,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Nav,
  NavItem,
  TabPane,
  TabContent,
  NavLink,
} from "reactstrap";
import Select from "react-select";
import ConfigDB from "../../config";
import { toast } from "react-toastify";
import Utils from "../../utils";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  getCarTreeByCar,
  getPartAutoTempList,
  getPartByGroup,
  getPartByPrice,
  getSchemaByGroup,
  getVehicleFuelAllList,
  getvehicleMakeAllList,
  getVehiclePartList,
  getvehicleYearList,
  updateVehiclePartImageSort,
} from "../../services/VehicleService";
import Table from "react-bootstrap/Table";
import Card from "react-bootstrap/Card";
import Pagination from "react-js-pagination";
import { getAllViewShelfList } from "../../services/ShelfServices";
import {
  getCommonSearchList,
  getSettingsCompanyDetails,
} from "../../services/settingsServices";
import { getAllBrandSerachList } from "../../services/PartBrandServices";
import moment from "moment/moment";
import { getVehicleAllModalSerachList } from "../../services/VehicleModelService";
import { getVehicleEngineSerachList } from "../../services/VehicleEngineService";
import {
  actionTempStoreDismental,
  getDismentalList,
} from "../../services/DismentalServices";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import { getVehicleSerachVariantList } from "../../services/VehicleVariantsService";
import { useTranslation } from "react-i18next";
import { tConst } from "../../utils/constantsTranslator";
import ReactStars from "react-rating-stars-component";
import AssignedDamageImage from "./AssignedDamageImage";
import AddPartVideo from "./AddPartVideo";
import { profileDetailForWeb } from "../../services/AuthServices";
import AssignedDamageVideo from "./AssignedDamageVideo";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import { ReactSketchCanvas } from "react-sketch-canvas";
import axios from "axios";
import { getAllVehicleSerachType } from "../../services/VehicleMakeService";
import {
  createLabelBrothers,
  createLabelZebras,
  printPartLabel,
} from "../../services/LabelServices";
import { Tab, Tabs } from "react-bootstrap";
import RatingImage from "../../asset/images/rating.png";
import { PhotoProvider, PhotoView } from "react-photo-view";

const VehiclePartsAdd = ({
  vehicleAddDetails,
  vehicleImageDetails,
  setvehicleImageDetails,
  vehicleMainData,
  vehicleAddDetailsLoader,
}) => {
  const tableLengthList = ConfigDB?.data?.dataTableLength;
  const navigate = useNavigate();
  const LangData = localStorage.getItem("lng");
  const state = useLocation();
  const { t } = useTranslation();
  const { uuid } = useParams();
  const levels = [1, 2, 3, 4];

  const [searchQuery, setSearchQuery] = useState("");
  const [searchQueryTemp, setSearchQueryTemp] = useState("");
  // ---- Módulo Lotes (edit mode) — paridade com mobile _LotInlineEditor.
  // Permite trocar/remover o lote associado à peça via /update-part-lot.
  const [partLotInfo, setPartLotInfo] = useState({
    lot_id: null,
    lot_name: "",
    lot_internal_id: "",
  });
  const [lotEditModalOpen, setLotEditModalOpen] = useState(false);
  const [lotEditSearch, setLotEditSearch] = useState("");
  const [lotEditList, setLotEditList] = useState([]);
  const [lotEditLoading, setLotEditLoading] = useState(false);
  const [lotEditSaving, setLotEditSaving] = useState(false);
  const [VehicleModelAllList, setVehicleModelAllList] = useState([]);
  const [CatalogList, setCatalogList] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [tempData, setTempData] = useState({});
  const [partsData, setPartsData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentStep, setCurrentStep] = useState(1);
  const [inputValue, setInputValue] = useState("");
  const [inputCategoryValue, setInputCategoryValue] = useState("");

  const [inputSelctedValue, setInputSelctedValue] = useState("");
  const [images, setImage] = useState([]);
  const [ShelfList, SetShelfList] = useState([]);
  const [enlargedIndexes, setEnlargedIndexes] = useState([]);
  const [detailsForImages, SetDetailsForImages] = useState([]);
  const [currentPartIndex, setCurrentPartIndex] = useState(0);
  const [showSkip, setShowSkip] = useState(false);
  const [previewUrl, SetPreviewUrl] = useState([]);
  const [showModalAbout, setShowModalAbout] = useState(false);
  const [ImageDetailsNot, setImageDetailsNot] = useState("");
  const [stateList, setStateList] = useState([]);
  const [conditionList, setConditionList] = useState([]);
  const [inventoryList, setInventoryList] = useState([]);
  const [modifyExpiry, setModifyExpiry] = useState(false);
  const [settingDetails, setSettingDetails] = useState("");
  const [vehicleExceedData, setVehicleExceedData] = useState("");
  const [vehiclePartDetailsModal, setVehiclePartDetailsModal] = useState(false);
  const [vehicleData, setVehicleData] = useState({
    date: "",
  });
  const [allBrandList, SetAllBrandList] = useState([]);
  const [brandName, setBrandName] = useState("");
  const [btnLoader, setBtnLoader] = useState(false);
  const [btnLoading, setbtnLoading] = useState(false);
  const [btnClosed, setbtnClosed] = useState(false);
  const [btnNext, setbtnNext] = useState(false);
  const [btnSaveNext, setbtnSaveNext] = useState(false);
  const [selectedModels, setSelectedModels] = useState([]);
  const [params, setParams] = useState({
    limit: tableLengthList[0],
    page: 1,
    search: "",
    is_reload: false,
  });
  const [vehicleEngineAuto, setVehicleEngineAuto] = useState("");
  const [vehicleEngineId, setVehicleEngineId] = useState({
    vehicle_model_id: "",
    make_id: "",
    vehicle_model_name: "",
    vehicle_process_end_date: "",
    id: "",
    vehicle_in_inventory: "",
    variants_id: "",
    vehicle_make_name: "",
    registration_plate: "",
    registration: "",
  });

  const fileInputRef = useRef(null);

  const [referenceList, setReferenceList] = useState([]);
  const [partETAIRerList, setPartETAIRerList] = useState("");
  const [partEtaiModify, setPartEtaiModify] = useState(false);
  const [partEtaiPriceModify, setPartEtaiPriceModify] = useState(false);
  const [partETAIPriceList, setPartETAIPriceList] = useState("");
  const [partETAIRefDetails, setPartETAIRefDetails] = useState([]);
  const [partETAIPriceDetail, setPartETAIPriceDetail] = useState([]);
  const [selectedReferenceCode, setSelectedReferenceCode] = useState(null);

  const [EngineData, setEngineData] = useState({
    engine_code: "",
    kw: "",
    hp: "",
    motor_code: "",
  });

  const [vehicleEngineList, setvehicleEngineList] = useState([]);
  const [inputSelctedEngineValue, setInputSelctedEngineValue] = useState("");
  const [vehicleModalSelectedList, setVehicleModalSelectedList] = useState({
    vehicle_model_name: "",
    vehicle_exp_value: "",
  });
  const [DismetalList, setDismetalList] = useState([]);
  const [inputSelctedDismetalValue, setInputSelctedDismetalValue] =
    useState("");
  const [dismentalData, setDismentalData] = useState({
    dismantle_id: "",
  });
  const [dismantleTempData, setDismantleTempData] = useState("");
  const [categoryMasterPart, setCategoryMasterPart] = useState({});
  const [modifyMasterPart, setModifyMasterPart] = useState(false);
  const [checkedItems, setCheckedItems] = useState([]);
  const [modifyImportModal, setModifyImportModal] = useState(false);

  const [modifyMasterVehiclePart, setModifyMasterVehiclePart] = useState(false);
  const [modifyMasterVehicleNotPart, setModifyMasterVehicleNotPart] =
    useState(false);

  const [isSaveClicked, setIsSaveClicked] = useState(false);

  const [selectedRows, setSelectedRows] = useState(
    categoryMasterPart?.part_list?.map(() => ({
      vehicle_year: null,
      vehicle_make: null,
      vehicle_model: null,
      vehicle_variant: null,
    })) || [],
  );

  const [selectedItemsCheckBox, setSelectedItemsCheckBox] = useState([]);
  const [locationDamageList, setLocationDamageList] = useState([]);
  const [typeDamageList, setTypeDamageList] = useState([]);

  const [modifyDelteRef, setModifyDelteRef] = useState(false);
  const [modifyDelteDamage, setModifyDelteDamage] = useState(false);
  const [DelteRefId, setDelteRefId] = useState({
    pIndex: "",
    rowIndex: "",
    id: "",
  });
  const [DelteDamageId, setDelteDamageId] = useState({
    pIndex: "",
    rowIndex: "",
    id: "",
  });

  const [partImageDataList, setPartImageDataList] = useState([]);

  const [catalogModalStateDataList, setCatalogModalStateDataList] = useState(
    [],
  );
  const [catalogModalStateDataId, setCatalogModalStateDataId] = useState("");
  const [modalStateHistory, setModalStateHistory] = useState(false);
  const [modalSponsorPrice, setModalSponsorPrice] = useState(false);
  const [sponsorPriceDataId, setSponsorPriceDataId] = useState("");
  const [sponsorPricDataList, setSponsorPricDataList] = useState([]);

  const [modalEstimatePrice, setModalEstimatePrice] = useState(false);
  const [estimatePriceDataId, setEstimatePriceDataId] = useState("");
  const [estimatePricDataList, setEstimatePricDataList] = useState([]);
  const [profileDetails, setProfileDetails] = useState("");

  const [modalRefCodeCondition, setModalRefCodeCondition] = useState(false);
  const [refCodeConditionDataId, setRefCodeConditionDataId] = useState("");
  const [refCodeConditionDataList, setRefCodeConditionDataList] = useState([]);
  const [partVideoDataList, setPartVideoDataList] = useState([]);

  const [selectedImage, setSelectedImage] = useState(null);

  const [rotation, setRotation] = useState(0);
  const canvasRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const imgRef = useRef(null);
  const [completedCrop, setCompletedCrop] = useState(null);
  const [crop, setCrop] = useState({ unit: "%", width: 50, height: 50 });
  const [highlights, setHighlights] = useState([]);
  const [selectedColor, setSelectedColor] = useState("#ff0000");
  const [isCropping, setIsCropping] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadings, setIsLoadings] = useState(false);
  const [isLoadingColor, setIsLoadingColor] = useState(false);
  const [settingCompanyDetails, setSettingCompanyDetails] = useState("");
  const [isDrawing, setIsDrawing] = useState(false);
  const [modalRefCodeEstimate, setModalRefCodeEstimate] = useState(false);

  const [modalOcrRef, setModalOcrRef] = useState(false);
  const [file, setFile] = useState(null);
  let errorsObjImport = {
    file: "",
  };
  const [errorsImport, setErrorsImport] = useState(errorsObjImport);
  const [refReadData, setRefReadData] = useState([]);
  const [selectedConditions, setSelectedConditions] = useState({});
  const [selectedReferenceType, setSelectedReferenceType] = useState({});
  const [selectedRowsRef, setSelectedRowsRef] = useState({});
  const [selectedData, setSelectedData] = useState([]);
  const [updatedTexts, setUpdatedTexts] = useState({});
  const [modalCompatible, setModalCompatible] = useState(false);
  const [VehicleMakeList, setVehicleMakeList] = useState([]);
  const [inputSelctedeMakeValue, setInputSelctedeMakeValue] = useState("");
  const [VehicleModalList, setVehicleModalList] = useState([]);
  const [inputSelctedeModalValue, setInputSelctedeModalValue] = useState("");
  const [VehicleVariantList, setVehicleVariantList] = useState([]);
  const [inputSelctededVariantValue, setInputSelctededVariantValue] =
    useState("");

  const [VehicleTypeList, setVehicleTypeList] = useState([]);
  const [selectedVehicle, setSelectedVehicle] = useState(null);

  const [VehicleYearList, setVehicleYearList] = useState([]);
  const [inputSelctedeYearValue, setinputSelctedeYearValue] = useState("");

  const [vehiclePartsComData, setVehiclePartsComData] = useState({
    vehicle_model_id: "",
    vehicle_make: "",
    vehicle_year: "",
    vehicle_model: "",
    vehicle_variants: "",
    vehicle_parts_id: "",
    vehicle_type: "",
    notes: "",
    vehicle_make_name: "",
  });
  const [compatibleList, setCompatibleList] = useState([]);
  const [modifyNotes, setModifyNotes] = useState(false);
  const [selectedPartIndex, setSelectedPartIndex] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedPartForPopup, setSelectedPartForPopup] = useState(null);
  const [estimatePricDataRefList, setEstimatePricDataRefList] = useState([]);
  const [vehicleFuelList, setVehicleFuelList] = useState([]);
  const [inputSelctedFuelValue, setInputSelctedFuelValue] = useState([]);
  const [vehicleYearPartList, setvehicleYearPartList] = useState([]);
  const [inputSelctedYearValue, setInputSelctedYearValue] = useState("");
  const [vehicleMakePartList, setvehicleMakePartList] = useState([]);
  const [inputSelctedMakeValue, setInputSelctedMakeValue] = useState("");
  const [vehicleModalPartList, setvehicleModalPartList] = useState([]);
  const [inputSelctedModalValue, setInputSelctedModalValue] = useState("");
  const [vehicleVariantPartList, setvehicleVariantPartList] = useState([]);
  const [inputSelctedVariantValue, setInputSelctedVariantValue] = useState("");
  const [VehicleTypePartList, setVehicleTypePartList] = useState([]);
  const [inputSelctedTypeValue, setInputSelctedTypeValue] = useState([]);
  const [categoryPartsData, setCategoryPartsData] = useState({
    catalog_id: "",
    vehicle_year: "",
    vehicle_make: "",
    vehicle_model: "",
    vehicle_variant: "",
    is_master_id: "",
    vehicle_make_name: "",
    vehicle_model_name: "",
    vehicle_variant_name: "",
    vehicle_type: "",
    vehicle_type_name: "",
    vehicle_id: "",
    vehicle_internal_id: "",
    part_catalog_name: "",
  });

  const [detailsForVideo, SetDetailsForVideo] = useState([]);
  const [currentPartVideoIndex, setCurrentPartVideoIndex] = useState(0);
  const [categoryPartList, setCategoryPartList] = useState([]);

  const [modifyOemModal, setModifyOemModal] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [structureOemList, setStructureOemList] = useState([]);
  const [vehicleCompatibleItems, setvehicleCompatibleItems] = useState([]);
  const [vehicleCompatibleProductList, setVehicleCompatibleProductList] =
    useState([]);
  const [loadingCompatible, setLoadingCompatible] = useState(false);

  const [vehicleCompatibleProductDetails, setVehicleCompatibleProductDetails] =
    useState([]);
  const [productVehicleId, setProductVehicleId] = useState([]);
  const [modifyProductModal, setModifyProductModal] = useState(false);
  const [modifyConfirmModal, setModifyConfirmModal] = useState(false);
  const [loadingStructureOem, setLoadingStructureOem] = useState(false);
  const [selectedVehicleData, setSelectedVehicleData] = useState({
    iem_list: [],
    oem_list: [],
    vehicle_compatible_list: [],
  });

  const [vehicleComDataList, setVehicleComDataList] = useState([]);
  const [vehicleSelectedComDataList, setVehicleSelectedComDataList] = useState(
    [],
  );
  const [selectedOEMIndices, setSelectedOEMIndices] = useState([]);
  const [modalStateRefHistory, setModalStateRefHistory] = useState(false);
  const [catalogModalStateRefDataList, setCatalogModalStateRefDataList] =
    useState([]);
  const [countRefData, setCountRefData] = useState("");
  const [partAttributesList, setPartAttributesList] = useState([]);
  const [partCatalogModal, setPartCatalogModal] = useState(false);
  const [selectedPartCatalogForPopup, setSelectedPartCatalogForPopup] =
    useState(null);
  const [modalCarVin, setModalCarVin] = useState(false);
  const [carVinData, setCarVinData] = useState("");
  const [key, setKey] = useState("car_type_selection");
  const [showTab2, setShowTab2] = useState(false);
  const [showTab3, setShowTab3] = useState(false);
  const [showTabInteractive, setShowTabInteractive] = useState(false);
  const [partCatalogData, setPartCatalogData] = useState([]);
  const [loadingTreeCar, setLoadingTreeCar] = useState(false);
  const [showAllList, setShowAllList] = useState(
    Array(partCatalogData?.length).fill(false),
  );
  const [schemaByGroupLocalData, setSchemaByGroupLocalData] = useState([]);
  const [showAlTypeList, setShowAllTypeList] = useState(
    Array(schemaByGroupLocalData?.length).fill(false),
  );
  const [partByGroupLocalData, setPartByGroupLocalData] = useState([]);
  const [mainPartData, setMainPartData] = useState("");
  const [partPriceLocalData, setPartPriceLocalData] = useState([]);
  const [priceModal, setpriceModal] = useState(false);
  const [codeData, setCodeData] = useState("");
  const [autoMainFillData, setAutoMainFillData] = useState("");
  const [autoFillData, setAutoFillData] = useState("");
  const [btnImageLoading, setBtnImageLoading] = useState(false);
  const [changePartModal, setChangePartModal] = useState(false);
  const [overwriteConfirmed, setOverwriteConfirmed] = useState(false);
  const [updatedData, setUpdatedData] = useState("");
  const [openIndexes, setOpenIndexes] = useState({});

  const [selectedPart, setSelectedPart] = useState(null);
  const [partByGroup, setPartByGroup] = useState([]);
  const [partPriceData, setPartPriceData] = useState([]);
  const [openPriceRows, setOpenPriceRows] = useState({});
  const [selectedPrice, setSelectedPrice] = useState(null);
  const [selectedImages, setSelectedImages] = useState([]);
  const [entityList, setEntityList] = useState([]);
  const [selectedEntities, setSelectedEntities] = useState({});
  const [selectedValueBrand, setSelectedValueBrand] = useState("");
  const [modifyAssoicate, setModifyAssoicate] = useState(false);
  const [modifyAssoicateConfirm, setModifyAssoicateConfirm] = useState(false);

  const [btnSaved, setBtnSaved] = useState(false);
  const [partCheckListStatusList, setPartCheckListStatusList] = useState([]);
  const [partCheckList, setPartCheckList] = useState([]);
  const [viewerOpen, setViewerOpen] = useState(false);
  const [viewerIndex, setViewerIndex] = useState(0);
  const [vehicleModelCategoryAllList, setVehicleModelCategoryAllList] =
    useState([]);
  const [priceBulkModel, setPriceBulkModel] = useState(false);
  const [priceBulkData, setPriceBulkData] = useState({
    price_1: "",
    price_1_check: false,
    price_2: "",
    price_2_check: false,
    part_cost_price: "",
    cost_price_check: false,
  });
  const [priceBulkLoader, setPriceBulkLoader] = useState(false);
  const [selectedHistoryItem, setSelectedHistoryItem] = useState(null);
  const [referencesBulkModel, seteReferencesBulkModel] = useState(false);
  const [referencesBulkData, setReferencesBulkData] = useState({
    reference: [
      {
        reference_code: "",
        condition_id: 1,
        type_id: 2,
        brand: "",
        manufacter: "",
      },
    ],
  });
  const [referencesBulkLoader, setReferencesBulkLoader] = useState(false);

  const handleChangeReferencesBulkOpen = () => {
    seteReferencesBulkModel(true);
    if (catalogModalStateDataList?.length > 0) {
      setModalStateHistory(false);
    }
    if (catalogModalStateRefDataList?.length > 0) {
      setModalStateRefHistory(false);
    }
  };

  const handleChangeReferencesBulkClose = () => {
    seteReferencesBulkModel(false);
    setReferencesBulkData({
      reference: [
        {
          reference_code: "",
          condition_id: 1,
          type_id: 2,
          brand: "",
          manufacter: "",
        },
      ],
    });
  };

  const handleInputChangeRefBulk = (e, index) => {
    const { name, value } = e.target;
    const updatedReferences = [...referencesBulkData.reference];
    updatedReferences[index][name] = value;
    setReferencesBulkData({ reference: updatedReferences });
  };

  // Handle Select changes
  const handleSelectChangeRefBulk = (index, field, selectedOption) => {
    const updatedReferences = [...referencesBulkData.reference];
    updatedReferences[index][field] = selectedOption
      ? selectedOption.value
      : null;
    setReferencesBulkData({ reference: updatedReferences });
  };

  // Add new reference entry
  const addReferenceuBulk = () => {
    const codes = referencesBulkData.reference.map((item) =>
      item.reference_code.trim().toLowerCase(),
    );

    const hasDuplicate = new Set(codes).size !== codes.length;

    if (hasDuplicate) {
      toast.error(t("pi_toast_ref_already_added"));
      return;
    }

    setReferencesBulkData((prev) => ({
      reference: [
        ...prev.reference,
        {
          reference_code: "",
          condition_id: 1,
          type_id: 2,
          brand: "",
          manufacter: "",
        },
      ],
    }));
  };

  const removeReferenceBulk = (index) => {
    const updatedReferences = referencesBulkData.reference.filter(
      (_, i) => i !== index,
    );
    setReferencesBulkData({ reference: updatedReferences });
  };

  const handleReferenceBulkSubmit = (e) => {
    e.preventDefault();

    if (referencesBulkData.reference.length === 0) {
      toast.error(t("pi_toast_please_add_one_reference"));
      return;
    }

    // Passed validation
    setReferencesBulkLoader(true);
    let data = {
      part_ids: catalogModalStateRefDataList?.length
        ? catalogModalStateRefDataList.map((item) => item.id)
        : catalogModalStateDataList?.map((item) => item.id) || [],

      reference: referencesBulkData?.reference,
    };
    updateBulkPartInventoryReference(data)
      .then((response) => {
        toast.success(response.data.message);
        seteReferencesBulkModel(false);
        setReferencesBulkLoader(false);
        setReferencesBulkData({
          reference: [
            {
              reference_code: "",
              condition_id: 1,
              type_id: 2,
              brand: "",
              manufacter: "",
            },
          ],
        });
        if (catalogModalStateDataList?.length > 0) {
          setModalStateHistory(true);
          if (selectedHistoryItem) {
            const refreshData = {
              search: "",
              limit: 10,
              page: 1,
              part_catalog_id: selectedHistoryItem.id,
              vehicle_model_id: selectedHistoryItem.vehicle_model,
            };

            getCatalogModalStatsHistoryDetails(refreshData)
              .then((response) => {
                setCatalogModalStateDataList(response.data.data);
                setModalStateHistory(true); // reopen modal
              })
              .catch((err) => {
                toast.error(Utils.getErrorMessage(err));
              });
          }
        }
        if (catalogModalStateRefDataList?.length > 0) {
          setModalStateRefHistory(false);
        }
      })
      .catch((err) => {
        setReferencesBulkLoader(false);
        toast.error(err.message);
      });
  };

  const handleRowPriceBulkCheck = (e) => {
    const { name, checked } = e.target;

    setPriceBulkData((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  const isAllChecked =
    priceBulkData.price_1_check &&
    priceBulkData.price_2_check &&
    priceBulkData.cost_price_check;

  const handleSelectPriceBulkAll = () => {
    const allChecked =
      priceBulkData.price_1_check &&
      priceBulkData.price_2_check &&
      priceBulkData.cost_price_check;

    const newValue = !allChecked; // toggle

    setPriceBulkData((prev) => ({
      ...prev,
      price_1_check: newValue,
      price_2_check: newValue,
      cost_price_check: newValue,

      // If unchecking
      price_1: newValue ? prev.price_1 : "",
      price_2: newValue ? prev.price_2 : "",
      part_cost_price: newValue ? prev.part_cost_price : "",
    }));
  };

  const handleChangePriceBulk = (e) => {
    const { name, value } = e.target;

    setPriceBulkData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangePriceBulkClose = () => {
    setPriceBulkModel(false);
    setPriceBulkData({
      price_1: "",
      price_1_check: false,
      price_2: "",
      price_2_check: false,
      part_cost_price: "",
      cost_price_check: false,
    });
  };

  const handleChangePriceBulkOpen = () => {
    setPriceBulkModel(true);

    if (catalogModalStateDataList?.length > 0) {
      setModalStateHistory(false);
    }
    if (catalogModalStateRefDataList?.length > 0) {
      setModalStateRefHistory(false);
    }
  };

  const handlePriceBulkSubmit = (e) => {
    e.preventDefault();
    const isAnyChecked =
      priceBulkData.price_1_check ||
      priceBulkData.price_2_check ||
      priceBulkData.cost_price_check;

    if (!isAnyChecked) {
      toast.error(t("pi_toast_please_check_one_price"));
      return;
    }

    // check if checked fields have a value
    if (
      (priceBulkData.price_1_check && !priceBulkData.price_1) ||
      (priceBulkData.price_2_check && !priceBulkData.price_2) ||
      (priceBulkData.cost_price_check && !priceBulkData.part_cost_price)
    ) {
      toast.error(t("pi_toast_please_enter_price_all_checked"));
      return;
    }

    // Passed validation
    setPriceBulkLoader(true);
    let data = {
      part_ids: catalogModalStateRefDataList?.length
        ? catalogModalStateRefDataList.map((item) => item.id)
        : catalogModalStateDataList?.map((item) => item.id) || [],
      price_1: priceBulkData?.price_1,
      price_1_check: priceBulkData?.price_1_check,
      price_2: priceBulkData?.price_2,
      price_2_check: priceBulkData?.price_2_check,
      part_cost_price: priceBulkData?.part_cost_price,
      cost_price_check: priceBulkData?.cost_price_check,
    };
    updateBulkPartInventoryPrice(data)
      .then((response) => {
        toast.success(response.data.message);
        setPriceBulkModel(false);
        setPriceBulkLoader(false);
        setPriceBulkData({
          price_1: "",
          price_1_check: false,
          price_2: "",
          price_2_check: false,
          part_cost_price: "",
          cost_price_check: false,
        });
        if (catalogModalStateDataList?.length > 0) {
          setModalStateHistory(true);
          if (selectedHistoryItem) {
            const refreshData = {
              search: "",
              limit: 10,
              page: 1,
              part_catalog_id: selectedHistoryItem.id,
              vehicle_model_id: selectedHistoryItem.vehicle_model,
            };

            getCatalogModalStatsHistoryDetails(refreshData)
              .then((response) => {
                setCatalogModalStateDataList(response.data.data);
                setModalStateHistory(true); // reopen modal
              })
              .catch((err) => {
                toast.error(Utils.getErrorMessage(err));
              });
          }
        }
        if (catalogModalStateRefDataList?.length > 0) {
          setModalStateRefHistory(false);
        }
      })
      .catch((err) => {
        setPriceBulkLoader(false);
        toast.error(err.message);
      });
  };

  useEffect(() => {
    const allChecked =
      priceBulkData.price_1_check &&
      priceBulkData.price_2_check &&
      priceBulkData.cost_price_check; // add all your checks here

    if (
      allChecked &&
      priceBulkData.price_1 &&
      settingDetails?.discount_percentage
    ) {
      const discount = settingDetails.discount_percentage / 100;

      const calculatedPrice2 = priceBulkData.price_1 * (1 - discount);

      setPriceBulkData((prev) => ({
        ...prev,
        price_2: calculatedPrice2.toFixed(2),
      }));
    }
  }, [
    priceBulkData.price_1,
    priceBulkData.price_1_check,
    priceBulkData.price_2_check,
    priceBulkData.cost_price_check,
    settingDetails?.discount_percentage,
  ]);

  const customStyles = {
    option: (provided, state) => {
      const isSelectedId =
        Number(state.data.id) === Number(categoryPartsData?.vehicle_id);
      return {
        ...provided,
        backgroundColor: isSelectedId ? "blue" : provided.backgroundColor,
        color: isSelectedId ? "white" : provided.color,
      };
    },
  };

  const handleSubmitAssoicateVehicle = () => {
    if (categoryPartsData?.vehicle_id) {
      let data = {
        part_catelog: vehicleAddDetails?.part_catelog,
        vehicle_id: categoryPartsData?.vehicle_id,
      };
      getCheckVehicleAssociatePart(data)
        .then((response) => {
          toast.success(response.data.message);
          setModifyAssoicate(false);
        })
        .catch((err) => {
          toast.error(err.message);
        });
    }
  };

  const handleSubmitAssoicateVehicleClose = () => {
    setModifyAssoicate(false);
  };

  const handleSubmitAssoicateVehicleConfirm = () => {
    setModifyAssoicateConfirm(true);
  };

  const handleSubmitAssoicateVehicleOpen = (e, part) => {
    // setAssociateVehicleId(part);
    setModifyAssoicate(true);
  };

  const handleSubmitAssocYesVehicleConfirm = () => {
    // setAssociateVehicleId(vehicleAddDetails.vehicle_id);
    setModifyAssoicate(true);
    setModifyAssoicateConfirm(false);
  };

  const handleSubmitAssocRemoveVehicle = () => {
    // setAssociateVehicleId(0);

    setCategoryPartsData((prev) => ({
      ...prev,
      vehicle_id: 0,
      vehicle_year: "",
      vehicle_make: "",
      vehicle_model: "",
      vehicle_variant: "",
      is_master_id: "",
      vehicle_make_name: "",
      vehicle_model_name: "",
      vehicle_variant_name: "",
      vehicle_type: "",
      vehicle_type_name: "",
      part_catalog_name: "",
    }));

    toast.success(t("pi_toast_assign_vehicle_removed"));
    setModifyAssoicateConfirm(false);
  };

  useEffect(() => {
    let data = {
      limit: tableLengthList[0],
      page: 1,
      search: "",
      is_reload: false,
    };
    getwarHouseEntityList(data)
      .then((response) => {
        setEntityList(response.data.data);
      })
      .catch((err) => {
        toast.error(err.message);
      });
  }, []);

  const handleSelectChangeLocation = (e, part) => {
    const value = Number(e.target.value);

    setSelectedEntities((prev) => ({
      ...prev,

      location_ids: value,
    }));

    setPartsData((prev) =>
      prev.map((p) =>
        p.tempId === part.id ? { ...p, location_ids: value } : p,
      ),
    );
  };

  const renderOptions = (nodes, level = 0) => {
    return nodes?.map((node) => {
      if (node.children && node.children.length > 0) {
        return (
          <>
            <optgroup
              label={"\u00A0\u00A0".repeat(level) + node.warehouse_name}
              key={node.id}
            />
            {renderOptions(node.children, level + 1)}
          </>
        );
      } else {
        return (
          <option value={node.id} key={node.id}>
            {"\u00A0\u00A0".repeat(level) + node.warehouse_name}
          </option>
        );
      }
    });
  };

  const handleCheckboxChangeImage = (rowKey, imgUrl, isChecked) => {
    setSelectedImages((prev) => {
      const filtered = prev.filter((item) => item.rowKey !== rowKey);

      if (isChecked) {
        return [...filtered, { rowKey, imgUrl }];
      } else {
        return filtered;
      }
    });
  };

  const toggleRowLive = (part) => {
    setOpenPriceRows((prev) => ({
      ...prev,
      [part.number]: !prev[part.number],
    }));

    const obj = {
      catalogId: selectedPart?.parts_catalog_id,
      code: part?.id,
      status: 1,
    };

    getPartByPrice(obj)
      .then((response) => {
        const dataWithStatus = response.data.data;

        setPartPriceData((prev) => ({
          ...prev,
          [part.number]: dataWithStatus,
        }));
        setLoadingTreeCar(false);
      })
      .catch((err) => {
        setLoadingTreeCar(false);

        toast.error(Utils.getErrorMessage(err));
      })
      .finally(() => {
        setLoadingTreeCar(false);
      });
  };

  const handleRadioChangePrice = (price, idx) => {
    setSelectedPrice(price); // store only the priceOption object

    setPartsData((prevParts) =>
      prevParts.map((part, index) =>
        index === idx ? { ...part, part_price: price } : part,
      ),
    );
  };

  const toggleOpen = (index, partData) => {
    setOpenIndexes((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
    setSelectedPart(partData);
  };

  const handleChangePartClose = () => {
    setChangePartModal(false);
  };

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "vehicle_parts_checklist_action",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setPartCheckListStatusList(list);
      })
      .catch((err) => {});
  }, []);

  const handleUpdatePartCheckStatus = (pIndex, rowIndex, key, value, item) => {
    setPartsData((prev) =>
      prev.map((part, index) => {
        if (index !== pIndex) return part;

        let list = part.catalog_part_check_list || [];

        if (!list[rowIndex]) {
          list = [
            ...list,
            {
              [key]: value,
              item: item,
            },
          ];
        } else {
          list = list.map((row, idx) => {
            if (idx !== rowIndex) return row;
            return {
              ...row,
              [key]: value,
              part_catalog_id: item?.part_catalog_id,
              part_check_list_id: item?.id,
            };
          });
        }

        return {
          ...part,
          catalog_part_check_list: list,
        };
      }),
    );
  };

  useEffect(() => {
    if (selectedPart) {
      let obj = {
        // catalogId: selectedPart?.group_id,
        // carId: selectedPart?.car_id,
        // groupId: selectedPart?.group_id,
        // status: 1,
        catalogId: "seat",
        carId: "794297dd50385375598c176aeea6e07a",
        groupId:
          "MiPwn5qAOTUxMjDwn5qBMjM4OTUxMjAw8J-agjE4NzE1OfCfkIk5NTEyMDIzODIzODk1MTIwMA",
        status: 1,
      };
      getPartByGroup(obj)
        .then((response) => {
          setPartByGroup(response.data.data);
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        });
    }
  }, [selectedPart]);

  useEffect(() => {
    const savedData = localStorage.getItem("partFormData");
    if (savedData) {
      const parsedData = JSON.parse(savedData);
      setAutoFillData(parsedData);
    }
  }, []);

  // Seed do estado do lote da peça (modo edit) a partir de vehicleAddDetails.
  // /part-inventory-details devolve lot_id, lot_name e lot_internal_id.
  useEffect(() => {
    if (vehicleAddDetails?.id) {
      setPartLotInfo({
        lot_id: vehicleAddDetails.lot_id || null,
        lot_name: vehicleAddDetails.lot_name || "",
        lot_internal_id: vehicleAddDetails.lot_internal_id || "",
      });
    }
  }, [
    vehicleAddDetails?.id,
    vehicleAddDetails?.lot_id,
    vehicleAddDetails?.lot_name,
    vehicleAddDetails?.lot_internal_id,
  ]);

  // ---- Handlers do _LotInlineEditor ----
  const openLotEditModal = () => {
    setLotEditModalOpen(true);
    setLotEditSearch("");
    setLotEditLoading(true);
    getLotsActiveList({ limit: 200, page: 1, search: "" })
      .then((res) => {
        const data = res?.data?.data ?? [];
        setLotEditList(Array.isArray(data) ? data : []);
        setLotEditLoading(false);
      })
      .catch(() => {
        setLotEditList([]);
        setLotEditLoading(false);
      });
  };

  const filteredLotEditList = (lotEditList || []).filter((l) => {
    const q = (lotEditSearch || "").trim().toLowerCase();
    if (!q) return true;
    const intern = String(l?.lot_internal_id || "").toLowerCase();
    const nm = String(l?.name || "").toLowerCase();
    return intern.includes(q) || nm.includes(q);
  });

  const submitPartLotChange = (newLotId, newLotName, newLotInternal) => {
    if (!vehicleAddDetails?.uuid) {
      toast.error(t("error", { defaultValue: "Erro" }));
      return;
    }
    setLotEditSaving(true);
    const payload = { uuid: vehicleAddDetails.uuid };
    if (newLotId !== null && newLotId !== undefined) {
      payload.lot_id = newLotId;
    }
    updatePartLot(payload)
      .then((res) => {
        toast.success(
          res?.data?.message ||
            t("part_lot_updated", { defaultValue: "Lote actualizado" })
        );
        setPartLotInfo({
          lot_id: newLotId || null,
          lot_name: newLotId ? newLotName || "" : "",
          lot_internal_id: newLotId ? newLotInternal || "" : "",
        });
        setLotEditSaving(false);
        setLotEditModalOpen(false);
      })
      .catch((err) => {
        setLotEditSaving(false);
        toast.error(Utils.getErrorMessage(err));
      });
  };

  useEffect(() => {
    if (autoFillData?.temp_id) {
      let data = {
        part_list: "",
        temp_id: autoFillData?.temp_id,
      };

      getPartAutoTempList(data)
        .then((response) => {
          setCurrentStep(2);
          setAutoMainFillData(response.data.data);
          setSelectedItems(response.data.data.part_list?.part_list);
          setPartAttributesList(response.data.part_inventory_attribute);

          localStorage.removeItem("partFormData");

          // toast.success(response.data.message);
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        });
    }
  }, [autoFillData]);

  const toggleShowAll = (index) => {
    const updated = [...showAllList];
    updated[index] = !updated[index];
    setShowAllList(updated);
  };

  const toggleShowTypeAll = (index) => {
    const updated = [...showAlTypeList];
    updated[index] = !updated[index];
    setShowAllTypeList(updated);
  };

  const handlePartCatalogModelOpen = (e, part, index) => {
    const hasNoCatalogParts = partsData?.some(
      (p) => !p.catalog_part_list || p.catalog_part_list.length === 0,
    );

    if (hasNoCatalogParts) {
      toast.error(t("pi_toast_vehicle_no_vin_decode"));
      return;
    }

    setSelectedPartCatalogForPopup(index);
    setPartCatalogModal(true);
  };

  const handlePartCatalogModelClose = () => {
    setPartCatalogModal(false);
  };

  const handlePriceClose = () => {
    setpriceModal(false);
  };

  const handleSubmitSchemaByGroup = (e, item) => {
    e.preventDefault();

    const obj = {
      catalogId: carVinData?.catalog,
      carId: item.car_id,
      groupId: item?.group_uid,
      partNameIds: "",
      status: 2,
    };

    setLoadingTreeCar(true);

    getSchemaByGroup(obj)
      .then((response) => {
        const dataWithStatus = response.data.data.map((item) => ({
          ...item,
          status: 2,
        }));
        setSchemaByGroupLocalData(dataWithStatus);
        setKey("interactive_diagram_selection");
        setShowTab2(true);
        setShowTabInteractive(true);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      })
      .finally(() => {
        setLoadingTreeCar(false);
      });
  };

  const handleSubmitPartByGroup = (e, item) => {
    e.preventDefault();
    const obj = {
      catalogId: carVinData?.catalog_id,
      carId: item.car_id,
      groupId: item?.group_id,
      status: 2,
    };

    setMainPartData(item);

    // const obj = {
    //   catalogId: "seat",
    //   carId: "1ce118e147075167c57c7980449d3327",
    //   groupId:
    //     "MiPwn5qAOTUxMjDwn5qBMjM4OTUxMjAw8J-agjE1NDg1NfCfkIk5NTEyMDIzODIzODk1MTIwMA",
    //   status: 2, //live 1 ,2= local
    // };

    setLoadingTreeCar(true);

    getPartByGroup(obj)
      .then((response) => {
        const dataWithStatus = response.data.data.map((item) => ({
          ...item,
          status: 2,
        }));
        setPartByGroupLocalData(dataWithStatus);
        setShowTabInteractive(true);
        setShowTab3(true);
        setShowTab2(true);
        setKey("part_selection");
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      })
      .finally(() => {
        setLoadingTreeCar(false);
      });
  };

  const toggleRowLocal = (item) => {
    setCodeData(item);

    if (item) {
      const obj = {
        catalogId: carVinData?.catalog,
        code: item,
        status: 2,
      };

      getPartByPrice(obj)
        .then((response) => {
          const dataWithStatus = response.data.data.map((item) => ({
            ...item,
            status: 1,
          }));
          setPartPriceLocalData(dataWithStatus);
          setpriceModal(true);
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        })
        .finally(() => {
          setLoadingTreeCar(false);
        });
    }
  };

  const handleCarVinModalClose = () => {
    setModalCarVin(false);
    setKey("car_type_selection");
    setShowTab3(false);
    setShowTabInteractive(false);
  };

  const getFieldPermission = (attribute_name) => {
    const attrArray =
      vehicleAddDetails?.id &&
      vehicleAddDetails?.part_inventory_attribute?.attribute_array
        ? vehicleAddDetails.part_inventory_attribute.attribute_array
        : partAttributesList?.attribute_array;

    if (!attrArray || attrArray.length === 0) {
      return { show: true, editable: true }; // default if nothing present
    }

    const attr = attrArray.find((item) => item.column_name === attribute_name);

    if (!attr) {
      return { show: false, editable: false };
    }

    return {
      show: attr.is_view === 1,
      editable: attr.is_edit === 1,
    };
  };

  const getFieldBehavior = (item) => {
    return {
      shouldShow: item.is_view === 1,
      isEditable: item.is_edit === 1,
      isRequired: item.is_required === "1" || item.is_required === 1,
    };
  };

  const getAttributeValue = (part, attributeId) => {
    return (
      part.parts_attribute?.find(
        (attr) => attr.attribute_id === attributeId.toString(),
      )?.attribute_value || ""
    );
  };

  const handleGenericAttributeInputChange = (e, attributeId, partTempId) => {
    const value = e.target.value;

    setPartsData((prevData) =>
      prevData.map((part) => {
        if (part.tempId !== partTempId) return part;

        const updatedAttrs = [...(part.parts_attribute || [])];
        const idx = updatedAttrs.findIndex(
          (a) => a.attribute_id === attributeId.toString(),
        );

        if (idx !== -1) {
          updatedAttrs[idx].attribute_value = value;
          updatedAttrs[idx].attribute_option_id = null;
        } else {
          updatedAttrs.push({
            attribute_id: attributeId.toString(),
            attribute_option_id: null,
            attribute_value: value,
          });
        }

        return {
          ...part,
          parts_attribute: updatedAttrs,
        };
      }),
    );
  };

  const handleAttributeSelectChange = (
    selectedOption,
    attributeId,
    partTempId,
  ) => {
    const value = selectedOption?.value;

    setPartsData((prevData) =>
      prevData.map((part) => {
        if (part.tempId !== partTempId) return part;

        const updatedAttrs = [...(part.parts_attribute || [])];
        const idx = updatedAttrs.findIndex(
          (a) => a.attribute_id === attributeId.toString(),
        );

        if (idx !== -1) {
          updatedAttrs[idx].attribute_value = selectedOption?.label;
          updatedAttrs[idx].attribute_option_id = value;
        } else {
          updatedAttrs.push({
            attribute_id: attributeId.toString(),
            attribute_option_id: value,
            attribute_value: selectedOption?.label,
          });
        }

        return {
          ...part,
          parts_attribute: updatedAttrs,
        };
      }),
    );
  };

  const handleAttributeCheckboxChange = (e, attributeId, partTempId) => {
    const value = e.target.checked ? "1" : "0";

    setPartsData((prevData) =>
      prevData.map((part) => {
        if (part.tempId !== partTempId) return part;

        const updatedAttrs = [...(part.parts_attribute || [])];
        const idx = updatedAttrs.findIndex(
          (a) => a.attribute_id === attributeId.toString(),
        );

        if (idx !== -1) {
          updatedAttrs[idx].attribute_value = value;
          updatedAttrs[idx].attribute_option_id = null;
        } else {
          updatedAttrs.push({
            attribute_id: attributeId.toString(),
            attribute_option_id: null,
            attribute_value: value,
          });
        }

        return {
          ...part,
          parts_attribute: updatedAttrs,
        };
      }),
    );
  };

  const defaultAssociateLocation =
    settingCompanyDetails?.associate_location ?? 0;

  const vehicleCompatiblesList =
    vehicleCompatibleProductList?.length > 0
      ? vehicleCompatibleProductList
      : structureOemList?.decode?.vehiclesCompatibles || [];

  const handleProductDetailsModalClose = () => {
    setModifyProductModal(false);
  };

  const handleProductConfirmClose = () => {
    setModifyConfirmModal(false);
  };

  const handleOpenProductConfirm = () => {
    if (selectedVehicleData?.iem_list?.length === 0) {
      toast.error(t("please_select_at_least_one_product"));
      return;
    }
    setModifyConfirmModal(true);
  };

  const handleCompatibleCheck = (variantID) => {
    const isSelected = selectedVehicleData?.vehicle_compatible_list?.some(
      (item) => item.variantID === variantID,
    );

    const selectedItem = vehicleCompatiblesList.find(
      (item) => item.variantID === variantID,
    );

    if (!selectedItem) return;

    setSelectedVehicleData((prev) => {
      const currentList = prev?.vehicle_compatible_list || [];

      return {
        ...prev,
        vehicle_compatible_list: isSelected
          ? currentList.filter((item) => item.variantID !== variantID)
          : [...currentList, selectedItem],
      };
    });
  };

  const handleCompatibleCheckAll = () => {
    const list = vehicleCompatiblesList || [];

    setSelectedVehicleData((prev) => ({
      ...prev,
      vehicle_compatible_list:
        prev.vehicle_compatible_list?.length === list?.length ? [] : [...list],
    }));
  };

  const handleCheckVehicle = (productID) => {
    const isSelected = selectedVehicleData?.iem_list?.some(
      (item) => item.productID === productID,
    );
    const selectedItem = structureOemList?.decode?.equivalentsIAM.find(
      (item) => item.productID === productID,
    );
    setSelectedVehicleData((prev) => {
      const currentList = prev?.iem_list || [];
      return {
        ...prev,
        iem_list: isSelected
          ? currentList.filter((item) => item.productID !== productID)
          : [...currentList, selectedItem],
      };
    });
  };

  const handleCheckAll = () => {
    const list = structureOemList?.decode?.equivalentsIAM || [];

    setSelectedVehicleData((prev) => ({
      ...prev,
      iem_list: prev.iem_list?.length === list?.length ? [] : [...list],
    }));
  };

  const handleCheckOEM = (index) => {
    const list = structureOemList?.decode?.equivalentsOEM || [];
    const selectedItem = list[index];

    if (!selectedItem) return;

    const isSelected = selectedOEMIndices.includes(index);

    const updatedIndices = isSelected
      ? selectedOEMIndices.filter((i) => i !== index)
      : [...selectedOEMIndices, index];

    setSelectedOEMIndices(updatedIndices);

    setSelectedVehicleData((prev) => {
      const updatedList = isSelected
        ? prev.oem_list.filter((_, idx) => idx !== index)
        : [...prev.oem_list, selectedItem];

      return {
        ...prev,
        oem_list: updatedList,
      };
    });
  };

  const handleCheckAllOEM = () => {
    const list = structureOemList?.decode?.equivalentsOEM || [];

    const allIndices = list.map((_, i) => i);
    const isAllSelected = selectedOEMIndices.length === list.length;

    setSelectedOEMIndices(isAllSelected ? [] : allIndices);

    setSelectedVehicleData((prev) => ({
      ...prev,
      oem_list: isAllSelected ? [] : [...list],
    }));
  };
  const handleChangeOemRefClose = () => {
    setModifyOemModal(false);
    setSelectedVehicleData({
      iem_list: [],
      oem_list: [],
      vehicle_compatible_list: [],
    });
    setSelectedOEMIndices([]);
  };

  const handleOpenPartRefHistory = async (e, item) => {
    if (!item?.addedData?.length) {
      toast.error(t("pi_toast_no_reference_codes_found"));
      return;
    }

    for (const ref of item.addedData) {
      try {
        const response = await getPartsByReference({
          search: "",
          limit: 10,
          page: 1,
          reference_code: ref.reference_code,
          data_type: "list",
        });

        setCatalogModalStateRefDataList(response.data.data);
        setModalStateRefHistory(true);
      } catch (err) {
        console.error(`Error fetching for ${ref.reference_code}`, err);
        toast.error(Utils.getErrorMessage(err));
        return;
      }
    }
  };

  const handleOpenPartRefHistoryEdit = async (e, item) => {
    try {
      const response = await getPartsByReference({
        search: "",
        limit: 10,
        page: 1,
        reference_code: item,
        data_type: "list",
      });

      setCatalogModalStateRefDataList(response.data.data);
      setModalStateRefHistory(true);
    } catch (err) {
      toast.error(Utils.getErrorMessage(err));
      return;
    }
  };
  const handleClosePartRefHistory = () => {
    setModalStateRefHistory(false);
  };

  const handleSelectRef = () => {
    const iemMapped =
      selectedVehicleData?.iem_list?.map((item) => ({
        reference_code: item.reference,
        condition_id_ref: 2,
        type_id: 1,
        is_main: 0,
        productID: item.productID,
        brand: item?.brandName,
        manufacter: item?.manufacter,
      })) || [];

    const oemMapped =
      selectedVehicleData?.oem_list?.map((item) => ({
        reference_code: item.reference,
        condition_id_ref: 1,
        type_id: 1,
        is_main: 0,
        brand: item?.brandName,
        manufacter: item?.manufacter,
      })) || [];

    const mergedRefs = [...iemMapped, ...oemMapped];

    const partIndex = 0;

    setPartsData((prev) => {
      const updated = [...prev];
      const existing = updated[partIndex].addedData || [];

      const newRefs = mergedRefs.filter(
        (newItem) =>
          !existing.some(
            (existingItem) =>
              existingItem.reference_code === newItem.reference_code,
          ),
      );

      updated[partIndex] = {
        ...updated[partIndex],
        addedData: [...existing, ...newRefs],
      };

      return updated;
    });

    const vehicleMapped =
      selectedVehicleData?.vehicle_compatible_list?.map((item) => ({
        ...item,
      })) || [];

    const newUniqueVehicles = vehicleMapped?.filter(
      (item) =>
        !vehicleSelectedComDataList?.some(
          (existing) => existing.variantID === item.variantID,
        ),
    );

    setVehicleSelectedComDataList((prev) => [...prev, ...newUniqueVehicles]);

    setModifyOemModal(false);

    setSelectedVehicleData({
      iem_list: [],
      oem_list: [],
      vehicle_compatible_list: [],
    });
    setSelectedOEMIndices([]);
  };

  useEffect(
    function () {
      if (vehicleSelectedComDataList?.length > 0) {
        const vehicleSelectedData = vehicleSelectedComDataList?.map((item) => ({
          variantID: item.variantID,
          modelId: item.modelId,
        }));

        const obj = {
          variants: vehicleSelectedData,
        };
        getVehicleCompatibleDetails(obj)
          .then((response) => {
            setVehicleComDataList(response.data.data);
          })
          .catch((err) => {});
      }
    },
    [vehicleSelectedComDataList],
  );

  useEffect(() => {
    if (vehicleComDataList?.length > 0) {
      const partIndex = 0;

      const mappedVehicleData = vehicleComDataList?.map((item) => ({
        vehicle_type_name: item.vehicle_type_description,
        vehicle_year: item.initial_year,
        make_name: item.vehicle_make_description,
        model_name: item.vehicle_model_description,
        variant_name: item.vehicle_variant_description,
        vehicle_type: item.vehicle_type_id,
        make_id: item.make_id,
        model_id: item.model_id,
        vehicle_variant: item.variant_id,
        notes: "",
      }));

      setPartsData((prev) => {
        const updated = [...prev];
        const existing = updated[partIndex]?.parts_associate || [];

        const newUniqueVehicles = mappedVehicleData.filter(
          (newItem) =>
            !existing.some(
              (existingItem) =>
                existingItem.vehicle_variant === newItem.vehicle_variant,
            ),
        );

        updated[partIndex] = {
          ...updated[partIndex],
          parts_associate: [...existing, ...newUniqueVehicles],
        };

        return updated;
      });
    }
  }, [vehicleComDataList]);

  useEffect(
    function () {
      if (productVehicleId?.productID) {
        const obj = {
          productID: productVehicleId?.productID,
          language: LangData ? LangData : "PT",
          country: profileDetails?.company_details?.state,
          regNumberCompany:
            profileDetails?.company_details?.company_registration_number,
        };
        getvehicleProductDetails(obj)
          .then((response) => {
            setVehicleCompatibleProductDetails(response.data.data);
          })
          .catch((err) => {});
      }
    },
    [productVehicleId],
  );

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const handleChangeNotesOpen = (e, part, index) => {
    setSelectedPartIndex(index);
    setModifyNotes(true);
  };

  const handleChangeNotesClose = () => {
    setModifyNotes(false);
    setSelectedPartIndex(null);
  };

  const handleInputNotesChangePartList = (e, index) => {
    const { name, value } = e.target;
    setPartsData((prev) => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        [name]: value,
      };
      return updated;
    });
  };
  const handleSubmitAsLabelPrint = (e) => {
    e.preventDefault();

    setBtnLoader(true);
    const vehiclePartID = partsData?.map((item) => item.id) || [];

    // Template-aware endpoint (see migration note in AddForParts.js).
    Promise.all(
      vehiclePartID.map((id) => printPartLabel({ part_id: id })),
    )
      .then((responses) => {
        const msg = responses?.[0]?.data?.message;
        if (msg) toast.success(tConst(msg, t));
        setCurrentStep(3);
      })
      .catch((err) => {
        setBtnLoader(false);
        toast.error(Utils.getErrorMessage(err));
      });
  };

  const handleInputChangeComp = (e) => {
    const { name, value } = e.target;
    setVehiclePartsComData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(
    function () {
      if (categoryPartsData?.vehicle_type) {
        var obj = {
          search: categoryPartsData?.part_catalog_name
            ? categoryPartsData?.part_catalog_name
            : "",
          limit: tableLengthList[0],
          page: 1,
          vehicle_type_id: categoryPartsData?.vehicle_type
            ? categoryPartsData?.vehicle_type
            : "",
        };

        getCatalogList(obj)
          .then((response) => {
            response = response.data;
            let list = [];
            for (let i = 0; i < response.data.length; i++) {
              list.push({
                value: response.data[i].id,
                label: response.data[i].namePartPT,
                is_master_part: response.data[i].is_master_part,
                part_list: response.data[i].part_list,
              });
            }
            setCategoryPartList(list);
          })
          .catch((err) => {});
      }
    },
    [categoryPartsData?.vehicle_type, categoryPartsData?.part_catalog_name],
  );

  const handleInputSelectedChangeCategoryList = (inputSelctedValue) => {
    setInputSelctedValue(inputSelctedValue);

    if (inputSelctedValue.length > 0) {
      const obj = {
        search: inputSelctedValue
          ? inputSelctedValue
          : categoryPartsData?.part_catalog_name,
        limit: tableLengthList[0],
        page: 1,
        vehicle_type_id: categoryPartsData?.vehicle_type
          ? categoryPartsData?.vehicle_type
          : "",
      };

      getCatalogList(obj)
        .then((response) => {
          response = response.data;

          let list = [];
          for (let i = 0; i < response.data.length; i++) {
            list.push({
              value: response.data[i].id,
              label: response.data[i].namePartPT,
              is_master_part: response.data[i].is_master_part,
              part_list: response.data[i].part_list,
            });
          }
          setCategoryPartList(list);
        })
        .catch((err) => {});
    }
  };
  const handleSelectWithoutChangeCategoryList = (option) => {
    setCategoryPartsData((prev) => ({
      ...prev,
      catalog_id: option.value,
    }));

    const existingCatalogId = vehicleAddDetails?.part_catalog_id;

    if (existingCatalogId && existingCatalogId === option.value) {
      setPartsData((prev) => [
        {
          ...prev[0],
          catalog_part_check_list:
            vehicleAddDetails?.parts_checklist_item || [],
        },
      ]);

      setPartCheckList(vehicleAddDetails?.parts_checklist_item || []);

      setCategoryMasterPart(option);
      return;
    }

    let obj = { part_catalog_id: option.value };

    getPartCatalogChecklistItems(obj)
      .then((response) => {
        const newList = response.data.data;

        setPartCheckList(newList);

        setPartsData((prev) => [
          {
            ...prev[0],
            catalog_part_check_list: newList,
          },
        ]);
      })
      .catch((err) => {});

    setCategoryMasterPart(option);
  };

  useEffect(
    function () {
      const obj = {
        search: "",
        limit: 20,
        page: 1,
      };
      getAllVehicleSerachType(obj)
        .then((response) => {
          response = response.data;

          let list = [];
          for (let i = 0; i < response.data.length; i++) {
            list.push({
              value: response.data[i].id,
              label: response.data[i].description,
            });
          }
          setVehicleTypePartList(list);
        })
        .catch((err) => {});
    },
    [categoryPartsData],
  );

  const handleInputSelectedChangeVehicleTypeList = (inputSelctedTypeValue) => {
    setInputSelctedTypeValue(inputSelctedTypeValue);

    const obj = {
      search: inputSelctedTypeValue,
      limit: 20,
      page: 1,
    };

    getAllVehicleSerachType(obj)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].vehicle_type_name,
          });
        }
        setVehicleTypePartList(list);
      })
      .catch((err) => {});
  };

  useEffect(function () {
    var obj = {
      search: "",
      limit: 20,
      page: 1,
    };

    getvehicleYearList(obj)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i],
            label: response.data[i],
          });
        }
        setvehicleYearPartList(list);
      })
      .catch((err) => {});
  }, []);

  const handleInputSelectedChangeYearList = (inputSelctedYearValue) => {
    setInputSelctedYearValue(inputSelctedYearValue);

    const obj = {
      search: inputSelctedYearValue,
      limit: 20,
      page: 1,
    };

    getvehicleYearList(obj)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i],
            label: response.data[i],
          });
        }
        setvehicleYearPartList(list);
      })
      .catch((err) => {});
  };

  const handleSelectWithoutChangeYearList = (option) => {
    setCategoryPartsData((prevData) => ({
      ...prevData,
      vehicle_year: option.value,
      vehicle_make: "",
      vehicle_model: "",
      vehicle_variant: "",
    }));
    setvehicleMakePartList([]);
    setvehicleModalPartList([]);
    setvehicleVariantPartList([]);
  };

  const handleSelectWithoutChangeTypeList = (option) => {
    setCategoryPartsData((prevData) => ({
      ...prevData,
      vehicle_type: option.value,
      vehicle_make: "",
      vehicle_model: "",
      vehicle_variant: "",
      vehicle_year: "",
    }));
    setvehicleMakePartList([]);
    setvehicleModalPartList([]);
    setvehicleVariantPartList([]);
    setVehicleYearList([]);
  };

  useEffect(
    function () {
      if (categoryPartsData?.vehicle_year) {
        var obj = {
          search: categoryPartsData?.vehicle_make_name
            ? categoryPartsData?.vehicle_make_name
            : "",
          limit: 20,
          page: 1,
          year: categoryPartsData?.vehicle_year,
          vehicle_type_id: categoryPartsData?.vehicle_type,
        };

        getvehicleMakeAllList(obj)
          .then((response) => {
            response = response.data;
            let list = [];
            for (let i = 0; i < response.data.length; i++) {
              list.push({
                value: response.data[i].id,
                label: response.data[i].description,
              });
            }
            setvehicleMakePartList(list);
          })
          .catch((err) => {});
      }
    },

    [categoryPartsData?.vehicle_year],
  );

  const handleInputSelectedChangeMakeList = (inputSelctedMakeValue) => {
    setInputSelctedMakeValue(inputSelctedMakeValue);

    if (inputSelctedMakeValue.length > 0) {
      const obj = {
        search: inputSelctedMakeValue,
        limit: 20,
        page: 1,
        year: categoryPartsData?.vehicle_year,
        vehicle_type_id: categoryPartsData?.vehicle_type,
      };

      getvehicleMakeAllList(obj)
        .then((response) => {
          response = response.data;
          let list = [];
          for (let i = 0; i < response.data.length; i++) {
            list.push({
              value: response.data[i].id,
              label: response.data[i].description,
            });
          }
          setvehicleMakePartList(list);
        })
        .catch((err) => {});
    }
  };

  const handleSelectWithoutChangeMakeList = (option) => {
    setCategoryPartsData((prevData) => ({
      ...prevData,
      vehicle_make: option.value,
      vehicle_make_name: option.label,
      vehicle_model: "",
      vehicle_variant: "",
    }));

    setvehicleModalPartList([]);
    setvehicleVariantPartList([]);
  };

  useEffect(
    function () {
      if (categoryPartsData?.vehicle_make) {
        var obj = {
          search: categoryPartsData?.vehicle_model_name
            ? categoryPartsData?.vehicle_model_name
            : "",
          limit: 20,
          page: 1,
          vehicle_year: categoryPartsData?.vehicle_year,
          make_id: categoryPartsData?.vehicle_make,
          vehicle_type_id: categoryPartsData?.vehicle_type,
        };

        getVehicleAllModalSerachList(obj)
          .then((response) => {
            response = response.data;
            let list = [];
            for (let i = 0; i < response.data.length; i++) {
              list.push({
                value: response.data[i].id,
                label: response.data[i].description,
              });
            }
            setvehicleModalPartList(list);
          })
          .catch((err) => {});
      }
    },
    [categoryPartsData?.vehicle_make],
  );

  const handleInputSelectedChangeModelList = (inputSelctedModalValue) => {
    setInputSelctedModalValue(inputSelctedModalValue);

    if (inputSelctedModalValue.length > 0) {
      const obj = {
        search: inputSelctedModalValue,
        limit: 20,
        page: 1,
        vehicle_year: categoryPartsData?.vehicle_year,
        make_id: categoryPartsData?.vehicle_make,
        vehicle_type_id: categoryPartsData?.vehicle_type,
      };

      getVehicleAllModalSerachList(obj)
        .then((response) => {
          response = response.data;
          let list = [];
          for (let i = 0; i < response.data.length; i++) {
            list.push({
              value: response.data[i].id,
              label: response.data[i].model_name,
            });
          }
          setvehicleModalPartList(list);
        })
        .catch((err) => {});
    }
  };

  const handleSelectWithoutChangeModelList = (option) => {
    setCategoryPartsData((prevData) => ({
      ...prevData,
      vehicle_model: option.value,
      vehicle_model_name: option.label,
      vehicle_variant: "",
    }));
    setvehicleVariantPartList([]);
  };

  useEffect(
    function () {
      if (categoryPartsData?.vehicle_model) {
        var obj = {
          search: categoryPartsData?.vehicle_variant_name
            ? categoryPartsData?.vehicle_variant_name
            : "",
          limit: 20,
          page: 1,
          vehicle_year: categoryPartsData?.vehicle_year,
          model_id: categoryPartsData?.vehicle_model,
          vehicle_type_id: categoryPartsData?.vehicle_type,
        };

        getVehicleSerachVariantList(obj)
          .then((response) => {
            response = response.data;
            let list = [];
            for (let i = 0; i < response.data.length; i++) {
              list.push({
                value: response.data[i].id,
                label: response.data[i].variants_name,
              });
            }
            setvehicleVariantPartList(list);
          })
          .catch((err) => {});
      }
    },
    [categoryPartsData?.vehicle_model],
  );

  const handleInputSelectedChangeVariantList = (inputSelctedVariantValue) => {
    setInputSelctedVariantValue(inputSelctedVariantValue);

    if (inputSelctedVariantValue.length > 0) {
      const obj = {
        serach: inputSelctedVariantValue,
        limit: 20,
        page: 1,
        vehicle_year: categoryPartsData?.vehicle_year,
        model_id: categoryPartsData?.vehicle_model,
        vehicle_type_id: categoryPartsData?.vehicle_type,
      };

      getVehicleSerachVariantList(obj)
        .then((response) => {
          response = response.data;
          let list = [];
          for (let i = 0; i < response.data.length; i++) {
            list.push({
              value: response.data[i].id,
              label: response.data[i].variants_name,
            });
          }
          setvehicleVariantPartList(list);
        })
        .catch((err) => {});
    }
  };

  const handleSelectWithoutChangeVariantList = (option) => {
    setCategoryPartsData((prevData) => ({
      ...prevData,
      vehicle_variant: option.value,
      vehicle_variant_name: option.label,
    }));
  };

  const handleVehicleChange = (selectedOption) => {
    setSelectedVehicle(selectedOption || null);
    setVehiclePartsComData((prevData) => ({
      ...prevData,
      vehicle_type: selectedOption ? selectedOption.value : "",
      vehicle_make: "",
      vehicle_model: "",
      vehicle_variants: "",
    }));
    setVehicleMakeList([]);
    setVehicleModalList([]);
    setVehicleVariantList([]);
  };

  const handleChangeCompatibleOpen = (e, part, index) => {
    setSelectedPartForPopup(index);
    setModalCompatible(true);
  };

  const handleChangeCompatibleClose = () => {
    setModalCompatible(false);
  };

  const handleAddCompatible = (index) => {
    if (!selectedVehicle) {
      toast.error(t("pi_toast_please_select_type"));
      return;
    }

    if (!vehiclePartsComData.vehicle_year) {
      toast.error(t("pi_toast_please_select_year"));
      return;
    }

    if (!vehiclePartsComData.vehicle_make) {
      toast.error(t("pi_toast_please_select_make"));
      return;
    }

    const updatedPartsData = [...partsData];

    if (!updatedPartsData[index]) {
      console.error("Part does not exist at the given index");
      return;
    }

    if (!updatedPartsData[index].parts_associate) {
      updatedPartsData[index].parts_associate = [];
    }

    const vehicle_type = selectedVehicle;
    const vehicle_year = VehicleYearList.find(
      (item) => item.value === vehiclePartsComData.vehicle_year,
    );
    const vehicle_make = VehicleMakeList.find(
      (item) => item.value === vehiclePartsComData.vehicle_make,
    );
    const vehicle_model = VehicleModalList.find(
      (item) => item.value === vehiclePartsComData.vehicle_model,
    );
    const vehicle_variant = VehicleVariantList.find(
      (item) => item.value === vehiclePartsComData.vehicle_variant,
    );

    if (vehicle_type && vehicle_make && vehicle_model && vehicle_year) {
      const getValueOrZero = (val) => {
        return val === "all" || val === "All" ? 0 : val;
      };

      const backendItem = {
        vehicle_type: getValueOrZero(vehicle_type?.value),
        vehicle_type_name: getValueOrZero(vehicle_type?.label),

        vehicle_year: getValueOrZero(vehicle_year?.value),
        vehicle_year_name: getValueOrZero(vehicle_year?.label),

        make_id: getValueOrZero(vehicle_make?.value),
        make_name: getValueOrZero(vehicle_make?.label),

        model_id: getValueOrZero(vehicle_model?.value),
        model_name: getValueOrZero(vehicle_model?.label),

        vehicle_variant: getValueOrZero(vehicle_variant?.value),
        variant_name: getValueOrZero(vehicle_variant?.label),

        notes: vehiclePartsComData.notes || "",
      };

      const updatedPartsData = [...partsData];

      if (!updatedPartsData[index]) {
        console.error("Part does not exist at the given index");
        return;
      }

      if (!updatedPartsData[index].hasOwnProperty("parts_associate")) {
        updatedPartsData[index].parts_associate = [];
      }

      updatedPartsData[index].parts_associate.push(backendItem);
      setPartsData(updatedPartsData);

      setSelectedVehicle(null);
      setVehiclePartsComData({
        vehicle_make: "",
        vehicle_year: "",
        vehicle_model: "",
        vehicle_variant: "",
        vehicle_parts_id: "",
        vehicle_type: "",
        notes: "",
      });

      setVehicleYearList([]);
      setVehicleMakeList([]);
      setVehicleModalList([]);
      setVehicleVariantList([]);
      setInputSelctedYearValue(null);
    }
  };

  const handleRemoveCompatible = (partIndex, itemIndex) => {
    const updatedPartsData = [...partsData];

    if (
      updatedPartsData[partIndex] &&
      updatedPartsData[partIndex].parts_associate &&
      updatedPartsData[partIndex].parts_associate.length > itemIndex
    ) {
      updatedPartsData[partIndex].parts_associate.splice(itemIndex, 1);
      setPartsData(updatedPartsData);
    } else {
      console.warn("Invalid indices for removal");
    }
  };
  const handleTextChange = (index, value) => {
    setUpdatedTexts((prev) => ({
      ...prev,
      [index]: value,
    }));

    if (selectedRows[index]) {
      const condition = selectedConditions[index];
      const referenceType = selectedReferenceType[index];
      if (condition && referenceType) {
        const updatedItem = {
          text: value,
          condition_id: condition.value,
          condition_label: condition.label,
          ref_type_id: referenceType.value,
          ref_type_label: referenceType.label,
        };

        setSelectedData((prevData) => {
          const filtered = prevData.filter((_, i) => i !== index);
          return [...filtered, updatedItem];
        });
      }
    }
  };

  useEffect(() => {
    const initialConditions = {};
    const initialReferenceTypes = {};

    refReadData.forEach((_, i) => {
      const condition = conditionList.find(
        (item) => item.value === settingCompanyDetails?.reference_condition,
      );

      const refType = referenceList.find(
        (item) => item.value === settingCompanyDetails?.reference_type,
      );

      if (condition) {
        initialConditions[i] = condition;
      }

      if (refType) {
        initialReferenceTypes[i] = refType;
      }
    });

    setSelectedConditions(initialConditions);
    setSelectedReferenceType(initialReferenceTypes);
  }, [refReadData, settingCompanyDetails, conditionList, referenceList]);

  const handleCheckboxChangeRow = (checked, catalogItem) => {
    setPartsData((prev) =>
      prev.map((part) => {
        const updatedAddedData = checked
          ? part.addedData?.some((p) => p.reference_code === catalogItem.id)
            ? part.addedData
            : [
                ...(part.addedData || []),
                {
                  reference_code: catalogItem.id,
                  type_id: 2,
                  condition_id_ref: 1,
                  is_main: 0,
                  selectedCondition: null,
                  selectedType: null,
                  count: "0",
                },
              ]
          : (part.addedData || []).filter(
              (p) =>
                p.reference_code !==
                (catalogItem.reference_code || catalogItem.id.toString()),
            );

        return { ...part, addedData: updatedAddedData };
      }),
    );
  };

  const handleCheckboxChange = (index) => {
    setSelectedRows((prev) => {
      const newSelectedRows = { ...prev, [index]: !prev[index] };

      const condition = selectedConditions[index];
      const referenceType = selectedReferenceType[index];
      const item = refReadData[index];
      const editedText =
        updatedTexts[index] !== undefined ? updatedTexts[index] : item.text;
      const editedBrand =
        updatedData[index] !== undefined ? updatedData[index] : item.brand;
      const editedManufacture =
        updatedData[index] !== undefined ? updatedData[index] : item.manufacter;

      if (!condition) {
        toast.error(t("pi_toast_please_select_condition"));
        return prev;
      }

      if (newSelectedRows[index] && condition) {
        const isDuplicate = selectedData.some(
          (d) =>
            d.text.trim().toLowerCase() === editedText.trim().toLowerCase(),
        );

        if (isDuplicate) {
          toast.error(`${editedText} reference code — already added!`);
          return prev;
        }
        const newEntry = {
          text: editedText,
          condition_id: condition?.value,
          condition_label: condition?.label,
          ref_type_id: referenceType?.value,
          ref_type_label: referenceType?.label,
          brand: editedBrand?.brand,
          manufacter: editedManufacture?.manufacturer,
        };

        setSelectedData((prevData) => {
          const filtered = prevData.filter((d) => d.text !== editedText);
          return [...filtered, newEntry];
        });
      } else {
        setSelectedData((prevData) =>
          prevData.filter(
            (d) =>
              d.text !==
              (updatedTexts[index] !== undefined
                ? updatedTexts[index]
                : item.text),
          ),
        );
      }

      return newSelectedRows;
    });
  };

  const handleBrandChange = (index, value) => {
    setUpdatedData((prev) => ({
      ...prev,
      [index]: {
        ...prev[index],
        brand: value,
      },
    }));
  };

  const handleManufacturerChange = (index, value) => {
    setUpdatedData((prev) => ({
      ...prev,
      [index]: {
        ...prev[index],
        manufacturer: value,
      },
    }));
  };

  const handleConditionChangeOcr = (index, selectedOption) => {
    setSelectedConditions((prev) => ({
      ...prev,
      [index]: selectedOption,
    }));

    if (selectedRowsRef[index]) {
      const item = refReadData[index];
      setSelectedData((prevData) => [
        ...prevData.filter((d) => d.text !== item.text),
        {
          text: item.text,
          condition_id: selectedOption.value,
          condition_label: selectedOption.label,
        },
      ]);
    }
  };

  const handleReferenceChangeOcr = (index, selectedOption) => {
    setSelectedReferenceType((prev) => ({
      ...prev,
      [index]: selectedOption,
    }));

    if (selectedRowsRef[index]) {
      const item = refReadData[index];
      setSelectedData((prevData) => [
        ...prevData.filter((d) => d.text !== item.text),
        {
          text: item.text,

          ref_type_id: selectedOption.value,
          ref_type_label: selectedOption.label,
        },
      ]);
    }
  };

  const handleChangeOCROpen = () => {
    setModalOcrRef(true);
  };

  const handleChangeOCRClose = () => {
    setModalOcrRef(false);
  };

  useEffect(function () {
    const obj = {
      search: "",
      limit: 20,
      page: 1,
    };
    getVehicleFuelAllList(obj)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].fuel_type,
          });
        }
        setVehicleFuelList(list);
      })
      .catch((err) => {});
  }, []);

  const handleInputSelectedChangeVehicleFuelList = (inputSelctedFuelValue) => {
    setInputSelctedFuelValue(inputSelctedFuelValue);

    if (inputSelctedFuelValue.length > 0) {
      const obj = {
        search: inputSelctedFuelValue,
        limit: 20,
        page: 1,
      };

      getVehicleFuelAllList(obj)
        .then((response) => {
          response = response.data;
          let list = [];
          for (let i = 0; i < response.data.length; i++) {
            list.push({
              value: response.data[i].id,
              label: response.data[i].fuel_type,
            });
          }
          setVehicleFuelList(list);
        })
        .catch((err) => {});
    }
  };

  useEffect(function () {
    getAllVehicleSerachType()
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].vehicle_type_name,
          });
        }
        setVehicleTypeList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(() => {
    // If Make is selected but Model is not
    if (
      vehiclePartsComData?.vehicle_make &&
      !vehiclePartsComData.vehicle_model &&
      VehicleModalList.find((item) => item.value === "all")
    ) {
      setVehiclePartsComData((prev) => ({
        ...prev,
        vehicle_model: "all",
      }));
    }

    // If Make & Model are selected but Variant is not
    if (
      vehiclePartsComData?.vehicle_make &&
      vehiclePartsComData?.vehicle_model &&
      !vehiclePartsComData.vehicle_variant &&
      VehicleVariantList.find((item) => item.value === "all")
    ) {
      setVehiclePartsComData((prev) => ({
        ...prev,
        vehicle_variant: "all",
      }));
    }
  }, [
    vehiclePartsComData?.vehicle_make,
    vehiclePartsComData?.vehicle_model,
    VehicleModalList,
    VehicleVariantList,
  ]);

  useEffect(function () {
    let data = {
      limit: 20,
      page: params.page,
      search: "",
      is_reload: true,
    };
    getvehicleYearList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i],
            label: response.data[i],
          });
        }
        setVehicleYearList(list);
      })
      .catch((err) => {});
  }, []);

  const handleInputSelectedChangeComYearList = (inputSelctedeYearValue) => {
    setinputSelctedeYearValue(inputSelctedeYearValue);
    const obj = {
      search: inputSelctedeYearValue,
      limit: 20,
      page: 1,
    };

    getvehicleYearList(obj)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i],
            label: response.data[i],
          });
        }
        setVehicleYearList(list);
      })
      .catch((err) => {});
  };

  useEffect(
    function () {
      if (vehiclePartsComData?.vehicle_type) {
        let data = {
          limit: 20,
          page: params.page,
          search: vehiclePartsComData?.vehicle_make_name
            ? vehiclePartsComData?.vehicle_make_name
            : "",
          vehicle_type_id: vehiclePartsComData?.vehicle_type,
          year: vehiclePartsComData?.vehicle_year,
          is_reload: true,
        };
        getvehicleMakeAllList(data)
          .then((response) => {
            response = response.data;
            let list = [];
            for (let i = 0; i < response.data.length; i++) {
              list.push({
                value: response.data[i]?.id,
                label: response.data[i]?.description,
              });
            }
            setVehicleMakeList(list);
          })
          .catch((err) => {});
      }
    },
    [vehiclePartsComData],
  );

  const handleInputSelectedChangeComMakeList = (inputSelctedeMakeValue) => {
    setInputSelctedeMakeValue(inputSelctedeMakeValue);
    const obj = {
      limit: 20,
      page: params.page,
      search: inputSelctedeMakeValue
        ? inputSelctedeMakeValue
        : vehiclePartsComData?.vehicle_make_name,
      vehicle_type_id: vehiclePartsComData?.vehicle_type,
      year: vehiclePartsComData?.vehicle_year,

      is_reload: true,
    };

    getvehicleMakeAllList(obj)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i]?.id,
            label: response.data[i]?.description,
          });
        }
        setVehicleMakeList(list);
      })
      .catch((err) => {});
  };

  useEffect(
    function () {
      if (vehiclePartsComData?.vehicle_make) {
        let data = {
          limit: 20,
          page: params.page,
          search: "",
          vehicle_year: vehiclePartsComData?.vehicle_year,

          make_id: vehiclePartsComData?.vehicle_make,
          vehicle_type_id: vehiclePartsComData?.vehicle_type,

          is_reload: true,
        };

        getVehicleAllModalSerachList(data)
          .then((response) => {
            response = response.data;

            let list = [
              { value: "all", label: "All" },
              ...response.data.map((item) => ({
                value: item.id,
                label: item.model_name,
              })),
            ];
            setVehicleModalList(list);
          })
          .catch((err) => {});
      }
    },
    [vehiclePartsComData],
  );

  const handleInputSelectedChangeModalList = (inputSelctedeModalValue) => {
    setInputSelctedeModalValue(inputSelctedeModalValue);
    if (inputSelctedeModalValue.length > 0) {
      const obj = {
        limit: 20,
        page: params.page,
        search: inputSelctedeModalValue,
        make_id: vehiclePartsComData?.make_id,
        vehicle_type_id: vehiclePartsComData?.vehicle_type,
        vehicle_year: vehiclePartsComData?.vehicle_year,
        is_reload: true,
      };

      getVehicleAllModalSerachList(obj)
        .then((response) => {
          response = response.data;
          let list = [
            { value: "all", label: "All" },
            ...response.data.map((item) => ({
              value: item.id,
              label: item.variants_name,
            })),
          ];
          setVehicleVariantList(list);
        })
        .catch((err) => {});
    }
  };

  useEffect(
    function () {
      if (vehiclePartsComData?.vehicle_model) {
        let data = {
          limit: 20,
          page: params.page,
          search: "",
          model_id:
            vehiclePartsComData.vehicle_model === "all"
              ? 0
              : vehiclePartsComData.vehicle_model,
          vehicle_type_id: vehiclePartsComData?.vehicle_type,
          vehicle_year: vehiclePartsComData?.vehicle_year,

          is_reload: true,
        };
        getVehicleSerachVariantList(data)
          .then((response) => {
            response = response.data;
            let list = [];
            for (let i = 0; i < response.data.length; i++) {
              list.push({
                value: response.data[i]?.id,
                label: response.data[i]?.variants_name,
              });
            }
            list.unshift({ value: "all", label: "All" });

            setVehicleVariantList(list);
          })
          .catch((err) => {});
      }
    },
    [vehiclePartsComData],
  );

  const handleInputSelectedChangeComVariantList = (
    inputSelctededVariantValue,
  ) => {
    setInputSelctededVariantValue(inputSelctededVariantValue);
    if (inputSelctededVariantValue.length > 0) {
      const obj = {
        limit: 20,
        page: params.page,
        search: inputSelctededVariantValue,
        model_id: vehiclePartsComData.vehicle_model,
        vehicle_type_id: vehiclePartsComData?.vehicle_type,
        vehicle_year: vehiclePartsComData?.vehicle_year,

        is_reload: true,
      };

      getVehicleSerachVariantList(obj)
        .then((response) => {
          response = response.data;
          let list = [];
          for (let i = 0; i < response.data.length; i++) {
            list.push({
              value: response.data[i]?.id,
              label: response.data[i]?.variants_name,
            });
          }
          setVehicleVariantList(list);
        })
        .catch((err) => {});
    }
  };

  useEffect(() => {
    if (!selectedData.length) return;

    const partIndexToUpdate = 0;

    setPartsData((prevParts) =>
      prevParts.map((part, idx) => {
        if (idx !== partIndexToUpdate) return part;

        const newEntries = selectedData.filter(
          (item) =>
            !part?.addedData?.some(
              (existing) => existing.reference_code === item.text,
            ),
        );

        const mapped = newEntries.map((item, index) => ({
          reference_code: item.text,
          type_id: item.ref_type_id,
          is_main: 0,
          condition_id_ref: item.condition_id,
          selectedCondition: {
            label: item.condition_label,
            value: item.condition_id,
          },
          selectedType: {
            label: item.ref_type_label,
            value: item.ref_type_id,
          },
          manufacter: item.manufacter,
          brand: item.brand,
        }));

        return {
          ...part,
          addedData: [...(part.addedData || []), ...mapped],
        };
      }),
    );

    // setSelectedData([]);
  }, [selectedData]);

  const handleSubmitOCRRef = async () => {
    let error = false;
    let errorObjImport = { ...errorsObjImport };

    if (!file) {
      errorObjImport.file = `File is required.`;
      error = true;
    }

    setErrorsImport(errorObjImport);
    if (error) return;

    setLoading(true); // Start loader

    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await createOCRreferenceRead(formData);
      const data = response.data.data;
      setRefReadData(data);
      // toast.success("Data saved successfully!");
      // setModalOcrRef(false);
    } catch (err) {
      toast.error(Utils.getErrorMessage(err));
    } finally {
      setLoading(false); // Stop loader
    }
  };

  const onImageLoad = (img) => {
    imgRef.current = img;
  };

  const onImageClick = (e) => {
    const { offsetX, offsetY } = e.nativeEvent;
    const newHighlight = {
      x: offsetX,
      y: offsetY,
      radius: 20,
      color: selectedColor,
    };

    setHighlights([...highlights, newHighlight]);
  };

  const handleCrop = () => {
    setIsCropping(!isCropping);
  };

  const saveDrawing = async (fileId) => {
    setIsDrawing((prev) => !prev);
  };

  // const handleImageSelect = (file) => {
  //   setImage((prevFiles) =>
  //     prevFiles.map((f) => (f.id === file.id ? { ...f } : f))
  //   );
  //   setSelectedImage(file);
  //   setCrop(null);
  //   setRotation(0);
  //   setHighlights([]);
  //   setIsModalOpen(true);
  // };

  const handleImageSelect = (file) => {
    if (file.file) {
      setImage((prevFiles) =>
        prevFiles.map((f) => (f.id === file.id ? { ...f } : f)),
      );
      setSelectedImage(file);
      setCrop(null);
      setRotation(0);
      setHighlights([]);
      setIsModalOpen(true);
    } else if (file.image_url && typeof file.image_url === "string") {
      // Safe to proceed with axios call
      axios({
        url: file.image_url,
        method: "GET",
        responseType: "blob",
      })
        .then((res) => {
          const myFile = new File([res.data], "image.png", {
            type: res.data.type,
          });

          let fileData = {
            ...file,
            url: URL.createObjectURL(myFile),
            file: myFile,
          };

          setImage((prevFiles) =>
            prevFiles.map((f) => (f.id === fileData.id ? fileData : f)),
          );
          setSelectedImage(fileData);
          setCrop(null);
          setRotation(0);
          setHighlights([]);
          setIsModalOpen(true);
        })
        .catch((err) => {
          console.error("Error fetching the file:", err);
        });
    } else {
      console.warn("Invalid image_url provided for file:", file);
    }
  };

  const getCroppedImage = async () => {
    if (!imgRef.current || !selectedImage) return;

    const image = imgRef.current;
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;

    let cropX = 0,
      cropY = 0,
      cropWidth = image.naturalWidth,
      cropHeight = image.naturalHeight;

    if (completedCrop) {
      cropX = completedCrop.x * scaleX;
      cropY = completedCrop.y * scaleY;
      cropWidth = completedCrop.width * scaleX;
      cropHeight = completedCrop.height * scaleY;
    }

    const radians = (rotation * Math.PI) / 180;
    canvas.width = cropWidth;
    canvas.height = cropHeight;

    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.save();

    ctx.translate(canvas.width / 2, canvas.height / 2);
    ctx.rotate(radians);
    ctx.translate(-canvas.width / 2, -canvas.height / 2);

    ctx.drawImage(
      image,
      cropX,
      cropY,
      cropWidth,
      cropHeight,
      0,
      0,
      cropWidth,
      cropHeight,
    );

    ctx.restore();

    // Overlay Drawing if available
    if (canvasRef.current) {
      try {
        const drawingDataURL = await canvasRef.current.exportImage("png");

        if (drawingDataURL) {
          const drawingImage = new Image();
          drawingImage.src = drawingDataURL;
          await new Promise((resolve) => (drawingImage.onload = resolve));

          ctx.drawImage(drawingImage, 0, 0, cropWidth, cropHeight);
        }
      } catch (error) {
        console.error("Error exporting drawing:", error);
      }
    }

    const editedImage = canvas.toDataURL("image/jpeg");

    // Update the image in the state
    setImage((prevFiles) =>
      prevFiles.map((file) =>
        file.id === selectedImage.id ? { ...file, url: editedImage } : file,
      ),
    );

    // Cleanup
    setSelectedImage(null);
    setIsModalOpen(false);
    setCompletedCrop(null);
    setHighlights([]);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const companyResponse = await getSettingsCompanyDetails();
        setSettingCompanyDetails(companyResponse.data.data);
      } catch (err) {
        console.error(err);
      }
    };

    fetchSettings();
  }, []);

  const handleRemoveBgImageeForm = async (fileId) => {
    const selectedImage = images.find((file) => file.id === fileId);

    if (!selectedImage) {
      toast.error(t("pi_toast_please_select_image_first"));
      return;
    }

    let fileData = selectedImage;

    if (selectedImage?.image_url) {
      try {
        const res = await axios({
          url: selectedImage?.image_url,
          method: "GET",
          responseType: "blob",
        });

        const myFile = new File([res.data], "image.png", {
          type: res.data.type,
        });

        fileData = {
          ...selectedImage,
          url: URL.createObjectURL(myFile),
          file: myFile,
        };
      } catch (err) {
        console.error("Error fetching the file:", err);
      }
    }

    const formData = new FormData();
    formData.append("file", fileData.file);

    setIsLoading(true);

    try {
      const response = await fetch(
        "https://images.tp.software/remove-bg/",
        {
          method: "POST",
          body: formData,
        },
      );

      let imageBlob;

      if (!response.ok) throw new Error("Failed to remove background");
      imageBlob = await response.blob();

      const imageUrl = URL.createObjectURL(imageBlob);
      setImage((prevFiles) =>
        prevFiles.map((file) =>
          file.id === fileId
            ? { ...file, url: imageUrl, file: imageBlob }
            : file,
        ),
      );

      toast.success(t("pi_toast_bg_removed_ok"));
      setSelectedImage({ url: imageUrl });
      setIsModalOpen(false);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const handleAddBgImageForm = async (fileId) => {
    const selectedImage = images.find((file) => file.id === fileId);

    let fileData = selectedImage;

    if (selectedImage?.image_url) {
      try {
        const res = await axios({
          url: selectedImage?.image_url,
          method: "GET",
          responseType: "blob",
        });

        const myFile = new File([res.data], "image.png", {
          type: res.data.type,
        });

        fileData = {
          ...selectedImage,
          url: URL.createObjectURL(myFile),
          file: myFile,
        };
      } catch (err) {
        console.error("Error fetching the file:", err);
      }
    }

    const proxyUrl = "https://api.allorigins.win/raw?url=";

    const response = await fetch(
      proxyUrl + encodeURIComponent(settingCompanyDetails?.default_image),
    );
    if (!response.ok) throw new Error("Default image is not available");

    const blob = await response.blob();
    const file = new File([blob], "background.jpg", { type: blob.type });

    if (!selectedImage) {
      toast.error(t("pi_toast_please_select_image_first"));
      return;
    }

    const formData = new FormData();
    formData.append("main_image", fileData?.file);
    formData.append("bg_image", file);

    setIsLoadings(true);

    try {
      const response = await fetch("https://images.tp.software/add-bg/", {
        method: "POST",
        body: formData,
      });

      if (!response.ok) throw new Error("Failed to remove background");

      const imageBlob = await response.blob();
      const imageUrl = URL.createObjectURL(imageBlob);
      setImage((prevFiles) =>
        prevFiles.map((file) =>
          file.id === fileId
            ? { ...file, url: imageUrl, file: imageBlob }
            : file,
        ),
      );

      toast.success(t("pi_toast_bg_added_ok"));
      setSelectedImage({ url: imageUrl });
      setIsModalOpen(false);
    } catch (error) {
    } finally {
      setIsLoadings(false);
    }
  };

  const handleAddBgColoreForm = async (fileId) => {
    const selectedImage = images.find((file) => file.id === fileId);

    if (!selectedImage) {
      toast.error(t("pi_toast_please_select_image_first"));
      return;
    }

    let fileData = selectedImage;

    if (selectedImage?.image_url) {
      try {
        const res = await axios({
          url: selectedImage?.image_url,
          method: "GET",
          responseType: "blob",
        });

        const myFile = new File([res.data], "image.png", {
          type: res.data.type,
        });

        fileData = {
          ...selectedImage,
          url: URL.createObjectURL(myFile),
          file: myFile,
        };
      } catch (err) {
        console.error("Error fetching the file:", err);
      }
    }

    const encodedColor = encodeURIComponent(
      settingCompanyDetails?.default_color,
    );

    const formData = new FormData();
    formData.append("main_image", fileData.file);

    setIsLoadingColor(true);

    try {
      const response = await fetch(
        `https://images.tp.software/add-bg-color/?hex_color=${encodedColor}`,
        {
          method: "POST",
          body: formData,
        },
      );

      if (!response.ok) throw new Error("Failed to add background color");

      const imageBlob = await response.blob();
      const imageUrl = URL.createObjectURL(imageBlob);
      setImage((prevFiles) =>
        prevFiles.map((file) =>
          file.id === fileId
            ? { ...file, url: imageUrl, file: imageBlob }
            : file,
        ),
      );

      toast.success(t("pi_toast_bg_color_added_ok"));
      setSelectedImage({ url: imageUrl });
      setIsModalOpen(false);
    } catch (error) {
      toast.error(error.message || "Something went wrong");
    } finally {
      setIsLoadingColor(false);
    }
  };

  const handleRotate = async (fileId) => {
    setRotation((prev) => (prev + 90) % 360);
  };

  const handleOpenRefCodeEstimate = (e, item) => {
    partsData?.forEach((part) => {
      const data = {
        regNumberCompany:
          profileDetails?.company_details?.company_registration_number,
        language: LangData ? LangData : "EN",

        references: part?.addedData?.map((item) => ({
          reference: item.reference_code,
          referenceType: item.condition_name
            ? item.condition_name
            : item.selectedCondition?.label,
        })),
      };

      getPartEstimatePriceDetails(data)
        .then((response) => {
          setEstimatePricDataRefList(response.data.data.stats);
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        });
    });
    setModalRefCodeEstimate(true);
  };

  const handleCloseRefCodeEstimate = () => {
    setModalRefCodeEstimate(false);
  };

  const handleOpenPartHistory = (e, item) => {
    setSelectedHistoryItem(item);
    const data = {
      search: "",
      limit: 10,
      page: 1,
      part_catalog_id: item?.id,
      vehicle_model_id: item?.vehicle_model,
    };

    getCatalogModalStatsHistoryDetails(data)
      .then((response) => {
        setCatalogModalStateDataList(response.data.data);
        setModalStateHistory(true);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  };

  const handleClosePartHistory = () => {
    setModalStateHistory(false);
  };

  const handleOpenSponsorPrice = (e, item) => {
    setSponsorPriceDataId(item);

    const data = {
      search: "",
      limit: 10,
      page: 1,
      part_catelog: item?.part_catalog_id,
      condition_id: settingDetails?.condition_id,
      state_id: settingDetails?.state_id,
      vehicle_model_id: item?.vehicle_model,
    };

    getPartStatiscalPriceDetails(data)
      .then((response) => {
        setSponsorPricDataList(response.data.data);
        setModalSponsorPrice(true);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  };

  const handleCloseSponsorPrice = () => {
    setModalSponsorPrice(false);
  };

  const handleOpenEstimatePrice = (e, item) => {
    setEstimatePriceDataId(item);
    partsData?.forEach((part) => {
      const data = {
        regNumberCompany:
          profileDetails?.company_details?.company_registration_number,
        partID: part.part_catalog_estimate_id,
        partDescription: part?.part_catalog_name ? part?.part_catalog_name : "",
        language: LangData ? LangData : "EN",
        ktype: part.k_type ? part.k_type : "",
        tecDocModel: part.tec_doc_model ? part.tec_doc_model : "",
        condition: part?.condition_name
          ? part?.condition_name
          : settingDetails?.condition_name,
        state: part?.state_name ? part?.state_name : settingDetails?.state_name,
        partMakeDescription: part?.vehicle_make_name
          ? part?.vehicle_make_name
          : "",
        references: part?.addedData?.map((item) => ({
          reference: item.reference_code,
          referenceType: item.condition_name
            ? item.condition_name
            : item.selectedCondition?.label,
        })),
        engineCode: part?.motor_code ? part.motor_code : "",
      };

      getPartEstimatePriceDetails(data)
        .then((response) => {
          setEstimatePricDataList(response.data.data);
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        });
    });

    setModalEstimatePrice(true);
  };

  const handleCloseEstimatePrice = () => {
    setModalEstimatePrice(false);
  };

  const handleOpenRefCodeCondition = (e, item) => {
    const refCodeConditionData = item?.addedData?.map((items) => ({
      ref_code: items?.reference_code,
      condition: items?.condition_id ?? items?.condition_id_ref ?? null,
    }));

    const requestData = {
      search: "",
      limit: 10,
      page: 1,
      refcode_condition: refCodeConditionData,
    };

    getPartRefcodeConditionDetails(requestData)
      .then((response) => {
        setRefCodeConditionDataList(response.data.data);
        setModalRefCodeCondition(true);
      })
      .catch((err) => toast.error(Utils.getErrorMessage(err)));
  };

  const handleCloseRefCodeCondition = () => {
    setModalRefCodeCondition(false);
  };

  const hasProcessedRef = useRef(false);

  useEffect(() => {
    if (currentStep === 3) {
      if (hasProcessedRef.current) return;

      if (!images?.length || !settingCompanyDetails?.edit_photo_type) return;

      hasProcessedRef.current = true;

      const type = settingCompanyDetails.edit_photo_type;

      images.forEach((file) => {
        if (type === 2) {
          handleRemoveBgImageeForm(file.id);
        } else if (type === 3) {
          handleAddBgColoreForm(file.id);
        } else if (type === 4) {
          handleAddBgImageForm(file.id);
        }
      });
    }
  }, [images, settingCompanyDetails, currentStep]);

  const handleRefClose = () => {
    setModifyDelteRef(false);
  };

  const handleDamageClose = () => {
    setModifyDelteDamage(false);
  };

  const handleRatingChange = (newRating, partId) => {
    setPartsData((prevParts) =>
      prevParts.map((part) =>
        part.tempId === partId ? { ...part, part_rating: newRating } : part,
      ),
    );
  };

  const handleCheckboxChangeMaster = (index, item) => {
    setSelectedItemsCheckBox((prevSelectedItems) => {
      if (prevSelectedItems.some((selected) => selected.index === index)) {
        return prevSelectedItems.filter((selected) => selected.index !== index);
      } else {
        return [...prevSelectedItems, { index, item }];
      }
    });
  };

  const handleSubmitAdd = () => {
    if (!selectedRows || Object.keys(selectedRows).length === 0) {
      console.error("selectedRows is null, undefined, or empty");
      return;
    }

    const selectedData = selectedItemsCheckBox?.map(({ item, index }) => ({
      catalog_id: item?.reference_id || "",
      vehicle_make: vehicleAddDetails?.vehicle_make || "",
      vehicle_year: vehicleAddDetails?.vehicle_year || "",
      vehicle_model: vehicleAddDetails?.vehicle_model || "",
      vehicle_variant: vehicleAddDetails?.variants_id || "",
      master_part_id: item?.parts_catalog_id || 0,
    }));

    const data = {
      temp_id: tempData?.temp_id || dismantleTempData?.temp_id || "",
      vehicle_id: 0,
      part_list: selectedData,
      is_add_for_vehicle: 1,
      allow_add_existing_parts_vehicle:
        settingCompanyDetails?.allow_add_existing_parts_vehicle
          ? settingCompanyDetails?.allow_add_existing_parts_vehicle
          : 0,
    };

    actionPartInventoryTempStore(data)
      .then((response) => {
        const data = response.data.data;
        // toast.success("Data saved successfully!");

        navigate("/parts-inventory-addparts", { state: { data } });
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  };

  useEffect(() => {
    if (catalogModalStateDataId) {
      const data = {
        search: "",
        limit: 10,
        page: 1,
        part_catalog_id: catalogModalStateDataId?.id,
        vehicle_model_id: catalogModalStateDataId?.vehicle_model,
      };

      getCatalogModalStatsHistoryDetails(data)
        .then((response) => {
          setCatalogModalStateDataList(response.data.data);
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        });
    }
  }, [catalogModalStateDataId]);

  useEffect(() => {
    if (sponsorPriceDataId) {
      const data = {
        search: "",
        limit: 10,
        page: 1,
        part_catelog: sponsorPriceDataId?.id,
        condition_id: settingDetails?.condition_id,
        state_id: settingDetails?.state_id,
      };

      getPartStatiscalPriceDetails(data)
        .then((response) => {
          setSponsorPricDataList(response.data.data);
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        });
    }
  }, [sponsorPriceDataId]);

  useEffect(() => {
    profileDetailForWeb()
      .then((response) => {
        setProfileDetails(response.data.data);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(() => {
    if (
      categoryMasterPart?.part_list &&
      selectedRows.length !== categoryMasterPart?.part_list.length
    ) {
      setSelectedRows(
        categoryMasterPart?.part_list?.map(() => ({
          vehicle_year: null,
          vehicle_make: null,
          vehicle_model: null,
          vehicle_variant: null,
        })),
      );
    }
  }, [categoryMasterPart?.part_list]);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "type_damage",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setTypeDamageList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "location_damage",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setLocationDamageList(list);
      })
      .catch((err) => {});
  }, []);

  const filteredData = vehicleAddDetails?.inventory_part_list?.filter(
    (inventoryItem) =>
      vehicleAddDetails?.part_list?.some(
        (partItem) => partItem?.reference_id === inventoryItem?.part_catalog_id,
      ),
  );
  const handlMasterVehicleNotOpen = () => {
    setModifyMasterVehicleNotPart(true);
  };

  const handlMasterVehicleNotClose = () => {
    setModifyMasterVehicleNotPart(false);
  };

  const handlMasterVehicleClose = () => {
    setModifyMasterVehiclePart(false);
  };

  const handlMasterVehicleOpen = () => {
    setModifyMasterVehiclePart(true);
  };

  const handleCheck = (itemId) => {
    setCheckedItems((prevState) => {
      if (prevState.includes(itemId)) {
        return prevState.filter((id) => id !== itemId);
      } else {
        return [...prevState, itemId];
      }
    });
  };

  const handleTempDismetalAddClick = (e) => {
    e.preventDefault();

    if (vehicleModalSelectedList?.id) {
      let data = {
        dismantle_id: dismentalData?.dismantle_id,
        temp_id: dismantleTempData?.temp_id || tempData?.temp_id || "",
        vehicle_id: vehicleModalSelectedList?.id,
      };

      actionTempStoreDismental(data)
        .then((response) => {
          setDismantleTempData(response.data.data);

          setDismentalData({
            dismantle_id: "",
          });

          setInputSelctedDismetalValue("");
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        });
    } else {
      toast.error(t("pi_toast_please_select_vehicle"));
    }
  };

  const handleSelectWithoutChangeDismetalList = (option) => {
    setDismentalData((prevData) => ({
      ...prevData,
      dismantle_id: option.value,
    }));
  };

  useEffect(function () {
    var obj = {
      search: "",
      limit: tableLengthList[0],
      page: 1,
    };

    getDismentalList(obj)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }
        setDismetalList(list);
      })
      .catch((err) => {});
  }, []);
  useEffect(
    function () {
      partsData?.map((item) => {
        const obj = {
          search: "",
          limit: 20,
          page: 1,
          model_id: parseInt(item?.vehicle_model),
          variants_id: parseInt(item?.variants_id),
        };

        getVehicleEngineSerachList(obj)
          .then((response) => {
            response = response.data;

            let list = [];
            for (let i = 0; i < response.data.length; i++) {
              list.push({
                value: response.data[i].id,
                label: response.data[i].motor_code,
                kw: response.data[i].kw,
                cv: response.data[i].hp,
                cc: response.data[i].cc,
              });
            }

            setvehicleEngineList(list);
          })
          .catch((err) => {
            console.error("Error fetching engine data", err);
          });
      });
    },
    [partsData],
  );

  const handleInputSelectedChangeEngineList = (inputSelctedEngineValue) => {
    setInputSelctedEngineValue(inputSelctedEngineValue);

    if (inputSelctedEngineValue.length > 0 && selectedItems?.length > 0) {
      selectedItems.map((item) => {
        const obj = {
          search: inputSelctedEngineValue,
          limit: 20,
          page: 1,
          model_id: parseInt(item?.vehicle_model),
          variants_id: parseInt(item?.variants_id),
        };

        getVehicleEngineSerachList(obj)
          .then((response) => {
            response = response.data;
            let list = [];
            for (let i = 0; i < response.data.length; i++) {
              list.push({
                value: response.data[i].id,
                label: response.data[i].motor_code,
                kw: response.data[i].kw,
                cv: response.data[i].hp,
                cc: response.data[i].cc,
              });
            }

            setvehicleEngineList(list);
          })
          .catch((err) => {
            console.error("Error fetching engine data", err);
          });
      });
    }
  };

  const handleInputSelectedChangeDismetalList = (inputSelctedDismetalValue) => {
    setInputSelctedDismetalValue(inputSelctedDismetalValue);

    if (inputSelctedDismetalValue.length > 0) {
      const obj = {
        search: inputSelctedDismetalValue,
        limit: tableLengthList[0],
        page: 1,
      };

      getDismentalList(obj)
        .then((response) => {
          response = response.data;
          let list = [];
          for (let i = 0; i < response.data.length; i++) {
            list.push({
              value: response.data[i].id,
              label: response.data[i].name,
            });
          }
          setDismetalList(list);
        })
        .catch((err) => {});
    }
  };

  const handleSelectWithoutChangeEngineList = (option) => {
    setEngineData((prevData) => ({
      ...prevData,
      engine_code: option.value,
      kw: option.kw,
      hp: option.hp,
      motor_code: option.label,
    }));
  };

  const handleRadioChange = (referenceCode) => {
    setSelectedReferenceCode(referenceCode);
  };

  const handleEtaiDetails = (event, etaiPartIds, index) => {
    event.preventDefault();
    setPartETAIRerList(etaiPartIds);
    setPartEtaiModify(true);
  };

  const handleEtaiPriceDetails = (event, etaiPartIds, index) => {
    event.preventDefault();
    setPartETAIPriceList(etaiPartIds);
    setPartEtaiPriceModify(true);
  };

  const handlePartEtaiClose = () => {
    setPartEtaiModify(false);
  };

  const handlePartEtaiPriceClose = () => {
    setPartEtaiPriceModify(false);
  };

  useEffect(() => {
    if (partETAIRerList) {
      const data = {
        etai_part_id: partETAIRerList,
      };

      partInvenoryPartETAI(data)
        .then((response) => {
          setPartETAIRefDetails(response.data.data);
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        });
    }
  }, [partETAIRerList]);

  useEffect(() => {
    if (partETAIPriceList) {
      const data = {
        etai_part_id: partETAIPriceList,
      };

      partInvenoryPartETAIPrice(data)
        .then((response) => {
          setPartETAIPriceDetail(response.data.data);
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        });
    }
  }, [partETAIPriceList]);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "reference",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setReferenceList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(() => {
    if (state?.state?.item) {
      setVehicleEngineId({
        vehicle_model_id: state?.state?.item?.vehicle_model_id,
        make_id: state?.state?.item?.make_id,
        vehicle_model_name: state?.state?.item?.vehicle_model,
        vehicle_process_end_date: state?.state?.item?.vehicle_process_end_date,
        id: state?.state?.item?.id,
        vehicle_in_inventory: state?.state?.item?.vehicle_in_inventory,
        variants_id: state?.state?.item?.variants_id,
        vehicle_make_name: state?.state?.vehicle_make_name,
        registration_plate: state?.state?.registration_plate,
        registration: state?.state?.registration,
      });
      setVehicleEngineAuto(state?.state?.item?.vehicle_model);
    }
  }, [state]);

  const excludeIds = vehicleExceedData?.parts?.map((x) =>
    parseInt(x.part_catelog, 10),
  );

  const filteredCatalogList = CatalogList?.data?.filter((item) => {
    const id = parseInt(item?.id, 10);

    if (settingCompanyDetails?.allow_add_existing_parts_vehicle === 1) {
      return true;
    }

    return !excludeIds?.includes(id);
  });

  const handleSkip = () => {
    setCurrentPartIndex((prevIndex) => prevIndex + 1);
    setShowSkip(false);
  };

  const handleOpenSkip = () => {
    setShowSkip(true);
  };

  const handleCloseSkip = () => {
    setShowSkip(false);
  };

  useEffect(() => {
    if (state?.state?.params?.photos) {
      setImage(state?.state?.params?.photos);
      const previewUrls = state?.state?.params?.photos?.map((img) => img);
      SetPreviewUrl(previewUrls);
    }
  }, [state?.state?.params?.photos]);

  useEffect(() => {
    if (selectedImages) {
      setImage(selectedImages);
      const previewUrls = selectedImages?.map((img) => img?.imgUrl);
      SetPreviewUrl(previewUrls);
    }
  }, [selectedImages]);

  //   const handleFinish = () => {

  //  if (!state?.state?.params?.photos && (!images || images?.length === 0)) {
  //       toast.error(t("pi_toast_please_upload_at_least_one_image"));
  //       return;
  //     }

  //     const hasNewImages = images?.some((item) => item.file instanceof File);

  //     const formData = new FormData();
  //     if (state?.state?.params?.photos) {
  //       fetch(state.state.params.photos)
  //         .then((res) => res.blob())
  //         .then((blobData) => {
  //           const filename = "image.png";
  //           const fileType = blobData.type || "image/png";

  //           const myFile = new File([blobData], filename, { type: fileType });

  //           formData.append("files", myFile, filename);
  //           formData.append("part_id", currentPart?.id);

  //           setBtnImageLoading(true);
  //           actionPartInventoryImage(formData)
  //             .then((response) => {
  //               toast.success(response.data.message);
  //               setPartImageDataList(response.data.data);

  //               setImage([]);
  //               SetPreviewUrl([]);
  //               if (partsData?.some((part) => part?.parts_damage.length > 0)) {
  //                 setCurrentStep(4);
  //               } else {
  //                 setCurrentStep(5);
  //               }
  //             })
  //             .catch((err) => {
  //               toast.dismiss();

  //               toast.error(Utils.getErrorMessage(err));
  //             })
  //             .finally(() => {
  //               setBtnImageLoading(false); // ⬅️ Stop loader
  //             });
  //         })
  //         .catch((err) => {
  //           console.error("Error converting blob URL:", err);
  //         });
  //     } else if (selectedImages) {
  //       fetch(selectedImages)
  //         .then((res) => res.blob())
  //         .then((blobData) => {
  //           const filename = "image.png";
  //           const fileType = blobData.type || "image/png";

  //           const myFile = new File([blobData], filename, { type: fileType });

  //           formData.append("files", myFile, filename);
  //           formData.append("part_id", currentPart?.id || vehicleAddDetails?.id);

  //           setBtnImageLoading(true);
  //           actionPartInventoryImage(formData)
  //             .then((response) => {
  //               toast.success(response.data.message);
  //               setPartImageDataList(response.data.data);

  //               setImage([]);
  //               SetPreviewUrl([]);
  //               if (partsData?.some((part) => part?.parts_damage.length > 0)) {
  //                 setCurrentStep(4);
  //               } else {
  //                 setCurrentStep(5);
  //               }
  //               setBtnImageLoading(false);
  //             })
  //             .catch((err) => {
  //               setBtnImageLoading(false);
  //               toast.dismiss();
  //               toast.error(Utils.getErrorMessage(err));
  //             })
  //             .finally(() => {
  //               setBtnImageLoading(false); // ⬅️ Stop loader
  //             });
  //         })
  //         .catch((err) => {
  //           console.error("Error converting blob URL:", err);
  //         });
  //     } else if (!hasNewImages) {
  //       setCurrentStep(5);
  //     } else if (vehicleAddDetails?.id) {
  //       formData.append("part_id", vehicleAddDetails?.id);
  //       images.forEach((item) => {
  //         if (item.file instanceof File) {
  //           formData.append("files", item.file);
  //         } else {
  //           console.error("Invalid file object:", item.file);
  //         }
  //       });

  //       setBtnImageLoading(true);
  //       actionPartInventoryImage(formData)
  //         .then((response) => {
  //           toast.success(response.data.message);
  //           setPartImageDataList(response.data.data);

  //           setImage([]);
  //           SetPreviewUrl([]);
  //           if (partsData?.some((part) => part?.parts_damage.length > 0)) {
  //             setCurrentStep(4);
  //           } else {
  //             setCurrentStep(5);
  //           }
  //         })
  //         .catch((err) => {
  //           toast.dismiss();

  //           toast.error(Utils.getErrorMessage(err));
  //         })
  //         .finally(() => {
  //           setBtnImageLoading(false); // ⬅️ Stop loader
  //         });
  //     }
  //     // } else {
  //     //   const formData = new FormData();
  //     //   formData.append("part_id", currentPart?.id);
  //     //   images.forEach((item) => {
  //     //     if (item.file instanceof File) {
  //     //       formData.append("files", item.file);
  //     //     } else {
  //     //       console.error("Invalid file object:", item.file);
  //     //     }
  //     //   });
  //     //   setBtnImageLoading(true);
  //     //   actionPartInventoryImage(formData)
  //     //     .then((response) => {
  //     //       toast.success(response.data.message);
  //     //       setPartImageDataList(response.data.data);

  //     //       setImage([]);
  //     //       SetPreviewUrl([]);
  //     //       const currentPartUpdated = partsData.find(
  //     //         (part) => part.id === Number(currentPart?.part_catelog)
  //     //       );

  //     //       if (currentPartUpdated?.parts_damage?.length > 0) {
  //     //         setCurrentStep(4);
  //     //       } else {
  //     //         setCurrentStep(5);
  //     //       }
  //     //     })
  //     //     .catch((err) => {
  //     //       setbtnImage(false);
  //     //       setImageSave(false);
  //     //       toast.dismiss();
  //     //       toast.error(Utils.getErrorMessage(err));
  //     //     })
  //     //     .finally(() => {
  //     //       setBtnImageLoading(false); // ⬅️ Stop loader
  //     //     });
  //     // }
  //   };

  const handleFinish = (event) => {
    event.preventDefault();

    if (!state?.state?.params?.photos && (!images || images?.length === 0)) {
      toast.error(t("pi_toast_please_upload_at_least_one_image"));
      return;
    }

    const formData = new FormData();
    setBtnSaved(true);

    const hasNewImages = images.some((item) => item.file instanceof File);

    if (ImageDetailsNot?.id && !hasNewImages) {
      setBtnSaved(false);
      toast.error(t("pi_toast_please_upload_at_least_one_new_image"));
      return;
    } else if (state?.state?.params?.photos) {
      fetch(state.state.params.photos)
        .then((res) => res.blob())
        .then((blobData) => {
          const filename = "image.png";
          const fileType = blobData.type || "image/png";
          formData.append(
            "part_id",
            ImageDetailsNot?.id ? ImageDetailsNot?.id : (currentPart?.part_id ?? currentPart?.id),
          );
          const myFile = new File([blobData], filename, { type: fileType });

          formData.append("files", myFile, filename);

          actionPartInventoryImage(formData)
            .then((response) => {
              toast.success(response.data.message);
              setPartImageDataList(response.data.data);
              const currentPartUpdated = partsData.find(
                (part) => part.id === Number(currentPart?.part_catelog),
              );

              if (currentPartUpdated?.parts_damage?.length > 0) {
                setCurrentStep(4);
              } else {
                setCurrentStep(5);
              }

              setImage([]);
              SetPreviewUrl([]);
              setBtnSaved(false);
            })
            .catch((err) => {
              setBtnSaved(false);
              toast.error(Utils.getErrorMessage(err));
            });
        })
        .catch((err) => {
          console.error("Error converting blob URL:", err);
        });
    } else {
      const formData = new FormData();
      formData.append(
        "part_id",
        ImageDetailsNot?.id ? ImageDetailsNot?.id : (currentPart?.part_id ?? currentPart?.id),
      );
      images.forEach((item, index) => {
        if (item.file instanceof File || item.file instanceof Blob) {
          const filename = item.file.name || `image-${index}.png`;
          formData.append("files", item.file, filename);
        } else {
          console.error("Invalid file object:", item.file);
        }
      });

      actionPartInventoryImage(formData)
        .then((response) => {
          toast.success(response.data.message);
          setPartImageDataList(response.data.data);

          const currentPartUpdated = partsData.find(
            (part) => part.id === Number(currentPart?.part_catelog),
          );

          if (currentPartUpdated?.parts_damage?.length > 0) {
            setCurrentStep(4);
          } else {
            setCurrentStep(5);
          }

          setImage([]);
          SetPreviewUrl([]);
          setBtnSaved(false);
        })
        .catch((err) => {
          setBtnSaved(false);
          toast.error(Utils.getErrorMessage(err));
        });
    }
  };

  const onvehiclePartDetailsOpen = (e, item) => {
    e.preventDefault();
    setVehiclePartDetailsModal(true);
  };

  const onvehiclePartDetailsClose = () => {
    setVehiclePartDetailsModal(false);
  };

  useEffect(() => {
    const obj = {
      search: brandName ? brandName : "",
      limit: 10,
      page: 1,
      placeName: "",
    };

    getAllBrandSerachList(obj)
      .then((response) => {
        response = response.data;
        let list = [];

        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].descriptionPT,
          });
        }
        SetAllBrandList(list);
      })
      .catch((err) => {
        console.error(err);
      });
  }, [brandName]);

  const handleInputSelectedPartBrand = (value) => {
    setSelectedValueBrand(value);

    const obj = {
      search: value ? value : brandName,
      limit: 20,
      page: 1,
      placeName: "",
    };

    getAllBrandSerachList(obj)
      .then((response) => {
        response = response.data;
        let list = [];

        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].descriptionPT,
          });
        }
        SetAllBrandList(list);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    if (vehicleModalSelectedList?.id) {
      let data = {
        vehicle_id: vehicleModalSelectedList.id,
      };
      getVehiclePartList(data)
        .then((response) => {
          setVehicleExceedData(response.data.data);
        })
        .catch((err) => {
          toast.dismiss();

          toast.error(Utils.getErrorMessage(err));
        });
    }
  }, [vehicleModalSelectedList]);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const companyResponse = await getSettingsCompanyDetails();

        setSettingDetails(companyResponse.data.data);
      } catch (err) {
        console.error(err);
      }
    };

    fetchSettings();
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "state",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setStateList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "part_inventory",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setInventoryList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      type: "condition",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setConditionList(list);
      })
      .catch((err) => {});
  }, []);

  const currentPart =
    vehicleImageDetails && vehicleImageDetails?.length > currentPartIndex
      ? vehicleImageDetails[currentPartIndex]
      : detailsForImages && detailsForImages?.length > currentPartIndex
        ? detailsForImages[currentPartIndex]
        : null;

  const formData = new FormData();

  const handleSubmits = (event) => {
    event.preventDefault();
    const hasNewImages = images.some((item) => item.file instanceof File);

    if (vehicleAddDetails?.id && !hasNewImages) {
      setCurrentPartIndex((prevIndex) => prevIndex + 1);
    } else if (state?.state?.params?.photos) {
      fetch(state.state.params.photos)
        .then((res) => res.blob())
        .then((blobData) => {
          const filename = "image.png";
          const fileType = blobData.type || "image/png";

          const myFile = new File([blobData], filename, { type: fileType });

          formData.append("files", myFile, filename);
          formData.append("part_id", currentPart?.part_id ?? currentPart?.id);

          setBtnImageLoading(true);
          setBtnImageLoading(true);
          actionPartInventoryImage(formData)
            .then((response) => {
              toast.success(response.data.message);
              setPartImageDataList(response.data.data);

              setImage([]);
              SetPreviewUrl([]);
              if (partsData?.some((part) => part?.parts_damage?.length > 0)) {
                setCurrentStep(4);
              } else {
                setCurrentPartIndex((prevIndex) => prevIndex + 1);
              }
              if (images.length === 1) {
                fileInputRef.current.value = "";
              }
            })
            .catch((err) => {
              toast.error(Utils.getErrorMessage(err));
            })
            .finally(() => {
              setBtnImageLoading(false);
            });
        })
        .catch((err) => {
          console.error("Error converting blob URL:", err);
        });
    } else if (selectedImages) {
      fetch(selectedImages)
        .then((res) => res.blob())
        .then((blobData) => {
          const filename = "image.png";
          const fileType = blobData.type || "image/png";

          const myFile = new File([blobData], filename, { type: fileType });

          formData.append("files", myFile, filename);
          formData.append("part_id", currentPart?.part_id ?? currentPart?.id);

          setBtnImageLoading(true);
          actionPartInventoryImage(formData)
            .then((response) => {
              toast.success(response.data.message);
              setPartImageDataList(response.data.data);

              setImage([]);
              SetPreviewUrl([]);
              if (partsData?.some((part) => part?.parts_damage?.length > 0)) {
                setCurrentStep(4);
              } else {
                setCurrentPartIndex((prevIndex) => prevIndex + 1);
              }
              if (images.length === 1) {
                fileInputRef.current.value = "";
              }
              setBtnImageLoading(false);
            })
            .catch((err) => {
              setBtnImageLoading(false);
              toast.dismiss();
              toast.error(Utils.getErrorMessage(err));
            })
            .finally(() => {
              setBtnImageLoading(false); // ⬅️ Stop loader
            });
        })
        .catch((err) => {
          console.error("Error converting blob URL:", err);
        });
    } else {
      formData.append("part_id", currentPart?.part_id ?? currentPart?.id);
      images.forEach((item) => {
        if (item.file instanceof File) {
          formData.append("files", item.file);
        } else {
          console.error("Invalid file object:", item.file);
        }
      });

      setBtnImageLoading(true);
      actionPartInventoryImage(formData)
        .then((response) => {
          toast.success(response.data.message);
          setPartImageDataList(response.data.data);

          setImage([]);
          SetPreviewUrl([]);
          if (partsData?.some((part) => part?.parts_damage?.length > 0)) {
            setCurrentStep(4);
          } else {
            setCurrentPartIndex((prevIndex) => prevIndex + 1);
          }
          if (images.length === 1) {
            fileInputRef.current.value = "";
          }
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        })
        .finally(() => {
          setBtnImageLoading(false);
        });
    }
  };

  const handleAboutFileChange = (event) => {
    const selectedFiles = Array.from(event.target.files);

    if (selectedFiles.length > 0) {
      const formattedFiles = selectedFiles.map((file, index) => ({
        id: `${Date.now()}-${index}`,
        file,
        url: URL.createObjectURL(file),
      }));

      setImage((prevImages) => [...prevImages, ...formattedFiles]);

      SetPreviewUrl((prevUrls) => {
        return Array.isArray(prevUrls)
          ? [...prevUrls, ...formattedFiles.map((file) => file.url)]
          : formattedFiles.map((file) => file.url);
      });
    }
  };

  const onDragEnd = (result) => {
    if (!result.destination) return;

    const reorderedFiles = Array.from(images);
    const [movedFile] = reorderedFiles.splice(result.source.index, 1);
    reorderedFiles.splice(result.destination.index, 0, movedFile);

    setImage(reorderedFiles);
  };
  const handleSaveOrder = () => {
    let simplifiedFiles = images
      .filter((file) => !/^\d{13}-\d+$/.test(file.id))
      .map((file, index) => ({
        id: file.id,
        sort_order: index + 1,
      }));

    if (simplifiedFiles.length === 0) {
      simplifiedFiles = images.map((_, index) => ({
        id: 0,
        sort_order: index + 1,
      }));
    }

    const data = { sort_list: simplifiedFiles };

    updateVehiclePartImageSort(data)
      .then((response) => {
        toast.success(response.data.message);
        setModifyImportModal(false);
      })
      .catch((err) => toast.error(Utils.getErrorMessage(err)));
  };

  const isLastPart =
    (vehicleImageDetails &&
      currentPartIndex === vehicleImageDetails?.length - 1) ||
    (detailsForImages && currentPartIndex === detailsForImages?.length - 1);

  const handleRemoveFile = (indexToRemove, item) => {
    if (typeof item === "string" && item.includes("-")) {
      setImage((prevFiles) =>
        prevFiles.filter((_, index) => index !== indexToRemove),
      );
      SetPreviewUrl((prevUrls) =>
        prevUrls.filter((_, index) => index !== indexToRemove),
      );
      toast.success(t("pi_toast_image_removed_ok"));
      return;
    }

    if (item) {
      const data = { id: item };
      destoryPartInventoryImage(data)
        .then((response) => {
          toast.success(response.data.message);

          setImage((prevFiles) =>
            prevFiles.filter((_, index) => index !== indexToRemove),
          );
          SetPreviewUrl((prevUrls) =>
            prevUrls.filter((_, index) => index !== indexToRemove),
          );

          var obj = { id: uuid };
          PartInventoryImageDetails(obj)
            .then((response) => {
              setvehicleImageDetails(response.data.data);
            })
            .catch((err) => {});
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        });
    }
  };

  const handleShowAbout = () => setShowModalAbout(true);
  const handleCloseAbout = () => setShowModalAbout(false);

  let errorsObj = {
    quantity: "",
    part_price: "",
  };
  const [errors, setErrors] = useState(errorsObj);

  const handleImportModal = () => {
    setModifyImportModal(true);
    if (vehicleAddDetails?.id) {
      setImage(vehicleImageDetails);
    }
  };
  useEffect(() => {
    if (vehicleAddDetails?.id) {
      setImage(vehicleImageDetails);
      const previewUrls = vehicleImageDetails?.map((img) => img.image_url);
      SetPreviewUrl(previewUrls);
    }
  }, [vehicleAddDetails]);

  const handleImportCloseModal = () => setModifyImportModal(false);

  useEffect(() => {
    const isDuplicatePart = (part, newPart) => {
      return (
        part.part_code === newPart.part_code &&
        part.vehicle_make === newPart.vehicle_make &&
        part.vehicle_model === newPart.vehicle_model &&
        part.vehicle_year === newPart.vehicle_year
      );
    };

    if (vehicleAddDetails?.id) {
      const newPart = {
        parts_internal_id: vehicleAddDetails?.parts_internal_id,
        id: vehicleAddDetails.part_catelog,
        namePartPT: vehicleAddDetails.namePartPT,
        part_code: vehicleAddDetails?.part_code,
        part_name: vehicleAddDetails?.part_name,
        quantity: vehicleAddDetails?.quantity,
        part_price: vehicleAddDetails?.part_price,
        part_description: vehicleAddDetails?.part_description,
        inventory_status: vehicleAddDetails?.inventory_status,
        parts_associate: vehicleAddDetails?.parts_associate,
        vehicle_make: vehicleAddDetails.vehicle_make,
        vehicle_model: vehicleAddDetails.vehicle_model,
        vehicle_model_id: vehicleAddDetails.vehicle_parts_id,
        vehicle_year: vehicleAddDetails.vehicle_year,
        print_label: vehicleAddDetails?.print_label,
        associate_location: vehicleAddDetails?.associate_location,
        state_id: vehicleAddDetails?.state_id,
        condition_id: vehicleAddDetails?.condition_id,
        part_cost_price: vehicleAddDetails?.part_cost_price,
        part_original_price: vehicleAddDetails?.part_original_price,
        is_custom_size: vehicleAddDetails?.is_custom_size,
        parts_weight: vehicleAddDetails?.parts_weight,
        parts_width: vehicleAddDetails?.parts_width,
        parts_height: vehicleAddDetails?.parts_height,
        parts_length: vehicleAddDetails?.parts_length,
        brand_id: vehicleAddDetails?.brand_id,
        addedData: vehicleAddDetails?.parts_reference,
        vat_included: vehicleAddDetails?.vat_included,
        // "Sob encomenda" / "Rascunho" / "Valor caução" — só ficam definidos
        // quando o detalhe os devolve; o update apenas os envia nesse caso
        // (back-compat).
        on_order: vehicleAddDetails?.on_order,
        is_draft: vehicleAddDetails?.is_draft,
        deposit_value: vehicleAddDetails?.deposit_value,
        reg_number_dismantler: vehicleAddDetails?.reg_number_dismantler,
        vehicle_model_name: vehicleAddDetails?.vehicle_model_name,
        vehicle_make_name: vehicleAddDetails?.vehicle_make_name,
        is_master_part: vehicleAddDetails?.is_master_part,
        master_part_id: vehicleAddDetails?.master_part_id,
        part_rating: vehicleAddDetails?.part_rating,
        parts_damage: vehicleAddDetails?.parts_damage,
        part_model_stats: vehicleAddDetails?.part_model_stats,
        extra_notes: vehicleAddDetails?.extra_notes,
        internal_notes: vehicleAddDetails?.internal_notes,
        is_show_engine_record: vehicleAddDetails?.is_show_engine_record,
        engine_code: vehicleAddDetails?.engine_id,
        cv: vehicleAddDetails?.cv,
        cc: vehicleAddDetails?.cc,
        kw: vehicleAddDetails?.kw,
        motor_code: vehicleAddDetails?.motor_code,
        fuel_type_id: Number(vehicleAddDetails?.fuel_type_id),
        motorization: vehicleAddDetails?.motorization,
        vehicle_type_id: vehicleAddDetails?.vehicle_type_id,
        variants_id: vehicleAddDetails?.variants_id,
        part_catalog_id: vehicleAddDetails?.part_catalog_id,
        parts_catalog_attributes: vehicleAddDetails?.parts_catalog_attributes,
        car_model_list: vehicleAddDetails?.car_model_list,
        part_catalog_name: vehicleAddDetails.part_catalog_name,
        k_type: vehicleAddDetails?.k_type,
        tec_doc_model: vehicleAddDetails?.tec_doc_model,
        catalog_part_list: vehicleAddDetails?.catalog_part_list,
        green_part_rating: vehicleAddDetails?.green_part_rating,
        catalog_part_check_list: vehicleAddDetails?.parts_checklist_item,
        part_catalog_estimate_id: vehicleAddDetails?.part_catalog_estimate_id,
        brand_name: vehicleAddDetails?.brand_name,
      };

      const attributes = [];

      ["text", "selection", "integer", "float", "checkbox", "date"].forEach(
        (type) => {
          const items =
            vehicleAddDetails.parts_catalog_attributes?.[type] || [];
          items.forEach((item) => {
            const index = attributes.findIndex(
              (attr) => attr.attribute_id === item.id.toString(),
            );

            const newAttr = {
              attribute_id: item.id.toString(),
              attribute_value: item.attribute_value,
              attribute_option_id: item.attribute_option_id || null,
              id: item.part_attribute_id,
            };

            if (index !== -1) {
              attributes[index] = newAttr;
            } else {
              attributes.push(newAttr);
            }
          });
        },
      );

      const finalPart = {
        ...newPart,
        parts_attribute: attributes,
      };
      setBrandName(vehicleAddDetails?.brand_name);
      setSelectedModels(vehicleAddDetails?.parts_associate);
      setCategoryMasterPart(vehicleAddDetails);
      setCompatibleList(vehicleAddDetails?.parts_associate);
      setCategoryPartsData({
        // catalog_id: vehicleAddDetails?.catalog_id,
        catalog_id: vehicleAddDetails?.part_catalog_id,
        part_catalog_name: vehicleAddDetails?.part_catalog_name,
        vehicle_year: Number(vehicleAddDetails?.vehicle_year),
        vehicle_make: Number(vehicleAddDetails?.vehicle_make),
        vehicle_model: Number(vehicleAddDetails?.vehicle_model),
        vehicle_variant: Number(vehicleAddDetails?.variants_id),
        vehicle_make_name: vehicleAddDetails?.vehicle_make_name,
        vehicle_model_name: vehicleAddDetails?.vehicle_model_name,
        vehicle_variant_name: vehicleAddDetails?.vehicle_variant_name,
        vehicle_type: Number(vehicleAddDetails?.vehicle_type_id),
        vehicle_type_name: vehicleAddDetails?.vehicle_type_name,
        vehicle_id: Number(vehicleAddDetails?.vehicle_id),
      });
      // setAssociateVehicleId(vehicleAddDetails?.vehicle_id);

      setPartsData((prevData) => {
        if (!prevData.some((part) => isDuplicatePart(part, newPart))) {
          return [...prevData, finalPart];
        }
        return prevData;
      });
    } else if (selectedItems && selectedItems.length > 0) {
      const selectedParts = selectedItems?.map((item) => ({
        tempId: item.id,
        temp_id: autoMainFillData?.temp_id
          ? autoMainFillData?.temp_id
          : item.temp_id,
        id: item.catalog_id,
        part_catalog_id: item?.part_catalog_id,
        is_master_part: item.is_master_part,
        part_model_stats: item?.part_model_stats ? item?.part_model_stats : 0,
        master_part_id: item.master_part_id,
        parts_internal_id: item.parts_internal_id,
        etai_part_id: item?.etai_part_id,
        namePartPT: item.namePartPT,
        part_name: item.namePartPT,
        quantity: "1",
        part_price: state?.state?.decode?.estimate_oem_price
          ? state?.state?.decode?.estimate_oem_price
          : "0",
        state_id: settingDetails?.state_id ? settingDetails?.state_id : "",
        condition_id: settingDetails ? settingDetails?.condition_id : 1,
        part_original_price: "0",
        part_cost_price: (() => {
          const exp = vehicleModalSelectedList?.vehicle_exp_value || 0;
          const weight = item?.part_catalog_weight || 0;
          const tare = vehicleModalSelectedList?.vehicle_tare || 0;
          const perc = item?.percentage || 0;

          if (settingCompanyDetails?.cost_price_based_on === 1) {
            return perc > 0 && exp > 0 ? (exp * (perc / 100)).toString() : "0";
          }

          if (settingCompanyDetails?.cost_price_based_on === 2) {
            return exp > 0 && weight > 0 && tare > 0
              ? (exp * (weight / tare)).toFixed(2)
              : "0";
          }
          return "0";
        })(),
        is_custom_size: "0",
        parts_weight: "0",
        parts_width: "0",
        parts_height: "0",
        parts_length: "0",
        inventory_status: "",
        print_label: settingDetails?.print_label
          ? settingDetails?.print_label
          : "0",
        vat_included: settingDetails?.vat_included
          ? settingDetails?.vat_included
          : "0",
        on_order: 0,
        is_draft: 0,
        deposit_value: "",
        part_description: "",
        vehicle_make: item.vehicle_make,
        vehicle_model: item.vehicle_model,
        vehicle_model_id: item.vehicle_model_id,
        vehicle_year: item.initial_year,
        brand_id: "0",
        reference_code: "",
        type_id: null,
        is_main: 1,
        condition_id_ref: null,
        vehicle_model_name: item.vehicle_model_name,
        vehicle_make_name: item?.vehicle_make_name,
        is_show_engine_record: item?.is_show_engine_record,

        engine_code: "",
        variants_id: item?.variants_id,
        cv: "",
        cc: "",
        kw: "",
        reg_number_dismantler: settingDetails?.reg_number_dismantler
          ? settingDetails?.reg_number_dismantler
          : "",
        part_rating: "0",
        parts_damage: [],
        associate_location: defaultAssociateLocation
          ? defaultAssociateLocation
          : "0",
        extra_notes: "",
        internal_notes: "",
        k_type: item?.k_type ? item?.k_type : "",
        tec_doc_model: item?.tec_doc_model ? item?.tec_doc_model : "",
        part_catalog_name: item?.part_catalog_name
          ? item?.part_catalog_name
          : "",
        motor_code: "",
        fuel_type_id: vehicleExceedData?.vehicle_data?.vehicle_fuel,
        motorization: vehicleExceedData?.vehicle_data?.vehicle_motorization,
        vehicle_type_id: item?.vehicle_type_id,
        parts_catalog_attributes: item?.parts_catalog_attributes,
        // Pré-popula parts_attribute com default_value dos atributos
        // (ex: checkboxes "Default Activo" no catálogo) — sem isto,
        // peça nova não envia o default no submit.
        parts_attribute: (() => {
          const seeded = [];
          const cat = item?.parts_catalog_attributes || {};
          for (const groupKey of Object.keys(cat)) {
            const group = cat[groupKey] || [];
            for (const a of group) {
              if (
                a?.default_value !== null &&
                a?.default_value !== undefined &&
                a?.default_value !== ""
              ) {
                seeded.push({
                  attribute_id: String(a.id),
                  attribute_value: String(a.default_value),
                });
              }
            }
          }
          return seeded;
        })(),
        car_model_list: item?.car_model_list,
        parts_associate: item?.parts_associate ? item?.parts_associate : [],
        addedData: item?.parts_reference ? item?.parts_reference : [],
        vehicle_id: vehicleAddDetails?.vehicle_id
          ? vehicleAddDetails?.vehicle_id
          : vehicleModalSelectedList?.id,
        catalog_part_list: item?.catalog_part_list,

        vehicle_ids: vehicleAddDetails?.vehicle_id
          ? vehicleAddDetails?.vehicle_id
          : "",
        green_part_rating: "",
        catalog_part_check_list: item?.catalog_part_check_list || [],
        part_catalog_estimate_id: item?.part_catalog_estimate_id,
        brand_name: "",
        percentage: item?.percentage,
      }));

      setPartsData(selectedParts);
    }
  }, [vehicleAddDetails, selectedItems]);

  const handleInputChangePartListRef = (e, pIndex) => {
    const { name, value } = e.target;
    setPartsData((prev) =>
      prev.map((part, index) =>
        index === pIndex ? { ...part, [name]: value } : part,
      ),
    );
  };

  const handleAddPartRef = async (pIndex) => {
    const part = partsData[pIndex];
    const referenceCode = selectedReferenceCode || part?.reference_code;

    if (!referenceCode) {
      toast.error(t("pi_toast_ref_code_required"));
      return;
    }
    let count;

    try {
      const response = await getPartsByReference({
        reference_code: referenceCode,
        data_type: "count",
      });

      count = response?.data.data || 0;
      setCountRefData(count);
    } catch (error) {
      console.error("API Error:", error);
      toast.error(t("pi_toast_failed_validate_ref_code"));
      return;
    }

    setPartsData((prev) =>
      prev.map((part, index) => {
        if (index === pIndex) {
          const isDuplicate = part?.addedData?.some(
            (data) => data?.reference_code === referenceCode,
          );
          if (isDuplicate) {
            toast.error(t("pi_toast_ref_code_already_added"));
            return part;
          }

          const selectedCondition = conditionList.find(
            (cond) =>
              cond?.value ===
              (part?.condition_id_ref ||
                settingCompanyDetails?.reference_condition),
          ) || { label: "Not Selected", value: "null" };

          const selectedType = referenceList.find(
            (cond) =>
              cond?.value ===
              (part?.type_id || settingCompanyDetails?.reference_type),
          ) || {
            label: "Not Selected",
            value: "null",
          };

          return {
            ...part,
            addedData: [
              ...(part?.addedData || []),
              {
                reference_code: referenceCode,
                type_id:
                  part?.type_id ?? settingCompanyDetails?.reference_type ?? 2,
                condition_id_ref:
                  part?.condition_id_ref ??
                  settingCompanyDetails?.reference_condition ??
                  1,
                is_main: part?.addedData?.length ? 0 : 1,
                manufacter: part?.manufacter,
                brand: part?.brand,
                selectedCondition,
                selectedType,
                count: count,
              },
            ],
            reference_code: "",
            type_id: null,
            condition_id_ref: null,
            is_main: 0,
            manufacter: "",
            brand: "",
          };
        }
        return part;
      }),
    );

    setSelectedReferenceCode(null);
  };

  const handleUpdatePartRef = (pIndex, rowIndex, key, value) => {
    setPartsData((prev) =>
      prev.map((part, index) => {
        if (index !== pIndex) return part;

        const updatedAddedData = part?.addedData?.map((data, idx) => {
          if (key === "is_main") {
            return { ...data, is_main: idx === rowIndex ? value : 0 };
          }

          if (idx !== rowIndex) return data;
          return { ...data, [key]: value };
        });

        return {
          ...part,
          addedData: updatedAddedData || [], // Ensure `addedData` is always valid
        };
      }),
    );
  };

  const hanldeEditdeleteRef = () => {
    let data = {
      id: DelteRefId.id,
    };
    partRefDelete(data)
      .then((res) => {
        setPartsData((prev) =>
          prev.map((part, index) =>
            index === DelteRefId.pIndex
              ? {
                  ...part,
                  addedData:
                    part.addedData?.filter(
                      (_, idx) => idx !== DelteRefId.rowIndex,
                    ) || [],
                }
              : part,
          ),
        );
        toast.success(res.data.message);

        setModifyDelteRef(false);
      })
      .catch((error) => console.error("Error deleting partRef:", error));
  };

  const handleDeletePartRef = (pIndex, rowIndex, id) => {
    if (id) {
      setModifyDelteRef(true);
      setDelteRefId({ pIndex, rowIndex, id });
    } else {
      setPartsData((prev) =>
        prev.map((part, index) => {
          if (index !== pIndex) return part;

          const updatedData =
            part.addedData?.filter((_, idx) => idx !== rowIndex) || [];

          const isDeletedMain = part.addedData[rowIndex]?.is_main === 1;
          if (isDeletedMain && updatedData.length > 0) {
            updatedData[0].is_main = 1;
          }

          return {
            ...part,
            addedData: updatedData,
          };
        }),
      );
    }
  };

  const hanldeEditdeleteDamage = () => {
    let data = {
      id: DelteDamageId.id,
    };
    partDamageDelete(data)
      .then((res) => {
        setPartsData((prev) =>
          prev.map((part, index) =>
            index === DelteDamageId.pIndex
              ? {
                  ...part,
                  parts_damage:
                    part.parts_damage?.filter(
                      (_, idx) => idx !== DelteDamageId.rowIndex,
                    ) || [],
                }
              : part,
          ),
        );
        setModifyDelteDamage(false);

        toast.success(res.data.message);
      })
      .catch((error) => console.error("Error deleting partRef:", error));
  };

  const handleAddPartDamage = (pIndex) => {
    setPartsData((prev) =>
      prev?.map((part, index) => {
        if (index === pIndex) {
          const damageDescription = part?.damage_description;

          if (!damageDescription) {
            toast.error(t("pi_toast_damage_description_required"));
            return part;
          }

          const selectedTypeDamage = typeDamageList.find(
            (cond) => cond?.value === part?.type_damage_id,
          ) || { label: "Not Selected", value: "null" };

          const selectedLocationDamage = locationDamageList.find(
            (cond) => cond?.value === part?.location_damage_id,
          ) || {
            label: "Not Selected",
            value: "null",
          };

          const updatedPart = {
            ...part,
            parts_damage: [
              ...(part?.parts_damage || []),
              {
                damage_description: part?.damage_description,
                type_damage_id: part?.type_damage_id,
                location_damage_id: part?.location_damage_id,
                damage_rating: part?.damage_rating,
                selectedTypeDamage,
                selectedLocationDamage,
              },
            ],
            damage_description: "",
            type_damage_id: null,
            location_damage_id: null,
            damage_rating: 0,
          };

          return updatedPart;
        }
        return part;
      }),
    );
  };

  const handleUpdatePartDamage = (pIndex, rowIndex, key, value) => {
    setPartsData((prev) =>
      prev.map((part, index) => {
        if (index !== pIndex) return part;

        const updatedAddedData = part?.parts_damage?.map((data, idx) => {
          if (idx !== rowIndex) return data;
          return { ...data, [key]: value };
        });

        return {
          ...part,
          parts_damage: updatedAddedData || [],
        };
      }),
    );
  };

  const handleDeletePartDamage = (pIndex, rowIndex, id) => {
    if (id) {
      setModifyDelteDamage(true);

      setDelteDamageId({
        pIndex: pIndex,
        rowIndex: rowIndex,
        id: id,
      });
    } else {
      setPartsData((prev) =>
        prev.map((part, index) =>
          index === pIndex
            ? {
                ...part,
                parts_damage:
                  part.parts_damage?.filter((_, idx) => idx !== rowIndex) || [],
              }
            : part,
        ),
      );
    }
  };

  const handleEngineCodeChange = (pIndex, selectedOption) => {
    setPartsData((prev) =>
      prev.map((part, index) =>
        index === pIndex
          ? {
              ...part,
              engine_code: selectedOption?.value || null,
              kw: selectedOption?.kw,
              cv: selectedOption?.cv,
              cc: selectedOption?.cc,
              motor_code: selectedOption.label,
            }
          : part,
      ),
    );
  };

  const handleConditionChangeRef = (id, selectedOption) => {
    setPartsData((prev) =>
      prev.map((part, index) =>
        part?.id === id
          ? { ...part, type_id: selectedOption?.value || null }
          : part,
      ),
    );
  };

  const handleConditionSChangeRefs = (id, selectedOption) => {
    setPartsData((prev) =>
      prev.map((part, index) =>
        part?.id === id
          ? { ...part, condition_id_ref: selectedOption?.value || null }
          : part,
      ),
    );
  };

  const handleTypeDamageChange = (pIndex, selectedOption) => {
    setPartsData((prev) =>
      prev.map((part, index) =>
        index === pIndex
          ? { ...part, type_damage_id: selectedOption?.value || null }
          : part,
      ),
    );
  };

  const hanldeLocationDamageChange = (pIndex, selectedOption) => {
    setPartsData((prev) =>
      prev.map((part, index) =>
        index === pIndex
          ? { ...part, location_damage_id: selectedOption?.value || null }
          : part,
      ),
    );
  };

  useEffect(() => {
    const obj = {
      search: "",
      limit: 20,
      page: 1,
      park_id: 0,
    };

    getAllViewShelfList(obj)
      .then((response) => {
        response = response.data;
        let list = [];

        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
            bar_code: response.data[i].bar_code,
            place: response.data[i].place,
            from_iels: response.data[i].from_iels,
            to_iels: response.data[i].to_iels,
          });
        }
        SetShelfList(list);
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  const handleSelfIdChange = (index, selectedOption) => {
    const updatedParts = [...partsData];

    updatedParts[index] = {
      ...updatedParts[index],
      name: selectedOption.label,
      bar_code: selectedOption.bar_code,
      place: selectedOption.place,
      from_iels: selectedOption.from_iels,
      to_iels: selectedOption.to_iels,
    };

    setPartsData(updatedParts);
  };

  const handleInputChangePartList = (e, id) => {
    const { name, value, type, checked } = e.target;
    setPartsData((prevData) =>
      prevData.map((part) =>
        part?.id === id
          ? { ...part, [name]: type === "checkbox" ? (checked ? 1 : 0) : value }
          : part,
      ),
    );
  };

  const handleInputChangePartLists = (e, tempId) => {
    const { name, value } = e.target;
    const updatedParts = [...partsData];
    const partToUpdate = updatedParts.find((part) => part.tempId === tempId);

    if (partToUpdate) {
      partToUpdate[name] = value;
      setPartsData(updatedParts);

      if (name === "part_price") {
        const originalPrice = parseFloat(value) || 0;

        setPartCostPrice(tempId, originalPrice);
      }
    }
  };

  const handleMasterPartClose = () => {
    setModifyMasterPart(false);
  };

  const handleAddClick = (item) => {
    setCategoryMasterPart(item);

    if (item.is_master_part === "1") {
      setModifyMasterPart(true);
      return;
    } else {
      let partListItem = {
        vehicle_make: vehicleModalSelectedList?.make_id || "",
        vehicle_year: vehicleModalSelectedList?.vehicle_year || "",
        vehicle_model: vehicleModalSelectedList?.vehicle_model_id || "",
        vehicle_variant: vehicleModalSelectedList?.variants_id || "",
        catalog_id: item.id,
        master_part_id: categoryMasterPart?.is_master_part,
        vehicle_type_id: vehicleExceedData?.vehicle_data?.vehicle_type,
      };

      let data = {
        temp_id: tempData?.temp_id || dismantleTempData?.temp_id || "",
        vehicle_id: vehicleModalSelectedList?.id,
        part_list: [partListItem],
        is_add_for_vehicle: 1,
        allow_add_existing_parts_vehicle:
          settingCompanyDetails?.allow_add_existing_parts_vehicle
            ? settingCompanyDetails?.allow_add_existing_parts_vehicle
            : 0,
      };

      actionPartInventoryTempStore(data)
        .then((response) => {
          setTempData(response.data.data);
        })
        .catch((err) => {
          toast.dismiss();
          toast.error(Utils.getErrorMessage(err));
        });
    }
    if (modifyMasterPart === true) {
      submitData();
    }
  };

  const handleModalSubmit = (e) => {
    e.preventDefault();
    submitData();
  };

  const submitData = () => {
    const partListItems = checkedItems?.map((item) => {
      const referenceId = item.reference_id;
      const masterId = item.parts_catalog_id;
      return {
        vehicle_make: vehicleModalSelectedList?.make_id || "",
        vehicle_year: vehicleModalSelectedList?.vehicle_year || "",
        vehicle_model: vehicleModalSelectedList?.vehicle_model_id || "",
        vehicle_variant: vehicleModalSelectedList?.variants_id || "",
        catalog_id: referenceId,
        master_part_id: masterId,
        vehicle_type_id: vehicleExceedData?.vehicle_data?.vehicle_type,
      };
    });

    let payload = {
      temp_id: tempData?.temp_id || dismantleTempData?.temp_id || "",
      vehicle_id: vehicleModalSelectedList?.id,
      part_list: [
        ...partListItems,
        ...(categoryMasterPart?.is_master_part === "1"
          ? [
              {
                vehicle_make: vehicleModalSelectedList?.make_id || "",
                vehicle_year: vehicleModalSelectedList?.vehicle_year || "",
                vehicle_model: vehicleModalSelectedList?.vehicle_model_id || "",
                vehicle_variant: vehicleModalSelectedList?.variants_id || "",
                catalog_id: categoryMasterPart.id,
                master_part_id: categoryMasterPart?.is_master_part,
                vehicle_type_id: vehicleExceedData?.vehicle_data?.vehicle_type,
              },
            ]
          : []),
      ],
      is_add_for_vehicle: 1,
      allow_add_existing_parts_vehicle:
        settingCompanyDetails?.allow_add_existing_parts_vehicle
          ? settingCompanyDetails?.allow_add_existing_parts_vehicle
          : 0,
    };

    actionPartInventoryTempStore(payload)
      .then((response) => {
        setTempData(response.data.data);
        setModifyMasterPart(false);
      })
      .catch((err) => {
        toast.dismiss();
        toast.error(Utils.getErrorMessage(err));
      });
  };

  const handleDeleteClick = (item) => {
    setbtnClosed(true);
    let data = {
      id: item.tempId ? item.tempId : item?.id,
    };

    setTempData(item);

    DestoryPartInventoryTemp(data)
      .then((response) => {
        toast.success(response.data.message);

        const fetchData = async () => {
          try {
            const obj = {
              search: searchQueryTemp,
              limit: tableLengthList[0],
              page: 1,
              temp_id: item?.temp_id,
            };
            const response = await getPartInventoryTempList(obj);
            setSelectedItems(response.data.data);
            setPartAttributesList(response.data.part_inventory_attribute);
          } catch (err) {
            console.error("Error fetching part inventory:", err);
          }
        };

        fetchData();
      })
      .catch((err) => {
        toast.dismiss();

        toast.error(Utils.getErrorMessage(err));
      })
      .finally(() => {
        // Reset button state to "close"
        setbtnClosed(false);
      });
  };

  useEffect(() => {
    if (selectedItems?.length === 0) {
      setCurrentStep(1);
    }
  }, [selectedItems]);

  const handleParams = (e, type) => {
    let paramsObj = { ...params };
    if (type === "length") {
      paramsObj.limit = e.target.value;
    } else if (type === "search") {
      paramsObj.page = 1;
      paramsObj.search = "";
    } else if (type === "pagination") {
      paramsObj.page = e;
    }

    setParams(paramsObj);
  };

  useEffect(() => {
    if (!modifyAssoicate) return;

    const obj = {
      search: categoryPartsData?.vehicle_internal_id || "",
      limit: 20,
      page: 1,
    };

    partInvenoryVehicleSearch(obj)
      .then((response) => {
        const arr = response?.data?.data || []; // safe handling if null

        const list = arr.map((item) => ({
          value: item.vehicle_model_name, // Use ID for React-Select
          label: `${item.vehicle_make_name || ""} | ${
            item.vehicle_model_name || ""
          } | ${item.registration_plate || ""} | ${item.registration || ""} | ${
            item.vehicle_internal_id || ""
          }`,

          vehicle_model_name: item.vehicle_model_name,
          vehicle_year: item.vehicle_year,
          vehicle_model_id: item.vehicle_model_id,
          make_id: item.make_id,
          variants_id: item.variants_id,
          vehicle_make_name: item.vehicle_make_name,
          registration_plate: item.registration_plate,
          registration: item.registration,
          vehicle_type: item.vehicle_type,
          vehicle_type_name: item.vehicle_type_name,
          id: item.id,
          ATYPNR: item.ATYPNR,
          KTYPNR: item.KTYPNR,
          NTYPNR: item.NTYPNR,
          id_tec_doc: item.id_tec_doc,
          vehicle_internal_id: item.vehicle_internal_id,
          vehicle_exp_value: item.vehicle_exp_value,
          vehicle_tare: item.vehicle_tare,
        }));

        setVehicleModelAllList(list);
      })
      .catch((err) => {
        console.error("Error loading vehicle list", err);
      });
  }, [modifyAssoicate, categoryPartsData?.vehicle_internal_id]);

  const handleInputChange = (inputValue) => {
    setInputValue(inputValue);

    // if (inputValue.length > 2) {
    const obj = {
      search: categoryPartsData?.vehicle_internal_id || inputValue,
      limit: tableLengthList[0],
      page: 1,
    };

    partInvenoryVehicleSearch(obj)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i]?.vehicle_model_name,
            label: `${response.data[i]?.vehicle_make_name || ""} | ${
              response.data[i]?.vehicle_model_name || ""
            } | ${response.data[i]?.registration_plate || ""} | ${
              response.data[i]?.registration || ""
            }
              | ${response.data[i]?.vehicle_internal_id}
           `,
            vehicle_model_name: response.data[i]?.vehicle_model_name,
            vehicle_model_id: response.data[i]?.vehicle_model_id,
            make_id: response.data[i]?.make_id,
            vehicle_process_end_date:
              response.data[i]?.vehicle_process_end_date,
            vehicle_in_inventory: response.data[i]?.vehicle_in_inventory,
            variants_id: response.data[i]?.variants_id,
            vehicle_make_name: response.data[i]?.vehicle_make_name,
            registration_plate: response.data[i]?.registration_plate,
            registration: response.data[i]?.registration,
            vehicle_year: response.data[i]?.vehicle_year,

            id: response.data[i]?.id,
            ATYPNR: response.data[i]?.ATYPNR,
            KTYPNR: response.data[i]?.KTYPNR,
            NTYPNR: response.data[i]?.NTYPNR,
            id_tec_doc: response.data[i]?.id_tec_doc,
            vehicle_exp_value: response.data[i]?.vehicle_exp_value,
            vehicle_tare: response?.data[i]?.vehicle_tare,
          });
        }

        setVehicleModelAllList(list);
      })
      .catch((err) => {
        console.error("Error fetching vehicle model list", err);
      });
    // }
  };

  useEffect(() => {
    const obj = {
      search: categoryPartsData?.vehicle_internal_id || "",
      limit: 10,
      page: 1,
    };

    partInvenoryVehicleSearch(obj)
      .then((res) => {
        const arr = res?.data?.data || []; // <-- FIX: handle null

        const list = arr.map((item) => ({
          value: item.id, // MUST MATCH Select.value
          label: `${item.vehicle_make_name || ""} | ${
            item.vehicle_model_name || ""
          } | ${item.registration_plate || ""} | ${item.registration || ""} | ${
            item.vehicle_internal_id || ""
          }`,

          // Save all useful fields
          vehicle_year: item.vehicle_year,
          vehicle_model_id: item.vehicle_model_id,
          make_id: item.make_id,
          variants_id: item.variants_id,
          vehicle_make_name: item.vehicle_make_name,
          vehicle_model_name: item.vehicle_model_name,
          registration_plate: item.registration_plate,
          registration: item.registration,
          vehicle_internal_id: item.vehicle_internal_id,
          vehicle_type: item.vehicle_type,
          vehicle_type_name: item.vehicle_type_name,

          id: item.id, // still included
        }));

        setVehicleModelCategoryAllList(list);
      })
      .catch((err) => console.warn("API error:", err));
  }, [categoryPartsData?.vehicle_internal_id]);

  const handleInputCategoryChange = (inputValue) => {
    setInputCategoryValue(inputValue);

    // if (inputValue.length > 2) {
    const obj = {
      search: categoryPartsData?.vehicle_internal_id
        ? categoryPartsData?.vehicle_internal_id
        : inputValue,
      limit: tableLengthList?.[0] || 10,
      page: 1,
    };

    partInvenoryVehicleSearch(obj)
      .then((res) => {
        const arr = res?.data?.data || []; // <-- FIX: handle null

        const list = arr.map((item) => ({
          value: item.id,
          label: `${item.vehicle_make_name || ""} | ${
            item.vehicle_model_name || ""
          } | ${item.registration_plate || ""} | ${item.registration || ""} | ${
            item.vehicle_internal_id || ""
          }`,

          vehicle_year: item.vehicle_year,
          vehicle_model_id: item.vehicle_model_id,
          make_id: item.make_id,
          variants_id: item.variants_id,
          vehicle_make_name: item.vehicle_make_name,
          vehicle_model_name: item.vehicle_model_name,
          registration_plate: item.registration_plate,
          registration: item.registration,
          vehicle_internal_id: item.vehicle_internal_id,
          vehicle_type: item.vehicle_type,
          vehicle_type_name: item.vehicle_type_name,
          id: item.id,
        }));

        setVehicleModelCategoryAllList(list);
      })
      .catch((err) => console.warn("Search error:", err));
    // }
  };

  useEffect(() => {
    if (vehicleModalSelectedList?.id || vehicleMainData?.item?.id) {
      const fetchCatalogList = () => {
        let data = {
          limit: params.limit,
          page: params.page,
          search: categoryPartsData?.part_catalog_name
            ? categoryPartsData?.part_catalog_name
            : searchQuery,
          is_reload: false,
          vehicle_id: vehicleMainData?.item?.id
            ? vehicleMainData?.item?.id
            : vehicleModalSelectedList?.id,
          is_add_for_vehicle: 1,
          allow_add_existing_parts_vehicle:
            settingCompanyDetails?.allow_add_existing_parts_vehicle
              ? settingCompanyDetails?.allow_add_existing_parts_vehicle
              : 0,
        };

        getCatalogList(data)
          .then((response) => {
            response = response.data;
            setCatalogList(response);
            setTotalRecords(response.total);
          })
          .catch((err) => {
            console.error("Error fetching catalog list:", err);
          });
      };

      fetchCatalogList();
    }
  }, [
    searchQuery,
    params,
    vehicleModalSelectedList,
    vehicleMainData,
    categoryPartsData,
  ]);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleSearchChangeTemp = (e) => {
    setSearchQueryTemp(e.target.value);
  };

  useEffect(() => {
    if (tempData?.temp_id || dismantleTempData?.temp_id) {
      const fetchData = async () => {
        try {
          const tempIdToSend = tempData?.temp_id || dismantleTempData?.temp_id;

          const obj = {
            search: searchQueryTemp,
            limit: tableLengthList[0],
            page: 1,
            temp_id: tempIdToSend,
          };

          const response = await getPartInventoryTempList(obj);
          setSelectedItems(response.data.data);
          setTotalRecords(response.data.total);
          setPartAttributesList(response.data.part_inventory_attribute);
        } catch (err) {
          console.error("Error fetching part inventory:", err);
        }
      };

      fetchData();
    }
  }, [searchQueryTemp, tempData, dismantleTempData]);

  const createPayload = () => {
    return partsData.map((part) => ({
      vehicle_id: part?.vehicle_id,
      part_catelog: part?.id || "",
      part_name: part?.part_name,
      quantity: part?.quantity,
      part_price: part?.part_price,
      condition_id: part?.condition_id,
      part_cost_price: part?.part_cost_price,
      part_original_price: part?.part_original_price,
      state_id: part?.state_id,
      is_custom_size: part?.is_custom_size,
      parts_weight: part?.parts_weight || 0,
      parts_width: part?.parts_width || 0,
      parts_height: part?.parts_height || 0,
      parts_length: part?.parts_length || 0,
      print_label: part?.print_label ? part?.print_label : 0,
      associate_location: part?.associate_location
        ? part?.associate_location
        : 0,
      vat_included: part?.vat_included ? part?.vat_included : 0,
      on_order:
        part?.on_order === 1 ||
        part?.on_order === true ||
        part?.on_order === "1",
      is_draft:
        part?.is_draft === 1 ||
        part?.is_draft === true ||
        part?.is_draft === "1",
      // "Valor caução" — vazio significa sem caução (null)
      deposit_value:
        part?.deposit_value === "" || part?.deposit_value == null
          ? null
          : Number(part?.deposit_value),
      inventory_status: part.inventory_status ? part.inventory_status : 1,

      sponsor_price: part?.sponsor_price,
      part_description: part?.part_description,

      brand_id: part.brand_id || 0,
      parts_reference: part?.addedData?.map((item) => ({
        reference_code: item?.reference_code,
        is_main: item?.is_main,
        type_id: item?.type_id,
        condition_id: item?.condition_id_ref,
        brand: item?.brand,
        manufacter: item?.manufacter,
      })),
      engine_code: part?.engine_code,
      variants_id: part?.variants_id,
      cv: part?.cv,
      cc: part?.cc,
      kw: part?.kw,
      reg_number_dismantler: part?.reg_number_dismantler,
      is_master_part: part?.is_master_part,
      master_part_id: part?.master_part_id,
      master_part_inventory_id: null,
      part_rating: part?.part_rating,
      extra_notes: part?.extra_notes,
      internal_notes: part?.internal_notes,
      fuel_type_id: part?.fuel_type_id,
      motorization: part?.motorization,

      parts_damage: part?.parts_damage?.map((item) => ({
        damage_description: item?.damage_description,
        damage_rating: item?.damage_rating,
        location_damage_id: item?.location_damage_id,
        type_damage_id: item?.type_damage_id,
      })),

      parts_associate:
        part?.parts_associate?.map((model) => ({
          vehicle_parts_id: part.id,
          vehicle_type: model.vehicle_type
            ? model.vehicle_type
            : model.vehicle_type?.value,
          vehicle_make: model.make_id
            ? model.make_id
            : model.vehicle_make?.value,
          vehicle_year: model.vehicle_year
            ? model.vehicle_year
            : model.vehicle_year?.value,
          vehicle_model:
            model.model_id === "all" || model.vehicle_model?.value === "all"
              ? 0
              : model.vehicle_model?.value || model.model_id,
          vehicle_variant:
            model.vehicle_variant === "all" ||
            model.vehicle_variant?.value === "all"
              ? 0
              : model.vehicle_variant?.value || model.vehicle_variant,

          notes: model.notes,
        })) || [],

      vehicle_make: part?.vehicle_make,
      vehicle_year: part?.vehicle_year,
      vehicle_model: part?.vehicle_model,
      vehicle_type_id: part?.vehicle_type_id,
      parts_attribute:
        part?.parts_attribute?.map((item) => ({
          attribute_id: item?.attribute_id,
          attribute_option_id: item?.attribute_option_id,
          attribute_value: item?.attribute_value,
          id: item?.id ? item?.id : "",
        })) || [],

      location_ids: selectedEntities?.location_ids,
      green_part_rating: part?.green_part_rating,
      part_catalog_check_list: part?.catalog_part_check_list?.map((row) => ({
        status: row?.check_list_status,
        part_catalog_id: row?.part_catalog_id,
        part_check_list_id: row?.id,
      })),
    }));
  };

  const createPayloads = () => {
    const part = partsData[0];

    return {
      uuid: vehicleAddDetails?.uuid,
      id: vehicleAddDetails?.id,
      vehicle_id: categoryPartsData?.vehicle_id,
      parts_internal_id: vehicleAddDetails?.parts_internal_id,
      part_catelog: categoryPartsData?.catalog_id,
      part_name: part?.part_name,
      quantity: part?.quantity,
      part_price: part?.part_price,
      condition_id: part?.condition_id,
      part_cost_price: part?.part_cost_price,
      part_original_price: part?.part_original_price,
      state_id: part?.state_id,
      is_custom_size: part?.is_custom_size,
      parts_weight: part?.parts_weight || 0,
      parts_width: part?.parts_width || 0,
      parts_height: part?.parts_height || 0,
      parts_length: part?.parts_length || 0,
      print_label: part?.print_label,
      associate_location: part?.associate_location,
      vat_included: part?.vat_included,
      // Back-compat: só enviamos on_order/is_draft quando o valor foi
      // carregado do detalhe ou alterado pelo utilizador — caso contrário
      // o backend não toca nas colunas (evita resets a false).
      ...(part?.on_order !== undefined
        ? {
            on_order:
              part?.on_order === 1 ||
              part?.on_order === true ||
              part?.on_order === "1",
          }
        : {}),
      ...(part?.is_draft !== undefined
        ? {
            is_draft:
              part?.is_draft === 1 ||
              part?.is_draft === true ||
              part?.is_draft === "1",
          }
        : {}),
      // "Valor caução" — só enviado quando o form o carregou/alterou;
      // "" é limpo para null no backend.
      ...(part?.deposit_value !== undefined
        ? { deposit_value: part?.deposit_value }
        : {}),
      inventory_status: part.inventory_status,
      vehicle_make: categoryPartsData?.vehicle_make,
      vehicle_year: categoryPartsData?.vehicle_year,
      vehicle_model: categoryPartsData?.vehicle_model,
      variants_id: categoryPartsData?.vehicle_variant,
      vehicle_type_id: categoryPartsData?.vehicle_type,
      part_description: part?.part_description,
      brand_id: part?.brand_id || 0,
      fuel_type_id: part?.fuel_type_id,
      motorization: part?.motorization,

      parts_associate:
        part?.parts_associate?.map((model) => ({
          vehicle_parts_id: part.id,
          vehicle_type: model.vehicle_type
            ? model.vehicle_type
            : model.vehicle_type?.value,
          vehicle_make: model.make_id
            ? model.make_id
            : model.vehicle_make?.value,
          vehicle_year: model.vehicle_year
            ? model.vehicle_year
            : model.vehicle_year?.value,
          vehicle_model:
            model.model_id === "all" || model.vehicle_model?.value === "all"
              ? 0
              : model.vehicle_model?.value || model.model_id,
          vehicle_variant:
            model.vehicle_variant === "all" ||
            model.vehicle_variant?.value === "all"
              ? 0
              : model.vehicle_variant?.value || model.vehicle_variant,

          notes: model.notes,
        })) || [],
      parts_reference: part?.addedData?.map((item) => ({
        id: item?.id ? item?.id : null,
        parts_id: vehicleAddDetails?.id,
        reference_code: item?.reference_code,
        is_main: item?.is_main,
        type_id: item?.type_id,
        condition_id: item?.condition_id_ref,
        brand: item?.brand,
        manufacter: item?.manufacter,
      })),
      engine_code: part?.engine_code,
      cv: part?.cv,
      cc: part?.cc,
      kw: part?.kw,
      reg_number_dismantler: part?.reg_number_dismantler,
      is_master_part: part?.is_master_part,
      master_part_id: part?.master_part_id,
      master_part_inventory_id: null,
      part_rating: part?.part_rating,
      extra_notes: part?.extra_notes,
      internal_notes: part?.internal_notes,

      parts_damage:
        part?.parts_damage?.map((item) => ({
          id: item?.id ? item?.id : null,
          parts_id: vehicleAddDetails?.id,
          damage_description: item?.damage_description,
          damage_rating: item?.damage_rating,
          location_damage_id: item?.location_damage_id,
          type_damage_id: item?.type_damage_id,
        })) || [],
      parts_attribute:
        part?.parts_attribute?.map((item) => ({
          attribute_id: item?.attribute_id,
          attribute_option_id: item?.attribute_option_id,
          attribute_value: item?.attribute_value,
          id: item?.id ? item?.id : null,
        })) || [],

      exist_part_status: categoryPartsData?.vehicle_id ? 3 : 2,
      green_part_rating: part?.green_part_rating,
      part_catalog_check_list: part?.catalog_part_check_list?.map((row) => ({
        status: row?.check_list_status,
        part_catalog_id: row?.part_catalog_id,
        part_check_list_id: row?.id,
      })),
    };
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let error = false;
    let errorObj = { ...errorsObj };
    partsData.forEach((part) => {
      if (!part.quantity) {
        errorObj.quantity = `Part Quantity is required.`;
        error = true;
      }
    });

    // const hasMissingReference = partsData.some(
    //   (part) => !part.addedData || part.addedData?.length === 0
    // );

    // if (hasMissingReference) {
    //   toast.error("Please add at least one reference for each part");
    //   return;
    // }

    const hasMissingDescription = partsData.some(
      (part) =>
        part.parts_damage > 0 &&
        (!part.damage_description || part.damage_description.trim() === ""),
    );

    if (hasMissingDescription) {
      toast.error(t("pi_toast_please_add_description"));
      return;
    }

    setErrors(errorObj);
    if (error) return;

    const payloads = createPayload();
    const payloadsUpdated = createPayloads();
    setbtnLoading(true);
    setbtnSaveNext(true);
    if (vehicleAddDetails?.id) {
      updatePartsInventory(payloadsUpdated)
        .then((response) => {
          SetDetailsForImages(response.data.data);
          SetDetailsForVideo(response.data.data);

          toast.success(response.data.message);
          // if (getFieldPermission("parts_photos").show) {
          setCurrentStep(3);
          // } else {
          //   navigate("/parts-inventory");
          // }
          setbtnLoading(false);
          setbtnSaveNext(false);
          setIsSaveClicked(true);
        })
        .catch((err) => {
          if (err?.response?.data?.exist_part_status === 1) {
            setChangePartModal(true);
          }
          setbtnLoading(false);
          toast.dismiss();
          setbtnSaveNext(false);
          toast.error(Utils.getErrorMessage(err));
        });
    } else {
      let data = {
        temp_id: tempData?.temp_id,
        part_list: payloads,
      };
      createPartsInventory(data)
        .then((response) => {
          const inventoryItems = response.data.data || [];

          const hasLabelToPrint = inventoryItems.some(
            (item) => item.print_label === 1,
          );

          if (hasLabelToPrint) {
            const vehiclePartIDs = inventoryItems.map((item) => item.id);

            // Template-aware endpoint (see migration note).
            Promise.all(
              vehiclePartIDs.map((id) => printPartLabel({ part_id: id })),
            )
              .then((responses) => {
                const msg = responses?.[0]?.data?.message;
                if (msg) toast.success(tConst(msg, t));
                if (getFieldPermission("parts_photos").show) {
                  setCurrentStep(3);
                } else {
                  navigate("/parts-inventory");
                }
                SetDetailsForImages(inventoryItems);
                SetDetailsForVideo(inventoryItems);
              })
              .catch((err) => {
                setBtnLoader(false);
                toast.error(Utils.getErrorMessage(err));
              });
          } else {
            SetDetailsForImages(inventoryItems);
            SetDetailsForVideo(inventoryItems);

            toast.success(response.data.message);
            // if (getFieldPermission("parts_photos").show) {
            setCurrentStep(3);
            // } else {
            //   navigate("/parts-inventory");
            // }
            setbtnLoading(false);
            setbtnSaveNext(false);

            setIsSaveClicked(true);
          }
        })
        .catch((err) => {
          setbtnLoading(false);
          setbtnSaveNext(false);
          toast.dismiss();

          toast.error(Utils.getErrorMessage(err));
        });
    }
  };

  const handleOverwriteConfirm = (e) => {
    setOverwriteConfirmed(true);
    setChangePartModal(false);
    e.preventDefault();

    let error = false;
    let errorObj = { ...errorsObj };
    partsData.forEach((part) => {
      if (!part.quantity) {
        errorObj.quantity = `Part Quantity is required.`;
        error = true;
      }
    });

    // const hasMissingReference = partsData.some(
    //   (part) => !part.addedData || part.addedData?.length === 0
    // );

    // if (hasMissingReference) {
    //   toast.error("Please add at least one reference for each part");
    //   return;
    // }

    setErrors(errorObj);
    if (error) return;

    const part = partsData[0];

    const payloadsUpdated = {
      uuid: vehicleAddDetails?.uuid,
      id: vehicleAddDetails?.id,
      vehicle_id: categoryPartsData?.vehicle_id || 0,
      parts_internal_id: vehicleAddDetails?.parts_internal_id,
      part_catelog: categoryPartsData?.catalog_id,
      part_name: part?.part_name,
      quantity: part?.quantity,
      part_price: part?.part_price,
      condition_id: part?.condition_id,
      part_cost_price: part?.part_cost_price,
      part_original_price: part?.part_original_price,
      state_id: part?.state_id,
      is_custom_size: part?.is_custom_size,
      parts_weight: part?.parts_weight || 0,
      parts_width: part?.parts_width || 0,
      parts_height: part?.parts_height || 0,
      parts_length: part?.parts_length || 0,
      print_label: part?.print_label,
      associate_location: part?.associate_location,
      vat_included: part?.vat_included,
      // Back-compat: só enviamos on_order/is_draft quando o valor foi
      // carregado do detalhe ou alterado pelo utilizador — caso contrário
      // o backend não toca nas colunas (evita resets a false).
      ...(part?.on_order !== undefined
        ? {
            on_order:
              part?.on_order === 1 ||
              part?.on_order === true ||
              part?.on_order === "1",
          }
        : {}),
      ...(part?.is_draft !== undefined
        ? {
            is_draft:
              part?.is_draft === 1 ||
              part?.is_draft === true ||
              part?.is_draft === "1",
          }
        : {}),
      // "Valor caução" — só enviado quando o form o carregou/alterou;
      // "" é limpo para null no backend.
      ...(part?.deposit_value !== undefined
        ? { deposit_value: part?.deposit_value }
        : {}),
      inventory_status: part.inventory_status,
      vehicle_make: categoryPartsData?.vehicle_make,
      vehicle_year: categoryPartsData?.vehicle_year,
      vehicle_model: categoryPartsData?.vehicle_model,
      variants_id: categoryPartsData?.vehicle_variant,
      vehicle_type_id: categoryPartsData?.vehicle_type,
      part_description: part?.part_description,
      brand_id: part?.brand_id || 0,
      fuel_type_id: part?.fuel_type_id,
      motorization: part?.motorization,

      parts_associate:
        part?.parts_associate?.map((model) => ({
          vehicle_parts_id: part.id,
          vehicle_type: model.vehicle_type
            ? model.vehicle_type
            : model.vehicle_type?.value,
          vehicle_make: model.make_id
            ? model.make_id
            : model.vehicle_make?.value,
          vehicle_year: model.vehicle_year
            ? model.vehicle_year
            : model.vehicle_year?.value,
          vehicle_model:
            model.model_id === "all" || model.vehicle_model?.value === "all"
              ? 0
              : model.vehicle_model?.value || model.model_id,
          vehicle_variant:
            model.vehicle_variant === "all" ||
            model.vehicle_variant?.value === "all"
              ? 0
              : model.vehicle_variant?.value || model.vehicle_variant,

          notes: model.notes,
        })) || [],
      parts_reference: part?.addedData?.map((item) => ({
        id: item?.id ? item?.id : null,
        parts_id: vehicleAddDetails?.id,
        reference_code: item?.reference_code,
        is_main: item?.is_main,
        type_id: item?.type_id,
        condition_id: item?.condition_id_ref,
      })),
      engine_code: part?.engine_code,
      cv: part?.cv,
      cc: part?.cc,
      kw: part?.kw,
      reg_number_dismantler: part?.reg_number_dismantler,
      is_master_part: part?.is_master_part,
      master_part_id: part?.master_part_id,
      master_part_inventory_id: null,
      part_rating: part?.part_rating,
      extra_notes: part?.extra_notes,
      internal_notes: part?.internal_notes,

      parts_damage:
        part?.parts_damage?.map((item) => ({
          id: item?.id ? item?.id : null,
          parts_id: vehicleAddDetails?.id,
          damage_description: item?.damage_description,
          damage_rating: item?.damage_rating,
          location_damage_id: item?.location_damage_id,
          type_damage_id: item?.type_damage_id,
        })) || [],
      parts_attribute:
        part?.parts_attribute?.map((item) => ({
          attribute_id: item?.attribute_id,
          attribute_option_id: item?.attribute_option_id,
          attribute_value: item?.attribute_value,
          id: item?.id ? item?.id : null,
        })) || [],
      exist_part_status: categoryPartsData?.vehicle_id ? 3 : 2,
      green_part_rating: part?.green_part_rating,
      part_catalog_check_list: part?.catalog_part_check_list?.map((row) => ({
        status: row?.check_list_status,
        part_catalog_id: row?.item?.part_catalog_id,
        part_check_list_id: row?.item?.id,
      })),
    };

    setbtnLoading(true);
    setbtnSaveNext(true);
    if (vehicleAddDetails?.id) {
      updatePartsInventory(payloadsUpdated)
        .then((response) => {
          SetDetailsForImages(response.data.data);
          SetDetailsForVideo(response.data.data);

          toast.success(response.data.message);
          // if (getFieldPermission("parts_photos").show) {
          setCurrentStep(3);
          // } else {
          //   navigate("/parts-inventory");
          // }
          setbtnLoading(false);
          setbtnSaveNext(false);
          setIsSaveClicked(true);
        })
        .catch((err) => {
          if (err?.response?.data?.exist_part_status === 1) {
            setChangePartModal(true);
          }
          setbtnLoading(false);
          toast.dismiss();
          setbtnSaveNext(false);
          toast.error(Utils.getErrorMessage(err));
        });
    }
  };

  const handleNextPart = () => {
    setCurrentStep(3);
    setImageDetailsNot(vehicleAddDetails);
  };

  const handleNextClick = (e) => {
    e.preventDefault();
    setbtnNext(true);

    if (selectedItems?.length === 0) {
      toast.error(t("pi_toast_please_select_vehicle_part"));
      setbtnNext(false);
      return;
    }

    // If popup should be shown (is_hide = 0) AND expiry date exists
    if (
      settingCompanyDetails?.is_hide_expiry_date_popup === 0 &&
      vehicleModalSelectedList?.vehicle_process_end_date
    ) {
      setCurrentStep(1);
      setModifyExpiry(true);
      setbtnNext(false);

      return;
    }

    // If popup should NOT appear (is_hide = 1)
    if (settingCompanyDetails?.is_hide_expiry_date_popup === 1) {
      setbtnNext(false);
      setCurrentStep(2);

      return;
    }
  };

  const handleBackButtonClick = () => {
    if (currentStep === 2 || currentStep === 3) {
      setCurrentStep(1);
    } else {
      navigate("/parts-inventory");
    }
  };
  const toggleEnlarge = (index) => {
    if (enlargedIndexes.includes(index)) {
      setEnlargedIndexes(enlargedIndexes.filter((i) => i !== index));
    } else {
      setEnlargedIndexes([...enlargedIndexes, index]);
    }
  };

  const setPartCostPrice = (tempId, price1) => {
    const discountPercentage = settingDetails?.discount_percentage / 100;

    const discountedPrice = price1 * (1 - discountPercentage);

    const updatedParts = [...partsData];
    const partToUpdate = updatedParts.find((part) => part.tempId === tempId);

    if (partToUpdate) {
      partToUpdate.part_original_price = discountedPrice;
      setPartsData(updatedParts);
    }
  };

  const setPartCostPriceEdit = (id, price1) => {
    const discountPercentage = settingDetails?.discount_percentage / 100;

    const discountedPrice = price1 * (1 - discountPercentage);

    const updatedParts = [...partsData];
    const partToUpdate = updatedParts.find((part) => part.id === id);

    if (partToUpdate) {
      partToUpdate.part_original_price = discountedPrice;
      setPartsData(updatedParts);
    }
  };

  const handleInputChangePartPrice1 = (e, id) => {
    const { name, value } = e.target;
    const updatedParts = [...partsData];
    const partToUpdate = updatedParts.find((part) => part?.id === id);

    if (partToUpdate) {
      partToUpdate[name] = value;
      setPartsData(updatedParts);

      if (name === "part_price") {
        const originalPrice = parseFloat(value) || 0;
        setPartCostPriceEdit(id, originalPrice);
      }
    }
  };

  useEffect(() => {
    if (state?.state?.decode?.estimate_oem_price) {
      setPartsData((prevParts) =>
        prevParts.map((part) => {
          const price = parseFloat(part.part_price) || 0;
          const discountPercentage = settingDetails?.discount_percentage / 100;
          const discountedPrice = price * (1 - discountPercentage);
          return {
            ...part,
            part_original_price: discountedPrice,
          };
        }),
      );
    }
  }, [state?.state?.decode?.estimate_oem_price, settingDetails]);

  useEffect(() => {
    if (selectedPrice) {
      setPartsData((prevParts) =>
        prevParts.map((part) => {
          const price = parseFloat(part.part_price) || 0;
          const discountPercentage = settingDetails?.discount_percentage / 100;
          const discountedPrice = price * (1 - discountPercentage);
          return {
            ...part,
            part_original_price: discountedPrice,
          };
        }),
      );
    }
  }, [selectedPrice, settingDetails]);

  const handleInventoryIdChange = (index, selectedOption) => {
    const updatedParts = [...partsData];

    updatedParts[index] = {
      ...updatedParts[index],
      inventory_status: selectedOption.value,
    };

    setPartsData(updatedParts);
  };

  const handleFuelTypeChange = (index, selectedOption) => {
    const updatedParts = [...partsData];

    updatedParts[index] = {
      ...updatedParts[index],
      fuel_type_id: selectedOption.value,
    };

    setPartsData(updatedParts);
  };

  const handleConditionChange = (index, selectedOption) => {
    const updatedParts = [...partsData];

    updatedParts[index] = {
      ...updatedParts[index],
      condition_id: selectedOption.value,
      condition_name: selectedOption.label,
    };

    setPartsData(updatedParts);
  };

  const handleStateListChange = (index, selectedOption) => {
    const updatedParts = [...partsData];

    updatedParts[index] = {
      ...updatedParts[index],
      state_id: selectedOption.value,
      state_name: selectedOption.label,
    };

    setPartsData(updatedParts);
  };

  const handleCheckboxCustomChange = (index, e) => {
    const updatedParts = [...partsData];

    updatedParts[index] = {
      ...updatedParts[index],
      is_custom_size: e.target.checked ? "1" : "0", // Update the specific part at that index
    };

    setPartsData(updatedParts);
  };

  const handleCheckboxPrintChanges = (pIndex, event) => {
    const updatedParts = [...partsData];
    const partToUpdate = updatedParts[pIndex];

    partToUpdate.print_label = event.target.checked ? 1 : 0;

    setPartsData(updatedParts);
  };

  const handleCheckboxVatChanges = (pIndex, event) => {
    const updatedParts = [...partsData];
    const partToUpdate = updatedParts[pIndex];

    partToUpdate.vat_included = event.target.checked ? 1 : 0;

    setPartsData(updatedParts);
  };

  const handleCheckboxOnOrderChanges = (pIndex, event) => {
    const updatedParts = [...partsData];
    const partToUpdate = updatedParts[pIndex];

    partToUpdate.on_order = event.target.checked ? 1 : 0;

    setPartsData(updatedParts);
  };

  const handleCheckboxDraftChanges = (pIndex, event) => {
    const updatedParts = [...partsData];
    const partToUpdate = updatedParts[pIndex];

    partToUpdate.is_draft = event.target.checked ? 1 : 0;

    setPartsData(updatedParts);
  };

  const handleCheckboxAssociateLocationChanges = (pIndex, event) => {
    const updatedParts = [...partsData];
    const partToUpdate = updatedParts[pIndex];

    partToUpdate.associate_location = event.target.checked ? 1 : 0;

    setPartsData(updatedParts);
  };

  const handleBrandIdChange = (index, selectedOption) => {
    const updatedParts = [...partsData];

    updatedParts[index] = {
      ...updatedParts[index],

      brand_id: selectedOption ? selectedOption.value : "",
    };

    setPartsData(updatedParts);
  };

  const vehicleDatesExpiry = moment(
    vehicleModalSelectedList?.vehicle_process_end_date,
  ).format("YYYY-MM-DD");

  useEffect(() => {
    if (vehicleDatesExpiry) {
      setVehicleData({
        date: vehicleDatesExpiry,
      });
    }
  }, [vehicleDatesExpiry]);

  const ExpiryModalNextclose = () => {
    if (vehicleModalSelectedList?.vehicle_process_end_date) {
      let data = {
        id: vehicleModalSelectedList.id,
        date: vehicleModalSelectedList?.vehicle_process_end_date,
      };

      partVehicleProcessUpdateExpiryDate(data)
        .then((response) => {
          setVehicleExceedData(response.data.data);
          toast.success(response.data.message);

          setModifyExpiry(false);
          setCurrentStep(2);
        })
        .catch((err) => {
          toast.dismiss();

          toast.error(Utils.getErrorMessage(err));
        })
        .finally(() => {
          setbtnNext(false);
        });
    } else {
      let data = {
        id: vehicleModalSelectedList?.vehicle_model_id,
        date: vehicleData.date,
      };

      if (
        vehicleData?.date < vehicleModalSelectedList?.vehicle_process_start_date
      ) {
        toast.error(t("pi_toast_end_date_after_start"));
        setbtnNext(false);
      }
      partVehicleProcessUpdateExpiryDate(data)
        .then((response) => {
          setVehicleExceedData(response.data.data);
          toast.success(response.data.message);

          setCurrentStep(2);
        })
        .catch((err) => {
          toast.dismiss();

          toast.error(Utils.getErrorMessage(err));
        })
        .finally(() => {
          setbtnNext(false);
        });
    }
  };

  const hanldeLastEditfinish = () => {
    // Fotos escolhidas ainda por gravar: sem isto, o Finish avançava e perdia-as em silêncio.
    if (images?.some((item) => item?.file instanceof File)) {
      handleFinish({ preventDefault: () => {} });
      return;
    }
    if (vehicleAddDetails?.parts_damage?.length > 0) {
      setCurrentStep(4);
    } else {
      // navigate("/parts-inventory");
      setCurrentStep(5);
    }
  };

  const handleOemRefSubmit = (e, item) => {
    if (item) {
      setModifyOemModal(true);
      setLoadingStructureOem(true);

      let data = {
        refOEM: item.reference_code,
        showAllVehiclesCompatibles: 1,
        language: LangData ? LangData : "PT",
        country: profileDetails?.company_details?.state,
        regNumberCompany:
          profileDetails?.company_details?.company_registration_number,
      };

      getStructureOem(data)
        .then((response) => {
          setStructureOemList(response.data.data);
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        })
        .finally(() => {
          setLoadingStructureOem(false); // stop loading
        });
    }
  };

  const handleSubmitVehicleComProduct = (e) => {
    const selectedProductIds = selectedVehicleData.iem_list
      ?.map((item) => item.productID)
      .join(",");
    let data = {
      productID: selectedProductIds,
      language: LangData ? LangData : "PT",
      country: profileDetails?.company_details?.state,
      regNumberCompany:
        profileDetails?.company_details?.company_registration_number,
    };
    setLoadingCompatible(true);
    getvehicleCompatibleProduct(data)
      .then((response) => {
        setVehicleCompatibleProductList(response.data.data);
        setActiveTab("3");
        setModifyConfirmModal(false);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      })
      .finally(() => {
        setLoadingCompatible(false);
      });
  };

  const handleGreenRatingChange = (tempId, level) => {
    setPartsData((prevParts) =>
      prevParts.map((part) => {
        const current =
          part.green_part_rating === "" ? -1 : Number(part.green_part_rating);
        let newRating;

        if (part.tempId === tempId) {
          if (current === level) {
            newRating = level - 1;
          } else {
            newRating = level;
          }

          if (newRating < 0) newRating = "";

          return { ...part, green_part_rating: newRating };
        }

        return part;
      }),
    );
  };

  const handleUpdateGreenRatingChange = (pIndex, level) => {
    setPartsData((prevParts) =>
      prevParts.map((part, index) => {
        if (index !== pIndex) return part;

        const current =
          part.green_part_rating === "" || part.green_part_rating === null
            ? -1
            : Number(part.green_part_rating);
        let newRating;

        if (current === level) {
          newRating = level - 1;
        } else {
          newRating = level;
        }

        if (newRating < 0) newRating = "";

        return { ...part, green_part_rating: newRating };
      }),
    );
  };

  return (
    <div>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item"></li>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <div className="row">
        <div className="col-md-12">
          <div className="card card-primary card-primary-Vehicle">
            {vehicleAddDetailsLoader ? (
              <div className="text-center p-4">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">{t("loading")}</span>
                </div>
              </div>
            ) : vehicleAddDetails?.id && uuid ? (
              <>
                {currentStep === 1 && (
                  <>
                    <div className="card-body vehicleparts-table mt-3">
                      <div className="vehicleparts-table-inner">
                        <Form method={`post`} onSubmit={handleSubmit}>
                          {/* Lot inline editor — paridade com mobile
                              _LotInlineEditor (edit_part_screen). Permite
                              trocar/remover o lote da peça via /update-part-lot. */}
                          <div
                            className="d-flex align-items-center mb-3 p-3"
                            style={{
                              border: `1px solid ${partLotInfo.lot_id ? "#81BB42" : "#dee2e6"}`,
                              backgroundColor: partLotInfo.lot_id
                                ? "#eef7e2"
                                : "#fff",
                              borderRadius: 10,
                            }}
                          >
                            <i
                              className="bi bi-archive-fill me-3"
                              style={{
                                color: partLotInfo.lot_id ? "#81BB42" : "#6c757d",
                                fontSize: 22,
                              }}
                            />
                            <div className="flex-grow-1">
                              <div
                                style={{ fontSize: 12, color: "#6c757d" }}
                              >
                                {t("lot", { defaultValue: "Lote" })}
                              </div>
                              <div
                                style={{
                                  fontSize: 15,
                                  fontWeight: 600,
                                  color: "#203444",
                                }}
                              >
                                {partLotInfo.lot_id
                                  ? partLotInfo.lot_internal_id &&
                                    partLotInfo.lot_name
                                    ? `#${partLotInfo.lot_internal_id} · ${partLotInfo.lot_name}`
                                    : partLotInfo.lot_internal_id
                                      ? `#${partLotInfo.lot_internal_id}`
                                      : partLotInfo.lot_name || "—"
                                  : "—"}
                              </div>
                            </div>
                            <button
                              type="button"
                              className="btn btn-outline-success btn-sm"
                              disabled={lotEditSaving}
                              onClick={openLotEditModal}
                            >
                              <i className="bi bi-arrow-left-right me-1" />
                              {t("change", { defaultValue: "Trocar" })}
                            </button>
                          </div>
                          <div className="row justify-content-start">
                            {partsData?.map((part, pIndex) => {
                              const PartState = Number(part?.state_id);
                              const PartCustomSize = Number(
                                part.is_custom_size,
                              );

                              return (
                                <React.Fragment key={pIndex}>
                                  <div className="col-lg-12" key={part?.id}>
                                    <div className="text-center inventory-addparts-custom">
                                      <Card.Header className="cardHeader">
                                        <div
                                          className="d-flex"
                                          data-bs-toggle="collapse"
                                          href={`#multiCollapseExample-${part?.tempId}`}
                                          role="button"
                                          aria-expanded="true"
                                          aria-controls={`multiCollapseExample-${part?.tempId}`}
                                        >
                                          <div className=""></div>
                                          <div className="AddPh6">
                                            <h6>
                                              {part?.namePartPT} |{" "}
                                              {
                                                vehicleAddDetails?.parts_internal_id
                                              }{" "}
                                              |{" "}
                                              {part?.vehicle_make_name ||
                                                categoryPartsData?.vehicle_make_name}{" "}
                                              |{" "}
                                              {part?.vehicle_model_name ||
                                                categoryPartsData?.vehicle_model_name}
                                            </h6>
                                          </div>
                                        </div>
                                      </Card.Header>
                                      <div className="vehicleThBg tableScroll  tablescroll-custom-two pb-2">
                                        <div className="row justify-content-end">
                                          <div className="col-md-12">
                                            <div className="mb-4 mt-3">
                                              <div className="btn-row-vehicale-part">
                                                {vehicleAddDetails?.vehicle_id ? (
                                                  <button
                                                    style={{
                                                      marginLeft: "12px",
                                                    }}
                                                    type="button"
                                                    className="btn btn-primary"
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      e.preventDefault();
                                                      handleSubmitAssoicateVehicleConfirm(
                                                        e,
                                                        part,
                                                      );
                                                    }}
                                                  >
                                                    <i className="bi bi-car-front me-2"></i>
                                                  </button>
                                                ) : (
                                                  <button
                                                    style={{
                                                      marginLeft: "12px",
                                                    }}
                                                    type="button"
                                                    className="btn btn-primary"
                                                    onClick={(e) => {
                                                      e.stopPropagation();
                                                      e.preventDefault();
                                                      handleSubmitAssoicateVehicleOpen(
                                                        e,
                                                        part,
                                                      );
                                                    }}
                                                  >
                                                    <i className="bi bi-car-front me-2"></i>
                                                  </button>
                                                )}

                                                {vehicleAddDetails?.vehicle_id && (
                                                  <button
                                                    style={{
                                                      marginLeft: "10px",
                                                    }}
                                                    type="button"
                                                    className="btn btn-primary"
                                                    onClick={(e) =>
                                                      handlePartCatalogModelOpen(
                                                        e,
                                                        part,
                                                        pIndex,
                                                      )
                                                    }
                                                  >
                                                    <i className="bi bi-car-front me-2"></i>
                                                    {t("catalog_model")}
                                                  </button>
                                                )}

                                                <button
                                                  style={{
                                                    marginLeft: "12px",
                                                  }}
                                                  type="button"
                                                  className="btn btn-primary"
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    e.preventDefault();
                                                    handleOpenPartHistory(
                                                      e,
                                                      part,
                                                    );
                                                  }}
                                                >
                                                  {part
                                                    ? part?.part_model_stats
                                                    : 0}
                                                </button>
                                                <button
                                                  style={{
                                                    marginLeft: "10px",
                                                  }}
                                                  type="button"
                                                  className="btn btn-primary"
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    e.preventDefault();
                                                    handleOpenSponsorPrice(
                                                      e,
                                                      part,
                                                    );
                                                  }}
                                                >
                                                  Statiscal Price
                                                </button>
                                                <button
                                                  style={{
                                                    marginLeft: "10px",
                                                  }}
                                                  type="button"
                                                  className="btn btn-primary"
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    e.preventDefault();
                                                    handleOpenEstimatePrice(
                                                      e,
                                                      part,
                                                    );
                                                  }}
                                                >
                                                  Estimate Price
                                                </button>
                                                <button
                                                  style={{
                                                    marginLeft: "10px",
                                                  }}
                                                  type="button"
                                                  className="btn btn-primary"
                                                  onClick={(e) =>
                                                    handleChangeCompatibleOpen(
                                                      e,
                                                      part,
                                                      pIndex,
                                                    )
                                                  }
                                                >
                                                  <i className="bi bi-car-front me-2"></i>
                                                  Compatible
                                                </button>
                                              </div>
                                            </div>
                                            {/* <div className="col-md-12"> */}
                                            <Card.Body
                                              className="collapse multi-collapse show"
                                              id={`multiCollapseExample-${part.tempId}`}
                                            >
                                              <div>
                                                <div className="row justify-content-end">
                                                  {vehicleAddDetails?.is_master_part ===
                                                    "1" && (
                                                    <>
                                                      {vehicleAddDetails?.vehicle_id ? (
                                                        <>
                                                          <div className="row justify-content-end">
                                                            <button
                                                              type="button"
                                                              className="back-btn"
                                                              style={{
                                                                width: "126px",
                                                                height: "49px",
                                                                marginBottom:
                                                                  "13px",
                                                              }}
                                                              onClick={
                                                                handlMasterVehicleOpen
                                                              }
                                                            >
                                                              <i className="bi bi-arrow-left">
                                                                {" "}
                                                              </i>
                                                              Add More
                                                            </button>{" "}
                                                          </div>
                                                        </>
                                                      ) : (
                                                        <>
                                                          <div className="row justify-content-end">
                                                            <button
                                                              type="button"
                                                              className="back-btn"
                                                              style={{
                                                                width: "126px",
                                                                height: "49px",
                                                                marginBottom:
                                                                  "13px",
                                                              }}
                                                              onClick={
                                                                handlMasterVehicleNotOpen
                                                              }
                                                            >
                                                              <i className="bi bi-arrow-left">
                                                                {" "}
                                                              </i>
                                                              Add More
                                                            </button>{" "}
                                                          </div>
                                                        </>
                                                      )}
                                                    </>
                                                  )}

                                                  <div className="col-lg-4">
                                                    <div>
                                                      <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                        Parts
                                                      </label>
                                                      <Select
                                                        className="my-Select"
                                                        options={
                                                          categoryPartList
                                                        }
                                                        value={
                                                          categoryPartList.find(
                                                            (item) =>
                                                              item.value ===
                                                              categoryPartsData.catalog_id,
                                                          ) || null
                                                        }
                                                        onChange={
                                                          handleSelectWithoutChangeCategoryList
                                                        }
                                                        placeholder={t("pi_select_part")}
                                                        isSearchable={true}
                                                        onInputChange={
                                                          handleInputSelectedChangeCategoryList
                                                        }
                                                        inputSelctedValue={
                                                          inputSelctedValue
                                                        }
                                                      />
                                                    </div>
                                                  </div>
                                                  <div className="col-lg-8"></div>

                                                  {(!categoryPartsData?.vehicle_id ||
                                                    categoryPartsData?.vehicle_id ===
                                                      0) && (
                                                    <>
                                                      <div className="row justify-content-start">
                                                        {getFieldPermission(
                                                          "vehicle_type_id",
                                                        ).show && (
                                                          <div className="col-lg-3 addPartField">
                                                            <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                              Vehicle Type
                                                            </label>
                                                            <div>
                                                              <Select
                                                                className="my-Select"
                                                                options={
                                                                  VehicleTypePartList
                                                                }
                                                                value={
                                                                  VehicleTypePartList.find(
                                                                    (item) =>
                                                                      item.value ===
                                                                      Number(
                                                                        categoryPartsData?.vehicle_type,
                                                                      ),
                                                                  ) || null
                                                                }
                                                                onChange={
                                                                  handleSelectWithoutChangeTypeList
                                                                }
                                                                placeholder={
                                                                  "Select Vehicle Type"
                                                                }
                                                                isSearchable={
                                                                  true
                                                                }
                                                                onInputChange={
                                                                  handleInputSelectedChangeVehicleTypeList
                                                                }
                                                                inputSelctedValue={
                                                                  inputSelctedTypeValue
                                                                }
                                                                isDisabled={
                                                                  !getFieldPermission(
                                                                    "vehicle_type_id",
                                                                  ).editable
                                                                }
                                                              />
                                                            </div>
                                                          </div>
                                                        )}

                                                        {getFieldPermission(
                                                          "vehicle_year",
                                                        ).show && (
                                                          <div className="col-lg-3 addPartField">
                                                            <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                              Vehicle Year
                                                            </label>
                                                            <div>
                                                              <Select
                                                                className="my-Select"
                                                                options={
                                                                  vehicleYearPartList
                                                                }
                                                                value={
                                                                  vehicleYearPartList.find(
                                                                    (item) =>
                                                                      item.value ===
                                                                      Number(
                                                                        categoryPartsData?.vehicle_year,
                                                                      ),
                                                                  ) || null
                                                                }
                                                                onChange={
                                                                  handleSelectWithoutChangeYearList
                                                                }
                                                                placeholder={
                                                                  "Select Year"
                                                                }
                                                                isSearchable={
                                                                  true
                                                                }
                                                                onInputChange={
                                                                  handleInputSelectedChangeYearList
                                                                }
                                                                inputSelctedValue={
                                                                  inputSelctedYearValue
                                                                }
                                                                isDisabled={
                                                                  !getFieldPermission(
                                                                    "vehicle_year",
                                                                  ).editable
                                                                }
                                                              />
                                                            </div>
                                                          </div>
                                                        )}
                                                        {getFieldPermission(
                                                          "vehicle_make",
                                                        ).show && (
                                                          <div className="col-lg-3 addPartField">
                                                            <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                              Vehicle Make
                                                            </label>
                                                            <div>
                                                              <Select
                                                                className="my-Select"
                                                                options={
                                                                  vehicleMakePartList
                                                                }
                                                                value={
                                                                  vehicleMakePartList.find(
                                                                    (item) =>
                                                                      item.value ===
                                                                      Number(
                                                                        categoryPartsData?.vehicle_make,
                                                                      ),
                                                                  ) || null
                                                                }
                                                                onChange={
                                                                  handleSelectWithoutChangeMakeList
                                                                }
                                                                placeholder={
                                                                  "Select Make"
                                                                }
                                                                isSearchable={
                                                                  true
                                                                }
                                                                onInputChange={
                                                                  handleInputSelectedChangeMakeList
                                                                }
                                                                inputSelctedValue={
                                                                  inputSelctedMakeValue
                                                                }
                                                                isDisabled={
                                                                  !getFieldPermission(
                                                                    "vehicle_make",
                                                                  ).editable
                                                                }
                                                              />
                                                            </div>
                                                          </div>
                                                        )}
                                                        {getFieldPermission(
                                                          "vehicle_model",
                                                        ).show && (
                                                          <div className="col-lg-3 addPartField">
                                                            <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                              Vehicle Modal
                                                            </label>
                                                            <div>
                                                              <Select
                                                                className="my-Select"
                                                                options={
                                                                  vehicleModalPartList
                                                                }
                                                                value={
                                                                  vehicleModalPartList.find(
                                                                    (item) =>
                                                                      item.value ===
                                                                      Number(
                                                                        categoryPartsData.vehicle_model,
                                                                      ),
                                                                  ) || null
                                                                }
                                                                onChange={
                                                                  handleSelectWithoutChangeModelList
                                                                }
                                                                placeholder={
                                                                  "Select modal"
                                                                }
                                                                isSearchable={
                                                                  true
                                                                }
                                                                onInputChange={
                                                                  handleInputSelectedChangeModelList
                                                                }
                                                                inputSelctedValue={
                                                                  inputSelctedModalValue
                                                                }
                                                                isDisabled={
                                                                  !getFieldPermission(
                                                                    "vehicle_model",
                                                                  ).editable
                                                                }
                                                              />
                                                            </div>
                                                          </div>
                                                        )}
                                                        {getFieldPermission(
                                                          "variants_id",
                                                        ).show && (
                                                          <div className="col-lg-3 addPartField">
                                                            <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                              Vehicle Variant
                                                            </label>
                                                            <div>
                                                              <Select
                                                                className="my-Select"
                                                                options={
                                                                  vehicleVariantPartList
                                                                }
                                                                value={
                                                                  vehicleVariantPartList.find(
                                                                    (item) =>
                                                                      item.value ===
                                                                      Number(
                                                                        categoryPartsData?.vehicle_variant,
                                                                      ),
                                                                  ) || null
                                                                }
                                                                onChange={
                                                                  handleSelectWithoutChangeVariantList
                                                                }
                                                                placeholder={
                                                                  "Select Variant"
                                                                }
                                                                isSearchable={
                                                                  true
                                                                }
                                                                onInputChange={
                                                                  handleInputSelectedChangeVariantList
                                                                }
                                                                inputSelctedValue={
                                                                  inputSelctedVariantValue
                                                                }
                                                                isDisabled={
                                                                  !getFieldPermission(
                                                                    "variants_id",
                                                                  ).editable
                                                                }
                                                              />
                                                            </div>
                                                          </div>
                                                        )}
                                                      </div>
                                                    </>
                                                  )}

                                                  <div className="col-lg-12">
                                                    <div className="row justify-content-start">
                                                      {getFieldPermission(
                                                        "quantity",
                                                      ).show && (
                                                        <div className="col-lg-3 addPartField">
                                                          <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                            Quantity
                                                          </label>
                                                          <input
                                                            className="form-control input-search"
                                                            type="number"
                                                            name="quantity"
                                                            value={
                                                              part?.quantity
                                                            }
                                                            onChange={(e) =>
                                                              handleInputChangePartList(
                                                                e,
                                                                part?.id,
                                                              )
                                                            }
                                                            placeholder="0"
                                                            disabled={
                                                              !getFieldPermission(
                                                                "variants_id",
                                                              ).editable
                                                            }
                                                            min="1"
                                                            onKeyDown={(e) => {
                                                              if (e.key === "-")
                                                                e.preventDefault();
                                                            }}
                                                          />

                                                          {errors.quantity && (
                                                            <span className="input-error">
                                                              {errors.quantity}
                                                            </span>
                                                          )}
                                                        </div>
                                                      )}
                                                      {getFieldPermission(
                                                        "part_price",
                                                      ).show && (
                                                        <div className="col-lg-3 addPartField">
                                                          <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                            Price 1 (€)
                                                          </label>
                                                          <input
                                                            className="form-control input-search"
                                                            type="number"
                                                            name="part_price"
                                                            value={
                                                              part.part_price
                                                            }
                                                            onChange={(e) => {
                                                              handleInputChangePartPrice1(
                                                                e,
                                                                part?.id,
                                                              );
                                                            }}
                                                            placeholder="0"
                                                            disabled={
                                                              !getFieldPermission(
                                                                "part_price",
                                                              ).editable
                                                            }
                                                          />

                                                          {errors.part_price && (
                                                            <span className="input-error">
                                                              {
                                                                errors.part_price
                                                              }
                                                            </span>
                                                          )}
                                                        </div>
                                                      )}
                                                      {getFieldPermission(
                                                        "part_original_price",
                                                      ).show && (
                                                        <div className="col-lg-3 addPartField">
                                                          <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                            Price 2 (
                                                            {
                                                              settingDetails?.discount_percentage
                                                            }
                                                            % discount) €
                                                          </label>
                                                          <input
                                                            className="form-control input-search"
                                                            type="number"
                                                            name="part_original_price"
                                                            value={
                                                              part.part_original_price
                                                            }
                                                            onChange={(e) =>
                                                              handleInputChangePartList(
                                                                e,
                                                                part.id,
                                                              )
                                                            }
                                                            disabled={
                                                              !getFieldPermission(
                                                                "part_original_price",
                                                              ).editable
                                                            }
                                                            placeholder="0"
                                                          />
                                                        </div>
                                                      )}
                                                      {getFieldPermission(
                                                        "part_cost_price",
                                                      ).show && (
                                                        <div className="col-lg-3 addPartField">
                                                          <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                            Part Cost Price €
                                                          </label>
                                                          <input
                                                            className="form-control input-search"
                                                            type="number"
                                                            name="part_cost_price"
                                                            value={
                                                              part?.part_cost_price
                                                            }
                                                            onChange={(e) => {
                                                              handleInputChangePartList(
                                                                e,
                                                                part?.id,
                                                              );
                                                            }}
                                                            placeholder="0"
                                                            disabled={
                                                              !getFieldPermission(
                                                                "part_cost_price",
                                                              ).editable
                                                            }
                                                          />
                                                        </div>
                                                      )}
                                                      <div className="col-lg-3 addPartField">
                                                        <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                          {t(
                                                            "pi_deposit_value",
                                                          )}{" "}
                                                          €
                                                        </label>
                                                        <input
                                                          className="form-control input-search"
                                                          type="number"
                                                          name="deposit_value"
                                                          value={
                                                            part?.deposit_value ??
                                                            ""
                                                          }
                                                          onChange={(e) =>
                                                            handleInputChangePartList(
                                                              e,
                                                              part?.id,
                                                            )
                                                          }
                                                          placeholder="0"
                                                          min="0"
                                                          onKeyDown={(e) => {
                                                            if (e.key === "-")
                                                              e.preventDefault();
                                                          }}
                                                        />
                                                      </div>
                                                      {getFieldPermission(
                                                        "inventory_status",
                                                      ).show && (
                                                        <div className="col-lg-3">
                                                          <div className="addPartField">
                                                            <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                              Inventory Status
                                                            </label>
                                                            <Select
                                                              className="my-Select"
                                                              options={
                                                                inventoryList
                                                              }
                                                              name="inventory_status"
                                                              value={inventoryList.find(
                                                                (option) =>
                                                                  option.value ===
                                                                  part.inventory_status,
                                                              )}
                                                              onChange={(
                                                                selectedOption,
                                                              ) =>
                                                                handleInventoryIdChange(
                                                                  pIndex,
                                                                  selectedOption,
                                                                )
                                                              }
                                                              placeholder={
                                                                "Select Inventory Status"
                                                              }
                                                              isSearchable={
                                                                true
                                                              }
                                                              isDisabled={
                                                                !getFieldPermission(
                                                                  "inventory_status",
                                                                ).editable
                                                              }
                                                            ></Select>
                                                          </div>
                                                        </div>
                                                      )}
                                                      {getFieldPermission(
                                                        "condition_id",
                                                      ).show && (
                                                        <div className="col-lg-3">
                                                          <div className="addPartField">
                                                            <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                              Condition
                                                            </label>
                                                            <Select
                                                              className="my-Select"
                                                              options={
                                                                conditionList
                                                              }
                                                              value={conditionList.find(
                                                                (option) =>
                                                                  option.value ===
                                                                  Number(
                                                                    part.condition_id,
                                                                  ),
                                                              )}
                                                              onChange={(
                                                                selectedOption,
                                                              ) =>
                                                                handleConditionChange(
                                                                  pIndex,
                                                                  selectedOption,
                                                                )
                                                              }
                                                              isSearchable
                                                              placeholder={
                                                                "Select Condition"
                                                              }
                                                              isDisabled={
                                                                !getFieldPermission(
                                                                  "condition_id",
                                                                ).editable
                                                              }
                                                            ></Select>
                                                          </div>
                                                        </div>
                                                      )}

                                                      {!vehicleAddDetails?.vehicle_id && (
                                                        <>
                                                          {getFieldPermission(
                                                            "fuel_type_id",
                                                          ).show && (
                                                            <div className="col-lg-3 ">
                                                              <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                                Fuel Type
                                                              </label>
                                                              <Select
                                                                className="my-Select"
                                                                options={
                                                                  vehicleFuelList
                                                                }
                                                                value={vehicleFuelList.find(
                                                                  (item) =>
                                                                    item.value ===
                                                                    partsData[
                                                                      pIndex
                                                                    ]
                                                                      ?.fuel_type_id,
                                                                )}
                                                                onChange={(
                                                                  selectedOption,
                                                                ) =>
                                                                  handleFuelTypeChange(
                                                                    pIndex,
                                                                    selectedOption,
                                                                  )
                                                                }
                                                                isSearchable
                                                                placeholder={
                                                                  "Select Fuel Type"
                                                                }
                                                                onInputChange={
                                                                  handleInputSelectedChangeVehicleFuelList
                                                                }
                                                                inputSelctedValue={
                                                                  inputSelctedFuelValue
                                                                }
                                                                isDisabled={
                                                                  !getFieldPermission(
                                                                    "fuel_type_id",
                                                                  ).editable
                                                                }
                                                              ></Select>
                                                            </div>
                                                          )}
                                                          {getFieldPermission(
                                                            "motorization",
                                                          ).show && (
                                                            <div className="col-lg-3">
                                                              <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                                Motorization
                                                              </label>
                                                              <input
                                                                className="form-control input-search"
                                                                type="text"
                                                                name="motorization"
                                                                value={
                                                                  part?.motorization
                                                                }
                                                                onChange={(e) =>
                                                                  handleInputChangePartList(
                                                                    e,
                                                                    part?.tempId,
                                                                  )
                                                                }
                                                                placeholder="0"
                                                                disabled={
                                                                  !getFieldPermission(
                                                                    "motorization",
                                                                  ).editable
                                                                }
                                                              />
                                                            </div>
                                                          )}
                                                        </>
                                                      )}
                                                      {getFieldPermission(
                                                        "brand_id",
                                                      ).show && (
                                                        <div className="col-lg-3">
                                                          <div className="addPartField">
                                                            <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                              {t("part")}{" "}
                                                              {t("brand")}
                                                            </label>
                                                            <Select
                                                              className="my-Select"
                                                              options={
                                                                allBrandList
                                                              }
                                                              name="brand_id"
                                                              value={allBrandList.find(
                                                                (option) =>
                                                                  option.value ===
                                                                  part.brand_id,
                                                              )}
                                                              onChange={(
                                                                selectedOption,
                                                              ) =>
                                                                handleBrandIdChange(
                                                                  pIndex,
                                                                  selectedOption,
                                                                )
                                                              }
                                                              placeholder={
                                                                "Select Part Brand"
                                                              }
                                                              onInputChange={(
                                                                inputValue,
                                                                actionMeta,
                                                              ) => {
                                                                if (
                                                                  actionMeta.action ===
                                                                  "input-change"
                                                                ) {
                                                                  handleInputSelectedPartBrand(
                                                                    inputValue,
                                                                  );
                                                                }
                                                              }}
                                                              isClearable={true}
                                                              isDisabled={
                                                                !getFieldPermission(
                                                                  "motorization",
                                                                ).editable
                                                              }
                                                            ></Select>
                                                          </div>
                                                        </div>
                                                      )}

                                                      {getFieldPermission(
                                                        "state_id",
                                                      ).show && (
                                                        <div className="col-lg-3">
                                                          <div className="addPartField">
                                                            <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                              State
                                                            </label>
                                                            <Select
                                                              className="my-Select"
                                                              options={
                                                                stateList
                                                              }
                                                              value={stateList.find(
                                                                (option) =>
                                                                  option.value ===
                                                                  Number(
                                                                    part.state_id,
                                                                  ),
                                                              )}
                                                              onChange={(
                                                                selectedOption,
                                                              ) =>
                                                                handleStateListChange(
                                                                  pIndex,
                                                                  selectedOption,
                                                                )
                                                              }
                                                              isSearchable
                                                              placeholder={
                                                                "Select State"
                                                              }
                                                              isDisabled={
                                                                !getFieldPermission(
                                                                  "state_id",
                                                                ).editable
                                                              }
                                                            ></Select>
                                                          </div>
                                                        </div>
                                                      )}
                                                      {getFieldPermission(
                                                        "part_rating",
                                                      ).show && (
                                                        <div className="col-lg-3 ">
                                                          <div className="addPartField">
                                                            <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                              Part Rating
                                                            </label>
                                                            <div className="addPartField">
                                                              <div className="form-check text-left">
                                                                <ReactStars
                                                                  size={20}
                                                                  count={5}
                                                                  activeColor="#ffd700"
                                                                  a11y={true}
                                                                  isHalf={true}
                                                                  emptyIcon={
                                                                    <i className="bi bi-star" />
                                                                  }
                                                                  halfIcon={
                                                                    <i className="bi bi-star-half" />
                                                                  }
                                                                  filledIcon={
                                                                    <i className="bi bi-star-fill" />
                                                                  }
                                                                  value={
                                                                    part?.part_rating
                                                                  }
                                                                  onChange={(
                                                                    newRating,
                                                                  ) =>
                                                                    handleRatingChange(
                                                                      newRating,
                                                                      part.tempId,
                                                                    )
                                                                  }
                                                                  // edit={
                                                                  //   !getFieldPermission(
                                                                  //     "part_rating"
                                                                  //   ).editable
                                                                  // }
                                                                />
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      )}
                                                      {getFieldPermission(
                                                        "is_custom_size",
                                                      ).show && (
                                                        <div className="col-lg-3 addPartField">
                                                          <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                            Custome Size
                                                          </label>

                                                          <div className="col-lg-12 addPartField">
                                                            <div className="form-check text-left">
                                                              <input
                                                                className="my-checkbox-1 form-check-input"
                                                                type="checkbox"
                                                                checked={
                                                                  PartCustomSize ==
                                                                  1
                                                                } // Handles both "1" (string) and 1 (number)
                                                                onChange={(e) =>
                                                                  handleCheckboxCustomChange(
                                                                    pIndex,
                                                                    e,
                                                                  )
                                                                }
                                                                disabled={
                                                                  !getFieldPermission(
                                                                    "is_custom_size",
                                                                  ).editable
                                                                }
                                                              />
                                                              <label className="form-check-label pl-6">
                                                                Custome Size
                                                              </label>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      )}
                                                      {getFieldPermission(
                                                        "print_label",
                                                      ).show && (
                                                        <div className="col-lg-3 addPartField">
                                                          <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                            Print label
                                                          </label>
                                                          <div className="col-lg-12 addPartField">
                                                            <div className="form-check text-left">
                                                              <input
                                                                className="my-checkbox-1 form-check-input"
                                                                type="checkbox"
                                                                checked={
                                                                  part.print_label ===
                                                                  1
                                                                }
                                                                onChange={(e) =>
                                                                  handleCheckboxPrintChanges(
                                                                    pIndex,
                                                                    e,
                                                                  )
                                                                }
                                                                disabled={
                                                                  !getFieldPermission(
                                                                    "print_label",
                                                                  ).editable
                                                                }
                                                              />
                                                              <label className="form-check-label pl-6">
                                                                Print label
                                                              </label>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      )}
                                                      {getFieldPermission(
                                                        "vat_included",
                                                      ).show && (
                                                        <div className="col-lg-3 addPartField">
                                                          <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                            VAT included{" "}
                                                          </label>
                                                          <div className="col-lg-12 addPartField">
                                                            <div className="form-check text-left">
                                                              <input
                                                                className="my-checkbox-1 form-check-input"
                                                                type="checkbox"
                                                                checked={
                                                                  part.vat_included ===
                                                                  1
                                                                }
                                                                onChange={(e) =>
                                                                  handleCheckboxVatChanges(
                                                                    pIndex,
                                                                    e,
                                                                  )
                                                                }
                                                                disabled={
                                                                  !getFieldPermission(
                                                                    "vat_included",
                                                                  ).editable
                                                                }
                                                              />
                                                              <label className="form-check-label pl-6">
                                                                VAT
                                                                included{" "}
                                                              </label>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      )}
                                                      <div className="col-lg-3 addPartField">
                                                        <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                          {t("pi_on_order")}
                                                        </label>
                                                        <div className="col-lg-12 addPartField">
                                                          <div className="form-check text-left">
                                                            <input
                                                              className="my-checkbox-1 form-check-input"
                                                              type="checkbox"
                                                              checked={
                                                                part?.on_order ===
                                                                  1 ||
                                                                part?.on_order ===
                                                                  true ||
                                                                part?.on_order ===
                                                                  "1"
                                                              }
                                                              onChange={(e) =>
                                                                handleCheckboxOnOrderChanges(
                                                                  pIndex,
                                                                  e,
                                                                )
                                                              }
                                                            />
                                                            <label className="form-check-label pl-6">
                                                              {t(
                                                                "pi_on_order",
                                                              )}
                                                            </label>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div className="col-lg-3 addPartField">
                                                        <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                          {t(
                                                            "pi_save_as_draft",
                                                          )}
                                                        </label>
                                                        <div className="col-lg-12 addPartField">
                                                          <div className="form-check text-left">
                                                            <input
                                                              className="my-checkbox-1 form-check-input"
                                                              type="checkbox"
                                                              checked={
                                                                part?.is_draft ===
                                                                  1 ||
                                                                part?.is_draft ===
                                                                  true ||
                                                                part?.is_draft ===
                                                                  "1"
                                                              }
                                                              onChange={(e) =>
                                                                handleCheckboxDraftChanges(
                                                                  pIndex,
                                                                  e,
                                                                )
                                                              }
                                                            />
                                                            <label className="form-check-label pl-6">
                                                              {t(
                                                                "pi_save_as_draft",
                                                              )}
                                                            </label>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      {getFieldPermission(
                                                        "associate_location",
                                                      ).show && (
                                                        <div className="col-lg-3 addPartField col-lg-3-mob">
                                                          <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                            Associate Location
                                                          </label>
                                                          <div className="addPartField">
                                                            <div className="form-check text-left">
                                                              <input
                                                                className="my-checkbox-1 form-check-input"
                                                                type="checkbox"
                                                                checked={
                                                                  part?.associate_location ===
                                                                  1
                                                                }
                                                                onChange={(e) =>
                                                                  handleCheckboxAssociateLocationChanges(
                                                                    pIndex,
                                                                    e,
                                                                  )
                                                                }
                                                                disabled={
                                                                  !getFieldPermission(
                                                                    "associate_location",
                                                                  ).editable
                                                                }
                                                              />
                                                              <label className="form-check-label pl-6">
                                                                Associate
                                                                Location
                                                              </label>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      )}
                                                    </div>

                                                    {Number(
                                                      settingDetails?.is_green_part,
                                                    ) === 1 && (
                                                      <div className="col-lg-3 addPartField col-lg-3-mob">
                                                        <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                          {t(
                                                            "GreenPartRatings",
                                                          )}
                                                        </label>
                                                        <div className="addPartField">
                                                          <div className="form-check text-left">
                                                            <div className="d-flex align-items-center gap-2">
                                                              {levels?.map(
                                                                (level) => (
                                                                  <img
                                                                    key={level}
                                                                    src={
                                                                      RatingImage
                                                                    }
                                                                    alt="Peça Verde"
                                                                    onClick={() =>
                                                                      handleUpdateGreenRatingChange(
                                                                        pIndex,
                                                                        level,
                                                                      )
                                                                    }
                                                                    style={{
                                                                      width: 40,
                                                                      height: 40,
                                                                      cursor:
                                                                        "pointer",
                                                                      opacity:
                                                                        part.green_part_rating !==
                                                                          "" &&
                                                                        part.green_part_rating !==
                                                                          null &&
                                                                        Number(
                                                                          part.green_part_rating,
                                                                        ) >=
                                                                          level
                                                                          ? 1
                                                                          : 0.3,
                                                                      transition:
                                                                        "opacity 0.2s ease-in-out",
                                                                    }}
                                                                  />
                                                                ),
                                                              )}
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    )}

                                                    {part?.is_show_engine_record ===
                                                      true && (
                                                      <>
                                                        <div className="row">
                                                          {getFieldPermission(
                                                            "engine_id",
                                                          ).show && (
                                                            <div className="col-lg-3 addPartField">
                                                              <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                                Engine Code{" "}
                                                              </label>
                                                              <Select
                                                                className="my-Select"
                                                                options={
                                                                  vehicleEngineList
                                                                }
                                                                value={vehicleEngineList.find(
                                                                  (item) =>
                                                                    item.value ===
                                                                    Number(
                                                                      part?.engine_code,
                                                                    ),
                                                                )}
                                                                onChange={(
                                                                  selectedOption,
                                                                ) =>
                                                                  handleEngineCodeChange(
                                                                    pIndex,
                                                                    selectedOption,
                                                                  )
                                                                }
                                                                placeholder={
                                                                  "Select Engine"
                                                                }
                                                                isSearchable={
                                                                  true
                                                                }
                                                                onInputChange={
                                                                  handleInputSelectedChangeEngineList
                                                                }
                                                                inputSelctedValue={
                                                                  inputSelctedEngineValue
                                                                }
                                                                disabled={
                                                                  !getFieldPermission(
                                                                    "engine_id",
                                                                  ).editable
                                                                }
                                                              />
                                                            </div>
                                                          )}
                                                          {getFieldPermission(
                                                            "cv",
                                                          ).show && (
                                                            <div className="col-lg-3 addPartField">
                                                              <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                                Cv{" "}
                                                              </label>
                                                              <input
                                                                className="form-control input-search"
                                                                type="text"
                                                                name="cv"
                                                                value={part?.cv}
                                                                onChange={(
                                                                  e,
                                                                ) => {
                                                                  handleInputChangePartList(
                                                                    e,
                                                                    part?.id,
                                                                  );
                                                                }}
                                                                placeholder="0"
                                                                disabled={
                                                                  !getFieldPermission(
                                                                    "cv",
                                                                  ).editable
                                                                }
                                                              />
                                                            </div>
                                                          )}
                                                          {getFieldPermission(
                                                            "cc",
                                                          ).show && (
                                                            <div className="col-lg-3 addPartField">
                                                              <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                                CC
                                                              </label>
                                                              <input
                                                                className="form-control input-search"
                                                                type="text"
                                                                name="cc"
                                                                value={part?.cc}
                                                                onChange={(
                                                                  e,
                                                                ) => {
                                                                  handleInputChangePartList(
                                                                    e,
                                                                    part?.id,
                                                                  );
                                                                }}
                                                                placeholder="0"
                                                                disabled={
                                                                  !getFieldPermission(
                                                                    "cc",
                                                                  ).editable
                                                                }
                                                              />
                                                            </div>
                                                          )}
                                                          {getFieldPermission(
                                                            "kw",
                                                          ).show && (
                                                            <div className="col-lg-3 addPartField">
                                                              <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                                KW
                                                              </label>
                                                              <input
                                                                className="form-control input-search"
                                                                type="text"
                                                                name="kw"
                                                                value={part?.kw}
                                                                onChange={(
                                                                  e,
                                                                ) => {
                                                                  handleInputChangePartList(
                                                                    e,
                                                                    part?.id,
                                                                  );
                                                                }}
                                                                placeholder="0"
                                                                disabled={
                                                                  !getFieldPermission(
                                                                    "kw",
                                                                  ).editable
                                                                }
                                                              />
                                                            </div>
                                                          )}
                                                        </div>
                                                      </>
                                                    )}
                                                  </div>

                                                  {PartCustomSize === 1 && (
                                                    <>
                                                      {/* {getFieldPermission(
                                                        "parts_weight"
                                                      ).show && ( */}
                                                      <div className="col-lg-3 addPartField">
                                                        <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                          Weight (kg){" "}
                                                        </label>
                                                        <input
                                                          className="form-control input-search"
                                                          type="number"
                                                          name="parts_weight"
                                                          value={
                                                            part.parts_weight
                                                          }
                                                          onChange={(e) =>
                                                            handleInputChangePartList(
                                                              e,
                                                              part.id,
                                                            )
                                                          }
                                                          placeholder="0"
                                                          // disabled={
                                                          //   !getFieldPermission(
                                                          //     "parts_weight"
                                                          //   ).editable
                                                          // }
                                                        />
                                                      </div>
                                                      {/* )} */}

                                                      {/* {getFieldPermission(
                                                        "parts_width"
                                                      ).show && ( */}
                                                      <div className="col-lg-3 addPartField">
                                                        <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                          Width(cm){" "}
                                                        </label>
                                                        <input
                                                          className="form-control input-search"
                                                          type="number"
                                                          name="parts_width"
                                                          value={
                                                            part.parts_width
                                                          }
                                                          onChange={(e) =>
                                                            handleInputChangePartList(
                                                              e,
                                                              part.id,
                                                            )
                                                          }
                                                          placeholder="0"
                                                          // disabled={
                                                          //   !getFieldPermission(
                                                          //     "parts_width"
                                                          //   ).editable
                                                          // }
                                                        />

                                                        {errors.parts_width && (
                                                          <span className="input-error">
                                                            {errors.parts_width}
                                                          </span>
                                                        )}
                                                      </div>
                                                      {/* )} */}
                                                      {/* {getFieldPermission(
                                                        "parts_height"
                                                      ).show && ( */}
                                                      <div className="col-lg-3 addPartField">
                                                        <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                          Height(cm){" "}
                                                        </label>
                                                        <input
                                                          className="form-control input-search"
                                                          type="number"
                                                          name="parts_height"
                                                          value={
                                                            part.parts_height
                                                          }
                                                          onChange={(e) =>
                                                            handleInputChangePartList(
                                                              e,
                                                              part.id,
                                                            )
                                                          }
                                                          placeholder="0"
                                                          // disabled={
                                                          //   !getFieldPermission(
                                                          //     "parts_height"
                                                          //   ).editable
                                                          // }
                                                        />
                                                      </div>
                                                      {/* )} */}
                                                      {/* {getFieldPermission(
                                                        "parts_length"
                                                      ).show && ( */}
                                                      <div className="col-lg-3 addPartField">
                                                        <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                          Length(cm){" "}
                                                        </label>
                                                        <input
                                                          className="form-control input-search"
                                                          type="number"
                                                          name="parts_length"
                                                          value={
                                                            part.parts_length
                                                          }
                                                          onChange={(e) =>
                                                            handleInputChangePartList(
                                                              e,
                                                              part.id,
                                                            )
                                                          }
                                                          placeholder="0"
                                                          // disabled={
                                                          //   !getFieldPermission(
                                                          //     "parts_length"
                                                          //   ).editable
                                                          // }
                                                        />
                                                      </div>
                                                      {/* )} */}
                                                    </>
                                                  )}

                                                  {PartState === 2 &&
                                                    getFieldPermission(
                                                      "reg_number_dismantler",
                                                    ).show && (
                                                      <div className="col-lg-3 addPartField col-lg-3-mob">
                                                        <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                          Reg Number Dismantler
                                                        </label>
                                                        <input
                                                          className="form-control input-search"
                                                          type="text"
                                                          name="reg_number_dismantler"
                                                          value={
                                                            part?.reg_number_dismantler
                                                          }
                                                          onChange={(e) =>
                                                            handleInputChangePartList(
                                                              e,
                                                              part?.id,
                                                            )
                                                          }
                                                          placeholder="0"
                                                          disabled={
                                                            !getFieldPermission(
                                                              "reg_number_dismantler",
                                                            ).editable
                                                          }
                                                        />
                                                      </div>
                                                    )}
                                                </div>
                                                <div className="col-lg-12">
                                                  <div className="btn-row-vehicale-part mb-4">
                                                    {(getFieldPermission(
                                                      "part_description",
                                                    ).show ||
                                                      getFieldPermission(
                                                        "extra_notes",
                                                      ).show ||
                                                      getFieldPermission(
                                                        "internal_notes",
                                                      ).show) && (
                                                      <button
                                                        style={{
                                                          marginTop: "8px",
                                                          marginRight: "10px",
                                                        }}
                                                        type="button"
                                                        className="btn btn-primary"
                                                        onClick={(e) =>
                                                          handleChangeNotesOpen(
                                                            e,
                                                            part,
                                                            pIndex,
                                                          )
                                                        }
                                                      >
                                                        Notes Fields
                                                      </button>
                                                    )}

                                                    {part?.etai_part_id && (
                                                      <>
                                                        <button
                                                          style={{
                                                            marginTop: "8px",
                                                            marginRight: "10px",
                                                          }}
                                                          type="button"
                                                          className="btn btn-primary"
                                                          onClick={(e) =>
                                                            handleEtaiDetails(
                                                              e,
                                                              part?.etai_part_id,
                                                              pIndex,
                                                            )
                                                          }
                                                        >
                                                          View Reference
                                                        </button>

                                                        <button
                                                          style={{
                                                            marginTop: "8px",
                                                          }}
                                                          type="button"
                                                          className="btn btn-primary"
                                                          onClick={(e) =>
                                                            handleEtaiPriceDetails(
                                                              e,
                                                              part?.etai_part_id,
                                                              pIndex,
                                                            )
                                                          }
                                                        >
                                                          View Price
                                                        </button>
                                                      </>
                                                    )}
                                                    {getFieldPermission(
                                                      "parts_reference",
                                                    ).show && (
                                                      <button
                                                        style={{
                                                          marginTop: "8px",
                                                          marginRight: "10px",
                                                        }}
                                                        type="button"
                                                        className="btn btn-primary"
                                                        onClick={
                                                          handleChangeOCROpen
                                                        }
                                                      >
                                                        OCR Multiple Reference
                                                      </button>
                                                    )}

                                                    {part?.addedData?.length >
                                                      0 && (
                                                      <>
                                                        <button
                                                          style={{
                                                            marginTop: "8px",
                                                            marginRight: "10px",
                                                          }}
                                                          type="button"
                                                          className="btn btn-primary"
                                                          onClick={(e) =>
                                                            handleOpenRefCodeCondition(
                                                              e,
                                                              part,
                                                            )
                                                          }
                                                        >
                                                          Parts
                                                        </button>

                                                        <button
                                                          style={{
                                                            marginTop: "8px",
                                                          }}
                                                          type="button"
                                                          className="btn btn-primary"
                                                          onClick={(e) =>
                                                            handleOpenRefCodeEstimate(
                                                              e,
                                                              part,
                                                            )
                                                          }
                                                        >
                                                          Estimate Price
                                                        </button>
                                                      </>
                                                    )}
                                                  </div>
                                                </div>
                                              </div>

                                              {getFieldPermission(
                                                "parts_reference",
                                              ).show && (
                                                <>
                                                  <div className="table-responsive-custom-q  table-custom-sticky-inherit">
                                                    <table className="table ">
                                                      <tbody>
                                                        <tr>
                                                          <th scope="col">
                                                            <div className="col-lg-12 addPartField">
                                                              <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                                {t(
                                                                  "reference_code",
                                                                )}{" "}
                                                              </label>
                                                              <input
                                                                className="form-control input-search"
                                                                type="text"
                                                                name="reference_code"
                                                                value={
                                                                  selectedReferenceCode
                                                                    ? selectedReferenceCode
                                                                    : part?.reference_code
                                                                }
                                                                onChange={(e) =>
                                                                  handleInputChangePartListRef(
                                                                    e,
                                                                    pIndex,
                                                                  )
                                                                }
                                                                placeholder={t("reference_code")}
                                                              />
                                                            </div>
                                                          </th>

                                                          <th scope="col">
                                                            <div className="col-lg-12 addPartField">
                                                              <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                                Condition
                                                              </label>
                                                              <Select
                                                                className="my-Select"
                                                                options={
                                                                  conditionList
                                                                }
                                                                value={
                                                                  conditionList.find(
                                                                    (option) =>
                                                                      option.value ===
                                                                        part?.condition_id_ref ||
                                                                      option.label ===
                                                                        part?.selectedCondition,
                                                                  ) ||
                                                                  conditionList.find(
                                                                    (item) =>
                                                                      item.value ===
                                                                      settingCompanyDetails?.reference_condition,
                                                                  ) ||
                                                                  conditionList.find(
                                                                    (item) =>
                                                                      item.value ===
                                                                      "1",
                                                                  ) ||
                                                                  null
                                                                }
                                                                onChange={(
                                                                  selectedOption,
                                                                ) =>
                                                                  handleConditionSChangeRefs(
                                                                    part?.id,
                                                                    selectedOption,
                                                                  )
                                                                }
                                                                isSearchable
                                                                placeholder={
                                                                  "Select Condition"
                                                                }
                                                              ></Select>
                                                            </div>
                                                          </th>
                                                          <th scope="col">
                                                            <div className="col-lg-12 addPartField">
                                                              <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                                Reference Type
                                                              </label>
                                                              <Select
                                                                className="my-Select"
                                                                options={
                                                                  referenceList
                                                                }
                                                                value={
                                                                  referenceList.find(
                                                                    (option) =>
                                                                      option.value ===
                                                                        part?.type_id ||
                                                                      option.label ===
                                                                        part?.selectedType,
                                                                  ) ||
                                                                  referenceList.find(
                                                                    (item) =>
                                                                      item.value ===
                                                                      settingCompanyDetails?.reference_type,
                                                                  ) ||
                                                                  referenceList.find(
                                                                    (item) =>
                                                                      item.value ===
                                                                      2,
                                                                  ) ||
                                                                  null
                                                                }
                                                                onChange={(
                                                                  selectedOption,
                                                                ) =>
                                                                  handleConditionChangeRef(
                                                                    part?.id,
                                                                    selectedOption,
                                                                  )
                                                                }
                                                                isSearchable
                                                                placeholder={t("select_type")}
                                                              />
                                                            </div>
                                                          </th>

                                                          {part?.type_id ===
                                                            1 &&
                                                            part?.condition_id_ref ===
                                                              2 && (
                                                              <th scope="col">
                                                                <div className="col-lg-12 addPartField">
                                                                  <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                                    {t("brand")}
                                                                  </label>
                                                                  <input
                                                                    className="form-control input-search"
                                                                    type="text"
                                                                    name="brand"
                                                                    value={
                                                                      part?.brand
                                                                    }
                                                                    onChange={(
                                                                      e,
                                                                    ) =>
                                                                      handleInputChangePartListRef(
                                                                        e,
                                                                        pIndex,
                                                                      )
                                                                    }
                                                                    placeholder={t("brand")}
                                                                    disabled={
                                                                      !getFieldPermission(
                                                                        "parts_reference",
                                                                      ).editable
                                                                    }
                                                                  />
                                                                </div>
                                                              </th>
                                                            )}
                                                          {part?.type_id ===
                                                            1 && (
                                                            <th scope="col">
                                                              <div className="col-lg-12 addPartField">
                                                                <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                                  {t(
                                                                    "manufacter",
                                                                  )}
                                                                </label>
                                                                <input
                                                                  className="form-control input-search"
                                                                  type="text"
                                                                  name="manufacter"
                                                                  value={
                                                                    selectedReferenceCode
                                                                      ? selectedReferenceCode
                                                                      : part?.manufacter
                                                                  }
                                                                  onChange={(
                                                                    e,
                                                                  ) =>
                                                                    handleInputChangePartListRef(
                                                                      e,
                                                                      pIndex,
                                                                    )
                                                                  }
                                                                  placeholder={t("manufacter")}
                                                                  disabled={
                                                                    !getFieldPermission(
                                                                      "parts_reference",
                                                                    ).editable
                                                                  }
                                                                />
                                                              </div>
                                                            </th>
                                                          )}

                                                          <th>
                                                            <button
                                                              style={{
                                                                marginTop:
                                                                  "44px",
                                                              }}
                                                              type="button"
                                                              className="btn btn-primary"
                                                              onClick={() =>
                                                                handleAddPartRef(
                                                                  pIndex,
                                                                )
                                                              }
                                                            >
                                                              Add Reference{" "}
                                                            </button>
                                                          </th>
                                                        </tr>
                                                      </tbody>
                                                      <tbody>
                                                        {part?.addedData?.map(
                                                          (data, rowIndex) => {
                                                            const conditionData =
                                                              Number(
                                                                data?.condition_id,
                                                              );

                                                            const ReferenceData =
                                                              Number(
                                                                data?.type_id,
                                                              );

                                                            const isBackendValidFromData =
                                                              Number(
                                                                data?.condition_id,
                                                              ) === 1 &&
                                                              Number(
                                                                data?.type_id,
                                                              ) === 2;

                                                            const isBackendValidFromCompanySettings =
                                                              settingCompanyDetails?.reference_type ===
                                                                2 &&
                                                              settingCompanyDetails?.reference_condition ===
                                                                1 &&
                                                              Number(
                                                                data?.condition_id_ref,
                                                              ) === 1;

                                                            const isAllBackendValid =
                                                              isBackendValidFromData ||
                                                              isBackendValidFromCompanySettings;

                                                            return (
                                                              <>
                                                                <tr
                                                                  key={rowIndex}
                                                                >
                                                                  <td>
                                                                    <div className="col-lg-12 addPartField">
                                                                      <label className="partsLabel col-form-label ml-2"></label>
                                                                      <button
                                                                        style={{
                                                                          marginLeft:
                                                                            "12px",
                                                                        }}
                                                                        type="button"
                                                                        className="btn btn-primary"
                                                                        onClick={(
                                                                          e,
                                                                        ) => {
                                                                          e.stopPropagation();
                                                                          e.preventDefault();
                                                                          handleOpenPartRefHistoryEdit(
                                                                            e,
                                                                            data?.reference_code,
                                                                          );
                                                                        }}
                                                                      >
                                                                        {data?.reference_parts_count
                                                                          ? data?.reference_parts_count
                                                                          : data?.count ||
                                                                            0}
                                                                      </button>
                                                                    </div>
                                                                  </td>

                                                                  <td>
                                                                    <div className="col-lg-12 addPartField">
                                                                      <label className="partsLabel col-form-label ml-2">
                                                                        Reference
                                                                        Code
                                                                      </label>
                                                                      <input
                                                                        className="form-control"
                                                                        type="text"
                                                                        name="reference_code"
                                                                        value={
                                                                          data?.reference_code
                                                                        }
                                                                        onChange={(
                                                                          e,
                                                                        ) =>
                                                                          handleUpdatePartRef(
                                                                            pIndex,
                                                                            rowIndex,
                                                                            "reference_code",
                                                                            e
                                                                              .target
                                                                              .value,
                                                                          )
                                                                        }
                                                                        placeholder={t("reference_code")}
                                                                      />
                                                                    </div>
                                                                  </td>

                                                                  <td>
                                                                    <label className="partsLabel col-form-label ml-2">
                                                                      Condition
                                                                    </label>
                                                                    <Select
                                                                      className="my-Select"
                                                                      options={
                                                                        conditionList
                                                                      }
                                                                      value={conditionList.find(
                                                                        (
                                                                          option,
                                                                        ) =>
                                                                          option.value ===
                                                                            data?.condition_id_ref ||
                                                                          option.value ===
                                                                            conditionData,
                                                                      )}
                                                                      onChange={(
                                                                        selectedOption,
                                                                      ) => {
                                                                        handleUpdatePartRef(
                                                                          pIndex,
                                                                          rowIndex,
                                                                          "condition_id_ref",
                                                                          selectedOption?.value ||
                                                                            null,
                                                                        );
                                                                        handleUpdatePartRef(
                                                                          pIndex,
                                                                          rowIndex,
                                                                          "condition_id",
                                                                          selectedOption?.value ||
                                                                            null,
                                                                        );
                                                                      }}
                                                                      isSearchable
                                                                      placeholder={t("select_condition")}
                                                                      style={{
                                                                        marginTop:
                                                                          "21px",
                                                                      }}
                                                                    />
                                                                  </td>
                                                                  <td>
                                                                    <label className="partsLabel col-form-label ml-2">
                                                                      Reference
                                                                      Type
                                                                    </label>
                                                                    <Select
                                                                      className="my-Select"
                                                                      options={
                                                                        referenceList
                                                                      }
                                                                      value={referenceList.find(
                                                                        (
                                                                          option,
                                                                        ) =>
                                                                          option.value ===
                                                                          ReferenceData,
                                                                      )}
                                                                      onChange={(
                                                                        selectedOption,
                                                                      ) =>
                                                                        handleUpdatePartRef(
                                                                          pIndex,
                                                                          rowIndex,
                                                                          "type_id",
                                                                          selectedOption?.value ||
                                                                            null,
                                                                        )
                                                                      }
                                                                      isSearchable
                                                                      placeholder={t("select_type")}
                                                                    />
                                                                  </td>
                                                                  {(Number(
                                                                    data?.condition_id,
                                                                  ) === 2 ||
                                                                    data?.condition_id_ref ===
                                                                      2) &&
                                                                    Number(
                                                                      data.type_id,
                                                                    ) === 1 && (
                                                                      <td>
                                                                        <div className="col-lg-12 addPartField">
                                                                          <label className="partsLabel col-form-label ml-2">
                                                                            {t(
                                                                              "brand",
                                                                            )}
                                                                          </label>
                                                                          <input
                                                                            className="form-control input-search"
                                                                            type="text"
                                                                            name="brand"
                                                                            value={
                                                                              data.brand
                                                                            }
                                                                            onChange={(
                                                                              e,
                                                                            ) =>
                                                                              handleUpdatePartRef(
                                                                                pIndex,
                                                                                rowIndex,
                                                                                "brand",
                                                                                e
                                                                                  .target
                                                                                  .value,
                                                                              )
                                                                            }
                                                                            placeholder={t("brand")}
                                                                            style={{
                                                                              marginTop:
                                                                                "21px",
                                                                            }}
                                                                          />
                                                                        </div>
                                                                      </td>
                                                                    )}

                                                                  {Number(
                                                                    data.type_id,
                                                                  ) === 1 && (
                                                                    <td>
                                                                      <div className="col-lg-12 addPartField">
                                                                        <label className="partsLabel col-form-label ml-2">
                                                                          {t(
                                                                            "manufacter",
                                                                          )}
                                                                        </label>
                                                                        <input
                                                                          className="form-control input-search"
                                                                          type="text"
                                                                          name="manufacter"
                                                                          value={
                                                                            data.manufacter
                                                                          }
                                                                          onChange={(
                                                                            e,
                                                                          ) =>
                                                                            handleUpdatePartRef(
                                                                              pIndex,
                                                                              rowIndex,
                                                                              "manufacter",
                                                                              e
                                                                                .target
                                                                                .value,
                                                                            )
                                                                          }
                                                                          placeholder={t("manufacter")}
                                                                          style={{
                                                                            marginTop:
                                                                              "21px",
                                                                          }}
                                                                        />
                                                                      </div>
                                                                    </td>
                                                                  )}
                                                                  <td>
                                                                    <div className="form-check text-left">
                                                                      <label className="partsLabel col-form-label ml-2">
                                                                        Is Main
                                                                      </label>
                                                                      <input
                                                                        style={{
                                                                          marginLeft:
                                                                            "20px",
                                                                        }}
                                                                        className="form-check-input"
                                                                        type="radio"
                                                                        name={`isMainRadioGroup-${pIndex}-${rowIndex}`}
                                                                        checked={
                                                                          data?.is_main ===
                                                                          1
                                                                        }
                                                                        onChange={() =>
                                                                          handleUpdatePartRef(
                                                                            pIndex,
                                                                            rowIndex,
                                                                            "is_main",
                                                                            1,
                                                                          )
                                                                        }
                                                                      />
                                                                    </div>
                                                                  </td>
                                                                  <td>
                                                                    <label className="partsLabel col-form-label ml-2">
                                                                      {t(
                                                                        "action",
                                                                      )}{" "}
                                                                    </label>
                                                                    <i
                                                                      className="bi bi-trash-fill"
                                                                      style={{
                                                                        cursor:
                                                                          "pointer",
                                                                      }}
                                                                      onClick={() =>
                                                                        handleDeletePartRef(
                                                                          pIndex,
                                                                          rowIndex,
                                                                          data.id,
                                                                        )
                                                                      }
                                                                    ></i>{" "}
                                                                  </td>
                                                                  {isAllBackendValid ? (
                                                                    <td>
                                                                      <div className="form-check text-left">
                                                                        <label className="partsLabel col-form-label ml-2"></label>
                                                                        <button
                                                                          type="button"
                                                                          className="btn btn-primary"
                                                                          onClick={(
                                                                            e,
                                                                          ) =>
                                                                            handleOemRefSubmit(
                                                                              e,
                                                                              data,
                                                                            )
                                                                          }
                                                                        >
                                                                          {t(
                                                                            "oem_references",
                                                                          )}
                                                                        </button>
                                                                      </div>
                                                                    </td>
                                                                  ) : (
                                                                    <td></td>
                                                                  )}
                                                                </tr>
                                                              </>
                                                            );
                                                          },
                                                        )}
                                                      </tbody>
                                                    </table>
                                                  </div>
                                                </>
                                              )}
                                              {getFieldPermission(
                                                "parts_damage",
                                              ).show && (
                                                <>
                                                  <div className=" table-responsive-custom-q  table-custom-sticky-inherit">
                                                    <table className="table">
                                                      <tbody>
                                                        <tr>
                                                          <td scope="col">
                                                            <div
                                                              className="col-lg-12 addPartField"
                                                              style={{
                                                                width: "206px",
                                                              }}
                                                            >
                                                              <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                                Damage
                                                                Description
                                                              </label>
                                                              <input
                                                                className="form-control input-search"
                                                                type="text"
                                                                name="damage_description"
                                                                value={
                                                                  selectedReferenceCode
                                                                    ? selectedReferenceCode
                                                                    : part?.damage_description
                                                                }
                                                                onChange={(e) =>
                                                                  handleInputChangePartListRef(
                                                                    e,
                                                                    pIndex,
                                                                  )
                                                                }
                                                                placeholder={t("damage_description")}
                                                              />
                                                            </div>
                                                          </td>

                                                          <td scope="col">
                                                            <div className="col-lg-12 addPartField">
                                                              <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                                Type Damage
                                                              </label>
                                                              <Select
                                                                className="my-Select"
                                                                options={
                                                                  typeDamageList
                                                                }
                                                                value={
                                                                  typeDamageList.find(
                                                                    (option) =>
                                                                      option.value ===
                                                                        part?.type_damage_id ||
                                                                      option.label ===
                                                                        part?.selectedCondition,
                                                                  ) || null
                                                                }
                                                                onChange={(
                                                                  selectedOption,
                                                                ) =>
                                                                  handleTypeDamageChange(
                                                                    pIndex,
                                                                    selectedOption,
                                                                  )
                                                                }
                                                                isSearchable
                                                                placeholder={
                                                                  "Select Type Damage"
                                                                }
                                                              ></Select>
                                                            </div>
                                                          </td>
                                                          <td scope="col">
                                                            <div className="col-lg-12 addPartField">
                                                              <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                                Location Damage
                                                              </label>
                                                              <Select
                                                                className="my-Select"
                                                                options={
                                                                  locationDamageList
                                                                }
                                                                value={
                                                                  locationDamageList.find(
                                                                    (option) =>
                                                                      option.value ===
                                                                        part?.location_damage_id ||
                                                                      option.label ===
                                                                        part?.selectedType,
                                                                  ) || null
                                                                }
                                                                onChange={(
                                                                  selectedOption,
                                                                ) =>
                                                                  hanldeLocationDamageChange(
                                                                    pIndex,
                                                                    selectedOption,
                                                                  )
                                                                }
                                                                isSearchable
                                                                placeholder={t("select_location_damage")}
                                                              />
                                                            </div>
                                                          </td>
                                                          <td scope="col">
                                                            <div
                                                              className="col-lg-12 addPartField"
                                                              style={{
                                                                width: "226px",
                                                              }}
                                                            >
                                                              <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                                Damage Rating
                                                              </label>
                                                              <ReactStars
                                                                size={20}
                                                                count={5}
                                                                activeColor="#ffd700"
                                                                value={
                                                                  part?.damage_rating
                                                                }
                                                                a11y={true}
                                                                isHalf={true}
                                                                emptyIcon={
                                                                  <i className="bi bi-star" />
                                                                }
                                                                halfIcon={
                                                                  <i className="bi bi-star-half" />
                                                                }
                                                                filledIcon={
                                                                  <i className="bi bi-star-fill" />
                                                                }
                                                                onChange={(
                                                                  newRating,
                                                                ) =>
                                                                  handleInputChangePartListRef(
                                                                    {
                                                                      target: {
                                                                        name: "damage_rating",
                                                                        value:
                                                                          newRating,
                                                                      },
                                                                    },
                                                                    pIndex,
                                                                  )
                                                                }
                                                              />
                                                            </div>
                                                          </td>

                                                          <td scope="col"></td>
                                                          <td
                                                            style={{
                                                              verticalAlign:
                                                                "middle",
                                                            }}
                                                          >
                                                            <button
                                                              style={{
                                                                marginTop:
                                                                  "44px",
                                                                width: "155px",
                                                              }}
                                                              type="button"
                                                              className="btn btn-primary"
                                                              onClick={() =>
                                                                handleAddPartDamage(
                                                                  pIndex,
                                                                )
                                                              }
                                                            >
                                                              Add Damage List
                                                            </button>
                                                          </td>
                                                        </tr>
                                                      </tbody>
                                                      <tbody>
                                                        {part?.parts_damage?.map(
                                                          (data, rowIndex) => {
                                                            return (
                                                              <>
                                                                <tr
                                                                  key={rowIndex}
                                                                >
                                                                  <td>
                                                                    <div className="col-lg-12 addPartField">
                                                                      <label className="partsLabel col-form-label ml-2">
                                                                        Damage
                                                                        Description
                                                                      </label>
                                                                      <input
                                                                        className="form-control input-search"
                                                                        type="text"
                                                                        name="damage_description"
                                                                        value={
                                                                          data.damage_description
                                                                        }
                                                                        onChange={(
                                                                          e,
                                                                        ) =>
                                                                          handleUpdatePartDamage(
                                                                            pIndex,
                                                                            rowIndex,
                                                                            "damage_description",
                                                                            e
                                                                              .target
                                                                              .value,
                                                                          )
                                                                        }
                                                                        placeholder={t("damage_description")}
                                                                      />
                                                                    </div>
                                                                  </td>

                                                                  <td>
                                                                    <label className="partsLabel col-form-label ml-2">
                                                                      Type
                                                                      Damage
                                                                    </label>
                                                                    <Select
                                                                      className="my-Select"
                                                                      options={
                                                                        typeDamageList
                                                                      }
                                                                      value={typeDamageList.find(
                                                                        (
                                                                          option,
                                                                        ) =>
                                                                          option.value ===
                                                                          Number(
                                                                            data.type_damage_id,
                                                                          ),
                                                                      )}
                                                                      onChange={(
                                                                        selectedOption,
                                                                      ) =>
                                                                        handleUpdatePartDamage(
                                                                          pIndex,
                                                                          rowIndex,
                                                                          "type_damage_id",
                                                                          selectedOption?.value ||
                                                                            null,
                                                                        )
                                                                      }
                                                                      isSearchable
                                                                      placeholder={t("select_type_damage")}
                                                                    />
                                                                  </td>
                                                                  <td>
                                                                    <label className="partsLabel col-form-label ml-2">
                                                                      Location
                                                                      Damage
                                                                    </label>
                                                                    <Select
                                                                      className="my-Select"
                                                                      options={
                                                                        locationDamageList
                                                                      }
                                                                      value={locationDamageList.find(
                                                                        (
                                                                          option,
                                                                        ) =>
                                                                          option.value ===
                                                                          Number(
                                                                            data.location_damage_id,
                                                                          ),
                                                                      )}
                                                                      onChange={(
                                                                        selectedOption,
                                                                      ) =>
                                                                        handleUpdatePartDamage(
                                                                          pIndex,
                                                                          rowIndex,
                                                                          "location_damage_id",
                                                                          selectedOption?.value ||
                                                                            null,
                                                                        )
                                                                      }
                                                                      isSearchable
                                                                      placeholder={t("select_location_damage")}
                                                                    />
                                                                  </td>
                                                                  <th scope="col">
                                                                    <div className="col-lg-12 addPartField">
                                                                      <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                                        Damage
                                                                        Rating
                                                                      </label>
                                                                      <ReactStars
                                                                        size={
                                                                          20
                                                                        }
                                                                        count={
                                                                          5
                                                                        }
                                                                        activeColor="#ffd700"
                                                                        a11y={
                                                                          true
                                                                        }
                                                                        isHalf={
                                                                          true
                                                                        }
                                                                        emptyIcon={
                                                                          <i className="bi bi-star" />
                                                                        }
                                                                        halfIcon={
                                                                          <i className="bi bi-star-half" />
                                                                        }
                                                                        filledIcon={
                                                                          <i className="bi bi-star-fill" />
                                                                        }
                                                                        value={
                                                                          data?.damage_rating
                                                                        }
                                                                        onChange={(
                                                                          newRating,
                                                                        ) =>
                                                                          handleUpdatePartDamage(
                                                                            pIndex,
                                                                            rowIndex,
                                                                            "damage_rating",
                                                                            newRating,
                                                                          )
                                                                        }
                                                                      />
                                                                    </div>
                                                                  </th>
                                                                  <td>
                                                                    <i
                                                                      className="bi bi-trash-fill"
                                                                      style={{
                                                                        cursor:
                                                                          "pointer",
                                                                      }}
                                                                      onClick={() =>
                                                                        handleDeletePartDamage(
                                                                          pIndex,
                                                                          rowIndex,
                                                                          data.id,
                                                                        )
                                                                      }
                                                                    ></i>{" "}
                                                                  </td>
                                                                </tr>
                                                              </>
                                                            );
                                                          },
                                                        )}
                                                      </tbody>
                                                    </table>
                                                  </div>
                                                </>
                                              )}

                                              {part?.catalog_part_check_list && (
                                                <div className="row">
                                                  <div
                                                    className="col-md-12"
                                                    style={{
                                                      marginTop: "10px",
                                                    }}
                                                  >
                                                    <div className="vehicleThBg table-responsive min-height-0 pb-2">
                                                      <table className="rounded-table table table-striped table-bordered table-hove">
                                                        <thead>
                                                          <tr>
                                                            <th
                                                              style={{
                                                                width: "10%",
                                                              }}
                                                            >
                                                              {t("name")}
                                                            </th>

                                                            <th
                                                              style={{
                                                                width: "10%",
                                                              }}
                                                            >
                                                              {t("description")}
                                                            </th>
                                                            <th
                                                              style={{
                                                                width: "10%",
                                                              }}
                                                            >
                                                              {t("is_default")}
                                                            </th>
                                                            <th
                                                              style={{
                                                                width: "10%",
                                                              }}
                                                            >
                                                              {t("part_check")}
                                                            </th>
                                                          </tr>
                                                        </thead>

                                                        <tbody>
                                                          {part
                                                            ?.catalog_part_check_list
                                                            ?.length > 0 ? (
                                                            part?.catalog_part_check_list?.map(
                                                              (item, index) => (
                                                                <tr key={index}>
                                                                  <td>
                                                                    {item?.name}
                                                                  </td>
                                                                  <td>
                                                                    {item?.description ||
                                                                      "-"}
                                                                  </td>
                                                                  <td>
                                                                    {item?.is_default ===
                                                                    1
                                                                      ? "Yes"
                                                                      : "No"}
                                                                  </td>

                                                                  <td>
                                                                    <Select
                                                                      className="my-select-v"
                                                                      options={
                                                                        partCheckListStatusList
                                                                      }
                                                                      value={
                                                                        item?.check_list_status ===
                                                                        0
                                                                          ? null
                                                                          : partCheckListStatusList.find(
                                                                              (
                                                                                option,
                                                                              ) =>
                                                                                option.value ===
                                                                                item?.check_list_status,
                                                                            )
                                                                      }
                                                                      onChange={(
                                                                        option,
                                                                      ) =>
                                                                        handleUpdatePartCheckStatus(
                                                                          pIndex,
                                                                          index,
                                                                          "check_list_status",
                                                                          option.value,
                                                                          item,
                                                                        )
                                                                      }
                                                                      placeholder={t("pi_select_part_check")}
                                                                      isDisabled={
                                                                        item?.part_converted_status ===
                                                                        1
                                                                      }
                                                                      menuPortalTarget={
                                                                        document.body
                                                                      }
                                                                      styles={{
                                                                        menuPortal:
                                                                          (
                                                                            base,
                                                                          ) => ({
                                                                            ...base,
                                                                            zIndex: 9999,
                                                                          }),
                                                                      }}
                                                                    />
                                                                  </td>
                                                                </tr>
                                                              ),
                                                            )
                                                          ) : (
                                                            <tr className="scrollBrdr">
                                                              <td colSpan={6}>
                                                                {t(
                                                                  "no_record_found",
                                                                )}
                                                              </td>
                                                            </tr>
                                                          )}
                                                        </tbody>
                                                      </table>
                                                    </div>
                                                  </div>
                                                </div>
                                              )}

                                              {part?.parts_catalog_attributes && (
                                                <>
                                                  <div className=" table-responsive-custom-q  table-custom-sticky-inherit">
                                                    <table className="table">
                                                      <div className="row justify-content-start">
                                                        {part?.parts_catalog_attributes?.text?.map(
                                                          (item, index) => {
                                                            const behavior =
                                                              getFieldBehavior(
                                                                item,
                                                              );
                                                            return (
                                                              behavior.shouldShow && (
                                                                <div
                                                                  className="col-lg-4 col-md-4 col-sm-12 mb-3"
                                                                  key={item.id}
                                                                  style={{
                                                                    padding:
                                                                      "15px",
                                                                  }}
                                                                >
                                                                  <label className="partsLabel col-form-label ml-2 Label-my form-label">
                                                                    {
                                                                      item?.label_name
                                                                    }
                                                                    {behavior.isRequired && (
                                                                      <span className="text-danger">
                                                                        {" "}
                                                                        *
                                                                      </span>
                                                                    )}
                                                                  </label>

                                                                  <input
                                                                    type="text"
                                                                    className="form-control input-search"
                                                                    name={`attribute_${item.id}`}
                                                                    value={getAttributeValue(
                                                                      part,
                                                                      item.id,
                                                                    )}
                                                                    onChange={(
                                                                      e,
                                                                    ) =>
                                                                      handleGenericAttributeInputChange(
                                                                        e,
                                                                        item.id,
                                                                        part.tempId,
                                                                      )
                                                                    }
                                                                    placeholder="text"
                                                                    // disabled={
                                                                    //   !behavior.isEditable
                                                                    // }
                                                                    required={
                                                                      behavior.isRequired
                                                                    }
                                                                  />

                                                                  {errors[
                                                                    `attribute_${item.id}`
                                                                  ] && (
                                                                    <span className="input-error">
                                                                      {
                                                                        errors[
                                                                          `attribute_${item.id}`
                                                                        ]
                                                                      }
                                                                    </span>
                                                                  )}
                                                                </div>
                                                              )
                                                            );
                                                          },
                                                        )}

                                                        {part.parts_catalog_attributes?.integer?.map(
                                                          (item, index) => {
                                                            const behavior =
                                                              getFieldBehavior(
                                                                item,
                                                              );
                                                            return (
                                                              behavior.shouldShow && (
                                                                <div
                                                                  className="col-lg-4 col-md-4 col-sm-12 mb-3"
                                                                  key={item.id}
                                                                  style={{
                                                                    padding:
                                                                      "15px",
                                                                  }}
                                                                >
                                                                  <label className="partsLabel col-form-label ml-2 Label-my form-label">
                                                                    {
                                                                      item?.label_name
                                                                    }
                                                                    {behavior.isRequired && (
                                                                      <span className="text-danger">
                                                                        {" "}
                                                                        *
                                                                      </span>
                                                                    )}
                                                                  </label>

                                                                  <input
                                                                    type="number"
                                                                    className="form-control input-search"
                                                                    name={`attribute_${item.id}`}
                                                                    value={getAttributeValue(
                                                                      part,
                                                                      item.id,
                                                                    )}
                                                                    onChange={(
                                                                      e,
                                                                    ) =>
                                                                      handleGenericAttributeInputChange(
                                                                        e,
                                                                        item.id,
                                                                        part.tempId,
                                                                      )
                                                                    }
                                                                    placeholder="0"
                                                                    onKeyDown={(
                                                                      e,
                                                                    ) => {
                                                                      if (
                                                                        e.key ===
                                                                          "-" ||
                                                                        e.key ===
                                                                          "e"
                                                                      ) {
                                                                        e.preventDefault();
                                                                      }
                                                                    }}
                                                                    disabled={
                                                                      !behavior.isEditable
                                                                    }
                                                                    required={
                                                                      behavior.isRequired
                                                                    }
                                                                  />

                                                                  {errors[
                                                                    `attribute_${item.id}`
                                                                  ] && (
                                                                    <span className="input-error">
                                                                      {
                                                                        errors[
                                                                          `attribute_${item.id}`
                                                                        ]
                                                                      }
                                                                    </span>
                                                                  )}
                                                                </div>
                                                              )
                                                            );
                                                          },
                                                        )}

                                                        {part.parts_catalog_attributes?.float?.map(
                                                          (item, index) => {
                                                            const behavior =
                                                              getFieldBehavior(
                                                                item,
                                                              );
                                                            return (
                                                              behavior.shouldShow && (
                                                                <div
                                                                  className="col-lg-4 col-md-4 col-sm-12 mb-3"
                                                                  key={item.id}
                                                                  style={{
                                                                    padding:
                                                                      "15px",
                                                                  }}
                                                                >
                                                                  <label className="partsLabel col-form-label ml-2 Label-my form-label">
                                                                    {
                                                                      item?.label_name
                                                                    }
                                                                    {behavior.isRequired && (
                                                                      <span className="text-danger">
                                                                        {" "}
                                                                        *
                                                                      </span>
                                                                    )}
                                                                  </label>

                                                                  <input
                                                                    type="number"
                                                                    className="form-control input-search"
                                                                    name={`attribute_${item.id}`}
                                                                    value={getAttributeValue(
                                                                      part,
                                                                      item.id,
                                                                    )}
                                                                    onChange={(
                                                                      e,
                                                                    ) =>
                                                                      handleGenericAttributeInputChange(
                                                                        e,
                                                                        item.id,
                                                                        part.tempId,
                                                                      )
                                                                    }
                                                                    placeholder="0"
                                                                    disabled={
                                                                      !behavior.isEditable
                                                                    }
                                                                    required={
                                                                      behavior.isRequired
                                                                    }
                                                                    min="0"
                                                                    onKeyDown={(
                                                                      e,
                                                                    ) => {
                                                                      if (
                                                                        e.key ===
                                                                          "-" ||
                                                                        e.key ===
                                                                          "e"
                                                                      ) {
                                                                        e.preventDefault();
                                                                      }
                                                                    }}
                                                                  />

                                                                  {errors[
                                                                    `attribute_${item.id}`
                                                                  ] && (
                                                                    <span className="input-error">
                                                                      {
                                                                        errors[
                                                                          `attribute_${item.id}`
                                                                        ]
                                                                      }
                                                                    </span>
                                                                  )}
                                                                </div>
                                                              )
                                                            );
                                                          },
                                                        )}

                                                        {part.parts_catalog_attributes?.date?.map(
                                                          (item, index) => {
                                                            const behavior =
                                                              getFieldBehavior(
                                                                item,
                                                              );
                                                            return (
                                                              behavior.shouldShow && (
                                                                <div
                                                                  className="col-lg-4 col-md-4 col-sm-12 mb-3"
                                                                  key={item.id}
                                                                  style={{
                                                                    padding:
                                                                      "15px",
                                                                  }}
                                                                >
                                                                  <label className="partsLabel col-form-label ml-2 Label-my form-label">
                                                                    {
                                                                      item?.label_name
                                                                    }
                                                                    {behavior.isRequired && (
                                                                      <span className="text-danger">
                                                                        {" "}
                                                                        *
                                                                      </span>
                                                                    )}
                                                                  </label>
                                                                  <input
                                                                    type="date"
                                                                    className="form-control input-search"
                                                                    name={`attribute_${item.id}`}
                                                                    value={getAttributeValue(
                                                                      part,
                                                                      item.id,
                                                                    )}
                                                                    onChange={(
                                                                      e,
                                                                    ) =>
                                                                      handleGenericAttributeInputChange(
                                                                        e,
                                                                        item.id,
                                                                        part.tempId,
                                                                      )
                                                                    }
                                                                    placeholder="0"
                                                                    disabled={
                                                                      !behavior.isEditable
                                                                    }
                                                                    required={
                                                                      behavior.isRequired
                                                                    }
                                                                  />

                                                                  {errors[
                                                                    `attribute_${item.id}`
                                                                  ] && (
                                                                    <span className="input-error">
                                                                      {
                                                                        errors[
                                                                          `attribute_${item.id}`
                                                                        ]
                                                                      }
                                                                    </span>
                                                                  )}
                                                                </div>
                                                              )
                                                            );
                                                          },
                                                        )}

                                                        {part.parts_catalog_attributes?.selection?.map(
                                                          (item, index) => {
                                                            const behavior =
                                                              getFieldBehavior(
                                                                item,
                                                              );
                                                            return (
                                                              behavior.shouldShow && (
                                                                <div
                                                                  className="col-lg-4 col-md-4 col-sm-12 mb-3"
                                                                  key={item.id}
                                                                  style={{
                                                                    padding:
                                                                      "15px",
                                                                  }}
                                                                >
                                                                  <label className="partsLabel col-form-label ml-2 Label-my form-label">
                                                                    {
                                                                      item?.label_name
                                                                    }
                                                                    {behavior.isRequired && (
                                                                      <span className="text-danger">
                                                                        {" "}
                                                                        *
                                                                      </span>
                                                                    )}
                                                                  </label>
                                                                  <Select
                                                                    className="my-Select"
                                                                    options={item.options?.map(
                                                                      (
                                                                        opt,
                                                                      ) => ({
                                                                        value:
                                                                          opt.id,
                                                                        label:
                                                                          opt.option_name,
                                                                      }),
                                                                    )}
                                                                    name={`attribute_${item.id}`}
                                                                    value={
                                                                      item.options
                                                                        ?.map(
                                                                          (
                                                                            opt,
                                                                          ) => ({
                                                                            value:
                                                                              opt.id,
                                                                            label:
                                                                              opt.option_name,
                                                                          }),
                                                                        )
                                                                        .find(
                                                                          (
                                                                            opt,
                                                                          ) =>
                                                                            opt.label ===
                                                                            getAttributeValue(
                                                                              part,
                                                                              item.id,
                                                                            ),
                                                                        ) ||
                                                                      null
                                                                    }
                                                                    onChange={(
                                                                      selectedOption,
                                                                    ) => {
                                                                      handleAttributeSelectChange(
                                                                        selectedOption,
                                                                        item.id,
                                                                        part.tempId,
                                                                      );
                                                                    }}
                                                                    placeholder={t("pi_select_option")}
                                                                    isSearchable={
                                                                      true
                                                                    }
                                                                    menuPortalTarget={
                                                                      document.body
                                                                    }
                                                                    styles={{
                                                                      menuPortal:
                                                                        (
                                                                          base,
                                                                        ) => ({
                                                                          ...base,
                                                                          zIndex: 9999,
                                                                        }),
                                                                    }}
                                                                    isDisabled={
                                                                      !behavior.isEditable
                                                                    }
                                                                    isRequired={
                                                                      behavior.isRequired
                                                                    }
                                                                  />

                                                                  {errors[
                                                                    `attribute_${item.id}`
                                                                  ] && (
                                                                    <span className="input-error">
                                                                      {
                                                                        errors[
                                                                          `attribute_${item.id}`
                                                                        ]
                                                                      }
                                                                    </span>
                                                                  )}
                                                                </div>
                                                              )
                                                            );
                                                          },
                                                        )}

                                                        {part.parts_catalog_attributes?.checkbox?.map(
                                                          (item, index) => {
                                                            const behavior =
                                                              getFieldBehavior(
                                                                item,
                                                              );
                                                            return (
                                                              behavior.shouldShow && (
                                                                <>
                                                                  <div
                                                                    className="col-md-6"
                                                                    key={
                                                                      item.id
                                                                    }
                                                                  >
                                                                    <div
                                                                      className="d-flex align-items-center gap-2"
                                                                      style={{
                                                                        display:
                                                                          "flex",
                                                                        alignItems:
                                                                          "center",
                                                                        gap: "8px",
                                                                      }}
                                                                    >
                                                                      <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        id={`attribute_${item.id}`}
                                                                        name={`attribute_${item.id}`}
                                                                        checked={
                                                                          getAttributeValue(
                                                                            part,
                                                                            item.id,
                                                                          ) ===
                                                                          "1"
                                                                        }
                                                                        onChange={(
                                                                          e,
                                                                        ) =>
                                                                          handleAttributeCheckboxChange(
                                                                            e,
                                                                            item.id,
                                                                            part.tempId,
                                                                          )
                                                                        }
                                                                        style={{
                                                                          marginLeft:
                                                                            "9px",
                                                                        }}
                                                                        disabled={
                                                                          !behavior.isEditable
                                                                        }
                                                                        required={
                                                                          behavior.isRequired
                                                                        }
                                                                      />
                                                                      <label
                                                                        className="form-check-label mb-0"
                                                                        htmlFor={`attribute_${item.id}`}
                                                                        style={{
                                                                          fontWeight: 700,
                                                                          fontSize:
                                                                            "16px",
                                                                          marginLeft:
                                                                            "35px",
                                                                          marginTop:
                                                                            "7px",
                                                                        }}
                                                                      >
                                                                        {
                                                                          item?.label_name
                                                                        }
                                                                        {behavior.isRequired && (
                                                                          <span className="text-danger">
                                                                            {" "}
                                                                            *
                                                                          </span>
                                                                        )}
                                                                      </label>
                                                                    </div>

                                                                    {errors[
                                                                      `attribute_${item.id}`
                                                                    ] && (
                                                                      <span className="input-error">
                                                                        {
                                                                          errors[
                                                                            `attribute_${item.id}`
                                                                          ]
                                                                        }
                                                                      </span>
                                                                    )}
                                                                  </div>

                                                                  <div className="col-md-6"></div>
                                                                </>
                                                              )
                                                            );
                                                          },
                                                        )}
                                                      </div>{" "}
                                                    </table>
                                                  </div>
                                                </>
                                              )}
                                            </Card.Body>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </React.Fragment>
                              );
                            })}
                          </div>
                          <div className="back-footer">
                            <div className="row">
                              <div className="col-sm-6">
                                <button
                                  type="button"
                                  className="next-button btn btn-secondary"
                                  onClick={() => {
                                    if (state?.state?.history_id) {
                                      navigate("/history-repairs-process");
                                    } else {
                                      navigate("/parts-inventory");
                                    }
                                  }}
                                >
                                  <i className="bi bi-arrow-left"></i>{" "}
                                  {t("back")}
                                </button>
                              </div>

                              <div className="col-lg-6 btnTextAlign">
                                <div className="d-flex justify-content-end">
                                  {btnSaveNext ? (
                                    <button
                                      type="submit"
                                      disabled={true}
                                      className="btn btn-primary mr-2"
                                    >
                                      Loading...
                                    </button>
                                  ) : (
                                    <button
                                      type="submit"
                                      className="btn btn-primary mr-2"
                                    >
                                      {t("save")}& {t("next")}
                                      <i className="bi bi-save ms-2"></i>
                                    </button>
                                  )}

                                  <button
                                    type="button"
                                    className="btn btn-primary me-2"
                                    onClick={handleNextPart}
                                  >
                                    {t("next")}
                                    <i className="bi bi-arrow-right ms-2"></i>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Form>
                      </div>
                    </div>
                  </>
                )}

                {currentStep === 3 && (
                  <>
                    <div className="card-body vehicleparts-table mt-3">
                      <div className="vehicleparts-table-inner">
                        <div className="row">
                          <>
                            <Form onSubmit={handleSubmits} className="row">
                              <React.Fragment>
                                <div className="col-lg-12">
                                  <Card className="text-center">
                                    <Card.Header className="cardHeader">
                                      <div className="d-flex">
                                        <div className="AddPh6">
                                          <h6>Part Information</h6>
                                        </div>
                                      </div>
                                    </Card.Header>
                                    <Card.Body
                                      className="cardBody"
                                      style={{ padding: "0" }}
                                    >
                                      <div className="container text-justify">
                                        <div
                                          className="row"
                                          style={{
                                            padding: "8px",
                                            borderBottom: "1px solid #eee",
                                          }}
                                        >
                                          <div className="col">Part Name</div>
                                          <div className="col">
                                            {vehicleAddDetails?.part_name}
                                          </div>
                                        </div>
                                        <div
                                          className="row"
                                          style={{
                                            padding: "8px",
                                            borderBottom: "1px solid #eee",
                                          }}
                                        >
                                          <div className="col">
                                            Part Description
                                          </div>
                                          <div className="col">
                                            {
                                              vehicleAddDetails?.part_description
                                            }
                                          </div>
                                        </div>

                                        <div
                                          className="row"
                                          style={{
                                            padding: "8px",
                                            borderBottom: "1px solid #eee",
                                          }}
                                        >
                                          <div className="col">
                                            Part Quantity
                                          </div>
                                          <div className="col">
                                            {vehicleAddDetails?.quantity || "1"}
                                          </div>
                                        </div>
                                        <div
                                          className="row"
                                          style={{
                                            padding: "8px",
                                            borderBottom: "1px solid #eee",
                                          }}
                                        >
                                          <div className="col">Part Price</div>
                                          <div className="col">
                                            {vehicleAddDetails?.part_price || 0}{" "}
                                            €
                                          </div>
                                        </div>

                                        <div
                                          className="row"
                                          style={{
                                            padding: "8px",
                                            borderBottom: "1px solid #eee",
                                          }}
                                        >
                                          <div
                                            className="col"
                                            style={{ lineHeight: "18px" }}
                                          >
                                            Sponsor Price{" "}
                                          </div>
                                          <div className="col">
                                            {vehicleAddDetails?.sponsor_price ||
                                              0}{" "}
                                            €
                                          </div>
                                        </div>
                                      </div>
                                    </Card.Body>
                                  </Card>
                                </div>

                                <div className="col-lg-12">
                                  <Card className="text-center">
                                    <Card.Header className="cardHeader">
                                      <div className="d-flex">
                                        <div className="AddPh6">
                                          <h6>{t("upload_part_images")}</h6>
                                        </div>
                                      </div>
                                    </Card.Header>
                                    <Card.Body className="cardBody">
                                      {getFieldPermission("parts_photos")
                                        .show && (
                                        <div className="row">
                                          <div className="col-lg-12 addPartField">
                                            <div className="col-lg-12 addPartField">
                                              <label className="partsLabel col-form-label ml-2 Label-my form-label form-label uploadImgs">
                                                {t("upload_images")}{" "}
                                              </label>
                                              <div className="input-div">
                                                <div className="avatar-upload">
                                                  <div className="avatar-edit">
                                                    <input
                                                      ref={fileInputRef}
                                                      className="inputFile"
                                                      type="file"
                                                      id="imageuploadAbout"
                                                      onChange={
                                                        handleAboutFileChange
                                                      }
                                                      name="file"
                                                      accept=".jpg,.jpeg,.png,.webp,.jfif"
                                                      multiple
                                                    />
                                                    <PhotoProvider
                                                      visible={viewerOpen}
                                                      onVisibleChange={(v) =>
                                                        setViewerOpen(v)
                                                      }
                                                      current={viewerIndex}
                                                      onIndexChange={(i) =>
                                                        setViewerIndex(i)
                                                      }
                                                    >
                                                      <div className="input-div input-div-custom">
                                                        {previewUrl?.length >
                                                          0 &&
                                                        images?.length > 0 ? (
                                                          <>
                                                            {images?.map(
                                                              (file, index) => (
                                                                <div
                                                                  key={index}
                                                                  className="partImages mt-2"
                                                                >
                                                                  <div
                                                                    className="preview-item file-item-custom"
                                                                    style={{
                                                                      position:
                                                                        "relative",
                                                                    }}
                                                                  >
                                                                    {/* PhotoView wrapper */}
                                                                    <PhotoView
                                                                      src={
                                                                        previewUrl[
                                                                          index
                                                                        ]
                                                                      }
                                                                    >
                                                                      <img
                                                                        src={
                                                                          previewUrl[
                                                                            index
                                                                          ]
                                                                        }
                                                                        alt={`Preview ${index}`}
                                                                        style={{
                                                                          width:
                                                                            "100px",
                                                                          margin:
                                                                            "5px",
                                                                          height:
                                                                            "100px",
                                                                          border:
                                                                            "1px solid",
                                                                          borderRadius:
                                                                            "5px",
                                                                          maxWidth:
                                                                            "100px",
                                                                          maxHeight:
                                                                            "100px",
                                                                          cursor:
                                                                            "pointer",
                                                                        }}
                                                                        onClick={() => {
                                                                          setViewerIndex(
                                                                            index,
                                                                          );
                                                                          setViewerOpen(
                                                                            true,
                                                                          );
                                                                        }}
                                                                      />
                                                                    </PhotoView>

                                                                    {/* BLUE EDIT ICON */}
                                                                    <i
                                                                      className="editImageBtn bi bi-pen-fill"
                                                                      style={{
                                                                        position:
                                                                          "absolute",
                                                                        top: "33px",
                                                                        left: "35px",
                                                                        cursor:
                                                                          "pointer",
                                                                        color:
                                                                          "blue",
                                                                      }}
                                                                      onClick={() =>
                                                                        handleImageSelect(
                                                                          file,
                                                                        )
                                                                      }
                                                                    ></i>

                                                                    {/* RED DELETE ICON */}
                                                                    <i
                                                                      className="removeImageBtn bi bi-x"
                                                                      style={{
                                                                        position:
                                                                          "absolute",
                                                                        top: "33px",
                                                                        right:
                                                                          "13px",
                                                                        cursor:
                                                                          "pointer",
                                                                        color:
                                                                          "red",
                                                                      }}
                                                                      onClick={() =>
                                                                        handleRemoveFile(
                                                                          index,
                                                                          file.id,
                                                                        )
                                                                      }
                                                                    ></i>
                                                                  </div>
                                                                </div>
                                                              ),
                                                            )}
                                                          </>
                                                        ) : null}
                                                      </div>
                                                    </PhotoProvider>

                                                    <label htmlFor="imageuploadAbout"></label>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    </Card.Body>
                                  </Card>
                                </div>
                              </React.Fragment>
                              <div className="d-flex flex-row mt-3 finishBtn justify-content-between">
                                {/* {!isLastPart && (
                                  <Button
                                    className="me-2 mb-2 btn-primary"
                                    onClick={handleOpenSkip}
                                  >
                                     {t("skip")} & Next
                                  </Button>
                                )}

                                {!isLastPart && (
                                  <Button className="me-2 mb-2 btn-primary" type="submit">
                                                                    {t("save")}
 & Next
                                  </Button>
                                )} */}

                                {/* {isLastPart && ( */}
                                <div className="d-flex">
                                  <button
                                    type="button"
                                    className="back-btn bottomSpace"
                                    onClick={handleBackButtonClick}
                                  >
                                    <i className="bi bi-arrow-left"></i>{" "}
                                    {t("back")}
                                  </button>
                                </div>
                                <div className="d-flex">
                                  {btnSaved === true ? (
                                    <button
                                      type="button"
                                      disabled={true}
                                      className="btn btn-primary"
                                    >
                                      Loading...
                                    </button>
                                  ) : (
                                    <Button
                                      className="mb-2 next-button"
                                      onClick={handleFinish}
                                      style={{ marginRight: "10px" }}
                                      type="button"
                                    >
                                      {t("save")}
                                      <i className="bi bi-save"></i>
                                    </Button>
                                  )}

                                  <Button
                                    type="Button"
                                    className="btn btn-primary nxt-btn"
                                    onClick={handleImportModal}
                                  >
                                    Sort By Order{" "}
                                    <i className="bi bi-arrow-right"></i>
                                  </Button>

                                  <Button
                                    className="me-2 mb-2 btn-Finish"
                                    onClick={hanldeLastEditfinish}
                                  >
                                    {t("finish")}
                                    <i className="bi bi-check2"></i>
                                  </Button>
                                </div>

                                {/* )} */}
                                {/* {isLastPart && (
                                  <Button
                                    className="me-2 mb-2"
                                    onClick={() => navigate("/parts-inventory")}
                                  >
                                    Close
                                  </Button>
                                )} */}
                              </div>
                            </Form>
                          </>
                        </div>
                      </div>
                    </div>
                  </>
                )}

                {currentStep === 4 && (
                  <AssignedDamageImage
                    partImageDataList={partImageDataList}
                    currentStep={currentStep}
                    setCurrentStep={setCurrentStep}
                    currentPartIndex={currentPartIndex}
                    setCurrentPartIndex={setCurrentPartIndex}
                    isLastPart={isLastPart}
                    detailsForImages={detailsForImages}
                    partsData={partsData}
                    vehicleAddDetails={vehicleAddDetails}
                  />
                )}

                {currentStep === 5 && (
                  <AddPartVideo
                    currentStep={currentStep}
                    currentPart={currentPart}
                    vehicleAddDetails={vehicleAddDetails}
                    setCurrentStep={setCurrentStep}
                    isLastPart={isLastPart}
                    showSkip={showSkip}
                    setShowSkip={setShowSkip}
                    setPartVideoDataList={setPartVideoDataList}
                    partVideoDataList={partVideoDataList}
                    partsData={partsData}
                    detailsForVideo={detailsForVideo}
                    setCurrentPartVideoIndex={setCurrentPartVideoIndex}
                    currentPartVideoIndex={currentPartVideoIndex}
                    getFieldPermission={getFieldPermission}
                  />
                )}

                {currentStep === 6 && (
                  <AssignedDamageVideo
                    partVideoDataList={partVideoDataList}
                    currentStep={currentStep}
                    setCurrentStep={setCurrentStep}
                    currentPartVideoIndex={currentPartVideoIndex}
                    setCurrentPartVideoIndex={setCurrentPartVideoIndex}
                    partsData={partsData}
                  />
                )}
              </>
            ) : (
              <>
                {uuid && (
                  <div className="text-center p-4">
                    <p>{t("pi_no_data_found")}</p>
                  </div>
                )}
              </>
            )}

            {!uuid && (
              <>
                {currentStep === 1 && (
                  <>
                    <div className="d-flex">
                      <div className="mt-2">
                        <FormGroup>
                          <Label className="col-form-label ml-2">
                            {t("vehicle")}
                          </Label>
                        </FormGroup>
                      </div>
                      <div className="">
                        {vehicleModalSelectedList?.vehicle_in_inventory ===
                          true && (
                          <div className="mt-2 ms-3">
                            <Button
                              className="next-button"
                              type="button"
                              style={{ width: "134px" }}
                              onClick={onvehiclePartDetailsOpen}
                            >
                              {t("pi_btn_exceed_part")}
                              <i className="bi bi-tools"></i>
                            </Button>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-7">
                        <div className="card-body vehicleparts-table vehicleparts-table-h-100">
                          <div className="row justify-content-start">
                            <div className="col-md-6">
                              <div className="input-div">
                                <Select
                                  className="my-Select"
                                  options={VehicleModelAllList}
                                  value={
                                    VehicleModelAllList.find(
                                      (item) =>
                                        item.value ===
                                        (vehicleModalSelectedList?.vehicle_model_name ||
                                          vehicleMainData?.item?.vehicle_model),
                                    ) || null
                                  }
                                  onChange={(selectedOption) => {
                                    setVehicleEngineId({
                                      ...vehicleModalSelectedList,
                                      vehicle_model_name: selectedOption
                                        ? selectedOption.value
                                        : "",
                                    });
                                    setVehicleModalSelectedList(selectedOption);
                                  }}
                                  isSearchable={true}
                                  onInputChange={handleInputChange}
                                  inputSelctedValue={inputValue}
                                  placeholder={t("pi_fp_select_vehicle_short")}
                                />
                              </div>
                            </div>

                            <div
                              className="col-md-6"
                              style={{ marginBottom: "10px" }}
                            >
                              <div className="row">
                                <div className="col-md-10">
                                  <Select
                                    className="my-Select"
                                    options={DismetalList}
                                    value={
                                      DismetalList.find(
                                        (item) =>
                                          item.value ===
                                          dismentalData.dismantle_id,
                                      ) || null
                                    }
                                    onChange={
                                      handleSelectWithoutChangeDismetalList
                                    }
                                    placeholder={t("pi_fp_select_dismantle")}
                                    isSearchable={true}
                                    onInputChange={
                                      handleInputSelectedChangeDismetalList
                                    }
                                    inputSelctedValue={
                                      inputSelctedDismetalValue
                                    }
                                  />{" "}
                                </div>
                                <div
                                  className="col-md-2"
                                  style={{ marginTop: "10px" }}
                                >
                                  <div
                                    className="addBtn"
                                    style={{ cursor: "pointer" }}
                                    onClick={handleTempDismetalAddClick}
                                  >
                                    <i className="bi bi-plus-lg"></i>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="mb-3  vehicleparts-input">
                                <div className="">
                                  <div className="">
                                    <input
                                      className="form-control input-search"
                                      type="text"
                                      value={searchQuery}
                                      onChange={handleSearchChange}
                                      maxLength={50}
                                      placeholder={t("search")}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            {vehicleModalSelectedList?.vehicle_model_name && (
                              <div className="col-md-6">
                                <div style={{ marginTop: "10px" }}>
                                  <div
                                    style={{
                                      cursor: "pointer",
                                      backgroundColor: "#9458f8",
                                      justifyItems: "center",
                                      width: "30px",
                                      height: "30px",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      borderRadius: "2px",
                                      border: "none",
                                      opacity: "unset",
                                    }}
                                    onClick={() =>
                                      navigate("/auto-fill-parts", {
                                        state: {
                                          item: vehicleExceedData,
                                        },
                                      })
                                    }
                                  >
                                    <i
                                      className="bi bi-robot"
                                      style={{ color: "white" }}
                                    ></i>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                          <div className="vehicleparts-table-inner vehicleThBg tableScroll min-height-0 pb-2">
                            <table className="rounded-table table table-striped table-bordered table-hover">
                              <thead>
                                <tr>
                                  <th style={{ width: "10%" }}>Part Catalog</th>
                                  {(vehicleModalSelectedList?.vehicle_model_id ||
                                    vehicleMainData?.item?.id) && (
                                    <th style={{ width: "10%" }}>Vehicle</th>
                                  )}

                                  <th style={{ width: "0%" }}>{t("action")}</th>
                                </tr>
                              </thead>

                              <tbody>
                                {(vehicleModalSelectedList?.vehicle_model_id
                                  ? filteredCatalogList
                                  : CatalogList.data
                                )?.length > 0 ? (
                                  (vehicleModalSelectedList?.vehicle_model_id
                                    ? filteredCatalogList
                                    : CatalogList.data
                                  ).map((item, index) => (
                                    <tr key={index}>
                                      <td>
                                        {LangData === "pt"
                                          ? item.namePartPT
                                          : LangData === "fr"
                                            ? item.namePartFR
                                            : LangData === "es"
                                              ? item.namePartES
                                              : LangData === "it"
                                                ? item.namePartIT
                                                : LangData === "de"
                                                  ? item.namePartDE
                                                  : item.namePartEN}{" "}
                                      </td>
                                      {(vehicleModalSelectedList?.vehicle_model_id ||
                                        vehicleMainData?.item?.id) && (
                                        <td>
                                          {
                                            vehicleModalSelectedList?.vehicle_make_name
                                          }{" "}
                                          |{" "}
                                          {vehicleModalSelectedList?.vehicle_model_name ||
                                            vehicleMainData?.item
                                              ?.vehicle_model}
                                          |{" "}
                                          {vehicleModalSelectedList?.registration_plate ||
                                            vehicleMainData?.item
                                              ?.registration_plate}{" "}
                                          |{" "}
                                          {vehicleModalSelectedList?.registration ||
                                            vehicleMainData?.item?.registration}
                                        </td>
                                      )}
                                      <td>
                                        <Button
                                          className="addBtn"
                                          onClick={() => handleAddClick(item)}
                                          disabled={
                                            !(
                                              vehicleModalSelectedList?.vehicle_model_id ||
                                              vehicleMainData?.item?.id
                                            )
                                          }
                                        >
                                          <i className="bi bi-plus-lg"></i>
                                        </Button>
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td colSpan="100%" className="text-center">
                                      No results found
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-5">
                        <div className="card-body vehicleparts-table  vehicleparts-table-h-100">
                          <div className="mb-3  vehicleparts-input">
                            <input
                              className="form-control input-search"
                              type="text"
                              value={searchQueryTemp}
                              onChange={handleSearchChangeTemp}
                              maxLength={50}
                              placeholder={t("search")}
                            />
                          </div>
                          <div className="spacheheight"></div>
                          <div className="vehicleparts-table-inner vehicleThBg tableScroll min-height-0 pb-2">
                            <table className="rounded-table table table-striped table-bordered table-hover scrolldown">
                              <thead>
                                <tr>
                                  <th style={{ width: "24%" }}>
                                    {t("part_catalog")}
                                  </th>
                                  <th style={{ width: "10%" }}>
                                    {t("vehicle_model")}
                                  </th>

                                  <th style={{ width: "0%" }}>{t("action")}</th>
                                </tr>
                              </thead>

                              <tbody>
                                {selectedItems?.length > 0 ? (
                                  selectedItems?.map((item, index) => (
                                    <tr key={index}>
                                      <td>{item.namePartPT}</td>

                                      <td>{item?.vehicle_model_name}</td>

                                      <td>
                                        <Button
                                          className="btn-danger-delete"
                                          onClick={() =>
                                            handleDeleteClick(item)
                                          }
                                        >
                                          <i className="bi bi-trash3"></i>
                                        </Button>
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td colSpan="100%" className="text-center">
                                      {t("no_results_found")}
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      {tempData?.temp_id && (
                        <div className="col-lg-12">
                          <div className="fuelCF">
                            <div className="card-footer clearfix card-footer-part float-end">
                              <div className="pagination pagination-sm m-0  paginationRight">
                                <Pagination
                                  activePage={params.page}
                                  itemsCountPerPage={parseInt(params.limit)}
                                  totalItemsCount={parseInt(totalRecords)}
                                  pageRangeDisplayed={5}
                                  itemClass={`page-item`}
                                  linkClass={`page-link`}
                                  onChange={(e) =>
                                    handleParams(e, "pagination")
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="back-footer">
                      <div className="row">
                        <div className="col">
                          <button
                            type="button"
                            className="back-button btn btn-secondary"
                            onClick={handleBackButtonClick}
                          >
                            <i className="bi bi-arrow-left"></i> {t("back")}
                          </button>
                        </div>
                        <div className="d-flex justify-content-end col">
                          {btnNext ? (
                            <Button
                              className="btn-primary"
                              type="button"
                              disabled={true}
                            >
                              Loading...
                            </Button>
                          ) : (
                            <Button
                              className="next-button"
                              type="button"
                              onClick={(e) => handleNextClick(e)}
                              // disabled={
                              //   !vehiclePartsComData?.vehicle_make &&
                              //   !tempData?.temp_id
                              // }
                            >
                              {t("next")}
                              <i className="bi bi-arrow-right"></i>
                            </Button>
                          )}
                        </div>
                      </div>
                    </div>
                  </>
                )}

                {currentStep === 2 && (
                  <>
                    <div className="card-body vehicleparts-table mt-3">
                      <div className="vehicleparts-table-inner">
                        <Form method={`post`} onSubmit={handleSubmit}>
                          <div
                            className="row justify-content-start"
                            style={{ justifyContent: "flex-start" }}
                          >
                            {partsData?.map((part, pIndex) => {
                              return (
                                <React.Fragment key={pIndex}>
                                  <div className="col-lg-12" key={part?.id}>
                                    <div className="text-center  inventory-addparts-custom">
                                      <Card.Header className="cardHeader partInfoHeader">
                                        <div
                                          className="partInfo"
                                          data-bs-toggle="collapse"
                                          href={`#multiCollapseExample-${part?.tempId}`}
                                          role="button"
                                          aria-expanded="true"
                                          aria-controls={`multiCollapseExample-${part?.tempId}`}
                                        >
                                          <div className="AddPh6">
                                            <h6>
                                              {part?.part_name} |{" "}
                                              {part?.parts_internal_id} |{" "}
                                              {part?.vehicle_make_name} |{" "}
                                              {part?.vehicle_model_name}
                                            </h6>
                                          </div>
                                          <div className="">
                                            {btnClosed ? (
                                              <button
                                                type="button"
                                                className="btnClose"
                                              >
                                                <i className="bi bi-arrow-repeat"></i>
                                              </button>
                                            ) : (
                                              <button
                                                type="button"
                                                className="btnClose"
                                                onClick={() =>
                                                  handleDeleteClick(part)
                                                }
                                              >
                                                <i className="bi bi-x-lg"></i>
                                              </button>
                                            )}
                                          </div>
                                        </div>
                                      </Card.Header>
                                      <div className="row mb-4 mt-4 justify-content-end text-end">
                                        <div className="col-md-12 mb-4">
                                          <button
                                            style={{
                                              marginLeft: "10px",
                                            }}
                                            type="button"
                                            className="btn btn-primary"
                                            onClick={(e) =>
                                              handlePartCatalogModelOpen(
                                                e,
                                                part,
                                                pIndex,
                                              )
                                            }
                                          >
                                            <i className="bi bi-car-front me-2"></i>
                                            {t("catalog_model")}
                                          </button>
                                          <button
                                            style={{
                                              marginLeft: "12px",
                                            }}
                                            type="button"
                                            className="btn btn-primary"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              e.preventDefault();
                                              handleOpenPartHistory(e, part);
                                            }}
                                          >
                                            {part ? part?.part_model_stats : 0}
                                          </button>
                                          <button
                                            style={{
                                              marginLeft: "10px",
                                            }}
                                            type="button"
                                            className="btn btn-primary"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              e.preventDefault();
                                              handleOpenSponsorPrice(e, part);
                                            }}
                                          >
                                            Statiscal Price
                                          </button>
                                          <button
                                            style={{
                                              marginLeft: "10px",
                                            }}
                                            type="button"
                                            className="btn btn-primary"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              e.preventDefault();
                                              handleOpenEstimatePrice(e, part);
                                            }}
                                          >
                                            Estimate Price
                                          </button>

                                          <button
                                            style={{
                                              marginLeft: "10px",
                                            }}
                                            type="button"
                                            className="btn btn-primary"
                                            onClick={(e) =>
                                              handleChangeCompatibleOpen(
                                                e,
                                                part,
                                                pIndex,
                                              )
                                            }
                                          >
                                            <i className="bi bi-car-front me-2"></i>
                                            Compatible
                                          </button>
                                        </div>
                                        <div className="col-md-12">
                                          <Card.Body
                                            className="cardBody collapse multi-collapse show card"
                                            id={`multiCollapseExample-${part?.tempId}`}
                                          >
                                            <div className="vehicleThBg tableScroll  tablescroll-custom-two pb-2">
                                              <div className="row justify-content-start">
                                                {getFieldPermission("quantity")
                                                  .show && (
                                                  <div className="col-lg-3 addPartField">
                                                    <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                      {t("quantity")}
                                                    </label>
                                                    <input
                                                      className="form-control input-search"
                                                      type="number"
                                                      name="quantity"
                                                      value={part?.quantity}
                                                      onChange={(e) =>
                                                        handleInputChangePartLists(
                                                          e,
                                                          part?.tempId,
                                                        )
                                                      }
                                                      placeholder="0"
                                                      disabled={
                                                        !getFieldPermission(
                                                          "quantity",
                                                        ).editable
                                                      }
                                                      min="1"
                                                      onKeyDown={(e) => {
                                                        if (e.key === "-")
                                                          e.preventDefault();
                                                      }}
                                                    />

                                                    {errors.quantity && (
                                                      <span className="input-error">
                                                        {errors.quantity}
                                                      </span>
                                                    )}
                                                  </div>
                                                )}
                                                {getFieldPermission(
                                                  "part_price",
                                                ).show && (
                                                  <div className="col-lg-3 addPartField">
                                                    <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                      Price 1 (€){" "}
                                                    </label>
                                                    <input
                                                      className="form-control input-search"
                                                      type="number"
                                                      name="part_price"
                                                      value={part?.part_price}
                                                      onChange={(e) =>
                                                        handleInputChangePartLists(
                                                          e,
                                                          part?.tempId,
                                                        )
                                                      }
                                                      placeholder="0"
                                                      disabled={
                                                        !getFieldPermission(
                                                          "part_price",
                                                        ).editable
                                                      }
                                                    />

                                                    {errors.part_price && (
                                                      <span className="input-error">
                                                        {errors.part_price}
                                                      </span>
                                                    )}
                                                  </div>
                                                )}
                                                {getFieldPermission(
                                                  "part_original_price",
                                                ).show && (
                                                  <div className="col-lg-3 addPartField">
                                                    <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                      Price 2 (
                                                      {
                                                        settingDetails?.discount_percentage
                                                      }
                                                      % discount) €
                                                    </label>
                                                    <input
                                                      className="form-control input-search"
                                                      type="number"
                                                      name="part_original_price"
                                                      value={
                                                        part?.part_original_price
                                                      }
                                                      onChange={(e) =>
                                                        handleInputChangePartLists(
                                                          e,
                                                          part?.tempId,
                                                        )
                                                      }
                                                      placeholder="0"
                                                      disabled={
                                                        !getFieldPermission(
                                                          "part_original_price",
                                                        ).editable
                                                      }
                                                    />
                                                  </div>
                                                )}
                                                {getFieldPermission(
                                                  "part_cost_price",
                                                ).show && (
                                                  <div className="col-lg-3 addPartField">
                                                    <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                      Part Cost Price €
                                                    </label>
                                                    <input
                                                      className="form-control input-search"
                                                      type="number"
                                                      name="part_cost_price"
                                                      value={
                                                        part?.part_cost_price
                                                      }
                                                      onChange={(e) =>
                                                        handleInputChangePartLists(
                                                          e,
                                                          part?.tempId,
                                                        )
                                                      }
                                                      placeholder="0"
                                                      disabled={
                                                        !getFieldPermission(
                                                          "part_cost_price",
                                                        ).editable
                                                      }
                                                    />
                                                  </div>
                                                )}
                                                <div className="col-lg-3 addPartField">
                                                  <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                    {t("pi_deposit_value")} €
                                                  </label>
                                                  <input
                                                    className="form-control input-search"
                                                    type="number"
                                                    name="deposit_value"
                                                    value={
                                                      part?.deposit_value ?? ""
                                                    }
                                                    onChange={(e) =>
                                                      handleInputChangePartLists(
                                                        e,
                                                        part?.tempId,
                                                      )
                                                    }
                                                    placeholder="0"
                                                    min="0"
                                                    onKeyDown={(e) => {
                                                      if (e.key === "-")
                                                        e.preventDefault();
                                                    }}
                                                  />
                                                </div>
                                                {getFieldPermission(
                                                  "inventory_status",
                                                ).show && (
                                                  <div className="col-lg-3 addPartField">
                                                    <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                      Inventory Status
                                                    </label>
                                                    <Select
                                                      className="my-Select"
                                                      options={inventoryList}
                                                      name="inventory_status"
                                                      value={
                                                        inventoryList.find(
                                                          (item) =>
                                                            item.value ===
                                                            partsData[pIndex]
                                                              ?.inventory_status,
                                                        ) ||
                                                        inventoryList.find(
                                                          (item) =>
                                                            item.value === 1,
                                                        )
                                                      }
                                                      onChange={(
                                                        selectedOption,
                                                      ) =>
                                                        handleInventoryIdChange(
                                                          pIndex,
                                                          selectedOption,
                                                        )
                                                      }
                                                      placeholder={
                                                        "Select Inventory Status"
                                                      }
                                                      isSearchable={true}
                                                      isDisabled={
                                                        !getFieldPermission(
                                                          "inventory_status",
                                                        ).editable
                                                      }
                                                    ></Select>
                                                  </div>
                                                )}
                                                {getFieldPermission(
                                                  "condition_id",
                                                ).show && (
                                                  <div className="col-lg-3 addPartField">
                                                    <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                      Condition
                                                    </label>
                                                    <Select
                                                      className="my-Select"
                                                      options={conditionList}
                                                      value={
                                                        conditionList.find(
                                                          (item) =>
                                                            item.value ===
                                                            partsData[pIndex]
                                                              ?.condition_id,
                                                        ) ||
                                                        conditionList.find(
                                                          (item) =>
                                                            item.value ===
                                                            settingDetails?.condition_id,
                                                        ) ||
                                                        conditionList.find(
                                                          (item) =>
                                                            item.value === 1,
                                                        )
                                                      }
                                                      onChange={(
                                                        selectedOption,
                                                      ) =>
                                                        handleConditionChange(
                                                          pIndex,
                                                          selectedOption,
                                                        )
                                                      }
                                                      isSearchable
                                                      placeholder={
                                                        "Select Condition"
                                                      }
                                                      isDisabled={
                                                        !getFieldPermission(
                                                          "condition_id",
                                                        ).editable
                                                      }
                                                    ></Select>
                                                  </div>
                                                )}
                                                {getFieldPermission("state_id")
                                                  .show && (
                                                  <div className="col-lg-3 addPartField">
                                                    <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                      State
                                                    </label>
                                                    <Select
                                                      className="my-Select"
                                                      options={stateList}
                                                      value={
                                                        stateList.find(
                                                          (item) =>
                                                            item.value ===
                                                            partsData[pIndex]
                                                              ?.state_id,
                                                        ) ||
                                                        stateList.find(
                                                          (item) =>
                                                            item.value ===
                                                            settingDetails?.state_id,
                                                        ) ||
                                                        stateList.find(
                                                          (item) =>
                                                            item.value === 1,
                                                        )
                                                      }
                                                      onChange={(
                                                        selectedOption,
                                                      ) =>
                                                        handleStateListChange(
                                                          pIndex,
                                                          selectedOption,
                                                        )
                                                      }
                                                      isSearchable
                                                      placeholder={
                                                        "Select State"
                                                      }
                                                      isDisabled={
                                                        !getFieldPermission(
                                                          "state_id",
                                                        ).editable
                                                      }
                                                    ></Select>
                                                  </div>
                                                )}

                                                <div className="col-lg-3 addPartField col-lg-3-mob">
                                                  <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                    Location
                                                  </label>
                                                  <select
                                                    className="form-select"
                                                    value={
                                                      selectedEntities?.location_ids ??
                                                      part.location_ids ??
                                                      ""
                                                    }
                                                    onChange={(e) =>
                                                      handleSelectChangeLocation(
                                                        e,
                                                        part,
                                                      )
                                                    }
                                                    disabled={
                                                      part.is_sold === 1
                                                    }
                                                  >
                                                    <option value="" disabled>
                                                      Select
                                                    </option>
                                                    {renderOptions(entityList)}
                                                  </select>
                                                </div>

                                                {/* <div className="col-lg-3 addPartField">
                                       <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                         {t("part")} {t("brand")}
                                       </label>
                                       <Select
                                         className="my-Select"
                                         options={allBrandList}
                                         name="brand_id"
                                         value={allBrandList.find(
                                           (option) =>
                                             option.value ===
                                             part?.brand_id
                                         )}
                                         onChange={(
                                           selectedOption
                                         ) =>
                                           handleBrandIdChange(
                                             pIndex,
                                             selectedOption
                                           )
                                         }
                                         placeholder={
                                           "Select Part Brand"
                                         }
                                         isSearchable={true}
                                       ></Select>
                                     </div> */}
                                                {getFieldPermission(
                                                  "is_custom_size",
                                                ).show && (
                                                  <div className="col-lg-2 addPartField">
                                                    <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                      Custome Size
                                                    </label>

                                                    <div className="col-lg-12 addPartField">
                                                      <div className="form-check text-left">
                                                        <input
                                                          className="form-check-input"
                                                          type="checkbox"
                                                          checked={
                                                            part?.is_custom_size ===
                                                            "1"
                                                          }
                                                          onChange={(e) =>
                                                            handleCheckboxCustomChange(
                                                              pIndex,
                                                              e,
                                                            )
                                                          }
                                                          disabled={
                                                            !getFieldPermission(
                                                              "is_custom_size",
                                                            ).editable
                                                          }
                                                        />
                                                        <label className="form-check-label">
                                                          Custome Size
                                                        </label>
                                                      </div>
                                                    </div>
                                                  </div>
                                                )}
                                                {getFieldPermission(
                                                  "print_label",
                                                ).show && (
                                                  <div className="col-lg-2 addPartField">
                                                    <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                      Print label
                                                    </label>
                                                    <div className="col-lg-12 addPartField">
                                                      <div className="form-check text-left">
                                                        <input
                                                          className="my-checkbox-1 form-check-input"
                                                          type="checkbox"
                                                          checked={
                                                            part?.print_label ===
                                                            1
                                                          }
                                                          onChange={(e) =>
                                                            handleCheckboxPrintChanges(
                                                              pIndex,
                                                              e,
                                                            )
                                                          }
                                                          disabled={
                                                            !getFieldPermission(
                                                              "print_label",
                                                            ).editable
                                                          }
                                                        />
                                                        <label className="form-check-label pl-6">
                                                          Print label
                                                        </label>
                                                      </div>
                                                    </div>
                                                  </div>
                                                )}
                                                {getFieldPermission(
                                                  "vat_included",
                                                ).show && (
                                                  <div className="col-lg-2 addPartField">
                                                    <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                      VAT included{" "}
                                                    </label>
                                                    <div className="col-lg-12 addPartField">
                                                      <div className="form-check text-left">
                                                        <input
                                                          className="my-checkbox-1 form-check-input"
                                                          type="checkbox"
                                                          checked={
                                                            part?.vat_included ===
                                                            1
                                                          }
                                                          onChange={(e) =>
                                                            handleCheckboxVatChanges(
                                                              pIndex,
                                                              e,
                                                            )
                                                          }
                                                          disabled={
                                                            !getFieldPermission(
                                                              "vat_included",
                                                            ).editable
                                                          }
                                                        />
                                                        <label className="form-check-label pl-6">
                                                          VAT included{" "}
                                                        </label>
                                                      </div>
                                                    </div>
                                                  </div>
                                                )}
                                                <div className="col-lg-2 addPartField">
                                                  <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                    {t("pi_on_order")}
                                                  </label>
                                                  <div className="col-lg-12 addPartField">
                                                    <div className="form-check text-left">
                                                      <input
                                                        className="my-checkbox-1 form-check-input"
                                                        type="checkbox"
                                                        checked={
                                                          part?.on_order ===
                                                            1 ||
                                                          part?.on_order ===
                                                            true ||
                                                          part?.on_order ===
                                                            "1"
                                                        }
                                                        onChange={(e) =>
                                                          handleCheckboxOnOrderChanges(
                                                            pIndex,
                                                            e,
                                                          )
                                                        }
                                                      />
                                                      <label className="form-check-label pl-6">
                                                        {t("pi_on_order")}
                                                      </label>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div className="col-lg-2 addPartField">
                                                  <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                    {t("pi_save_as_draft")}
                                                  </label>
                                                  <div className="col-lg-12 addPartField">
                                                    <div className="form-check text-left">
                                                      <input
                                                        className="my-checkbox-1 form-check-input"
                                                        type="checkbox"
                                                        checked={
                                                          part?.is_draft ===
                                                            1 ||
                                                          part?.is_draft ===
                                                            true ||
                                                          part?.is_draft ===
                                                            "1"
                                                        }
                                                        onChange={(e) =>
                                                          handleCheckboxDraftChanges(
                                                            pIndex,
                                                            e,
                                                          )
                                                        }
                                                      />
                                                      <label className="form-check-label pl-6">
                                                        {t("pi_save_as_draft")}
                                                      </label>
                                                    </div>
                                                  </div>
                                                </div>
                                                {getFieldPermission(
                                                  "associate_location",
                                                ).show && (
                                                  <div className="col-lg-3 addPartField col-lg-3-mob">
                                                    <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                      Associate Location
                                                    </label>
                                                    <div className="addPartField">
                                                      <div className="form-check text-left">
                                                        <input
                                                          className="my-checkbox-1 form-check-input"
                                                          type="checkbox"
                                                          checked={
                                                            part?.associate_location ===
                                                            1
                                                          }
                                                          onChange={(e) =>
                                                            handleCheckboxAssociateLocationChanges(
                                                              pIndex,
                                                              e,
                                                            )
                                                          }
                                                          disabled={
                                                            !getFieldPermission(
                                                              "associate_location",
                                                            ).editable
                                                          }
                                                        />
                                                        <label className="form-check-label pl-6">
                                                          Associate Location
                                                        </label>
                                                      </div>
                                                    </div>
                                                  </div>
                                                )}
                                                {/* {getFieldPermission(
                                                      "part_rating"
                                                ).show && ( */}
                                                <div className="col-lg-3 addPartField col-lg-3-mob">
                                                  <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                    Part Rating
                                                  </label>
                                                  <div className="addPartField">
                                                    <div className="form-check text-left">
                                                      <ReactStars
                                                        size={20}
                                                        count={5}
                                                        activeColor="#ffd700"
                                                        a11y={true}
                                                        isHalf={true}
                                                        emptyIcon={
                                                          <i className="bi bi-star" />
                                                        }
                                                        halfIcon={
                                                          <i className="bi bi-star-half" />
                                                        }
                                                        filledIcon={
                                                          <i className="bi bi-star-fill" />
                                                        }
                                                        value={
                                                          part?.part_rating
                                                        }
                                                        onChange={(newRating) =>
                                                          handleRatingChange(
                                                            newRating,
                                                            part.tempId,
                                                          )
                                                        }
                                                        // edit={
                                                        // !getFieldPermission(
                                                        // "part_rating"
                                                        // ).editable
                                                        // }
                                                      />
                                                    </div>
                                                  </div>
                                                </div>
                                                {/* )} */}
                                                <div className="clearfix"></div>
                                                {part?.is_custom_size ===
                                                  "1" && (
                                                  <>
                                                    {getFieldPermission(
                                                      "parts_weight",
                                                    ).show && (
                                                      <div className="col-lg-3 addPartField">
                                                        <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                          Weight (kg){" "}
                                                        </label>
                                                        <input
                                                          className="form-control input-search"
                                                          type="number"
                                                          name="parts_weight"
                                                          value={
                                                            part?.parts_weight
                                                          }
                                                          onChange={(e) =>
                                                            handleInputChangePartList(
                                                              e,
                                                              part?.id,
                                                            )
                                                          }
                                                          placeholder="0"
                                                          disabled={
                                                            !getFieldPermission(
                                                              "parts_weight",
                                                            ).editable
                                                          }
                                                        />
                                                      </div>
                                                    )}
                                                    {getFieldPermission(
                                                      "parts_width",
                                                    ).show && (
                                                      <div className="col-lg-3 addPartField">
                                                        <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                          Width(cm){" "}
                                                        </label>
                                                        <input
                                                          className="form-control input-search"
                                                          type="number"
                                                          name="parts_width"
                                                          value={
                                                            part?.parts_width
                                                          }
                                                          onChange={(e) =>
                                                            handleInputChangePartList(
                                                              e,
                                                              part?.id,
                                                            )
                                                          }
                                                          placeholder="0"
                                                          disabled={
                                                            !getFieldPermission(
                                                              "parts_width",
                                                            ).editable
                                                          }
                                                        />

                                                        {errors.parts_width && (
                                                          <span className="input-error">
                                                            {errors.parts_width}
                                                          </span>
                                                        )}
                                                      </div>
                                                    )}
                                                    {getFieldPermission(
                                                      "parts_height",
                                                    ).show && (
                                                      <div className="col-lg-3 addPartField">
                                                        <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                          Height(cm){" "}
                                                        </label>
                                                        <input
                                                          className="form-control input-search"
                                                          type="number"
                                                          name="parts_height"
                                                          value={
                                                            part?.parts_height
                                                          }
                                                          onChange={(e) =>
                                                            handleInputChangePartList(
                                                              e,
                                                              part?.id,
                                                            )
                                                          }
                                                          placeholder="0"
                                                          disabled={
                                                            !getFieldPermission(
                                                              "parts_height",
                                                            ).editable
                                                          }
                                                        />
                                                      </div>
                                                    )}

                                                    {getFieldPermission(
                                                      "parts_length",
                                                    ).show && (
                                                      <div className="col-lg-3 addPartField">
                                                        <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                          Length(cm){" "}
                                                        </label>
                                                        <input
                                                          className="form-control input-search"
                                                          type="number"
                                                          name="parts_length"
                                                          value={
                                                            part?.parts_length
                                                          }
                                                          onChange={(e) =>
                                                            handleInputChangePartList(
                                                              e,
                                                              part?.id,
                                                            )
                                                          }
                                                          placeholder="0"
                                                          disabled={
                                                            !getFieldPermission(
                                                              "parts_length",
                                                            ).editable
                                                          }
                                                        />
                                                      </div>
                                                    )}
                                                  </>
                                                )}

                                                {part?.state_id === 2 &&
                                                  getFieldPermission(
                                                    "reg_number_dismantler",
                                                  ).show && (
                                                    <div className="col-lg-3 addPartField col-lg-3-mob">
                                                      <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                        Reg Number Dismantler
                                                      </label>
                                                      <input
                                                        className="form-control input-search"
                                                        type="text"
                                                        name="reg_number_dismantler"
                                                        value={
                                                          part?.reg_number_dismantler
                                                        }
                                                        onChange={(e) =>
                                                          handleInputChangePartList(
                                                            e,
                                                            part?.id,
                                                          )
                                                        }
                                                        placeholder="0"
                                                        disabled={
                                                          !getFieldPermission(
                                                            "reg_number_dismantler",
                                                          ).editable
                                                        }
                                                      />
                                                    </div>
                                                  )}

                                                {Number(
                                                  settingDetails?.is_green_part,
                                                ) === 1 && (
                                                  <div className="col-lg-3 addPartField col-lg-3-mob">
                                                    <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                      {t("GreenPartRatings")}
                                                    </label>
                                                    <div className="addPartField">
                                                      <div className="form-check text-left">
                                                        <div className="d-flex align-items-center gap-2">
                                                          {levels?.map(
                                                            (level) => (
                                                              <img
                                                                key={level}
                                                                src={
                                                                  RatingImage
                                                                }
                                                                alt="Peça Verde"
                                                                onClick={() =>
                                                                  handleGreenRatingChange(
                                                                    part.tempId,
                                                                    level,
                                                                  )
                                                                }
                                                                style={{
                                                                  width: 40,
                                                                  height: 40,
                                                                  cursor:
                                                                    "pointer",
                                                                  opacity:
                                                                    part.green_part_rating !==
                                                                      "" &&
                                                                    Number(
                                                                      part.green_part_rating,
                                                                    ) >= level
                                                                      ? 1
                                                                      : 0.3,
                                                                  transition:
                                                                    "opacity 0.2s ease-in-out",
                                                                }}
                                                              />
                                                            ),
                                                          )}
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                )}

                                                <div className="col-lg-6 addPartField"></div>

                                                <div className="col-lg-6 addPartField"></div>

                                                {part?.is_show_engine_record ===
                                                  true && (
                                                  <>
                                                    {getFieldPermission(
                                                      "engine_id",
                                                    ).show && (
                                                      <div className="col-lg-3 addPartField">
                                                        <div className="col-md-12">
                                                          <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                            Engine Code{" "}
                                                          </label>
                                                          <Select
                                                            className="my-Select"
                                                            options={
                                                              vehicleEngineList
                                                            }
                                                            value={vehicleEngineList.find(
                                                              (item) =>
                                                                item.value ===
                                                                part?.engine_code,
                                                            )}
                                                            onChange={(
                                                              selectedOption,
                                                            ) =>
                                                              handleEngineCodeChange(
                                                                pIndex,
                                                                selectedOption,
                                                              )
                                                            }
                                                            placeholder={
                                                              "Select Engine"
                                                            }
                                                            isSearchable={true}
                                                            onInputChange={
                                                              handleInputSelectedChangeEngineList
                                                            }
                                                            inputSelctedValue={
                                                              inputSelctedEngineValue
                                                            }
                                                            isDisabled={
                                                              !getFieldPermission(
                                                                "engine_id",
                                                              ).editable
                                                            }
                                                          />
                                                        </div>
                                                      </div>
                                                    )}
                                                    {getFieldPermission("cv")
                                                      .show && (
                                                      <div className="col-lg-3 addPartField">
                                                        <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                          Cv{" "}
                                                        </label>
                                                        <input
                                                          className="form-control input-search"
                                                          type="text"
                                                          name="cv"
                                                          value={part?.cv}
                                                          onChange={(e) => {
                                                            handleInputChangePartList(
                                                              e,
                                                              part?.tempId,
                                                            );
                                                          }}
                                                          placeholder="0"
                                                          disabled={
                                                            !getFieldPermission(
                                                              "cv",
                                                            ).editable
                                                          }
                                                        />
                                                      </div>
                                                    )}
                                                    {getFieldPermission("cc")
                                                      .show && (
                                                      <div className="col-lg-3 addPartField">
                                                        <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                          CC
                                                        </label>
                                                        <input
                                                          className="form-control input-search"
                                                          type="text"
                                                          name="cc"
                                                          value={part?.cc}
                                                          onChange={(e) => {
                                                            handleInputChangePartList(
                                                              e,
                                                              part?.tempId,
                                                            );
                                                          }}
                                                          placeholder="0"
                                                          disabled={
                                                            !getFieldPermission(
                                                              "cc",
                                                            ).editable
                                                          }
                                                        />
                                                      </div>
                                                    )}
                                                    {getFieldPermission("kw")
                                                      .show && (
                                                      <div className="col-lg-3 addPartField">
                                                        <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                          KW
                                                        </label>
                                                        <input
                                                          className="form-control input-search"
                                                          type="text"
                                                          name="kw"
                                                          value={part?.kw}
                                                          onChange={(e) => {
                                                            handleInputChangePartList(
                                                              e,
                                                              part?.tempId,
                                                            );
                                                          }}
                                                          placeholder="0"
                                                          disabled={
                                                            !getFieldPermission(
                                                              "kw",
                                                            ).editable
                                                          }
                                                        />
                                                      </div>
                                                    )}
                                                  </>
                                                )}

                                                <div
                                                  className="col-lg-12"
                                                  style={{
                                                    display: "flex",
                                                    justifyContent: "end",
                                                    marginBottom: "10px",
                                                  }}
                                                >
                                                  <button
                                                    style={{
                                                      marginTop: "8px",
                                                      marginRight: "10px",
                                                    }}
                                                    type="button"
                                                    className="btn btn-primary"
                                                    onClick={(e) =>
                                                      handleChangeNotesOpen(
                                                        e,
                                                        part,
                                                        pIndex,
                                                      )
                                                    }
                                                  >
                                                    Notes Fields{" "}
                                                  </button>
                                                  {part?.etai_part_id && (
                                                    <>
                                                      <button
                                                        style={{
                                                          marginTop: "8px",
                                                          marginRight: "10px",
                                                        }}
                                                        type="button"
                                                        className="btn btn-primary"
                                                        onClick={(e) =>
                                                          handleEtaiDetails(
                                                            e,
                                                            part?.etai_part_id,
                                                            pIndex,
                                                          )
                                                        }
                                                      >
                                                        View Reference
                                                      </button>

                                                      <button
                                                        style={{
                                                          marginTop: "8px",
                                                          marginRight: "10px",
                                                        }}
                                                        type="button"
                                                        className="btn btn-primary"
                                                        onClick={(e) =>
                                                          handleEtaiPriceDetails(
                                                            e,
                                                            part?.etai_part_id,
                                                            pIndex,
                                                          )
                                                        }
                                                      >
                                                        View Price
                                                      </button>
                                                    </>
                                                  )}

                                                  <button
                                                    style={{
                                                      marginTop: "8px",
                                                    }}
                                                    type="button"
                                                    className="btn btn-primary"
                                                    onClick={
                                                      handleChangeOCROpen
                                                    }
                                                  >
                                                    OCR Multiple Reference
                                                  </button>

                                                  {part?.addedData?.length >
                                                    0 && (
                                                    <>
                                                      <button
                                                        style={{
                                                          marginTop: "8px",
                                                          marginRight: "10px",
                                                        }}
                                                        type="button"
                                                        className="btn btn-primary"
                                                        onClick={(e) =>
                                                          handleOpenRefCodeCondition(
                                                            e,
                                                            part,
                                                          )
                                                        }
                                                      >
                                                        Parts
                                                      </button>

                                                      <button
                                                        style={{
                                                          marginTop: "8px",
                                                        }}
                                                        type="button"
                                                        className="btn btn-primary"
                                                        onClick={(e) =>
                                                          handleOpenRefCodeEstimate(
                                                            e,
                                                            part,
                                                          )
                                                        }
                                                      >
                                                        Estimate Price
                                                      </button>
                                                    </>
                                                  )}
                                                </div>

                                                {getFieldPermission(
                                                  "parts_reference",
                                                ).show && (
                                                  <div className="col-lg-12">
                                                    <div className="table-responsive-custom-q  table-custom-sticky-inherit">
                                                      <table className="table ">
                                                        <thead>
                                                          <tr>
                                                            <th scope="col">
                                                              <div className="col-lg-12 addPartField">
                                                                <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                                  {t(
                                                                    "reference_code",
                                                                  )}{" "}
                                                                </label>
                                                                <input
                                                                  className="form-control input-search"
                                                                  type="text"
                                                                  name="reference_code"
                                                                  value={
                                                                    selectedReferenceCode
                                                                      ? selectedReferenceCode
                                                                      : part?.reference_code
                                                                  }
                                                                  onChange={(
                                                                    e,
                                                                  ) =>
                                                                    handleInputChangePartListRef(
                                                                      e,
                                                                      pIndex,
                                                                    )
                                                                  }
                                                                  placeholder={t("reference_code")}
                                                                  disabled={
                                                                    !getFieldPermission(
                                                                      "parts_reference",
                                                                    ).editable
                                                                  }
                                                                />
                                                              </div>
                                                            </th>

                                                            <th scope="col">
                                                              <div className="col-lg-12 addPartField">
                                                                <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                                  Condition
                                                                </label>
                                                                <Select
                                                                  className="my-Select"
                                                                  options={
                                                                    conditionList
                                                                  }
                                                                  value={
                                                                    conditionList.find(
                                                                      (
                                                                        option,
                                                                      ) =>
                                                                        option.value ===
                                                                          part?.condition_id_ref ||
                                                                        option.label ===
                                                                          part?.selectedCondition,
                                                                    ) ||
                                                                    conditionList.find(
                                                                      (item) =>
                                                                        item.value ===
                                                                        settingCompanyDetails?.reference_condition,
                                                                    ) ||
                                                                    null
                                                                  }
                                                                  onChange={(
                                                                    selectedOption,
                                                                  ) =>
                                                                    handleConditionSChangeRefs(
                                                                      part?.id,
                                                                      selectedOption,
                                                                    )
                                                                  }
                                                                  isSearchable
                                                                  placeholder={
                                                                    "Select Condition"
                                                                  }
                                                                  isDisabled={
                                                                    !getFieldPermission(
                                                                      "parts_reference",
                                                                    ).editable
                                                                  }
                                                                ></Select>
                                                              </div>
                                                            </th>
                                                            <th scope="col">
                                                              <div className="col-lg-12 addPartField">
                                                                <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                                  Reference Type
                                                                </label>
                                                                <Select
                                                                  className="my-Select"
                                                                  options={
                                                                    referenceList
                                                                  }
                                                                  value={
                                                                    referenceList.find(
                                                                      (
                                                                        option,
                                                                      ) =>
                                                                        option.value ===
                                                                          part?.type_id ||
                                                                        option.label ===
                                                                          part?.selectedType,
                                                                    ) ||
                                                                    referenceList.find(
                                                                      (item) =>
                                                                        item.value ===
                                                                        settingCompanyDetails?.reference_type,
                                                                    ) ||
                                                                    null
                                                                  }
                                                                  onChange={(
                                                                    selectedOption,
                                                                  ) =>
                                                                    handleConditionChangeRef(
                                                                      part?.id,
                                                                      selectedOption,
                                                                    )
                                                                  }
                                                                  isSearchable
                                                                  placeholder={t("select_type")}
                                                                  isDisabled={
                                                                    !getFieldPermission(
                                                                      "parts_reference",
                                                                    ).editable
                                                                  }
                                                                />
                                                              </div>
                                                            </th>

                                                            {part?.type_id ===
                                                              1 &&
                                                              part?.condition_id_ref ===
                                                                2 && (
                                                                <th scope="col">
                                                                  <div className="col-lg-12 addPartField">
                                                                    <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                                      {t(
                                                                        "brand",
                                                                      )}
                                                                    </label>
                                                                    <input
                                                                      className="form-control input-search"
                                                                      type="text"
                                                                      name="brand"
                                                                      value={
                                                                        part?.brand
                                                                      }
                                                                      onChange={(
                                                                        e,
                                                                      ) =>
                                                                        handleInputChangePartListRef(
                                                                          e,
                                                                          pIndex,
                                                                        )
                                                                      }
                                                                      placeholder={t("brand")}
                                                                      disabled={
                                                                        !getFieldPermission(
                                                                          "parts_reference",
                                                                        )
                                                                          .editable
                                                                      }
                                                                    />
                                                                  </div>
                                                                </th>
                                                              )}
                                                            {part?.type_id ===
                                                              1 && (
                                                              <th scope="col">
                                                                <div className="col-lg-12 addPartField">
                                                                  <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                                    {t(
                                                                      "manufacter",
                                                                    )}
                                                                  </label>
                                                                  <input
                                                                    className="form-control input-search"
                                                                    type="text"
                                                                    name="manufacter"
                                                                    value={
                                                                      selectedReferenceCode
                                                                        ? selectedReferenceCode
                                                                        : part?.manufacter
                                                                    }
                                                                    onChange={(
                                                                      e,
                                                                    ) =>
                                                                      handleInputChangePartListRef(
                                                                        e,
                                                                        pIndex,
                                                                      )
                                                                    }
                                                                    placeholder={t("manufacter")}
                                                                    disabled={
                                                                      !getFieldPermission(
                                                                        "parts_reference",
                                                                      ).editable
                                                                    }
                                                                  />
                                                                </div>
                                                              </th>
                                                            )}
                                                            <th scope="col"></th>
                                                            <th>
                                                              <button
                                                                style={{
                                                                  marginTop:
                                                                    "77px",
                                                                }}
                                                                type="button"
                                                                className="btn btn-primary"
                                                                onClick={() =>
                                                                  handleAddPartRef(
                                                                    pIndex,
                                                                  )
                                                                }
                                                                disabled={
                                                                  !getFieldPermission(
                                                                    "parts_reference",
                                                                  ).editable
                                                                }
                                                              >
                                                                Add
                                                                Reference{" "}
                                                              </button>
                                                            </th>
                                                          </tr>
                                                        </thead>
                                                        <tbody>
                                                          {part?.addedData?.map(
                                                            (
                                                              data,
                                                              rowIndex,
                                                            ) => {
                                                              const refType =
                                                                settingCompanyDetails?.reference_type ===
                                                                2;
                                                              const refCond =
                                                                settingCompanyDetails?.reference_condition ===
                                                                1;
                                                              const condRef =
                                                                data.condition_id_ref ===
                                                                1;
                                                              const typeId =
                                                                data.type_id ===
                                                                2;

                                                              const isAllBackendValid =
                                                                refType &&
                                                                refCond &&
                                                                condRef &&
                                                                typeId;
                                                              const isManualValid =
                                                                data
                                                                  .selectedType
                                                                  ?.value ===
                                                                  2 &&
                                                                data
                                                                  .selectedCondition
                                                                  ?.value === 1;
                                                              return (
                                                                <>
                                                                  <tr
                                                                    key={
                                                                      rowIndex
                                                                    }
                                                                  >
                                                                    <td>
                                                                      <div className="col-lg-12 addPartField">
                                                                        <label className="partsLabel col-form-label ml-2"></label>
                                                                        <button
                                                                          style={{
                                                                            marginLeft:
                                                                              "12px",
                                                                          }}
                                                                          type="button"
                                                                          className="btn btn-primary"
                                                                          onClick={(
                                                                            e,
                                                                          ) => {
                                                                            e.stopPropagation();
                                                                            e.preventDefault();
                                                                            handleOpenPartRefHistory(
                                                                              e,
                                                                              part,
                                                                            );
                                                                          }}
                                                                        >
                                                                          {data?.count
                                                                            ? data?.count
                                                                            : 0}
                                                                        </button>
                                                                      </div>
                                                                    </td>
                                                                    <td>
                                                                      <div className="col-lg-12 addPartField">
                                                                        <label className="partsLabel col-form-label ml-2">
                                                                          Reference
                                                                          Code
                                                                        </label>
                                                                        <input
                                                                          className="form-control"
                                                                          type="text"
                                                                          name="reference_code"
                                                                          value={
                                                                            data?.reference_code
                                                                          }
                                                                          onChange={(
                                                                            e,
                                                                          ) =>
                                                                            handleUpdatePartRef(
                                                                              pIndex,
                                                                              rowIndex,
                                                                              "reference_code",
                                                                              e
                                                                                .target
                                                                                .value,
                                                                            )
                                                                          }
                                                                          placeholder={t("reference_code")}
                                                                        />
                                                                      </div>
                                                                    </td>

                                                                    <td>
                                                                      <label className="partsLabel col-form-label ml-2">
                                                                        Condition
                                                                      </label>
                                                                      <Select
                                                                        className="my-Select"
                                                                        options={
                                                                          conditionList
                                                                        }
                                                                        value={conditionList.find(
                                                                          (
                                                                            option,
                                                                          ) =>
                                                                            option.value ===
                                                                            data?.condition_id_ref,
                                                                        )}
                                                                        onChange={(
                                                                          selectedOption,
                                                                        ) =>
                                                                          handleUpdatePartRef(
                                                                            pIndex,
                                                                            rowIndex,
                                                                            "condition_id_ref",
                                                                            selectedOption?.value ||
                                                                              null,
                                                                          )
                                                                        }
                                                                        isSearchable
                                                                        placeholder={t("select_condition")}
                                                                      />
                                                                    </td>
                                                                    <td>
                                                                      <label className="partsLabel col-form-label ml-2">
                                                                        Reference
                                                                        Type
                                                                      </label>
                                                                      <Select
                                                                        className="my-Select"
                                                                        options={
                                                                          referenceList
                                                                        }
                                                                        value={referenceList.find(
                                                                          (
                                                                            option,
                                                                          ) =>
                                                                            option.value ===
                                                                            data?.type_id,
                                                                        )}
                                                                        onChange={(
                                                                          selectedOption,
                                                                        ) =>
                                                                          handleUpdatePartRef(
                                                                            pIndex,
                                                                            rowIndex,
                                                                            "type_id",
                                                                            selectedOption?.value ||
                                                                              null,
                                                                          )
                                                                        }
                                                                        isSearchable
                                                                        placeholder={t("select_type")}
                                                                      />
                                                                    </td>
                                                                    {data.condition_id_ref ===
                                                                      2 &&
                                                                      data.type_id ===
                                                                        1 && (
                                                                        <td>
                                                                          <div className="col-lg-12 addPartField">
                                                                            <label className="partsLabel col-form-label ml-2">
                                                                              {t(
                                                                                "brand",
                                                                              )}
                                                                            </label>
                                                                            <input
                                                                              className="form-control input-search"
                                                                              type="text"
                                                                              name="brand"
                                                                              value={
                                                                                data.brand
                                                                              }
                                                                              onChange={(
                                                                                e,
                                                                              ) =>
                                                                                handleUpdatePartRef(
                                                                                  pIndex,
                                                                                  rowIndex,
                                                                                  "brand",
                                                                                  e
                                                                                    .target
                                                                                    .value,
                                                                                )
                                                                              }
                                                                              placeholder={t("brand")}
                                                                            />
                                                                          </div>
                                                                        </td>
                                                                      )}

                                                                    {data.type_id ===
                                                                      2 && (
                                                                      <td>
                                                                        <div className="col-lg-12 addPartField">
                                                                          <label className="partsLabel col-form-label ml-2">
                                                                            {t(
                                                                              "manufacter",
                                                                            )}
                                                                          </label>
                                                                          <input
                                                                            className="form-control input-search"
                                                                            type="text"
                                                                            name="manufacter"
                                                                            value={
                                                                              data.manufacter
                                                                            }
                                                                            onChange={(
                                                                              e,
                                                                            ) =>
                                                                              handleUpdatePartRef(
                                                                                pIndex,
                                                                                rowIndex,
                                                                                "manufacter",
                                                                                e
                                                                                  .target
                                                                                  .value,
                                                                              )
                                                                            }
                                                                            placeholder={t("manufacter")}
                                                                          />
                                                                        </div>
                                                                      </td>
                                                                    )}
                                                                    <td>
                                                                      <div className="form-check text-left">
                                                                        <label className="partsLabel col-form-label ml-2">
                                                                          Is
                                                                          Main
                                                                        </label>
                                                                        <input
                                                                          style={{
                                                                            marginLeft:
                                                                              "20px",
                                                                          }}
                                                                          className="form-check-input"
                                                                          type="radio" // Changed from checkbox to radio
                                                                          name={`isMainRadioGroup-${pIndex}-${rowIndex}`} // Unique name for each radio button group (to handle multiple groups)
                                                                          checked={
                                                                            data?.is_main ===
                                                                            1
                                                                          }
                                                                          onChange={() =>
                                                                            handleUpdatePartRef(
                                                                              pIndex,
                                                                              rowIndex,
                                                                              "is_main",
                                                                              1,
                                                                            )
                                                                          }
                                                                        />
                                                                      </div>
                                                                    </td>
                                                                    {isAllBackendValid && (
                                                                      <td>
                                                                        <div className="form-check text-left">
                                                                          <label className="partsLabel col-form-label ml-2"></label>
                                                                          <button
                                                                            type="button"
                                                                            className="btn btn-primary"
                                                                            onClick={(
                                                                              e,
                                                                            ) =>
                                                                              handleOemRefSubmit(
                                                                                e,
                                                                                data,
                                                                              )
                                                                            }
                                                                          >
                                                                            {t(
                                                                              "oem_references",
                                                                            )}
                                                                          </button>
                                                                        </div>
                                                                      </td>
                                                                    )}
                                                                    <td>
                                                                      <label className="partsLabel col-form-label ml-2">
                                                                        {t(
                                                                          "action",
                                                                        )}{" "}
                                                                      </label>
                                                                      <i
                                                                        className="bi bi-trash-fill"
                                                                        style={{
                                                                          cursor:
                                                                            "pointer",
                                                                        }}
                                                                        onClick={() =>
                                                                          handleDeletePartRef(
                                                                            pIndex,
                                                                            rowIndex,
                                                                          )
                                                                        }
                                                                      ></i>{" "}
                                                                    </td>

                                                                    {data.productID && (
                                                                      <td>
                                                                        <div className="form-check text-left">
                                                                          <label className="partsLabel col-form-label ml-2"></label>
                                                                          <i
                                                                            className="bi bi-eye-fill"
                                                                            style={{
                                                                              cursor:
                                                                                "pointer",
                                                                              fontSize:
                                                                                "22px",
                                                                            }}
                                                                            onClick={(
                                                                              e,
                                                                            ) => {
                                                                              setProductVehicleId(
                                                                                data.productID,
                                                                              );
                                                                              setModifyProductModal(
                                                                                true,
                                                                              );
                                                                            }}
                                                                          ></i>{" "}
                                                                        </div>
                                                                      </td>
                                                                    )}
                                                                  </tr>
                                                                </>
                                                              );
                                                            },
                                                          )}
                                                        </tbody>
                                                      </table>
                                                    </div>
                                                  </div>
                                                )}

                                                {getFieldPermission(
                                                  "parts_damage",
                                                ).show && (
                                                  <div className="col-lg-12">
                                                    <div className=" table-responsive-custom-q  table-custom-sticky-inherit">
                                                      <table className="table">
                                                        <thead>
                                                          <tr>
                                                            <th scope="col">
                                                              <div
                                                                className="col-lg-12 addPartField"
                                                                style={{
                                                                  width:
                                                                    "206px",
                                                                }}
                                                              >
                                                                <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                                  Damage
                                                                  Description
                                                                </label>
                                                                <input
                                                                  className="form-control input-search"
                                                                  type="text"
                                                                  name="damage_description"
                                                                  value={
                                                                    part?.damage_description
                                                                  }
                                                                  onChange={(
                                                                    e,
                                                                  ) =>
                                                                    handleInputChangePartListRef(
                                                                      e,
                                                                      pIndex,
                                                                    )
                                                                  }
                                                                  placeholder={t("damage_description")}
                                                                  disabled={
                                                                    !getFieldPermission(
                                                                      "parts_damage",
                                                                    ).editable
                                                                  }
                                                                />
                                                              </div>
                                                            </th>

                                                            <th scope="col">
                                                              <div className="col-lg-12 addPartField">
                                                                <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                                  Type Damage
                                                                </label>
                                                                <Select
                                                                  className="my-Select"
                                                                  options={
                                                                    typeDamageList
                                                                  }
                                                                  value={
                                                                    typeDamageList.find(
                                                                      (
                                                                        option,
                                                                      ) =>
                                                                        option.value ===
                                                                          part?.type_damage_id ||
                                                                        option.label ===
                                                                          part?.selectedCondition,
                                                                    ) || null
                                                                  }
                                                                  onChange={(
                                                                    selectedOption,
                                                                  ) =>
                                                                    handleTypeDamageChange(
                                                                      pIndex,
                                                                      selectedOption,
                                                                    )
                                                                  }
                                                                  isSearchable
                                                                  placeholder={
                                                                    "Select Type Damage"
                                                                  }
                                                                  isDisabled={
                                                                    !getFieldPermission(
                                                                      "parts_damage",
                                                                    ).editable
                                                                  }
                                                                ></Select>
                                                              </div>
                                                            </th>
                                                            <th scope="col">
                                                              <div className="col-lg-12 addPartField">
                                                                <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                                  Location
                                                                  Damage
                                                                </label>
                                                                <Select
                                                                  className="my-Select"
                                                                  options={
                                                                    locationDamageList
                                                                  }
                                                                  value={
                                                                    locationDamageList.find(
                                                                      (
                                                                        option,
                                                                      ) =>
                                                                        option.value ===
                                                                          part?.location_damage_id ||
                                                                        option.label ===
                                                                          part?.selectedType,
                                                                    ) || null
                                                                  }
                                                                  onChange={(
                                                                    selectedOption,
                                                                  ) =>
                                                                    hanldeLocationDamageChange(
                                                                      pIndex,
                                                                      selectedOption,
                                                                    )
                                                                  }
                                                                  isSearchable
                                                                  placeholder={t("select_location_damage")}
                                                                  isDisabled={
                                                                    !getFieldPermission(
                                                                      "parts_damage",
                                                                    ).editable
                                                                  }
                                                                />
                                                              </div>
                                                            </th>
                                                            <th scope="col">
                                                              <div
                                                                className="col-lg-12 addPartField"
                                                                style={{
                                                                  width:
                                                                    "192px",
                                                                }}
                                                              >
                                                                <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                                  Damage Rating
                                                                </label>
                                                                <ReactStars
                                                                  size={20}
                                                                  count={5}
                                                                  activeColor="#ffd700"
                                                                  a11y={true}
                                                                  isHalf={true}
                                                                  emptyIcon={
                                                                    <i className="bi bi-star" />
                                                                  }
                                                                  halfIcon={
                                                                    <i className="bi bi-star-half" />
                                                                  }
                                                                  filledIcon={
                                                                    <i className="bi bi-star-fill" />
                                                                  }
                                                                  value={
                                                                    part?.damage_rating
                                                                  }
                                                                  onChange={(
                                                                    newRating,
                                                                  ) =>
                                                                    handleInputChangePartListRef(
                                                                      {
                                                                        target:
                                                                          {
                                                                            name: "damage_rating",
                                                                            value:
                                                                              newRating,
                                                                          },
                                                                      },
                                                                      pIndex,
                                                                    )
                                                                  }
                                                                />
                                                              </div>
                                                            </th>

                                                            <th scope="col"></th>
                                                            <th>
                                                              <button
                                                                style={{
                                                                  marginTop:
                                                                    "77px",
                                                                }}
                                                                type="button"
                                                                className="btn btn-primary"
                                                                onClick={() =>
                                                                  handleAddPartDamage(
                                                                    pIndex,
                                                                  )
                                                                }
                                                                disabled={
                                                                  !getFieldPermission(
                                                                    "parts_damage",
                                                                  ).editable
                                                                }
                                                              >
                                                                Add Damage List
                                                              </button>
                                                            </th>
                                                          </tr>
                                                        </thead>
                                                        <tbody>
                                                          {part?.parts_damage?.map(
                                                            (
                                                              data,
                                                              rowIndex,
                                                            ) => {
                                                              return (
                                                                <>
                                                                  <tr
                                                                    key={
                                                                      rowIndex
                                                                    }
                                                                  >
                                                                    <td>
                                                                      <div className="col-lg-12 addPartField">
                                                                        <label className="partsLabel col-form-label ml-2">
                                                                          Damage
                                                                          Description
                                                                        </label>
                                                                        <input
                                                                          className="form-control input-search"
                                                                          type="text"
                                                                          name="damage_description"
                                                                          value={
                                                                            data.damage_description
                                                                          }
                                                                          onChange={(
                                                                            e,
                                                                          ) =>
                                                                            handleUpdatePartDamage(
                                                                              pIndex,
                                                                              rowIndex,
                                                                              "damage_description",
                                                                              e
                                                                                .target
                                                                                .value,
                                                                            )
                                                                          }
                                                                          placeholder={t("damage_description")}
                                                                        />
                                                                      </div>
                                                                    </td>

                                                                    <td>
                                                                      <label className="partsLabel col-form-label ml-2">
                                                                        Type
                                                                        Damage
                                                                      </label>
                                                                      <Select
                                                                        className="my-Select"
                                                                        options={
                                                                          typeDamageList
                                                                        }
                                                                        value={typeDamageList.find(
                                                                          (
                                                                            option,
                                                                          ) =>
                                                                            option.value ===
                                                                            data.type_damage_id,
                                                                        )}
                                                                        onChange={(
                                                                          selectedOption,
                                                                        ) =>
                                                                          handleUpdatePartDamage(
                                                                            pIndex,
                                                                            rowIndex,
                                                                            "type_damage_id",
                                                                            selectedOption?.value ||
                                                                              null,
                                                                          )
                                                                        }
                                                                        isSearchable
                                                                        placeholder={t("select_type_damage")}
                                                                      />
                                                                    </td>
                                                                    <td>
                                                                      <label className="partsLabel col-form-label ml-2">
                                                                        Location
                                                                        Damage
                                                                      </label>
                                                                      <Select
                                                                        className="my-Select"
                                                                        options={
                                                                          locationDamageList
                                                                        }
                                                                        value={locationDamageList.find(
                                                                          (
                                                                            option,
                                                                          ) =>
                                                                            option.value ===
                                                                            data.location_damage_id,
                                                                        )}
                                                                        onChange={(
                                                                          selectedOption,
                                                                        ) =>
                                                                          handleUpdatePartDamage(
                                                                            pIndex,
                                                                            rowIndex,
                                                                            "location_damage_id",
                                                                            selectedOption?.value ||
                                                                              null,
                                                                          )
                                                                        }
                                                                        isSearchable
                                                                        placeholder={t("select_location_damage")}
                                                                      />
                                                                    </td>
                                                                    <th scope="col">
                                                                      <div className="col-lg-12 addPartField">
                                                                        <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                                                                          Damage
                                                                          Rating
                                                                        </label>
                                                                        <ReactStars
                                                                          size={
                                                                            20
                                                                          }
                                                                          count={
                                                                            5
                                                                          }
                                                                          activeColor="#ffd700"
                                                                          a11y={
                                                                            true
                                                                          }
                                                                          isHalf={
                                                                            true
                                                                          }
                                                                          emptyIcon={
                                                                            <i className="bi bi-star" />
                                                                          }
                                                                          halfIcon={
                                                                            <i className="bi bi-star-half" />
                                                                          }
                                                                          filledIcon={
                                                                            <i className="bi bi-star-fill" />
                                                                          }
                                                                          value={
                                                                            data?.damage_rating
                                                                          }
                                                                          onChange={(
                                                                            newRating,
                                                                          ) =>
                                                                            handleUpdatePartDamage(
                                                                              pIndex,
                                                                              rowIndex,
                                                                              "damage_rating",
                                                                              newRating,
                                                                            )
                                                                          }
                                                                        />
                                                                      </div>
                                                                    </th>
                                                                    <td>
                                                                      <i
                                                                        className="bi bi-trash-fill"
                                                                        style={{
                                                                          cursor:
                                                                            "pointer",
                                                                        }}
                                                                        onClick={() =>
                                                                          handleDeletePartDamage(
                                                                            pIndex,
                                                                            rowIndex,
                                                                          )
                                                                        }
                                                                      ></i>{" "}
                                                                    </td>
                                                                  </tr>
                                                                </>
                                                              );
                                                            },
                                                          )}
                                                        </tbody>
                                                      </table>
                                                    </div>
                                                  </div>
                                                )}

                                                {part?.catalog_part_check_list && (
                                                  <div className="row">
                                                    <div
                                                      className="col-md-12"
                                                      style={{
                                                        marginTop: "10px",
                                                      }}
                                                    >
                                                      <div className="vehicleThBg table-responsive min-height-0 pb-2">
                                                        <table className="rounded-table table table-striped table-bordered table-hove">
                                                          <thead>
                                                            <tr>
                                                              <th
                                                                style={{
                                                                  width: "10%",
                                                                }}
                                                              >
                                                                {t("name")}
                                                              </th>

                                                              <th
                                                                style={{
                                                                  width: "10%",
                                                                }}
                                                              >
                                                                {t(
                                                                  "description",
                                                                )}
                                                              </th>
                                                              <th
                                                                style={{
                                                                  width: "10%",
                                                                }}
                                                              >
                                                                {t(
                                                                  "is_default",
                                                                )}
                                                              </th>
                                                              <th
                                                                style={{
                                                                  width: "10%",
                                                                }}
                                                              >
                                                                {t(
                                                                  "part_check",
                                                                )}
                                                              </th>
                                                            </tr>
                                                          </thead>

                                                          <tbody>
                                                            {part
                                                              ?.catalog_part_check_list
                                                              ?.length > 0 ? (
                                                              part?.catalog_part_check_list?.map(
                                                                (
                                                                  item,
                                                                  index,
                                                                ) => (
                                                                  <tr
                                                                    key={index}
                                                                  >
                                                                    <td>
                                                                      {
                                                                        item?.name
                                                                      }
                                                                    </td>
                                                                    <td>
                                                                      {item?.description ||
                                                                        "-"}
                                                                    </td>
                                                                    <td>
                                                                      {item?.is_default ===
                                                                      1
                                                                        ? "Yes"
                                                                        : "No"}
                                                                    </td>

                                                                    <td>
                                                                      <Select
                                                                        className="my-select-v"
                                                                        options={
                                                                          partCheckListStatusList
                                                                        }
                                                                        value={partCheckListStatusList.find(
                                                                          (
                                                                            option,
                                                                          ) =>
                                                                            option.value ===
                                                                            item?.check_list_status,
                                                                        )}
                                                                        onChange={(
                                                                          option,
                                                                        ) =>
                                                                          handleUpdatePartCheckStatus(
                                                                            pIndex,
                                                                            index,
                                                                            "check_list_status",
                                                                            option.value,
                                                                            item,
                                                                          )
                                                                        }
                                                                        placeholder={t("pi_select_part_check")}
                                                                        isDisabled={
                                                                          item?.part_converted_status ===
                                                                          1
                                                                        }
                                                                        menuPortalTarget={
                                                                          document.body
                                                                        }
                                                                        styles={{
                                                                          menuPortal:
                                                                            (
                                                                              base,
                                                                            ) => ({
                                                                              ...base,
                                                                              zIndex: 9999,
                                                                            }),
                                                                        }}
                                                                      />
                                                                    </td>
                                                                  </tr>
                                                                ),
                                                              )
                                                            ) : (
                                                              <tr className="scrollBrdr">
                                                                <td colSpan={6}>
                                                                  {t(
                                                                    "no_record_found",
                                                                  )}
                                                                </td>
                                                              </tr>
                                                            )}
                                                          </tbody>
                                                        </table>
                                                      </div>
                                                    </div>
                                                  </div>
                                                )}

                                                {part?.parts_catalog_attributes && (
                                                  <div className="col-lg-12">
                                                    <div className=" table-responsive-custom-q  table-custom-sticky-inherit">
                                                      <table className="table">
                                                        <div className="row">
                                                          {part?.parts_catalog_attributes?.text?.map(
                                                            (item, index) => {
                                                              const behavior =
                                                                getFieldBehavior(
                                                                  item,
                                                                );
                                                              return (
                                                                behavior.shouldShow && (
                                                                  <div
                                                                    className="col-lg-6 col-md-6 col-sm-12 mb-3"
                                                                    key={
                                                                      item.id
                                                                    }
                                                                    style={{
                                                                      padding:
                                                                        "15px",
                                                                    }}
                                                                  >
                                                                    <label className="partsLabel col-form-label ml-2 Label-my form-label">
                                                                      {
                                                                        item?.label_name
                                                                      }
                                                                      {behavior.isRequired && (
                                                                        <span className="text-danger">
                                                                          {" "}
                                                                          *
                                                                        </span>
                                                                      )}
                                                                    </label>

                                                                    <input
                                                                      type="text"
                                                                      className="form-control input-search"
                                                                      name={`attribute_${item.id}`}
                                                                      value={getAttributeValue(
                                                                        part,
                                                                        item.id,
                                                                      )}
                                                                      onChange={(
                                                                        e,
                                                                      ) =>
                                                                        handleGenericAttributeInputChange(
                                                                          e,
                                                                          item.id,
                                                                          part.tempId,
                                                                        )
                                                                      }
                                                                      placeholder="text"
                                                                      disabled={
                                                                        !behavior.isEditable
                                                                      }
                                                                      required={
                                                                        behavior.isRequired
                                                                      }
                                                                    />

                                                                    {errors[
                                                                      `attribute_${item.id}`
                                                                    ] && (
                                                                      <span className="input-error">
                                                                        {
                                                                          errors[
                                                                            `attribute_${item.id}`
                                                                          ]
                                                                        }
                                                                      </span>
                                                                    )}
                                                                  </div>
                                                                )
                                                              );
                                                            },
                                                          )}

                                                          {part.parts_catalog_attributes?.integer?.map(
                                                            (item, index) => {
                                                              const behavior =
                                                                getFieldBehavior(
                                                                  item,
                                                                );
                                                              return (
                                                                behavior.shouldShow && (
                                                                  <div
                                                                    className="col-lg-6 col-md-6 col-sm-12 mb-3"
                                                                    key={
                                                                      item.id
                                                                    }
                                                                    style={{
                                                                      padding:
                                                                        "15px",
                                                                    }}
                                                                  >
                                                                    <label className="partsLabel col-form-label ml-2 Label-my form-label">
                                                                      {
                                                                        item?.label_name
                                                                      }
                                                                      {behavior.isRequired && (
                                                                        <span className="text-danger">
                                                                          {" "}
                                                                          *
                                                                        </span>
                                                                      )}
                                                                    </label>

                                                                    <input
                                                                      type="number"
                                                                      className="form-control input-search"
                                                                      name={`attribute_${item.id}`}
                                                                      value={getAttributeValue(
                                                                        part,
                                                                        item.id,
                                                                      )}
                                                                      onChange={(
                                                                        e,
                                                                      ) =>
                                                                        handleGenericAttributeInputChange(
                                                                          e,
                                                                          item.id,
                                                                          part.tempId,
                                                                        )
                                                                      }
                                                                      placeholder="0"
                                                                      onKeyDown={(
                                                                        e,
                                                                      ) => {
                                                                        if (
                                                                          e.key ===
                                                                            "-" ||
                                                                          e.key ===
                                                                            "e"
                                                                        ) {
                                                                          e.preventDefault();
                                                                        }
                                                                      }}
                                                                      disabled={
                                                                        !behavior.isEditable
                                                                      }
                                                                      required={
                                                                        behavior.isRequired
                                                                      }
                                                                    />

                                                                    {errors[
                                                                      `attribute_${item.id}`
                                                                    ] && (
                                                                      <span className="input-error">
                                                                        {
                                                                          errors[
                                                                            `attribute_${item.id}`
                                                                          ]
                                                                        }
                                                                      </span>
                                                                    )}
                                                                  </div>
                                                                )
                                                              );
                                                            },
                                                          )}

                                                          {part.parts_catalog_attributes?.float?.map(
                                                            (item, index) => {
                                                              const behavior =
                                                                getFieldBehavior(
                                                                  item,
                                                                );
                                                              return (
                                                                behavior.shouldShow && (
                                                                  <div
                                                                    className="col-lg-6 col-md-6 col-sm-12 mb-3"
                                                                    key={
                                                                      item.id
                                                                    }
                                                                    style={{
                                                                      padding:
                                                                        "15px",
                                                                    }}
                                                                  >
                                                                    <label className="partsLabel col-form-label ml-2 Label-my form-label">
                                                                      {
                                                                        item?.label_name
                                                                      }
                                                                      {behavior.isRequired && (
                                                                        <span className="text-danger">
                                                                          {" "}
                                                                          *
                                                                        </span>
                                                                      )}
                                                                    </label>

                                                                    <input
                                                                      type="number"
                                                                      className="form-control input-search"
                                                                      name={`attribute_${item.id}`}
                                                                      value={getAttributeValue(
                                                                        part,
                                                                        item.id,
                                                                      )}
                                                                      onChange={(
                                                                        e,
                                                                      ) =>
                                                                        handleGenericAttributeInputChange(
                                                                          e,
                                                                          item.id,
                                                                          part.tempId,
                                                                        )
                                                                      }
                                                                      placeholder="0"
                                                                      disabled={
                                                                        !behavior.isEditable
                                                                      }
                                                                      required={
                                                                        behavior.isRequired
                                                                      }
                                                                      min="0"
                                                                      onKeyDown={(
                                                                        e,
                                                                      ) => {
                                                                        if (
                                                                          e.key ===
                                                                            "-" ||
                                                                          e.key ===
                                                                            "e"
                                                                        ) {
                                                                          e.preventDefault();
                                                                        }
                                                                      }}
                                                                    />

                                                                    {errors[
                                                                      `attribute_${item.id}`
                                                                    ] && (
                                                                      <span className="input-error">
                                                                        {
                                                                          errors[
                                                                            `attribute_${item.id}`
                                                                          ]
                                                                        }
                                                                      </span>
                                                                    )}
                                                                  </div>
                                                                )
                                                              );
                                                            },
                                                          )}

                                                          {part.parts_catalog_attributes?.date?.map(
                                                            (item, index) => {
                                                              const behavior =
                                                                getFieldBehavior(
                                                                  item,
                                                                );
                                                              return (
                                                                behavior.shouldShow && (
                                                                  <div
                                                                    className="col-lg-6 col-md-6 col-sm-12 mb-3"
                                                                    key={
                                                                      item.id
                                                                    }
                                                                    style={{
                                                                      padding:
                                                                        "15px",
                                                                    }}
                                                                  >
                                                                    <label className="partsLabel col-form-label ml-2 Label-my form-label">
                                                                      {
                                                                        item?.label_name
                                                                      }
                                                                      {behavior.isRequired && (
                                                                        <span className="text-danger">
                                                                          {" "}
                                                                          *
                                                                        </span>
                                                                      )}
                                                                    </label>
                                                                    <input
                                                                      type="date"
                                                                      className="form-control input-search"
                                                                      name={`attribute_${item.id}`}
                                                                      value={getAttributeValue(
                                                                        part,
                                                                        item.id,
                                                                      )}
                                                                      onChange={(
                                                                        e,
                                                                      ) =>
                                                                        handleGenericAttributeInputChange(
                                                                          e,
                                                                          item.id,
                                                                          part.tempId,
                                                                        )
                                                                      }
                                                                      placeholder="0"
                                                                      disabled={
                                                                        !behavior.isEditable
                                                                      }
                                                                      required={
                                                                        behavior.isRequired
                                                                      }
                                                                    />

                                                                    {errors[
                                                                      `attribute_${item.id}`
                                                                    ] && (
                                                                      <span className="input-error">
                                                                        {
                                                                          errors[
                                                                            `attribute_${item.id}`
                                                                          ]
                                                                        }
                                                                      </span>
                                                                    )}
                                                                  </div>
                                                                )
                                                              );
                                                            },
                                                          )}

                                                          {part.parts_catalog_attributes?.selection?.map(
                                                            (item, index) => {
                                                              const behavior =
                                                                getFieldBehavior(
                                                                  item,
                                                                );
                                                              return (
                                                                behavior.shouldShow && (
                                                                  <div
                                                                    className="col-lg-6 col-md-6 col-sm-12 mb-3"
                                                                    key={
                                                                      item.id
                                                                    }
                                                                    style={{
                                                                      padding:
                                                                        "15px",
                                                                    }}
                                                                  >
                                                                    <label className="partsLabel col-form-label ml-2 Label-my form-label">
                                                                      {
                                                                        item?.label_name
                                                                      }
                                                                      {behavior.isRequired && (
                                                                        <span className="text-danger">
                                                                          {" "}
                                                                          *
                                                                        </span>
                                                                      )}
                                                                    </label>
                                                                    <Select
                                                                      className="my-Select"
                                                                      options={item.options?.map(
                                                                        (
                                                                          opt,
                                                                        ) => ({
                                                                          value:
                                                                            opt.id,
                                                                          label:
                                                                            opt.option_name,
                                                                        }),
                                                                      )}
                                                                      name={`attribute_${item.id}`}
                                                                      value={
                                                                        item.options
                                                                          ?.map(
                                                                            (
                                                                              opt,
                                                                            ) => ({
                                                                              value:
                                                                                opt.id,
                                                                              label:
                                                                                opt.option_name,
                                                                            }),
                                                                          )
                                                                          .find(
                                                                            (
                                                                              opt,
                                                                            ) =>
                                                                              opt.label ===
                                                                              getAttributeValue(
                                                                                part,
                                                                                item.id,
                                                                              ), // ✅ match by label
                                                                          ) ||
                                                                        null
                                                                      }
                                                                      onChange={(
                                                                        selectedOption,
                                                                      ) => {
                                                                        handleAttributeSelectChange(
                                                                          selectedOption,
                                                                          item.id,
                                                                          part.tempId,
                                                                        );
                                                                      }}
                                                                      placeholder={t("pi_select_option")}
                                                                      isSearchable={
                                                                        true
                                                                      }
                                                                      menuPortalTarget={
                                                                        document.body
                                                                      }
                                                                      styles={{
                                                                        menuPortal:
                                                                          (
                                                                            base,
                                                                          ) => ({
                                                                            ...base,
                                                                            zIndex: 9999,
                                                                          }),
                                                                      }}
                                                                      isDisabled={
                                                                        !behavior.isEditable
                                                                      }
                                                                      isRequired={
                                                                        behavior.isRequired
                                                                      }
                                                                    />

                                                                    {errors[
                                                                      `attribute_${item.id}`
                                                                    ] && (
                                                                      <span className="input-error">
                                                                        {
                                                                          errors[
                                                                            `attribute_${item.id}`
                                                                          ]
                                                                        }
                                                                      </span>
                                                                    )}
                                                                  </div>
                                                                )
                                                              );
                                                            },
                                                          )}

                                                          {part.parts_catalog_attributes?.checkbox?.map(
                                                            (item, index) => {
                                                              const behavior =
                                                                getFieldBehavior(
                                                                  item,
                                                                );
                                                              return (
                                                                behavior.shouldShow && (
                                                                  <>
                                                                    <div
                                                                      className="col-md-6"
                                                                      key={
                                                                        item.id
                                                                      }
                                                                    >
                                                                      <div
                                                                        className="d-flex align-items-center gap-2"
                                                                        style={{
                                                                          display:
                                                                            "flex",
                                                                          alignItems:
                                                                            "center",
                                                                          gap: "8px",
                                                                        }}
                                                                      >
                                                                        <input
                                                                          className="form-check-input"
                                                                          type="checkbox"
                                                                          id={`attribute_${item.id}`}
                                                                          name={`attribute_${item.id}`}
                                                                          checked={
                                                                            getAttributeValue(
                                                                              part,
                                                                              item.id,
                                                                            ) ===
                                                                            "1"
                                                                          }
                                                                          onChange={(
                                                                            e,
                                                                          ) =>
                                                                            handleAttributeCheckboxChange(
                                                                              e,
                                                                              item.id,
                                                                              part.tempId,
                                                                            )
                                                                          }
                                                                          style={{
                                                                            marginLeft:
                                                                              "9px",
                                                                          }}
                                                                          disabled={
                                                                            !behavior.isEditable
                                                                          }
                                                                          required={
                                                                            behavior.isRequired
                                                                          }
                                                                        />
                                                                        <label
                                                                          className="form-check-label mb-0"
                                                                          htmlFor={`attribute_${item.id}`}
                                                                          style={{
                                                                            fontWeight: 700,
                                                                            fontSize:
                                                                              "16px",
                                                                            marginLeft:
                                                                              "35px",
                                                                            marginTop:
                                                                              "7px",
                                                                          }}
                                                                        >
                                                                          {
                                                                            item?.label_name
                                                                          }
                                                                          {behavior.isRequired && (
                                                                            <span className="text-danger">
                                                                              {" "}
                                                                              *
                                                                            </span>
                                                                          )}
                                                                        </label>
                                                                      </div>

                                                                      {errors[
                                                                        `attribute_${item.id}`
                                                                      ] && (
                                                                        <span className="input-error">
                                                                          {
                                                                            errors[
                                                                              `attribute_${item.id}`
                                                                            ]
                                                                          }
                                                                        </span>
                                                                      )}
                                                                    </div>

                                                                    <div className="col-md-6"></div>
                                                                  </>
                                                                )
                                                              );
                                                            },
                                                          )}
                                                        </div>{" "}
                                                      </table>
                                                    </div>
                                                  </div>
                                                )}
                                              </div>
                                            </div>
                                          </Card.Body>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </React.Fragment>
                              );
                            })}
                          </div>
                          <div className="back-footer">
                            <div className="row">
                              <div className="col-lg-6">
                                <button
                                  type="button"
                                  className="back-button btn btn-primary"
                                  onClick={handleBackButtonClick}
                                >
                                  <i className="bi bi-arrow-left"></i>{" "}
                                  {t("back")}
                                </button>
                              </div>

                              <div className="col-lg-6 saveasLBtns">
                                {btnLoader === true ? (
                                  <button
                                    type="button"
                                    disabled={true}
                                    className="btn btn-primary"
                                  >
                                    Loading...
                                  </button>
                                ) : (
                                  <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={handleSubmitAsLabelPrint}
                                    disabled={isSaveClicked}
                                    style={{ display: "none" }}
                                  >
                                    {t("save_as_label")}
                                    <i className="bi bi-save ms-2" />
                                  </button>
                                )}

                                <div>
                                  {btnLoading === true ? (
                                    <button
                                      type="button"
                                      disabled={true}
                                      className="btn btn-primary"
                                    >
                                      Loading...
                                    </button>
                                  ) : (
                                    <button
                                      type="submit"
                                      className="btn btn-primary addPArtsSave"
                                    >
                                      {t("save")}
                                      <i className="bi bi-save ms-2"></i>
                                    </button>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </Form>
                        {/* <div className="card-footer clearfix card-footer-part">
               <div className="pagination pagination-sm m-0 float-right">
                 <Pagination
                   activePage={params.page}
                   itemsCountPerPage={parseInt(params.limit)}
                   totalItemsCount={parseInt(totalRecords)}
                   pageRangeDisplayed={5}
                   itemClass={`page-item`}
                   linkClass={`page-link`}
                   onChange={(e) => handleParams(e, "pagination")}
                 />
               </div>
             </div> */}
                      </div>
                    </div>
                  </>
                )}

                {currentStep === 3 && (
                  <>
                    <div className="card-body vehicleparts-table mt-3">
                      <div className="vehicleparts-table-inner">
                        <div className="row">
                          <>
                            <Form className="row" onSubmit={handleSubmits}>
                              <React.Fragment>
                                <div className="col-lg-6">
                                  <Card className="text-justify">
                                    <Card.Header className="cardHeader">
                                      <div className="d-flex">
                                        <div className="AddPh6">
                                          <h6>Part Information</h6>
                                        </div>
                                      </div>
                                    </Card.Header>
                                    <Card.Body
                                      className="cardBody"
                                      style={{ padding: "0" }}
                                    >
                                      <div className="container-fluid text-justify">
                                        <div className="row pt-2 pb-2 border-bottom">
                                          <div className="col-lg-6">
                                            Part Name:
                                          </div>
                                          <div className="col-lg-6">
                                            {currentPart?.part_name}
                                          </div>
                                        </div>
                                        <div className="row pt-2 pb-2 border-bottom">
                                          <div className="col-lg-6">
                                            Part Description:
                                          </div>
                                          <div
                                            className="col-lg-6"
                                            style={{ lineHeight: "25px" }}
                                          >
                                            {currentPart?.part_description}
                                          </div>
                                        </div>

                                        <div className="row pt-2 pb-2 border-bottom">
                                          <div className="col-lg-6">
                                            Part Quantity:
                                          </div>
                                          <div className="col-lg-6">
                                            {currentPart?.quantity}
                                          </div>
                                        </div>
                                        <div className="row pt-2 pb-2 border-bottom">
                                          <div className="col-lg-6">
                                            Part Price:
                                          </div>
                                          <div className="col-lg-6">
                                            {currentPart?.part_price}
                                          </div>
                                        </div>

                                        <div className="row pt-2 pb-2 border-bottom">
                                          <div className="col-lg-6">
                                            Part Original Price:
                                          </div>
                                          <div className="col-lg-6">
                                            {currentPart?.part_original_price}
                                          </div>
                                        </div>

                                        <div className="row pt-2 pb-2 border-bottom">
                                          <div className="col-lg-6">
                                            Sponsor Price:{" "}
                                          </div>
                                          <div className="col-lg-6">
                                            {currentPart?.sponsor_price}
                                          </div>
                                        </div>
                                      </div>
                                    </Card.Body>
                                  </Card>
                                </div>
                                <div className="col-lg-6">
                                  <Card className="text-center">
                                    <Card.Header className="cardHeader">
                                      <div className="d-flex">
                                        <div className="AddPh6">
                                          <h6>{t("upload_part_images")}</h6>
                                        </div>
                                      </div>
                                    </Card.Header>
                                    <Card.Body className="cardBody">
                                      {getFieldPermission("parts_photos")
                                        .show && (
                                        <div className="row">
                                          <div className="col-lg-12 addPartField">
                                            <div
                                              className="col-lg-12 addPartField"
                                              style={{
                                                height: "221px",
                                                overflowY: "auto",
                                                overflowX: "hidden",
                                              }}
                                            >
                                              <label className="partsLabel col-form-label ml-2 Label-my form-label">
                                                {t("upload_images")}
                                              </label>

                                              <div className="input-div">
                                                <div className="avatar-upload">
                                                  <div className="avatar-edit">
                                                    <input
                                                      ref={fileInputRef}
                                                      className="inputFile"
                                                      type="file"
                                                      id="imageuploadAbout"
                                                      onChange={
                                                        handleAboutFileChange
                                                      }
                                                      name="file"
                                                      accept=".jpg,.jpeg,.png,.webp,.jfif"
                                                      multiple
                                                      disabled={
                                                        !getFieldPermission(
                                                          "parts_photos",
                                                        ).editable
                                                      }
                                                    />
                                                    <label htmlFor="imageuploadAbout"></label>
                                                  </div>

                                                  <PhotoProvider
                                                    visible={viewerOpen}
                                                    onVisibleChange={(v) =>
                                                      setViewerOpen(v)
                                                    }
                                                    current={viewerIndex}
                                                    onIndexChange={(i) =>
                                                      setViewerIndex(i)
                                                    }
                                                  >
                                                    <div className="partImages partImages_mob mt-2 d-flex flex-wrap">
                                                      {images?.map(
                                                        (file, index) => (
                                                          <div
                                                            key={index}
                                                            className="preview-item"
                                                            style={{
                                                              position:
                                                                "relative",
                                                              display:
                                                                "inline-block",
                                                              margin: "5px",
                                                            }}
                                                          >
                                                            <PhotoView
                                                              src={
                                                                previewUrl[
                                                                  index
                                                                ]
                                                              }
                                                            >
                                                              <img
                                                                className="image"
                                                                src={
                                                                  previewUrl[
                                                                    index
                                                                  ]
                                                                }
                                                                alt={`Preview ${index}`}
                                                                onClick={() => {
                                                                  toggleEnlarge(
                                                                    index,
                                                                  );
                                                                  setViewerIndex(
                                                                    index,
                                                                  );
                                                                  setViewerOpen(
                                                                    true,
                                                                  );
                                                                }}
                                                                style={{
                                                                  width:
                                                                    "100px",
                                                                  height:
                                                                    "100px",
                                                                  border:
                                                                    "1px solid",
                                                                  borderRadius:
                                                                    "5px",
                                                                  objectFit:
                                                                    "cover",
                                                                  cursor:
                                                                    "pointer",
                                                                }}
                                                              />
                                                            </PhotoView>

                                                            {getFieldPermission(
                                                              "parts_photos",
                                                            ).editable && (
                                                              <i
                                                                className="editImageBtn bi bi-pen-fill"
                                                                style={{
                                                                  position:
                                                                    "absolute",
                                                                  top: "5px",
                                                                  left: "5px",
                                                                  cursor:
                                                                    "pointer",
                                                                  color: "blue",
                                                                  backgroundColor:
                                                                    "white",
                                                                  borderRadius:
                                                                    "50%",
                                                                  padding:
                                                                    "2px",
                                                                  zIndex: 2,
                                                                }}
                                                                onClick={() =>
                                                                  handleImageSelect(
                                                                    file,
                                                                  )
                                                                }
                                                              ></i>
                                                            )}

                                                            {/* Delete */}
                                                            {getFieldPermission(
                                                              "parts_photos",
                                                            ).editable && (
                                                              <i
                                                                className="removeImageBtn bi bi-x"
                                                                style={{
                                                                  position:
                                                                    "absolute",
                                                                  top: "5px",
                                                                  right: "5px",
                                                                  cursor:
                                                                    "pointer",
                                                                  color: "red",
                                                                  backgroundColor:
                                                                    "white",
                                                                  borderRadius:
                                                                    "50%",
                                                                  padding:
                                                                    "2px",
                                                                  zIndex: 2,
                                                                }}
                                                                onClick={() =>
                                                                  handleRemoveFile(
                                                                    index,
                                                                  )
                                                                }
                                                              ></i>
                                                            )}
                                                          </div>
                                                        ),
                                                      )}
                                                    </div>
                                                  </PhotoProvider>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      )}
                                    </Card.Body>
                                  </Card>
                                </div>
                              </React.Fragment>

                              <div className="d-flex flex-row mt-3 justify-content-end">
                                {!isLastPart && (
                                  <Button
                                    className="me-2 mb-2 next-button"
                                    onClick={handleOpenSkip}
                                  >
                                    {t("skip")} & {t("next")}
                                  </Button>
                                )}

                                {!isLastPart && (
                                  <Button
                                    className="me-2 mb-2 btn-primary"
                                    type="submit"
                                  >
                                    {t("save")}& {t("next")}
                                  </Button>
                                )}

                                {!isLastPart && (
                                  <Button
                                    type="Button"
                                    className="btn btn-primary nxt-btn"
                                    onClick={handleImportModal}
                                  >
                                    Sort By Order{" "}
                                    <i className="bi bi-arrow-right"></i>
                                  </Button>
                                )}
                              </div>
                              {isLastPart && (
                                <>
                                  <div className="row">
                                    <div className="col">
                                      <Button
                                        type="button"
                                        className="back-btn ms-0 "
                                        onClick={handleBackButtonClick}
                                      >
                                        <i className="bi bi-arrow-left"></i>{" "}
                                        {t("back")}
                                      </Button>
                                    </div>
                                    <div className="col infobtns">
                                      {btnSaved === true ? (
                                        <button
                                          type="button"
                                          disabled={true}
                                          className="btn btn-primary"
                                        >
                                          Loading...
                                        </button>
                                      ) : (
                                        <Button
                                          className="mb-2 next-button"
                                          onClick={handleFinish}
                                          style={{ marginRight: "10px" }}
                                          type="button"
                                        >
                                          {t("save")}
                                          <i className="bi bi-save"></i>
                                        </Button>
                                      )}

                                      <Button
                                        type="Button"
                                        className="btn btn-primary nxt-btn"
                                        onClick={handleImportModal}
                                      >
                                        Sort By Order{" "}
                                        <i className="bi bi-arrow-right"></i>
                                      </Button>

                                      <Button
                                        className="mb-2 next-button"
                                        onClick={
                                          () => {
                                            if (
                                              currentPart?.parts_damage
                                                ?.length > 0
                                            ) {
                                              setCurrentStep(4);
                                            } else {
                                              setCurrentStep(5);
                                            }
                                          }
                                          // navigate("/parts-inventory")
                                        }
                                      >
                                        {t("finish")}{" "}
                                        <i className="bi bi-arrow-right"></i>
                                      </Button>
                                    </div>
                                  </div>
                                </>
                              )}
                            </Form>
                          </>
                        </div>
                      </div>
                    </div>
                  </>
                )}

                {currentStep === 4 && (
                  <AssignedDamageImage
                    partImageDataList={partImageDataList}
                    currentStep={currentStep}
                    setCurrentStep={setCurrentStep}
                    currentPartIndex={currentPartIndex}
                    setCurrentPartIndex={setCurrentPartIndex}
                    isLastPart={isLastPart}
                    vehicleImageDetails={vehicleImageDetails}
                    detailsForImages={detailsForImages}
                    partsData={partsData}
                  />
                )}

                {currentStep === 5 && (
                  <AddPartVideo
                    currentStep={currentStep}
                    currentPart={currentPart}
                    vehicleAddDetails={vehicleAddDetails}
                    setCurrentStep={setCurrentStep}
                    currentPartIndex={currentPartIndex}
                    setCurrentPartIndex={setCurrentPartIndex}
                    isLastPart={isLastPart}
                    showSkip={showSkip}
                    setShowSkip={setShowSkip}
                    setPartVideoDataList={setPartVideoDataList}
                    partVideoDataList={partVideoDataList}
                    partsData={partsData}
                    detailsForVideo={detailsForVideo}
                    setCurrentPartVideoIndex={setCurrentPartVideoIndex}
                    currentPartVideoIndex={currentPartVideoIndex}
                    getFieldPermission={getFieldPermission}
                  />
                )}

                {currentStep === 6 && (
                  <AssignedDamageVideo
                    partVideoDataList={partVideoDataList}
                    currentStep={currentStep}
                    setCurrentStep={setCurrentStep}
                    detailsForVideo={detailsForVideo}
                    partsData={partsData}
                    setCurrentPartVideoIndex={setCurrentPartVideoIndex}
                    currentPartVideoIndex={currentPartVideoIndex}
                  />
                )}
              </>
            )}
          </div>
        </div>

        <Modal isOpen={modifyImportModal} toggle={handleImportCloseModal}>
          <ModalHeader toggle={handleImportCloseModal}>
            Sort By Order
          </ModalHeader>
          <ModalBody>
            <DragDropContext onDragEnd={onDragEnd}>
              <Droppable droppableId="fileList" direction="vertical">
                {(provided) => (
                  <div
                    className="file-list"
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                    }}
                  >
                    {images?.map((file, index) => (
                      <Draggable
                        key={file.id.toString() ? file.id.toString() : file.id}
                        draggableId={
                          file.id.toString() ? file.id.toString() : file.id
                        }
                        index={index}
                      >
                        {(provided) => (
                          <div
                            className="file-item"
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={{
                              ...provided.draggableProps.style,
                              border: "1px solid #ddd",
                              padding: "10px",
                              borderRadius: "5px",
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <img
                              src={file.image_url ? file.image_url : file.url}
                              alt="Preview"
                              style={{
                                width: "50px",
                                height: "50px",
                                objectFit: "cover",
                                borderRadius: "5px",
                              }}
                            />
                            {/* <span>{file.file.name}</span> */}
                          </div>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={handleImportCloseModal}
            >
              Close
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleSaveOrder}
            >
              {t("save_order")}
            </button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={modifyMasterPart} size="lg">
          <ModalHeader>
            {categoryMasterPart ? categoryMasterPart?.label : ""}
          </ModalHeader>

          <ModalBody>
            <div className="row">
              <div className="col-md-12">
                <div className="col-md-12">
                  <FormGroup>
                    <div
                      className="vehicleparts-table-inner vehicleThBg tableScroll table-scroll-modal"
                      style={{
                        width: "530px",

                        marginLeft: "100px",
                      }}
                    >
                      <table className="rounded-table table table-striped table-bordered table-hover">
                        <thead>
                          <tr>
                            <th style={{ width: "10%" }}>Select</th>

                            <th style={{ width: "0%" }}>Part</th>
                          </tr>
                        </thead>
                        <tbody>
                          {categoryMasterPart?.part_list?.map((item, index) => (
                            <tr key={index}>
                              <td>
                                <input
                                  type="checkbox"
                                  checked={checkedItems.includes(item)}
                                  onChange={() => handleCheck(item)}
                                />
                              </td>
                              <td>{item?.namePartPT}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </FormGroup>
                </div>
              </div>
            </div>
          </ModalBody>

          <ModalFooter>
            <button
              type="button"
              className="btn btn-block btn-secondary"
              onClick={handleMasterPartClose}
              style={{ width: "100px", marginTop: "10px" }}
            >
              Close
            </button>
            <button
              type="button"
              className="btn btn-block btn-primary"
              style={{ width: "100px", marginTop: "10px" }}
              onClick={handleModalSubmit}
            >
              Submit
            </button>
          </ModalFooter>
        </Modal>

        {vehicleAddDetails?.vehicle_id && (
          <>
            {filteredData.length > 0 ? (
              <>
                <Modal isOpen={modifyMasterVehiclePart} size="lg">
                  <ModalHeader>
                    {categoryMasterPart ? categoryMasterPart?.label : ""}
                  </ModalHeader>

                  <ModalBody>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="col-md-12">
                          <FormGroup>
                            {categoryMasterPart?.part_list?.map(
                              (item, index) => (
                                <tr key={index}>
                                  <td>
                                    <input
                                      type="checkbox"
                                      checked={checkedItems.includes(item)}
                                      onChange={() => handleCheck(item)}
                                    />
                                  </td>
                                  <td>
                                    <div className="input-div SelectV">
                                      <div className="col-md-12">
                                        {item?.namePartPT}
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              ),
                            )}
                          </FormGroup>
                        </div>
                      </div>
                    </div>
                  </ModalBody>

                  <ModalFooter>
                    <button
                      type="button"
                      className="btn btn-block btn-secondary"
                      onClick={handlMasterVehicleClose}
                      style={{ width: "100px", marginTop: "10px" }}
                    >
                      Close
                    </button>
                    <button
                      type="button"
                      className="btn btn-block btn-primary"
                      style={{ width: "100px", marginTop: "10px" }}
                      onClick={handleModalSubmit}
                    >
                      Submit
                    </button>
                  </ModalFooter>
                </Modal>
              </>
            ) : (
              <>
                <Modal isOpen={modifyMasterVehiclePart} size="lg">
                  <ModalHeader>Part List</ModalHeader>

                  <ModalBody>
                    <div className="row">
                      No part was found, as it already exists{" "}
                    </div>
                  </ModalBody>

                  <ModalFooter>
                    <button
                      type="button"
                      className="btn btn-block btn-secondary"
                      onClick={handlMasterVehicleClose}
                      style={{ width: "100px", marginTop: "10px" }}
                    >
                      Close
                    </button>
                  </ModalFooter>
                </Modal>
              </>
            )}
          </>
        )}

        <Modal isOpen={modifyMasterVehicleNotPart} size="xxl">
          <ModalHeader>Part List</ModalHeader>

          <ModalBody>
            <div className="row">
              <div className="col-md-12">
                <div className="col-md-12">
                  <div className="vehicleThBg table-responsive">
                    <table className="rounded-table table table-striped table-bordered table-hover">
                      <thead>
                        <tr>
                          <th style={{ width: "10%" }}></th>

                          <th style={{ width: "10%" }}>Part Name</th>

                          <th style={{ width: "10%" }}>Year</th>

                          <th style={{ width: "0%" }}>Vehicle Make</th>
                          <th style={{ width: "0%" }}>Vehicle Modal</th>
                          <th style={{ width: "0%" }}>Vehicle Variant</th>
                        </tr>
                      </thead>
                      <tbody>
                        {categoryMasterPart?.part_list?.map((item, index) => (
                          <tr key={index}>
                            <td>
                              <input
                                type="checkbox"
                                checked={selectedItemsCheckBox.some(
                                  (selected) => selected.index === index,
                                )}
                                onChange={() =>
                                  handleCheckboxChangeMaster(index, item)
                                }
                              />
                            </td>
                            <td>
                              <div className="input-div SelectV">
                                <div className="col-md-12">
                                  {item?.namePartPT}
                                </div>
                              </div>
                            </td>

                            <td>{vehicleAddDetails?.vehicle_year}</td>

                            <td>{vehicleAddDetails?.vehicle_make_name}</td>

                            <td>{vehicleAddDetails?.vehicle_model_name}</td>

                            <td>{vehicleAddDetails?.vehicle_variant_name}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-block btn-secondary"
              onClick={handlMasterVehicleNotClose}
              style={{ width: "100px", marginTop: "10px" }}
            >
              Close
            </button>
            <button
              type="button"
              className="btn btn-block btn-primary"
              style={{ width: "100px", marginTop: "10px" }}
              onClick={handleSubmitAdd}
            >
              Submit
            </button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={showModalAbout}>
          <ModalHeader>"Part Image"</ModalHeader>
          <ModalBody>
            <div className="preview-container">
              {images.map(({ file, id }, index) => (
                <div key={id} className="preview-item">
                  <img
                    src={previewUrl[index]}
                    alt={`Preview ${index}`}
                    style={{ width: "100px", margin: "5px" }}
                  />
                  <div className="btn-Remove">
                    <i
                      className="bi bi-x"
                      style={{ color: "red", cursor: "pointer" }}
                      onClick={() => handleRemoveFile(index)}
                    ></i>
                  </div>
                </div>
              ))}
            </div>
          </ModalBody>
          <ModalFooter>
            <Button variant="secondary" onClick={handleCloseAbout}>
              Close
            </Button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={showSkip}>
          <ModalHeader></ModalHeader>
          <ModalBody>
            <div className="row">Are you sure you want to skip this part?</div>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-block btn-primary"
              onClick={handleCloseSkip}
              style={{ width: "100px", marginTop: "10px" }}
            >
              Close <i className="bi bi-x-lg"></i>
            </button>

            <button
              type="button"
              className="btn btn-block btn-primary"
              onClick={handleSkip}
              style={{ width: "100px", marginTop: "10px" }}
            >
              Yes <i className="bi bi-x-lg"></i>
            </button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={vehiclePartDetailsModal}>
          <ModalHeader>{`Part Details`}</ModalHeader>
          <ModalBody>
            <div className="row">
              <div className="col-md-12">
                <div className="vehicleThBg table-responsive">
                  <table className="rounded-table table table-striped table-bordered table-hover">
                    <thead>
                      <tr>
                        <th style={{ width: "10%" }}>Part Name</th>

                        <th style={{ width: "10%" }}>Part quantity</th>
                      </tr>
                    </thead>

                    <tbody>
                      {vehicleExceedData?.parts?.length > 0 ? (
                        vehicleExceedData?.parts?.map((item, index) => (
                          <tr key={index}>
                            <td>{item.part_name}</td>
                            <td>{item.quantity}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="100%">No results found</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-block btn-primary"
              onClick={onvehiclePartDetailsClose}
              style={{ width: "100px", marginTop: "10px" }}
            >
              Close <i className="bi bi-x-lg"></i>
            </button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={modifyExpiry}>
          <ModalHeader>{`Vehicle Expiry Date`}</ModalHeader>

          <ModalBody>
            <div className="row">
              <div className="col-md-12">
                <div className="col-md-12">
                  <FormGroup>
                    <Label className="col-form-label">{"Expiry Date"}</Label>
                    <div className="col-xl-12">
                      <div className="input-div">
                        <input
                          type="date"
                          id="date"
                          className="form-control"
                          value={vehicleData?.date}
                          onChange={(e) => {
                            setVehicleData({
                              ...vehicleData,
                              date: e.target.value,
                            });
                          }}
                          placeholder={t("expiry_date")}
                        />
                      </div>
                    </div>
                  </FormGroup>
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-block btn-primary"
              onClick={ExpiryModalNextclose}
              style={{ width: "100px", marginTop: "10px" }}
            >
              Submit <i className="bi bi-check2"></i>
            </button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={partEtaiModify}>
          <ModalHeader>{t("reference_code")}</ModalHeader>

          <ModalBody>
            <div className="row">
              <div className="col-md-12">
                <div className="col-md-12">
                  <FormGroup>
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>{t("reference_code")}</th>
                          <th>{t("product_label")}</th>
                          <th>{t("action")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {partETAIRefDetails?.map((item, index) => (
                          <tr key={index}>
                            <td>{item?.reference_code}</td>
                            <td>{item?.product_label}</td>
                            <td>
                              <input
                                type="radio"
                                className="form-check-input"
                                name="radio-select"
                                checked={
                                  selectedReferenceCode === item?.reference_code
                                }
                                onChange={() =>
                                  handleRadioChange(item?.reference_code)
                                }
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </FormGroup>
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-block btn-primary"
              onClick={handlePartEtaiClose}
              style={{ width: "100px", marginTop: "10px" }}
            >
              {t("submit")} <i className="bi bi-check2"></i>
            </button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={partEtaiPriceModify}>
          <ModalHeader>{t("price")}</ModalHeader>

          <ModalBody>
            <div className="row">
              <div className="col-md-12">
                <div className="col-md-12">
                  <FormGroup>
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>{t("price")}</th>
                          <th>{t("product_label")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {partETAIPriceDetail &&
                        partETAIPriceDetail.length > 0 ? (
                          partETAIPriceDetail.map((item, index) => (
                            <tr key={index}>
                              <td>€ {item?.source}</td>
                              <td>{item?.label}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="2" className="text-center">
                              {t("no_record_found")}
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </FormGroup>
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-block btn-primary"
              onClick={handlePartEtaiPriceClose}
              style={{ width: "100px", marginTop: "10px" }}
            >
              {t("close")} <i className="bi bi-check2"></i>
            </button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={modifyDelteRef}>
          <ModalHeader>{`Delete Reference `}</ModalHeader>
          <ModalBody>
            <p
              className={`mb-0`}
            >{`Are you sure you want to delete this Reference code?`}</p>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-block btn-primary"
              onClick={handleRefClose}
              style={{ width: "100px", marginTop: "10px" }}
            >
              Close <i className="bi bi-x-lg"></i>
            </button>

            <button
              type="button"
              className="btn btn-block bg-red"
              style={{ width: "100px" }}
              onClick={hanldeEditdeleteRef}
            >
              Delete <i className="bi bi-trash3"></i>
            </button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={modifyDelteDamage}>
          <ModalHeader>{`Delete Part Damage`}</ModalHeader>
          <ModalBody>
            <p
              className={`mb-0`}
            >{`Are you sure you want to delete this part damage?`}</p>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-block btn-primary"
              onClick={handleDamageClose}
              style={{ width: "100px", marginTop: "10px" }}
            >
              Close <i className="bi bi-x-lg"></i>
            </button>

            <button
              type="button"
              className="btn btn-block bg-red"
              style={{ width: "100px" }}
              onClick={hanldeEditdeleteDamage}
            >
              Delete <i className="bi bi-trash3"></i>
            </button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={modalStateHistory} size="xl">
          <ModalHeader>
            <div className="d-flex justify-content-between align-items-center w-100">
              <div className="card-title m-0">Part Details History</div>

              {catalogModalStateDataList?.length > 0 && (
                <div className="d-flex gap-2" style={{ marginLeft: "538px" }}>
                  <button
                    type="button"
                    className="btn btn-primary"
                    style={{ width: "185px" }}
                    onClick={handleChangePriceBulkOpen}
                  >
                    Change prices (bulk)
                  </button>

                  <button
                    type="button"
                    className="btn btn-primary"
                    style={{ width: "185px" }}
                    onClick={handleChangeReferencesBulkOpen}
                  >
                    Add References (bulk)
                  </button>
                </div>
              )}
            </div>
          </ModalHeader>

          <ModalBody>
            <div className="row">
              <div className="col-md-12">
                <div className="col-md-12">
                  <div
                    className="mb-3"
                    style={{ overflowX: "auto", minHeight: "200px" }}
                  >
                    <FormGroup>
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            <th>{t("id")}</th>
                            <th>{t("part_name")}</th>
                            <th>{t("make")}</th>
                            <th>{t("modal")}</th>
                            <th>{t("variant")}</th>
                            <th>{t("year")}</th>
                            <th>{t("quantity")}</th>
                            <th>{t("price")}</th>
                            <th>{t("createdDate")}</th>
                            <th>{t("action")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {catalogModalStateDataList &&
                          catalogModalStateDataList.length > 0 ? (
                            catalogModalStateDataList.map((item, index) => (
                              <tr key={index}>
                                <td>{item?.id}</td>
                                <td>{item?.part_name}</td>
                                <td>{item?.vehicle_make_name}</td>
                                <td>{item?.vehicle_model_name}</td>
                                <td>{item?.vehicle_variant_name}</td>
                                <td>{item?.vehicle_year}</td>
                                <td>{item?.quantity}</td>
                                <td>€ {item?.part_price}</td>
                                <td>
                                  {moment(item?.created_at).format(
                                    "DD/MM/YYYY HH:mm",
                                  )}
                                </td>
                                <td>
                                  <div
                                    style={{ cursor: "pointer" }}
                                    className="edit-btn"
                                    onClick={() =>
                                      window.open(
                                        `/part-details/${item.uuid}`,
                                        "_blank",
                                      )
                                    }
                                  >
                                    <i className="bi bi-eye-fill"></i>
                                  </div>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={10} className="text-center">
                                No Data Found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </FormGroup>
                  </div>
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-block btn-primary"
              onClick={handleClosePartHistory}
              style={{ width: "100px", marginTop: "10px" }}
            >
              Close <i className="bi bi-check2"></i>
            </button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={modalSponsorPrice} size="lg">
          <ModalHeader>{`Statiscal Price`}</ModalHeader>
          <ModalBody>
            <div className="row">
              <div className="col-md-12">
                <div className="col-md-12">
                  <FormGroup>
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Price1 Min</th>
                          <th>Price1 Avg</th>
                          <th>Price1 Max</th>
                          <th>Price2 Min</th>
                          <th>Price2 Avg</th>
                          <th>Price2 Max</th>
                        </tr>
                      </thead>
                      <tbody>
                        {sponsorPricDataList &&
                        sponsorPricDataList.length > 0 ? (
                          sponsorPricDataList.map((item, index) => (
                            <tr key={index}>
                              <td>€ {item?.price1_min}</td>
                              <td>€ {item?.price1_avg}</td>
                              <td>€ {item?.price1_max}</td>
                              <td>€ {item?.price2_min}</td>
                              <td>€ {item?.price2_price_avg}</td>
                              <td>€ {item?.price2_price_max}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="6" style={{ textAlign: "center" }}>
                              No record found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </FormGroup>
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-block btn-primary"
              onClick={handleCloseSponsorPrice}
              style={{ width: "100px", marginTop: "10px" }}
            >
              Close <i className="bi bi-check2"></i>
            </button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={modalEstimatePrice} size="lg">
          <ModalHeader>{`Estimate Price`}</ModalHeader>

          <ModalBody>
            <div className="row">
              <div className="col-md-12">
                <div className="col-md-12">
                  <FormGroup>
                    <div
                      className="row"
                      style={{
                        marginTop: "10px",
                      }}
                    >
                      <div className="col-md-12">
                        <h6 className="mb-0">Vehicle Model</h6>
                      </div>
                      <div className="vehical-list-1">
                        <div className="vehical-list-iteam">
                          Avg :
                          {estimatePricDataList?.stats?.stats_for_model
                            ?.price_avg || 0}
                        </div>

                        <div className="vehical-list-iteam">
                          Max :
                          {estimatePricDataList?.stats?.stats_for_model
                            ?.price_max || 0}
                        </div>

                        <div className="vehical-list-iteam">
                          Min :
                          {estimatePricDataList?.stats?.stats_for_model
                            ?.price_min || 0}
                        </div>

                        <div className="vehical-list-iteam">
                          Quantity. :
                          {estimatePricDataList?.stats?.stats_for_model
                            ?.quantity || 0}
                        </div>
                      </div>
                      <div className="col-md-12">
                        <h6 className="mb-0">Vehicle Variants</h6>
                      </div>
                      <div className="vehical-list-1">
                        <div className="vehical-list-iteam">
                          Avg :
                          {estimatePricDataList?.stats?.stats_for_variant
                            ?.price_avg || 0}
                        </div>

                        <div className="vehical-list-iteam">
                          Max :
                          {estimatePricDataList?.stats?.stats_for_variant
                            ?.price_max || 0}
                        </div>

                        <div className="vehical-list-iteam">
                          Min :
                          {estimatePricDataList?.stats?.stats_for_variant
                            ?.price_min || 0}
                        </div>

                        <div className="vehical-list-iteam">
                          Quantity. :
                          {estimatePricDataList?.stats?.stats_for_variant
                            ?.quantity || 0}
                        </div>
                      </div>
                      <div className="col-md-12">
                        <h6 className="mb-0">Part/Model</h6>
                      </div>
                      <div className="vehical-list-1">
                        <div className="vehical-list-iteam">
                          Avg :
                          {estimatePricDataList?.stats?.stats_for_part_and_model
                            ?.price_avg || 0}
                        </div>

                        <div className="vehical-list-iteam">
                          Max :
                          {estimatePricDataList?.stats?.stats_for_part_and_model
                            ?.price_max || 0}
                        </div>

                        <div className="vehical-list-iteam">
                          Min :
                          {estimatePricDataList?.stats?.stats_for_part_and_model
                            ?.price_min || 0}
                        </div>

                        <div className="vehical-list-iteam">
                          Quantity. :
                          {estimatePricDataList?.stats?.stats_for_part_and_model
                            ?.quantity || 0}
                        </div>
                      </div>
                      <div className="col-md-12">
                        <h6 className="mb-0"> Engine Code</h6>
                      </div>
                      <div className="vehical-list-1">
                        <div className="vehical-list-iteam">
                          Avg :
                          {estimatePricDataList?.stats?.stats_for_engine_code
                            ?.price_avg || 0}
                        </div>

                        <div className="vehical-list-iteam">
                          Max :
                          {estimatePricDataList?.stats?.stats_for_engine_code
                            ?.price_max || 0}
                        </div>

                        <div className="vehical-list-iteam">
                          Min :
                          {estimatePricDataList?.stats?.stats_for_engine_code
                            ?.price_min || 0}
                        </div>

                        <div className="vehical-list-iteam">
                          Quantity. :
                          {estimatePricDataList?.stats?.stats_for_engine_code
                            ?.quantity || 0}
                        </div>
                      </div>
                    </div>
                  </FormGroup>
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-block btn-primary"
              onClick={handleCloseEstimatePrice}
              style={{ width: "100px", marginTop: "10px" }}
            >
              Close <i className="bi bi-check2"></i>
            </button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={modalRefCodeCondition} size="lg">
          <ModalHeader>{`Part Details`}</ModalHeader>

          <ModalBody>
            <div className="row">
              <div className="col-md-12">
                <div className="col-md-12">
                  <FormGroup>
                    <table className="table table-bordered table-striped align-middle">
                      <thead className="table-dark">
                        <tr>
                          <th>Ref Code</th>
                          <th>Price1 Min</th>
                          <th>Price1 Avg</th>
                          <th>Price1 Max</th>
                          <th>Price2 Min</th>
                          <th>Price2 Avg</th>
                          <th>Price2 Max</th>
                          {/* <th>View</th> */}
                        </tr>
                      </thead>
                      <tbody>
                        {refCodeConditionDataList?.partsList?.map(
                          (part, index) => (
                            <tr key={index}>
                              <td>
                                <strong>{part.ref_code}</strong>
                              </td>
                              <td>€ {part?.prices?.price1_min || 0}</td>
                              <td>€ {part?.prices?.price1_avg || 0}</td>
                              <td>€ {part?.prices?.price1_max || 0}</td>
                              <td>€ {part?.prices?.price2_min || 0}</td>
                              <td>€ {part?.prices?.price2_price_avg || 0}</td>
                              <td>€ {part?.prices?.price2_price_max || 0}</td>
                              {/* <td>
                                    <div
                                      style={{ cursor: "pointer" }}
                                      className="text-primary"
                                      // onClick={() =>
                                      //   window.open(
                                      //     `/part-details/${part.uuid}`,
                                      //     "_blank"
                                      //   )
                                      // }
                                    >
                                      <i className="bi bi-eye-fill fs-5"></i>
                                    </div>
                                  </td> */}
                            </tr>
                          ),
                        )}
                      </tbody>
                    </table>
                  </FormGroup>
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-block btn-primary"
              onClick={handleCloseRefCodeCondition}
              style={{ width: "100px", marginTop: "10px" }}
            >
              Close <i className="bi bi-check2"></i>
            </button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={isModalOpen} toggle={closeModal} size="lg">
          <Form method="post">
            <ModalHeader toggle={closeModal}>Image Edit</ModalHeader>
            {selectedImage && (
              <ModalBody>
                <div className="modal-body" style={{ marginBottom: "100px" }}>
                  <div
                    style={{
                      width: "100%",
                      height: "400px",
                      textAlign: "center",
                    }}
                  >
                    <div
                      style={{
                        position: "relative",
                        display: "inline-block",
                        width: "100%",
                        height: "394px",
                      }}
                    >
                      {/* Cropping Section */}
                      <ReactCrop
                        crop={crop}
                        onImageLoaded={onImageLoad}
                        onChange={(newCrop) => setCrop(newCrop)}
                        onComplete={(c) => setCompletedCrop(c)}
                        disabled={!isCropping}
                      >
                        <img
                          src={selectedImage.url}
                          ref={imgRef}
                          style={{
                            transform: `rotate(${rotation}deg)`,
                            maxWidth: "100%",
                            maxHeight: "100%",
                            objectFit: "cover",
                            height: "394px",
                            display: selectedImage ? "block" : "none",
                          }}
                          alt="Crop preview"
                          onClick={onImageClick}
                        />
                      </ReactCrop>
                      {isDrawing && !isCropping && (
                        <div
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                          }}
                        >
                          <ReactSketchCanvas
                            ref={canvasRef}
                            style={{
                              width: "100%",
                              height: "100%",
                              position: "absolute",
                              top: 0,
                              left: 0,
                            }}
                            canvasColor="transparent"
                            allowOnlyPointerType="all"
                          />
                        </div>
                      )}
                    </div>

                    <div className="row" style={{ marginTop: "40px" }}>
                      <div className="col-md-2">
                        <i
                          className="bi bi-crop"
                          style={{
                            fontSize: "22px",
                            cursor: "pointer",
                            color: isCropping ? "blue" : "black",
                          }}
                          onClick={handleCrop}
                        ></i>
                      </div>

                      <div className="col-md-2">
                        <i
                          className="bi bi-brush"
                          style={{
                            fontSize: "22px",
                            cursor: "pointer",
                            color: isDrawing ? "blue" : "black",
                          }}
                          onClick={() => saveDrawing(selectedImage.id)}
                        ></i>
                      </div>

                      <div className="col-md-2">
                        <i
                          className="bi bi-arrow-counterclockwise"
                          style={{ fontSize: "22px", cursor: "pointer" }}
                          onClick={() => handleRotate(selectedImage.id)}
                        ></i>
                      </div>

                      <div className="col-md-2">
                        <i
                          className="bi bi-image"
                          style={{ fontSize: "22px", cursor: "pointer" }}
                          onClick={() =>
                            handleRemoveBgImageeForm(selectedImage.id)
                          }
                          disabled={isLoading}
                        ></i>
                      </div>

                      <div className="col-md-2">
                        <i
                          className="bi bi-image"
                          style={{ fontSize: "22px", cursor: "pointer" }}
                          onClick={(e) =>
                            handleAddBgImageForm(selectedImage.id)
                          }
                          disabled={isLoadings}
                        ></i>
                      </div>

                      <div className="col-md-2">
                        <i
                          className="bi bi-paint-bucket"
                          style={{ fontSize: "22px", cursor: "pointer" }}
                          onClick={() =>
                            handleAddBgColoreForm(selectedImage.id)
                          }
                        ></i>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-2">
                        <span>Crop</span>
                      </div>

                      <div className="col-md-2">
                        <span>Brush</span>
                      </div>

                      <div className="col-md-2">
                        <span>Rotate</span>
                      </div>

                      <div className="col-md-2">
                        <span>
                          {isLoading ? "Processing..." : "Remove Back"}
                        </span>
                      </div>

                      <div className="col-md-2">
                        <span>
                          {" "}
                          {isLoadings ? "Processing..." : "Add Back"}
                        </span>
                      </div>

                      <div className="col-md-2">
                        <span>
                          {isLoadingColor ? "Processing..." : "Add Color"}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </ModalBody>
            )}

            <ModalFooter>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={closeModal}
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={getCroppedImage}
              >
                Apply Changes
              </button>
            </ModalFooter>
          </Form>
        </Modal>

        <Modal isOpen={modalRefCodeEstimate} size="lg">
          <ModalHeader>{`Estimate Price`}</ModalHeader>

          <ModalBody>
            <div className="row">
              <div className="col-md-12">
                <div className="col-md-12">
                  <FormGroup>
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Reference</th>
                          <th>Reference Type</th>

                          <th>Price Avg</th>
                          <th>Price Max</th>
                          <th>Price Min</th>
                          <th>Quantity</th>
                        </tr>
                      </thead>
                      <tbody>
                        {estimatePricDataRefList?.stats_for_references?.map(
                          (item, index) => (
                            <tr key={index}>
                              <td>{item?.reference}</td>
                              <td>{item?.referenceType}</td>
                              <td>€ {item?.stats_reference?.price_avg}</td>
                              <td>€ {item?.stats_reference?.price_max}</td>
                              <td>€ {item?.stats_reference?.price_min}</td>
                              <td>{item?.stats_reference?.quantity}</td>
                            </tr>
                          ),
                        )}
                      </tbody>
                    </table>
                  </FormGroup>
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-block btn-primary"
              onClick={handleCloseRefCodeEstimate}
              style={{ width: "100px", marginTop: "10px" }}
            >
              Close <i className="bi bi-check2"></i>
            </button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={modalOcrRef} size="xl">
          <ModalHeader>{`OCR Multiple Reference`}</ModalHeader>

          <ModalBody>
            <div className="row align-items-center">
              <div className="col-md-8">
                <FormGroup>
                  <Label className="col-form-label">{t("select_file")}</Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control"
                        type="file"
                        onChange={(e) => setFile(e.target.files[0])}
                        name="file"
                        accept="image/*"
                      />
                      {errorsImport.file && (
                        <span className="input-error">{errorsImport.file}</span>
                      )}
                    </div>
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-4">
                <button
                  type="button"
                  className="btn btn-block btn-primary"
                  onClick={handleSubmitOCRRef}
                  style={{ marginTop: "25px" }}
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>{" "}
                      Processing...
                    </>
                  ) : (
                    <>
                      Add References Text <i className="bi bi-check2"></i>
                    </>
                  )}
                </button>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="col-md-12">
                  <FormGroup>
                    <div className="table-responsive">
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            <th>Reference Text</th>
                            <th>Reference Type</th>
                            <th>Condition</th>
                            <th>{t("action")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {refReadData?.length > 0 ? (
                            refReadData?.map((item, index) => (
                              <tr key={index}>
                                {/* Editable Text Input */}
                                <td>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={
                                      updatedTexts[index] !== undefined
                                        ? updatedTexts[index]
                                        : item.text
                                    }
                                    onChange={(e) =>
                                      handleTextChange(index, e.target.value)
                                    }
                                  />
                                </td>

                                {/* Reference Type Select */}
                                <td>
                                  <Select
                                    className="my-Select"
                                    options={referenceList}
                                    value={
                                      selectedReferenceType[index] ||
                                      referenceList.find(
                                        (r) => r.value === 2,
                                      ) ||
                                      null
                                    }
                                    onChange={(selectedOption) =>
                                      handleReferenceChangeOcr(
                                        index,
                                        selectedOption,
                                      )
                                    }
                                    isSearchable
                                    placeholder={t("pi_select_reference_type")}
                                  />
                                </td>

                                {/* Condition Select */}
                                <td>
                                  <Select
                                    className="my-Select"
                                    options={conditionList}
                                    value={selectedConditions[index] || null}
                                    onChange={(selectedOption) =>
                                      handleConditionChangeOcr(
                                        index,
                                        selectedOption,
                                      )
                                    }
                                    isSearchable
                                    placeholder={t("select_condition")}
                                  />
                                </td>

                                {selectedConditions[index]?.value === 2 &&
                                selectedReferenceType[index]?.value === 1 ? (
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={
                                        updatedData[index]?.brand !== undefined
                                          ? updatedData[index].brand
                                          : item.brand
                                      }
                                      onChange={(e) =>
                                        handleBrandChange(index, e.target.value)
                                      }
                                      placeholder={t("brand")}
                                    />
                                  </td>
                                ) : (
                                  <td>-</td>
                                )}

                                {selectedReferenceType[index]?.value === 1 ? (
                                  <td>
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={
                                        updatedData[index]?.manufacturer !==
                                        undefined
                                          ? updatedData[index].manufacturer
                                          : item.manufacturer
                                      }
                                      onChange={(e) =>
                                        handleManufacturerChange(
                                          index,
                                          e.target.value,
                                        )
                                      }
                                      placeholder={t("manufacturer")}
                                    />
                                  </td>
                                ) : (
                                  <td>-</td>
                                )}

                                {/* Checkbox */}
                                <td>
                                  <input
                                    style={{
                                      marginLeft: "100px",
                                      width: "20px",
                                      height: "20px",
                                      accentColor: "black",
                                      marginTop: "-9px",
                                    }}
                                    type="checkbox"
                                    className="form-check-input"
                                    checked={!!selectedRowsRef[index]}
                                    onChange={() => handleCheckboxChange(index)}
                                  />
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="4" style={{ textAlign: "center" }}>
                                No record found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </FormGroup>
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-block btn-secondary"
              onClick={handleChangeOCRClose}
              style={{ width: "100px", marginTop: "10px" }}
            >
              Close <i className="bi bi-check2"></i>
            </button>

            <button
              type="button"
              className="btn btn-block btn-primary"
              onClick={handleChangeOCRClose}
              style={{ width: "156px", marginTop: "10px" }}
            >
              Save References <i className="bi bi-check2"></i>
            </button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={modalCompatible} className="modal-xxl">
          <ModalHeader>{`Compatible`}</ModalHeader>

          <ModalBody>
            <div className="row">
              <div className="col-md-12">
                <FormGroup>
                  <div className="col-lg-12">
                    <div
                      className="vehicleThBg table-responsive table-responsive-sm"
                      style={{ height: "370px" }}
                    >
                      <Table className="rounded-table" striped bordered hover>
                        <thead>
                          <tr>
                            <th>
                              <div
                                className="input-div SelectV"
                                style={{ width: "190px" }}
                              >
                                <div className="col-md-12">
                                  <Select
                                    className="my-select-v"
                                    options={VehicleTypeList}
                                    value={selectedVehicle}
                                    onChange={handleVehicleChange}
                                    isSearchable={true}
                                    placeholder={"Select Vehicle Types"}
                                  />
                                </div>
                              </div>
                            </th>

                            <th>
                              <div
                                className="input-div SelectV"
                                style={{ width: "190px" }}
                              >
                                <div className="col-md-12">
                                  <Select
                                    className="my-select-v"
                                    options={VehicleYearList}
                                    value={
                                      VehicleYearList.find(
                                        (item) =>
                                          item.value ==
                                          vehiclePartsComData.vehicle_year,
                                      ) || null
                                    }
                                    onChange={(selectedOption) => {
                                      setVehiclePartsComData((prev) => ({
                                        ...prev,
                                        vehicle_year: selectedOption
                                          ? selectedOption.value
                                          : "",
                                        vehicle_make: "",
                                        vehicle_model: "",
                                        vehicle_variant: "",
                                        vehicle_make_name: "",
                                      }));
                                      setVehicleMakeList([]);
                                      setVehicleModalList([]);
                                      setVehicleVariantList([]);
                                    }}
                                    placeholder={"Select Vehicle Year"}
                                    onInputChange={
                                      handleInputSelectedChangeComYearList
                                    }
                                    inputSelctedValue={inputSelctedeYearValue}
                                  />
                                </div>
                              </div>
                            </th>

                            <th>
                              <div
                                className="input-div SelectV"
                                style={{ width: "190px" }}
                              >
                                <div className="col-md-12">
                                  <Select
                                    className="my-select-v"
                                    options={VehicleMakeList}
                                    value={
                                      VehicleMakeList.find(
                                        (item) =>
                                          item.value ===
                                          vehiclePartsComData.vehicle_make,
                                      ) || null
                                    }
                                    onChange={(selectedOption) => {
                                      setVehiclePartsComData((prev) => ({
                                        ...prev,
                                        vehicle_make: selectedOption
                                          ? selectedOption.value
                                          : "",
                                        vehicle_model: "",
                                        vehicle_variant: "",
                                        vehicle_make_name: selectedOption
                                          ? selectedOption.label
                                          : "",
                                      }));
                                      setVehicleModalList([]);
                                      setVehicleVariantList([]);
                                    }}
                                    isSearchable={true}
                                    onInputChange={
                                      handleInputSelectedChangeComMakeList
                                    }
                                    inputSelctedValue={inputSelctedeMakeValue}
                                    placeholder={"Select Vehicle Make"}
                                  />
                                </div>
                              </div>
                            </th>

                            <th>
                              <div
                                className="input-div SelectV"
                                style={{ width: "190px" }}
                              >
                                <div className="col-md-12">
                                  <Select
                                    className="my-select-v"
                                    options={
                                      vehiclePartsComData.vehicle_make
                                        ? VehicleModalList
                                        : [
                                            { value: "all", label: "All" },
                                            ...VehicleModalList,
                                          ]
                                    }
                                    value={
                                      vehiclePartsComData.vehicle_make
                                        ? VehicleModalList.find(
                                            (item) =>
                                              item.value ===
                                              vehiclePartsComData.vehicle_model,
                                          )
                                        : null
                                    }
                                    onChange={(selectedOption) => {
                                      setVehiclePartsComData((prev) => ({
                                        ...prev,
                                        vehicle_model: selectedOption
                                          ? selectedOption.value
                                          : "all",
                                        vehicle_variant: "all",
                                      }));
                                      setVehicleVariantList([]);
                                    }}
                                    isSearchable={true}
                                    onInputChange={
                                      handleInputSelectedChangeModalList
                                    }
                                    inputSelctedValue={inputSelctedeModalValue}
                                    placeholder={"Select Vehicle Model"}
                                  />
                                </div>
                                Statiscal Price
                              </div>
                            </th>

                            <th>
                              <div
                                className="input-div SelectV"
                                style={{ width: "190px" }}
                              >
                                <div className="col-md-12">
                                  <Select
                                    className="my-select-v"
                                    options={
                                      vehiclePartsComData.vehicle_model ||
                                      vehiclePartsComData.vehicle_make
                                        ? VehicleVariantList
                                        : [
                                            { value: "all", label: "All" },
                                            ...VehicleVariantList,
                                          ]
                                    }
                                    value={
                                      vehiclePartsComData.vehicle_model
                                        ? VehicleVariantList.find(
                                            (item) =>
                                              item.value ===
                                              vehiclePartsComData.vehicle_variant,
                                          )
                                        : vehiclePartsComData.vehicle_make
                                          ? { value: "all", label: "All" }
                                          : null
                                    }
                                    onChange={(selectedOption) =>
                                      setVehiclePartsComData({
                                        ...vehiclePartsComData,
                                        vehicle_variant: selectedOption
                                          ? selectedOption.value
                                          : "all", // Reset variant
                                      })
                                    }
                                    isSearchable={true}
                                    onInputChange={
                                      handleInputSelectedChangeComVariantList
                                    }
                                    inputSelctedValue={
                                      inputSelctededVariantValue
                                    }
                                    placeholder={"Select Vehicle Variant"}
                                  />
                                </div>
                              </div>
                            </th>

                            <th>
                              <div
                                className="input-div SelectV"
                                style={{ width: "190px" }}
                              >
                                <div className="col-md-12">
                                  <input
                                    className="form-control input-search"
                                    type="text"
                                    name="notes"
                                    value={vehiclePartsComData.notes}
                                    onChange={handleInputChangeComp}
                                    placeholder={t("notes")}
                                  />
                                </div>
                              </div>
                            </th>
                            <th>
                              <div
                                className="addBtn"
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  handleAddCompatible(selectedPartForPopup)
                                }
                              >
                                <i className="bi bi-plus-lg"></i>
                              </div>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {partsData?.filter(
                            (part, index) =>
                              part.parts_associate?.length > 0 &&
                              index === selectedPartForPopup,
                          ).length > 0 ? (
                            partsData
                              ?.filter(
                                (part, index) =>
                                  part.parts_associate?.length > 0 &&
                                  index === selectedPartForPopup,
                              )
                              .map((part, partIndex) => (
                                <React.Fragment key={partIndex}>
                                  {part.parts_associate.map((item, index) => (
                                    <tr key={`${partIndex}-${index}`}>
                                      <td>{item.vehicle_type_name}</td>
                                      <td>{item.vehicle_year}</td>
                                      <td>{item.make_name}</td>
                                      <td>{item.model_name}</td>
                                      <td>{item.variant_name || "All"}</td>
                                      <td>{item.notes}</td>
                                      <td>
                                        <Button
                                          type="button"
                                          className="btn-danger-delete"
                                          onClick={() =>
                                            handleRemoveCompatible(
                                              partIndex,
                                              index,
                                            )
                                          }
                                        >
                                          <i className="bi bi-trash3"></i>
                                        </Button>
                                      </td>
                                    </tr>
                                  ))}
                                </React.Fragment>
                              ))
                          ) : (
                            <tr>
                              <td colSpan="100%" className="text-center">
                                No results found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </FormGroup>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-block btn-primary"
              onClick={handleChangeCompatibleClose}
              style={{ width: "100px", marginTop: "10px" }}
            >
              Save <i className="bi bi-check2"></i>
            </button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={modifyNotes} size="lg">
          <ModalHeader>Notes Fields</ModalHeader>

          <ModalBody>
            {selectedPartIndex !== null && partsData[selectedPartIndex] && (
              <div className="row">
                {getFieldPermission("part_description").show && (
                  <div className="col-lg-12 addPartField col-lg-6-mob">
                    <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                      Notes
                    </label>
                    <textarea
                      className="form-control input-search"
                      name="part_description"
                      value={partsData[selectedPartIndex].part_description}
                      onChange={(e) =>
                        handleInputNotesChangePartList(e, selectedPartIndex)
                      }
                      placeholder={t("pi_part_description")}
                      rows={5}
                      disabled={
                        !getFieldPermission("part_description").editable
                      }
                    />
                  </div>
                )}

                {getFieldPermission("extra_notes").show && (
                  <div className="col-lg-12 addPartField col-lg-6-mob">
                    <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                      Extra Notes
                    </label>
                    <textarea
                      className="form-control input-search"
                      name="extra_notes"
                      value={partsData[selectedPartIndex].extra_notes}
                      onChange={(e) =>
                        handleInputNotesChangePartList(e, selectedPartIndex)
                      }
                      placeholder={t("pi_extra_notes")}
                      rows={5}
                      disabled={!getFieldPermission("extra_notes").editable}
                    />
                  </div>
                )}

                {getFieldPermission("internal_notes").show && (
                  <div className="col-lg-12 addPartField col-lg-6-mob">
                    <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                      Internal Notes
                    </label>
                    <textarea
                      className="form-control input-search"
                      name="internal_notes"
                      value={partsData[selectedPartIndex].internal_notes}
                      onChange={(e) =>
                        handleInputNotesChangePartList(e, selectedPartIndex)
                      }
                      placeholder={t("pi_internal_notes")}
                      rows={5}
                      disabled={!getFieldPermission("internal_notes").editable}
                    />
                  </div>
                )}
              </div>
            )}
          </ModalBody>

          <ModalFooter>
            <button
              type="button"
              className="btn btn-block btn-primary"
              onClick={handleChangeNotesClose}
              style={{ width: "100px", marginTop: "10px" }}
            >
              Save <i className="bi bi-check2"></i>
            </button>
          </ModalFooter>
        </Modal>
      </div>

      <Modal isOpen={modifyOemModal} size="xl">
        <ModalHeader>{t("oem_references")}</ModalHeader>
        <div className="col-md-6">
          {t("priceOEM")} : € {structureOemList?.decode?.priceOEM || 0}
        </div>
        <ModalBody>
          <div className="d-flex justify-content-between align-items-center">
            <Nav tabs>
              <NavItem>
                <NavLink
                  className={activeTab === "1" ? "active" : ""}
                  onClick={() => toggleTab("1")}
                  style={{ cursor: "pointer" }}
                >
                  {t("equivalentsIAM")}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={activeTab === "2" ? "active" : ""}
                  onClick={() => toggleTab("2")}
                  style={{ cursor: "pointer" }}
                >
                  {t("equivalentsOEM")}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={activeTab === "3" ? "active" : ""}
                  onClick={() => toggleTab("3")}
                  style={{ cursor: "pointer" }}
                >
                  {t("VehiclesCompatibles")}
                </NavLink>
              </NavItem>
            </Nav>
          </div>

          {loadingStructureOem ? (
            <div className="text-center my-4">
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">{t("loading")}</span>
              </div>
            </div>
          ) : (
            <TabContent activeTab={activeTab} className="pt-3">
              <TabPane tabId="1">
                <div className="row">
                  <div
                    className="col-md-12"
                    style={{
                      display: "flex",
                      justifyContent: "end",
                    }}
                  >
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={handleOpenProductConfirm}
                      style={{
                        width: "110px",
                        marginBottom: "9px",
                        marginTop: "-25px",
                      }}
                    >
                      {t("products")} <i className="bi bi-check2"></i>
                    </button>
                  </div>
                  <div className="col-md-12">
                    <FormGroup>
                      <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                        <table className="table table-bordered">
                          <thead>
                            <tr>
                              <th>
                                <input
                                  type="checkbox"
                                  checked={
                                    structureOemList?.decode?.equivalentsIAM
                                      ?.length > 0 &&
                                    selectedVehicleData?.iem_list?.length ===
                                      structureOemList?.decode?.equivalentsIAM
                                        ?.length
                                  }
                                  onChange={handleCheckAll}
                                />
                              </th>
                              <th>{t("brandName")}</th>
                              <th>{t("fullReference")}</th>
                              <th>{t("manufacter")}</th>
                              <th>{t("reference")}</th>
                              <th>{t("action")}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {structureOemList?.decode?.equivalentsIAM?.length >
                            0 ? (
                              structureOemList?.decode?.equivalentsIAM?.map(
                                (item, index) => (
                                  <tr key={index}>
                                    <td>
                                      <input
                                        type="checkbox"
                                        checked={selectedVehicleData?.iem_list?.some(
                                          (i) => i.productID === item.productID,
                                        )}
                                        onChange={() =>
                                          handleCheckVehicle(item.productID)
                                        }
                                      />
                                    </td>
                                    <td>{item?.brandName}</td>
                                    <td>{item?.fullReference}</td>
                                    <td>{item?.manufacter}</td>
                                    <td>{item?.reference}</td>
                                    <td>
                                      <button
                                        type="button"
                                        className="btn btn-block btn-primary"
                                        onClick={(e) => {
                                          setProductVehicleId(item);
                                          setModifyProductModal(true);
                                        }}
                                        style={{
                                          width: "45px",
                                          marginTop: "10px",
                                        }}
                                      >
                                        <i className="bi bi-eye-fill"></i>{" "}
                                      </button>{" "}
                                    </td>
                                  </tr>
                                ),
                              )
                            ) : (
                              <tr>
                                <td colSpan="5" style={{ textAlign: "center" }}>
                                  {t("no_results_found")}
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </FormGroup>
                  </div>
                </div>
              </TabPane>

              <TabPane tabId="2">
                <div className="row">
                  <div className="col-md-12">
                    <FormGroup>
                      <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                        <table className="table table-bordered">
                          <thead>
                            <tr>
                              <th>
                                <input
                                  type="checkbox"
                                  checked={
                                    structureOemList?.decode?.equivalentsOEM
                                      ?.length > 0 &&
                                    selectedOEMIndices.length ===
                                      structureOemList.decode.equivalentsOEM
                                        .length
                                  }
                                  onChange={handleCheckAllOEM}
                                />
                              </th>
                              <th>{t("manufacter")}</th>
                              <th>{t("fullReference")}</th>
                              <th>{t("reference")}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {structureOemList?.decode?.equivalentsOEM?.length >
                            0 ? (
                              structureOemList?.decode?.equivalentsOEM?.map(
                                (item, index) => (
                                  <tr key={index}>
                                    <td>
                                      <input
                                        type="checkbox"
                                        checked={selectedOEMIndices.includes(
                                          index,
                                        )}
                                        onChange={() => handleCheckOEM(index)}
                                      />
                                    </td>
                                    <td>{item?.manufacter}</td>
                                    <td>{item?.fullReference}</td>
                                    <td>{item?.reference}</td>
                                  </tr>
                                ),
                              )
                            ) : (
                              <tr>
                                <td colSpan="5" style={{ textAlign: "center" }}>
                                  {t("no_results_found")}
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </FormGroup>
                  </div>
                </div>
              </TabPane>

              <TabPane tabId="3">
                <div className="row">
                  <div className="col-md-12">
                    <FormGroup>
                      <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                        <table className="table table-bordered">
                          <thead>
                            <tr>
                              <th>
                                <input
                                  type="checkbox"
                                  checked={
                                    vehicleCompatiblesList?.length > 0 &&
                                    vehicleCompatibleItems?.length ===
                                      vehicleCompatiblesList?.length
                                  }
                                  onChange={handleCompatibleCheckAll}
                                />
                              </th>
                              <th>{t("vehicle_make_description")}</th>
                              <th>{t("vehicle_model_description")}</th>
                              <th>{t("vehicle_variant_description")}</th>
                              <th>{t("vehicle_variant_end_production")}</th>
                              <th>{t("vehicle_variant_init_production")}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {vehicleCompatiblesList?.length > 0 ? (
                              vehicleCompatiblesList?.map((item, index) => (
                                <tr key={index}>
                                  <td>
                                    <input
                                      type="checkbox"
                                      checked={selectedVehicleData?.vehicle_compatible_list?.some(
                                        (i) => i.variantID === item.variantID,
                                      )}
                                      onChange={() =>
                                        handleCompatibleCheck(item.variantID)
                                      }
                                    />
                                  </td>
                                  <td>{item?.vehicle_make_description}</td>
                                  <td>{item?.vehicle_model_description}</td>
                                  <td>{item?.vehicle_variant_description}</td>
                                  <td>
                                    {item?.vehicle_variant_end_production}
                                  </td>
                                  <td>
                                    {item?.vehicle_variant_init_production}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="5" style={{ textAlign: "center" }}>
                                  {t("no_results_found")}
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </FormGroup>
                  </div>
                </div>
              </TabPane>
            </TabContent>
          )}
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleSelectRef}
            style={{ width: "100px", marginTop: "10px" }}
          >
            {t("Select")} <i className="bi bi-check2"></i>
          </button>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleChangeOemRefClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            {t("close")} <i className="bi bi-check2"></i>
          </button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={modifyProductModal} size="xxl">
        <ModalHeader>{t("product_details")}</ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col-md-12">
              <div className="col-md-12">
                <FormGroup>
                  <div
                    className="row"
                    style={{
                      marginTop: "10px",
                    }}
                  >
                    <div className="col-md-4">
                      <h6
                        style={{
                          marginBottom: "-1px",
                          marginLeft: "-8px",
                        }}
                      >
                        {t("product_name")}:{" "}
                        {vehicleCompatibleProductDetails?.decode?.product
                          ?.name || "-"}
                      </h6>
                    </div>

                    <div className="col-md-4">
                      <h6
                        style={{
                          marginBottom: "-1px",
                          marginLeft: "-8px",
                        }}
                      >
                        {t("reference")}:{" "}
                        {vehicleCompatibleProductDetails?.decode?.product
                          ?.reference || "-"}
                      </h6>
                    </div>
                    <div className="col-md-4">
                      <h6
                        style={{
                          marginBottom: "-1px",
                          marginLeft: "-8px",
                        }}
                      >
                        {t("supplier")}:{" "}
                        {vehicleCompatibleProductDetails?.decode?.product
                          ?.supplier || "-"}
                      </h6>
                    </div>

                    <div className="col-md-4">
                      <h6
                        style={{
                          marginBottom: "-1px",
                          marginLeft: "-8px",
                          marginTop: "11px",
                        }}
                      >
                        {t("eanNumbers")}:{" "}
                        {vehicleCompatibleProductDetails?.decode?.product?.eanNo
                          ?.eanNumbers || 0}
                      </h6>
                    </div>
                    <div className="col-md-4"></div>
                    <div className="col-md-4"></div>
                  </div>

                  <div className="row">
                    <div className="col-md-6" style={{ marginTop: "15px" }}>
                      <div>
                        <h6
                          style={{
                            fontSize: "16px",
                            fontWeight: "700",
                          }}
                        >
                          {t("allSpecifications")}
                        </h6>
                        <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                          <table className="table table-bordered">
                            <thead>
                              <tr>
                                <th>{t("criteriaName")}</th>
                                <th>{t("criteriaValue")}</th>
                              </tr>
                            </thead>
                            <tbody>
                              {vehicleCompatibleProductDetails?.decode?.product
                                ?.allSpecifications?.length > 0 ? (
                                vehicleCompatibleProductDetails?.decode?.product?.allSpecifications?.map(
                                  (item, index) => (
                                    <tr key={index}>
                                      <td>{item?.criteriaName}</td>
                                      <td>{item?.criteriaValue}</td>
                                    </tr>
                                  ),
                                )
                              ) : (
                                <tr>
                                  <td
                                    colSpan="5"
                                    style={{ textAlign: "center" }}
                                  >
                                    {t("no_results_found")}
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6" style={{ marginTop: "15px" }}>
                      <div>
                        <h6
                          style={{
                            fontSize: "16px",
                            fontWeight: "700",
                          }}
                        >
                          {t("crossOEM")}
                        </h6>
                        <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                          <table className="table table-bordered">
                            <thead>
                              <tr>
                                <th>{t("fullReference")}</th>
                                <th>{t("manufacter")}</th>
                                <th>{t("reference")}</th>
                              </tr>
                            </thead>
                            <tbody>
                              {vehicleCompatibleProductDetails?.decode?.product
                                ?.crossOEM?.length > 0 ? (
                                vehicleCompatibleProductDetails?.decode?.product?.crossOEM?.map(
                                  (item, index) => (
                                    <tr key={index}>
                                      <td>{item?.fullReference}</td>
                                      <td>{item?.manufacter}</td>
                                      <td>{item?.reference}</td>
                                    </tr>
                                  ),
                                )
                              ) : (
                                <tr>
                                  <td
                                    colSpan="5"
                                    style={{ textAlign: "center" }}
                                  >
                                    {t("no_results_found")}
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-12" style={{ marginTop: "15px" }}>
                      <div>
                        <h6
                          style={{
                            fontSize: "16px",
                            fontWeight: "700",
                          }}
                        >
                          {t("vehiclesCompatibles")}
                        </h6>
                        <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                          <table className="table table-bordered">
                            <thead>
                              <tr>
                                <th>{t("vehicle_make_description")}</th>
                                <th>{t("vehicle_model_description")}</th>
                                <th>{t("vehicle_variant_description")}</th>
                                <th>{t("vehicle_variant_end_production")}</th>
                                <th>{t("vehicle_variant_init_production")}</th>
                              </tr>
                            </thead>
                            <tbody>
                              {vehicleCompatibleProductDetails?.decode?.product
                                ?.vehiclesCompatibles?.length > 0 ? (
                                vehicleCompatibleProductDetails?.decode?.product?.vehiclesCompatibles?.map(
                                  (item, index) => (
                                    <tr key={index}>
                                      <td>{item?.vehicle_make_description}</td>
                                      <td>{item?.vehicle_model_description}</td>
                                      <td>
                                        {item?.vehicle_variant_description}
                                      </td>
                                      <td>
                                        {item?.vehicle_variant_end_production}
                                      </td>
                                      <td>
                                        {item?.vehicle_variant_init_production}
                                      </td>
                                    </tr>
                                  ),
                                )
                              ) : (
                                <tr>
                                  <td
                                    colSpan="5"
                                    style={{ textAlign: "center" }}
                                  >
                                    {t("no_results_found")}
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </FormGroup>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleProductDetailsModalClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            Close <i className="bi bi-check2"></i>
          </button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={modifyConfirmModal}>
        <ModalHeader>{t("replace_the_vehicle_compatibles")}</ModalHeader>
        <ModalBody>
          <p className={`mb-0`}>
            {t("are_you_sure_you_want_to_replace_the_vehicle_compatibles_data")}
          </p>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleProductConfirmClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            {t("No")} <i className="bi bi-x-lg"></i>
          </button>

          {!loadingCompatible && (
            <button
              type="button"
              className="btn btn-block btn-primary"
              style={{ width: "100px" }}
              onClick={handleSubmitVehicleComProduct}
            >
              {t("yes")} <i className="bi bi-x-lg"></i>
            </button>
          )}
          {loadingCompatible && (
            <button
              color="secondary"
              type={`button`}
              disabled={true}
              className={`btn-square`}
            >
              <i className="fa fa-circle-o-notch fa-spin"></i> {`Loading...`}
            </button>
          )}
        </ModalFooter>
      </Modal>

      <Modal isOpen={modalStateRefHistory} size="xl">
        <ModalHeader>
          {" "}
          <div className="d-flex justify-content-between align-items-center w-100">
            <div className="card-title m-0">Part Details </div>

            {catalogModalStateRefDataList?.length > 0 && (
              <div className="d-flex gap-2" style={{ marginLeft: "538px" }}>
                <button
                  type="button"
                  className="btn btn-primary"
                  style={{ width: "185px" }}
                  onClick={handleChangePriceBulkOpen}
                >
                  Change prices (bulk)
                </button>

                <button
                  type="button"
                  className="btn btn-primary"
                  style={{ width: "185px" }}
                  onClick={handleChangeReferencesBulkOpen}
                >
                  Add References (bulk)
                </button>
              </div>
            )}
          </div>
        </ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="col-md-12">
              <div className="col-md-12">
                <FormGroup>
                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>{t("id")}</th>
                          <th>{t("part_name")}</th>
                          <th>{t("make")}</th>
                          <th>{t("modal")}</th>
                          <th>{t("variant")}</th>
                          <th>{t("year")}</th>
                          <th>{t("quantity")}</th>
                          <th>{t("price")}</th>
                          <th>{t("createdDate")}</th>
                          <th>{t("action")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {catalogModalStateRefDataList?.length > 0 ? (
                          catalogModalStateRefDataList.map((item, index) => (
                            <tr key={index}>
                              <td>{item?.id}</td>
                              <td>{item?.part_name}</td>
                              <td>{item?.make_name}</td>
                              <td>{item?.model_name}</td>
                              <td>{item?.variant_name}</td>
                              <td>{item?.vehicle_year}</td>
                              <td>{item?.quantity}</td>
                              <td>€ {item?.part_price}</td>
                              <td>
                                {moment(item?.created_at).format(
                                  "DD/MM/YYYY HH:mm",
                                )}
                              </td>
                              <td>
                                <div
                                  style={{ cursor: "pointer" }}
                                  className="edit-btn"
                                  onClick={() =>
                                    window.open(
                                      `/part-details/${item.uuid}`,
                                      "_blank",
                                    )
                                  }
                                >
                                  <i className="bi bi-eye-fill"></i>
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="10" className="text-center text-muted">
                              No reference part data available.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </FormGroup>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleClosePartRefHistory}
            style={{ width: "100px", marginTop: "10px" }}
          >
            Close <i className="bi bi-check2"></i>
          </button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={partCatalogModal} className="modal-fullscreen">
        <ModalHeader>{t("catalog_model")}</ModalHeader>

        <ModalBody>
          <div className="row">
            <div className="col-md-12">
              <div className="vehicleThBg table-responsive table-responsive-sm">
                <div className="card vehicle-card-new">
                  <div className="card-body">
                    <div className="card-body-inventory">
                      <div className="row mt-3 justify-content-start">
                        {partsData?.map((category, catIndex) =>
                          category?.catalog_part_list?.map(
                            (part, partIndex) => (
                              <div
                                className="col-sm-12"
                                key={`${catIndex}-${partIndex}`}
                              >
                                <div className="item-card-1 mb-2">
                                  <div
                                    className="d-flex justify-content-between align-items-center"
                                    style={{ cursor: "pointer" }}
                                    onClick={() =>
                                      toggleOpen(
                                        `${catIndex}-${partIndex}`,
                                        part,
                                      )
                                    }
                                  >
                                    <span style={{ fontWeight: "bold" }}>
                                      {part?.name}
                                    </span>

                                    {openIndexes[`${catIndex}-${partIndex}`] ? (
                                      <i className="bi bi-chevron-up"></i>
                                    ) : (
                                      <i className="bi bi-chevron-down"></i>
                                    )}
                                  </div>

                                  {openIndexes[`${catIndex}-${partIndex}`] && (
                                    <div
                                      className="mt-4 row justify-content-start"
                                      style={{
                                        maxHeight: "500px",
                                        overflowY: "auto",
                                        border: "1px solid #dee2e6",
                                      }}
                                    >
                                      <div className="col-md-12">
                                        <div className="row justify-content-start">
                                          <div className="card col-sm-3 shadow-none">
                                            <div className="card-body">
                                              <div className="brand-card">
                                                <input
                                                  type="checkbox"
                                                  className="my-checkbox-1 form-check-input"
                                                  checked={selectedImages.some(
                                                    (item) =>
                                                      item.rowKey ===
                                                      `${catIndex}-${partIndex}`,
                                                  )}
                                                  onChange={(e) =>
                                                    handleCheckboxChangeImage(
                                                      `${catIndex}-${partIndex}`,
                                                      part.img_url,
                                                      e.target.checked,
                                                    )
                                                  }
                                                  style={{ marginLeft: "10px" }}
                                                />
                                                <img
                                                  src={partByGroup.img}
                                                  alt="..."
                                                  className="img-fluid battery-imagesp"
                                                  style={{
                                                    display: "block",
                                                    margin: "0 auto",
                                                    marginLeft: "40px",
                                                  }}
                                                />
                                              </div>
                                            </div>

                                            <div className="card-body-title-block">
                                              {part?.title}
                                            </div>
                                          </div>
                                          <div className="card col-sm-9">
                                            <div className="card-body px-4 mt-3">
                                              {partByGroup?.partGroups?.map(
                                                (item, groupIndex) => (
                                                  <div key={groupIndex}>
                                                    <h4 className="mt-3 mb-3">
                                                      {item.name}
                                                    </h4>
                                                    <div className="table-responsive-inventory-add">
                                                      <table className="table table-bordered">
                                                        <thead
                                                          className="table-light"
                                                          style={{
                                                            position: "sticky",
                                                            top: 0,
                                                            backgroundColor:
                                                              "#f8f9fa",
                                                            zIndex: 1,
                                                          }}
                                                        >
                                                          <tr>
                                                            <th>{t("name")}</th>
                                                            <th>{t("code")}</th>
                                                            <th>
                                                              {t("description")}
                                                            </th>
                                                            <th></th>
                                                            <th>Price</th>
                                                          </tr>
                                                        </thead>
                                                        <tbody>
                                                          {item.parts?.map(
                                                            (
                                                              items,
                                                              partIndex,
                                                            ) => {
                                                              const rowId = `collapse-${groupIndex}-${partIndex}`;

                                                              return (
                                                                <React.Fragment
                                                                  key={rowId}
                                                                >
                                                                  <tr>
                                                                    <td>
                                                                      {
                                                                        items?.name
                                                                      }
                                                                    </td>
                                                                    <td>
                                                                      {
                                                                        items?.number
                                                                      }
                                                                    </td>
                                                                    <td>
                                                                      <div
                                                                        dangerouslySetInnerHTML={{
                                                                          __html:
                                                                            items?.description,
                                                                        }}
                                                                      />
                                                                    </td>
                                                                    <td>
                                                                      <input
                                                                        type="checkbox"
                                                                        checked={part.addedData?.some(
                                                                          (p) =>
                                                                            p.reference_code ===
                                                                            items.id,
                                                                        )}
                                                                        onChange={(
                                                                          e,
                                                                        ) =>
                                                                          handleCheckboxChangeRow(
                                                                            e
                                                                              .target
                                                                              .checked,
                                                                            items,
                                                                          )
                                                                        }
                                                                        className="cursore-pointer my-checkbox-1 form-check-input ms-2"
                                                                      />
                                                                    </td>

                                                                    <td>
                                                                      <button
                                                                        type="button"
                                                                        className="btn btn-block btn-primary"
                                                                        style={{
                                                                          cursor:
                                                                            "pointer",
                                                                          color:
                                                                            "blue",
                                                                          width:
                                                                            "100px",
                                                                          marginTop:
                                                                            "10px",
                                                                        }}
                                                                        onClick={() =>
                                                                          toggleRowLive(
                                                                            items,
                                                                          )
                                                                        }
                                                                      >
                                                                        {openPriceRows[
                                                                          items
                                                                            ?.number
                                                                        ]
                                                                          ? t(
                                                                              "hide_price",
                                                                            )
                                                                          : t(
                                                                              "see_price",
                                                                            )}
                                                                      </button>
                                                                    </td>
                                                                  </tr>

                                                                  {openPriceRows[
                                                                    items
                                                                      ?.number
                                                                  ] && (
                                                                    <tr>
                                                                      <td
                                                                        colSpan={
                                                                          3
                                                                        }
                                                                      >
                                                                        {partPriceData[
                                                                          items
                                                                            ?.number
                                                                        ]
                                                                          ?.length >
                                                                        0 ? (
                                                                          partPriceData[
                                                                            items
                                                                              ?.number
                                                                          ].map(
                                                                            (
                                                                              priceOption,
                                                                              idx,
                                                                            ) => (
                                                                              <div
                                                                                key={
                                                                                  idx
                                                                                }
                                                                                className="form-check form-check-radio"
                                                                              >
                                                                                <input
                                                                                  className="form-check-input custom-radio"
                                                                                  type="radio"
                                                                                  id={`price_${groupIndex}_${partIndex}_${idx}`}
                                                                                  name={`price-${idx}`} // group per part
                                                                                  value={
                                                                                    priceOption?.price
                                                                                  } // radio value = price
                                                                                  checked={
                                                                                    selectedPrice ===
                                                                                    priceOption?.price
                                                                                  }
                                                                                  onChange={() =>
                                                                                    handleRadioChangePrice(
                                                                                      priceOption?.price,
                                                                                      idx,
                                                                                    )
                                                                                  }
                                                                                />
                                                                                <label
                                                                                  htmlFor={`price_${groupIndex}_${partIndex}_${idx}`}
                                                                                  className="form-check-label form-label form-label mb-2"
                                                                                >
                                                                                  <strong>
                                                                                    {
                                                                                      priceOption?.price
                                                                                    }
                                                                                  </strong>
                                                                                </label>
                                                                              </div>
                                                                            ),
                                                                          )
                                                                        ) : (
                                                                          <div>
                                                                            {t(
                                                                              "loading_prices",
                                                                            )}
                                                                            ...
                                                                          </div>
                                                                        )}
                                                                      </td>
                                                                    </tr>
                                                                  )}
                                                                </React.Fragment>
                                                              );
                                                            },
                                                          )}
                                                        </tbody>
                                                      </table>
                                                    </div>
                                                  </div>
                                                ),
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            ),
                          ),
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handlePartCatalogModelClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            {t("submit")} <i className="bi bi-check2"></i>{" "}
          </button>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handlePartCatalogModelClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            Close <i className="bi bi-check2"></i>
          </button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={modalCarVin} className="modal-fullscreen">
        <ModalHeader className="modal-custom-header">
          {t("car_model_by_vin")}
        </ModalHeader>
        <ModalBody>
          <div>
            <div className="row">
              <div className="mt-4">
                <Tabs
                  id="controlled-tab-example"
                  activeKey={key}
                  onSelect={(k) => setKey(k)}
                  className="mb-3"
                >
                  <Tab
                    eventKey="car_type_selection"
                    title={t("pi_car_type_selection")}
                    style={{
                      color: "#81bb42",
                    }}
                  >
                    <div>
                      <div>
                        <h3>{t("parts_catalogs")}</h3>
                        <h6>
                          {/* {mainCatalogData?.brand}{" "}
                            {mainCatalogData?.model_name} */}
                        </h6>
                      </div>

                      <div>
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            justifyContent: "center",
                          }}
                        >
                          {partCatalogData?.map((card, cardIndex) => {
                            const showAll = showAllList[cardIndex];
                            const allItems = card?.subGroups || [];
                            const visibleItems = showAll
                              ? allItems
                              : allItems.slice(0, 5);
                            const extraCount = allItems?.length - 5;

                            return (
                              <div
                                key={cardIndex}
                                style={{
                                  width: "18rem",
                                  margin: "10px",
                                  padding: "13px",
                                }}
                              >
                                <img
                                  src={card.img_url}
                                  alt="..."
                                  className="card-img-top"
                                  style={{
                                    borderRadius: "145px",
                                    width: "50%",
                                    display: "block",
                                    margin: "0 auto",
                                  }}
                                />
                                <div
                                  className="card-body"
                                  style={{ marginLeft: "10px" }}
                                >
                                  <ul
                                    style={{
                                      listStyleType: "none",
                                      paddingLeft: 0,
                                      margin: 0,
                                    }}
                                  >
                                    <li
                                      key="level-1"
                                      style={{
                                        fontWeight: "bold",
                                        color: "#000",
                                        marginBottom: "5px",
                                        cursor: "pointer",
                                      }}
                                      onClick={(e) => {
                                        handleSubmitSchemaByGroup(e, card);
                                      }}
                                    >
                                      {card.name}
                                    </li>

                                    {/* Subgroups (Level 2 or deeper) */}
                                    {visibleItems.map((item, index) => (
                                      <li
                                        key={index}
                                        style={{
                                          fontWeight: "normal",
                                          color: "#555",
                                          marginBottom: "5px",
                                          cursor: "pointer",
                                        }}
                                      >
                                        {item.name}
                                      </li>
                                    ))}
                                  </ul>

                                  {allItems?.length > 5 && (
                                    <button
                                      onClick={() => toggleShowAll(cardIndex)}
                                      style={{
                                        background: "none",
                                        border: "none",
                                        color: "#007bff",
                                        cursor: "pointer",
                                        padding: 0,
                                        marginTop: "5px",
                                      }}
                                    >
                                      {showAll
                                        ? "Show less"
                                        : `Show more (${extraCount})`}
                                    </button>
                                  )}
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </Tab>

                  {showTabInteractive && (
                    <Tab
                      eventKey="interactive_diagram_selection"
                      title={t("pi_interactive_diagram_selection")}
                      style={{
                        color: "#81bb42",
                      }}
                    >
                      <div>
                        <div>
                          <h3>{t("engine")}</h3>
                          <h6></h6>
                        </div>
                      </div>
                      <div>
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            justifyContent: "center",
                          }}
                        >
                          {schemaByGroupLocalData?.map((card, cardIndex) => {
                            const showAll = showAlTypeList[cardIndex];
                            const allItems = card.part_names || [];
                            const visibleItems = showAll
                              ? allItems
                              : allItems.slice(0, 4);
                            const extraCount = allItems?.length - 4;
                            return (
                              <div
                                key={cardIndex}
                                style={{
                                  width: "18rem",
                                  margin: "10px",
                                  padding: "13px",
                                  marginTop: "30px",
                                }}
                              >
                                <img
                                  src={card.img}
                                  alt="..."
                                  className="card-img-top"
                                  style={{
                                    display: "block",
                                    margin: "0 auto",
                                    border: "1px solid #ddd",
                                    borderRadius: "10px",
                                  }}
                                />
                                <div
                                  className="card-body"
                                  style={{ color: "black" }}
                                >
                                  <h5
                                    className="card-title"
                                    style={{
                                      fontSize: "larger",
                                      fontWeight: 700,
                                      cursor: "pointer",
                                    }}
                                    onClick={(e) => {
                                      handleSubmitPartByGroup(e, card);
                                    }}
                                  >
                                    {card?.name}
                                  </h5>

                                  <div style={{ marginTop: "40px" }}>
                                    <div>
                                      {visibleItems?.map((item, index) => (
                                        <span
                                          className="badge sqaure-pill text-dark bg-light border px-3 py-2 d-inline-block text-center"
                                          style={{
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            marginLeft: "5px",
                                            marginTop: "5px",
                                          }}
                                        >
                                          {item?.name}
                                        </span>
                                      ))}
                                    </div>
                                  </div>

                                  {allItems?.length > 5 && (
                                    <button
                                      onClick={() =>
                                        toggleShowTypeAll(cardIndex)
                                      }
                                      style={{
                                        background: "none",
                                        border: "none",
                                        color: "#007bff",
                                        cursor: "pointer",
                                        padding: 0,
                                        marginTop: "5px",
                                      }}
                                    >
                                      {showAll
                                        ? "Show less"
                                        : `Show more (${extraCount})`}
                                    </button>
                                  )}
                                </div>{" "}
                                <div className="row">
                                  <small className="text-muted">
                                    {card?.description}
                                  </small>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </Tab>
                  )}

                  {showTab3 && (
                    <Tab
                      eventKey="part_selection"
                      title={t("pi_part_selection")}
                      style={{
                        color: "#81bb42",
                      }}
                    >
                      <div>
                        <div>
                          <h4
                            style={{
                              color: "black",
                            }}
                          >
                            {mainPartData?.name}
                          </h4>
                        </div>
                        {partByGroupLocalData?.map((card) => {
                          return (
                            <>
                              <div className="row">
                                <div className="col-md-6">
                                  <img
                                    src={card.img}
                                    alt="..."
                                    className="card-img-top"
                                    style={{
                                      borderRadius: "145px",
                                      width: "50%",
                                      display: "block",
                                      margin: "0 auto",
                                    }}
                                  />
                                </div>
                                <div className="col-md-6">
                                  <div className="container mt-4">
                                    {card?.part_groups?.map(
                                      (item, groupIndex) => (
                                        <div key={groupIndex}>
                                          <h4>{item.name}</h4>
                                          <div
                                            style={{
                                              maxHeight: "300px",
                                              overflowY: "auto",
                                              border: "1px solid #dee2e6",
                                            }}
                                          >
                                            <table className="table table-bordered">
                                              <thead
                                                className="table-light"
                                                style={{
                                                  position: "sticky",
                                                  top: 0,
                                                  backgroundColor: "#f8f9fa",
                                                  zIndex: 1,
                                                }}
                                              >
                                                <tr>
                                                  <th>{t("name")}</th>
                                                  <th>{t("code")}</th>
                                                  <th></th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {item.parts?.map(
                                                  (items, partIndex) => {
                                                    const rowId = `collapse-${groupIndex}-${partIndex}`;

                                                    return (
                                                      <React.Fragment
                                                        key={rowId}
                                                      >
                                                        <tr>
                                                          <td>{items?.name}</td>
                                                          <td>
                                                            {items?.number}
                                                          </td>

                                                          <td>
                                                            <button
                                                              type="button"
                                                              className="btn btn-block btn-primary"
                                                              style={{
                                                                cursor:
                                                                  "pointer",
                                                                color: "blue",
                                                                width: "100px",
                                                                marginTop:
                                                                  "10px",
                                                              }}
                                                              onClick={(e) => {
                                                                toggleRowLocal(
                                                                  items?.number,
                                                                );
                                                              }}
                                                            >
                                                              {t(
                                                                "see_price",
                                                              )}{" "}
                                                            </button>
                                                          </td>
                                                        </tr>
                                                      </React.Fragment>
                                                    );
                                                  },
                                                )}
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      ),
                                    )}
                                  </div>
                                </div>
                              </div>
                            </>
                          );
                        })}
                      </div>
                    </Tab>
                  )}
                </Tabs>
              </div>
            </div>
          </div>
        </ModalBody>

        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleCarVinModalClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            Close <i className="bi bi-x-lg"></i>
          </button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={priceModal}>
        <ModalHeader>{codeData}</ModalHeader>

        <ModalBody>
          <div className="row">
            <div className="col-md-12" style={{ marginTop: "10px" }}>
              <div className="col-md-12">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>{t("Price")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {partPriceLocalData?.length > 0 ? (
                      partPriceLocalData?.map((car, i) =>
                        car?.price_list?.map((cars, j) => (
                          <tr key={`${i}-${j}`}>
                            <td>{cars?.price} €</td>
                          </tr>
                        )),
                      )
                    ) : (
                      <tr>
                        <td
                          colSpan="1"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          {t("no_price_available")}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handlePriceClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            Close <i className="bi bi-check2"></i>
          </button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={changePartModal}>
        <ModalHeader>{t("part_added_at_this_dismantle_process")}</ModalHeader>
        <ModalBody>
          <p className={`mb-0`}>
            {t(
              "You have already this part added at this dismantle process want to continue",
            )}
          </p>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleChangePartClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            {t("No")} <i className="bi bi-x-lg"></i>
          </button>

          <button
            type="button"
            className="btn btn-block btn-primary"
            style={{ width: "100px" }}
            onClick={handleOverwriteConfirm}
          >
            {t("yes")} <i className="bi bi-x-lg"></i>
          </button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={modifyAssoicate}>
        <ModalHeader>Associate Vehicle</ModalHeader>
        <ModalBody>
          <p
            className={`mb-0`}
          >{`Please select a vehicle to associate with this part?`}</p>

          <div
            className="row"
            style={{
              marginTop: "13px",
            }}
          >
            <div className="col-md-12">
              <div className="Label-my">
                Vehicle{" "}
                <Select
                  className="my-select-v"
                  options={vehicleModelCategoryAllList}
                  isClearable={true}
                  placeholder={t("pi_select_vehicle_placeholder")}
                  value={
                    vehicleModelCategoryAllList.find(
                      (v) =>
                        Number(v.value) ===
                        Number(categoryPartsData?.vehicle_id),
                    ) || null
                  }
                  onChange={(selectedOption) => {
                    setCategoryPartsData((prev) => {
                      const opt = selectedOption || {};

                      return {
                        ...prev,
                        vehicle_year: opt.vehicle_year || "",
                        vehicle_make: opt.make_id || "",
                        vehicle_model: opt.vehicle_model_id || "",
                        vehicle_variant: opt.variants_id || "",
                        vehicle_make_name: opt.vehicle_make_name || "",
                        vehicle_model_name: opt.vehicle_model_name || "",
                        vehicle_variant_name: opt.vehicle_variant_name || "",
                        vehicle_type: opt.vehicle_type || "",
                        vehicle_type_name: opt.vehicle_type_name || "",
                        vehicle_id: opt.value || "",
                        label: `${opt.vehicle_make_name || ""} | ${
                          opt.vehicle_model_name || ""
                        } | ${opt.registration_plate || ""} | ${
                          opt.registration || ""
                        } | ${opt.vehicle_internal_id || ""}`,
                        vehicle_internal_id: opt.vehicle_internal_id,
                      };
                    });
                  }}
                  styles={customStyles}
                  onInputChange={handleInputCategoryChange}
                  inputSelctedValue={inputCategoryValue}
                />
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleSubmitAssoicateVehicleClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            No <i className="bi bi-x-lg"></i>
          </button>

          <button
            type="button"
            className="btn btn-block btn-primary"
            style={{ width: "100px" }}
            onClick={handleSubmitAssoicateVehicle}
          >
            Yes <i className="bi bi-check2"></i>
          </button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={modifyAssoicateConfirm}>
        <ModalHeader>Already Associated Vehicle</ModalHeader>
        <ModalBody>
          <p
            className={`mb-0`}
          >{`This part is already associated with a vehicle. Do you want to link it with another vehicle, or remove the existing vehicle from this part?`}</p>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={() => setModifyAssoicateConfirm(false)}
            style={{ width: "100px", marginTop: "10px" }}
          >
            No <i className="bi bi-x-lg"></i>
          </button>

          {categoryPartsData?.vehicle_id !== 0 &&
            categoryPartsData?.vehicle_id && (
              <button
                type="button"
                className="btn btn-block btn-danger"
                style={{
                  width: "115px",
                  marginTop: "183px",
                  marginRight: "233px",
                }}
                onClick={handleSubmitAssocRemoveVehicle}
              >
                Remove <i className="bi bi-trash"></i>
              </button>
            )}

          <button
            type="button"
            className="btn btn-block btn-primary"
            style={{ width: "100px" }}
            onClick={handleSubmitAssocYesVehicleConfirm}
          >
            Yes <i className="bi bi-check2"></i>
          </button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={priceBulkModel} size="lg">
        <ModalHeader>{"Change Price(Bulk)"}</ModalHeader>

        <ModalBody>
          <div className="row">
            <div className="col-md-12">
              <button
                type="button"
                className="btn btn-block btn-primary"
                style={{ width: "150px" }}
                onClick={handleSelectPriceBulkAll}
              >
                Check All <i className="bi bi-check2"></i>
              </button>
            </div>
            <div className="col-md-12" style={{ marginTop: "10px" }}>
              <div className="col-md-12 addPartField col-lg-3-mob">
                <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                  <input
                    type="checkbox"
                    name="price_1_check"
                    checked={priceBulkData.price_1_check}
                    onChange={handleRowPriceBulkCheck}
                  />
                  <span className="ms-2">Price 1 €</span>
                </label>
                <input
                  type="number"
                  name="price_1"
                  value={priceBulkData.price_1}
                  onChange={handleChangePriceBulk}
                  className="form-control"
                  placeholder={t("pi_price_1")}
                  onKeyDown={(e) => {
                    if (
                      e.key === "e" ||
                      e.key === "E" ||
                      e.key === "+" ||
                      e.key === "-"
                    ) {
                      e.preventDefault();
                    }
                  }}
                  min="0"
                />
              </div>

              <div className="col-md-12 addPartField col-lg-3-mob">
                <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                  <input
                    type="checkbox"
                    name="price_2_check"
                    checked={priceBulkData.price_2_check}
                    onChange={handleRowPriceBulkCheck}
                  />

                  <span className="ms-2">
                    Price 2{" "}
                    {isAllChecked && settingDetails?.discount_percentage && (
                      <span>
                        ({settingDetails.discount_percentage}% discount)
                      </span>
                    )}{" "}
                    €
                  </span>
                </label>
                <input
                  type="number"
                  name="price_2"
                  value={priceBulkData.price_2}
                  onChange={handleChangePriceBulk}
                  className="form-control"
                  placeholder={t("pi_price_2")}
                  onKeyDown={(e) => {
                    if (
                      e.key === "e" ||
                      e.key === "E" ||
                      e.key === "+" ||
                      e.key === "-"
                    ) {
                      e.preventDefault();
                    }
                  }}
                  min="0"
                />
              </div>

              <div className="col-md-12 addPartField col-lg-3-mob">
                <label className="partsLabel col-form-label ml-2 Label-my form-label form-label">
                  <input
                    type="checkbox"
                    name="cost_price_check"
                    checked={priceBulkData.cost_price_check}
                    onChange={handleRowPriceBulkCheck}
                  />
                  <span className="ms-2">Cost Price Check €</span>
                </label>
                <input
                  type="number"
                  name="part_cost_price"
                  value={priceBulkData.part_cost_price}
                  onChange={handleChangePriceBulk}
                  className="form-control"
                  placeholder={t("pi_part_price_cost")}
                  onKeyDown={(e) => {
                    if (
                      e.key === "e" ||
                      e.key === "E" ||
                      e.key === "+" ||
                      e.key === "-"
                    ) {
                      e.preventDefault();
                    }
                  }}
                  min="0"
                />
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleChangePriceBulkClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            Close <i className="bi bi-check2"></i>
          </button>
          <button
            type="button"
            className="btn btn-block btn-primary d-flex align-items-center justify-content-center"
            onClick={handlePriceBulkSubmit}
            style={{ width: "100px", marginTop: "10px" }}
            disabled={priceBulkLoader}
          >
            {priceBulkLoader ? (
              <div
                className="spinner-border spinner-border-sm text-light"
                role="status"
              >
                <span className="visually-hidden">Loading...</span>
              </div>
            ) : (
              <>
                Save <i className="bi bi-check2 ms-1"></i>
              </>
            )}
          </button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={referencesBulkModel} size="xl">
        <ModalHeader>{"Add References(Bulk)"}</ModalHeader>

        <ModalBody>
          <div className="row">
            <div>
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Reference Code</th>
                    <th>Condition</th>
                    <th>Type</th>
                    {referencesBulkData.reference.some(
                      (item) => item.condition_id === 2 && item.type_id === 1,
                    ) && <th>Brand</th>}

                    {referencesBulkData.reference.some(
                      (item) => item.type_id === 1,
                    ) && <th>Manufacturer</th>}
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {referencesBulkData.reference.map((part, index) => (
                    <tr key={index}>
                      <td>
                        <input
                          type="text"
                          className="form-control"
                          name="reference_code"
                          value={part.reference_code}
                          onChange={(e) => handleInputChangeRefBulk(e, index)}
                          placeholder={t("reference_code")}
                        />
                      </td>
                      <td>
                        <Select
                          className="my-Select"
                          options={conditionList}
                          value={
                            conditionList.find(
                              (opt) => opt.value === part.condition_id,
                            ) || null
                          }
                          onChange={(option) =>
                            handleSelectChangeRefBulk(
                              index,
                              "condition_id",
                              option,
                            )
                          }
                          placeholder={t("select_condition")}
                        />
                      </td>
                      <td>
                        <Select
                          className="my-Select"
                          options={referenceList}
                          value={
                            referenceList.find(
                              (opt) => opt.value === part.type_id,
                            ) || null
                          }
                          onChange={(option) =>
                            handleSelectChangeRefBulk(index, "type_id", option)
                          }
                          placeholder={t("select_type")}
                        />
                      </td>
                      {referencesBulkData.reference.some(
                        (item) => item.condition_id === 2 && item.type_id === 1,
                      ) && (
                        <td>
                          {part?.condition_id === 2 && part?.type_id === 1 ? (
                            <input
                              type="text"
                              className="form-control"
                              name="brand"
                              value={part.brand}
                              onChange={(e) =>
                                handleInputChangeRefBulk(e, index)
                              }
                              placeholder={t("brand")}
                            />
                          ) : null}
                        </td>
                      )}

                      {/* Manufacturer Column */}
                      {referencesBulkData.reference.some(
                        (item) => item.type_id === 1,
                      ) && (
                        <td>
                          {part?.type_id === 1 ? (
                            <input
                              type="text"
                              className="form-control"
                              name="manufacter"
                              value={part.manufacter}
                              onChange={(e) =>
                                handleInputChangeRefBulk(e, index)
                              }
                              placeholder={t("manufacturer")}
                            />
                          ) : null}
                        </td>
                      )}

                      <td>
                        <div className="trash-btn">
                          <a
                            className="delete-btn"
                            href="#"
                            onClick={() => removeReferenceBulk(index)}
                          >
                            <i className="bi bi-trash3"></i>
                          </a>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <button
                type="button"
                className="btn btn-primary"
                onClick={addReferenceuBulk}
              >
                Add More
              </button>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleChangeReferencesBulkClose}
            style={{ width: "100px", marginTop: "10px" }}
          >
            Close <i className="bi bi-check2"></i>
          </button>
          <button
            type="button"
            className="btn btn-block btn-primary d-flex align-items-center justify-content-center"
            onClick={handleReferenceBulkSubmit}
            style={{ width: "100px", marginTop: "10px" }}
            disabled={referencesBulkLoader}
          >
            {referencesBulkLoader ? (
              <div
                className="spinner-border spinner-border-sm text-light"
                role="status"
              >
                <span className="visually-hidden">Loading...</span>
              </div>
            ) : (
              <>
                Save <i className="bi bi-check2 ms-1"></i>
              </>
            )}
          </button>
        </ModalFooter>
      </Modal>

      {/* Modal de troca de lote — paridade com mobile _LotInlineEditor */}
      <Modal
        isOpen={lotEditModalOpen}
        toggle={() => !lotEditSaving && setLotEditModalOpen(false)}
        centered
        size="md"
      >
        <ModalHeader toggle={() => !lotEditSaving && setLotEditModalOpen(false)}>
          {t("lot", { defaultValue: "Lote" })}
        </ModalHeader>
        <ModalBody>
          <input
            type="text"
            className="form-control mb-2"
            placeholder={`${t("lot_internal_id", { defaultValue: "ID interno" })} / ${t("name", { defaultValue: "Nome" })}`}
            value={lotEditSearch}
            onChange={(e) => setLotEditSearch(e.target.value)}
            autoFocus
            disabled={lotEditSaving}
          />

          {partLotInfo.lot_id && (
            <button
              type="button"
              className="list-group-item list-group-item-action text-start w-100 d-flex align-items-center mb-2"
              onClick={() => submitPartLotChange(null, "", "")}
              disabled={lotEditSaving}
              style={{
                border: "1px solid #f5c2c7",
                backgroundColor: "#fbecec",
                color: "#842029",
                borderRadius: 8,
                padding: "10px 12px",
              }}
            >
              <i className="bi bi-x-circle me-2" />
              <span className="flex-grow-1">
                {t("remove_from_lot", { defaultValue: "Remover do lote" })}
              </span>
            </button>
          )}

          <div style={{ maxHeight: 360, overflowY: "auto" }}>
            {lotEditLoading && (
              <div className="text-center text-muted py-3">
                <i className="bi bi-arrow-clockwise" /> ...
              </div>
            )}
            {!lotEditLoading && filteredLotEditList.length === 0 && (
              <div className="text-center text-muted py-3">
                {t("no_data_found", { defaultValue: "Sem resultados" })}
              </div>
            )}
            {!lotEditLoading &&
              filteredLotEditList.map((lot) => {
                const isCurrent = partLotInfo.lot_id === lot.id;
                return (
                  <button
                    key={lot.id}
                    type="button"
                    className="list-group-item list-group-item-action text-start w-100 d-flex align-items-center"
                    disabled={lotEditSaving || isCurrent}
                    onClick={() =>
                      submitPartLotChange(
                        lot.id,
                        lot.name || "",
                        lot.lot_internal_id || ""
                      )
                    }
                    style={{
                      border: 0,
                      borderBottom: "1px solid #e9ecef",
                      padding: "10px 12px",
                      backgroundColor: isCurrent ? "#eef7e2" : "#fff",
                    }}
                  >
                    {lot.lot_internal_id ? (
                      <span
                        className="badge me-2"
                        style={{
                          backgroundColor: "#81BB42",
                          color: "#fff",
                          fontSize: 11,
                        }}
                      >
                        #{lot.lot_internal_id}
                      </span>
                    ) : (
                      <i
                        className="bi bi-archive-fill me-2"
                        style={{ color: "#81BB42" }}
                      />
                    )}
                    <span className="flex-grow-1">{lot.name || "—"}</span>
                    {isCurrent && (
                      <i
                        className="bi bi-check-circle-fill"
                        style={{ color: "#81BB42" }}
                      />
                    )}
                  </button>
                );
              })}
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default VehiclePartsAdd;
